var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _g, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 75,
    viewBox: "0 0 145 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10106_6282)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4039 32.7173L8.46233 62.1997C7.55898 63.1529 7.59936 64.6579 8.55253 65.5612L55.2561 109.824C56.2093 110.727 57.7143 110.687 58.6176 109.734L86.5592 80.2514C87.4626 79.2983 87.4222 77.7932 86.469 76.8899L39.7655 32.6271C38.8123 31.7238 37.3073 31.7642 36.4039 32.7173Z",
    fill: "url(#paint0_linear_10106_6282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8426 65.1556L15.4371 65.9808L15.082 66.3514L12.1225 62.2322L12.6796 61.6517L16.9487 64.3803L16.5708 64.7804L15.7091 64.2308L14.8393 65.1459L14.8426 65.1556ZM14.5503 64.7741L15.3159 63.9706L12.8456 62.4031L14.5503 64.7741Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9607 66.5409C20.1079 65.7265 18.9449 65.9658 18.0954 66.1321C17.6249 66.2252 17.2522 66.2199 16.863 66.1656C16.9428 66.5642 16.9733 66.8812 16.8965 67.398C16.7719 68.2583 16.5993 69.4293 17.4521 70.2437C18.0621 70.8236 18.9612 70.837 19.5248 70.2433C19.7594 70.0006 19.8664 69.7354 19.9047 69.4607C20.0562 69.8133 20.1461 70.2739 19.8659 70.5757C19.961 70.6636 19.9971 70.706 19.9971 70.706L20.704 69.955L20.8507 69.8073L21.5576 69.0563C21.5576 69.0563 21.5215 69.0139 21.4264 68.926C21.1462 69.2277 20.6752 69.1573 20.3152 69.0278C20.5798 68.9713 20.8442 68.8495 21.0788 68.6067C21.6326 68.0164 21.5805 67.1175 20.9705 66.5376L20.9607 66.5409Z",
    fill: "url(#paint1_linear_10106_6282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0498 75.9323C74.9025 76.7467 76.0656 76.5074 76.915 76.3411C77.3855 76.248 77.7582 76.2533 78.1475 76.3076C78.0677 75.909 78.0372 75.592 78.1139 75.0752C78.2385 74.2149 78.4111 73.0439 77.5584 72.2295C76.9484 71.6496 76.0493 71.6362 75.4857 72.2299C75.2511 72.4726 75.1441 72.7378 75.1058 73.0125C74.9542 72.6599 74.8644 72.1993 75.1445 71.8976C75.0494 71.8096 75.0133 71.7672 75.0133 71.7672L74.3064 72.5183L74.1598 72.6659L73.4529 73.4169C73.4529 73.4169 73.489 73.4593 73.5841 73.5472C73.8642 73.2455 74.3352 73.3159 74.6953 73.4454C74.4307 73.5019 74.1663 73.6238 73.9317 73.8665C73.3779 74.4568 73.4299 75.3557 74.04 75.9356L74.0498 75.9323Z",
    fill: "url(#paint2_linear_10106_6282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4849 72.9111C63.4527 69.7725 63.0707 65.0463 59.8042 61.958C52.5724 55.1003 40.9083 61.1811 36.1687 60.4875C37.1195 65.1856 31.6639 77.1597 38.9055 84.0141C42.1623 87.1057 46.9098 87.2402 49.8776 84.1015C52.347 81.4909 52.242 78.4606 51.5769 75.0954C54.9785 75.5744 58.0058 75.5251 60.4849 72.9111Z",
    fill: "url(#paint3_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4851 72.9111C63.4529 69.7724 63.0709 65.0463 59.8043 61.958C52.7169 55.2372 41.3654 60.9507 36.4535 60.5225C36.3063 60.5067 36.1955 60.6313 36.2124 60.7784C36.899 65.6637 31.8084 77.2965 38.8959 84.0174C42.1527 87.109 46.9002 87.2435 49.868 84.1048C52.2755 81.5696 52.2329 78.6273 51.627 75.3732C51.6037 75.2392 51.7144 75.1146 51.8518 75.1337C55.1389 75.5641 58.0678 75.4496 60.4753 72.9144L60.4851 72.9111Z",
    fill: "url(#paint4_linear_10106_6282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M60.4786 72.9242C63.4399 69.7986 63.0612 65.0823 59.8242 62.0168C52.8482 55.4002 41.7238 60.5899 36.7904 60.5835C36.5191 60.5877 36.2943 60.8271 36.3083 61.0952C36.5733 66.0244 31.9984 77.4071 38.9744 84.0236C42.2148 87.099 46.9361 87.2205 49.9072 84.0916C52.2886 81.5761 52.2331 78.66 51.6697 75.4351C51.6365 75.2718 51.7831 75.1242 51.9532 75.1432C55.2075 75.541 58.1201 75.4429 60.5015 72.9274L60.4786 72.9242Z",
    fill: "url(#paint5_linear_10106_6282)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M60.472 72.9373C63.4333 69.8117 63.0548 65.1281 59.8308 62.069C52.9696 55.5665 42.0535 60.4678 37.1044 60.6413C36.7056 60.6557 36.3602 61.0231 36.3714 61.4121C36.4566 66.3582 32.1589 77.5275 39.0168 84.0202C42.2408 87.0793 46.9489 87.1943 49.9038 84.0818C52.2689 81.5827 52.2004 78.6928 51.6601 75.5038C51.6267 75.3078 51.7961 75.1307 51.9891 75.1529C55.2106 75.5181 58.0938 75.4299 60.4622 72.9406L60.472 72.9373Z",
    fill: "url(#paint6_linear_10106_6282)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M60.4557 72.9537C63.4106 69.8412 63.0451 65.1641 59.8375 62.1213C53.0911 55.7328 42.3704 60.4046 37.4282 60.6958C36.9052 60.7303 36.4557 61.2091 36.4476 61.7355C36.425 66.6853 32.3293 77.6446 39.0659 84.0364C42.2735 87.0792 46.9587 87.191 49.9136 84.0785C52.2559 81.6089 52.194 78.7386 51.6734 75.5757C51.6432 75.3568 51.8354 75.1501 52.0513 75.1756C55.2335 75.5213 58.1069 75.4364 60.4492 72.9668L60.4557 72.9537Z",
    fill: "url(#paint7_linear_10106_6282)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M60.4494 72.9668C63.3944 69.8576 63.0355 65.2001 59.8444 62.1736C53.2226 55.8959 42.7007 60.3806 37.7522 60.7503C37.1018 60.795 36.5415 61.3984 36.5208 62.0491C36.4131 67.0057 32.4966 77.7519 39.1216 84.0395C42.3128 87.066 46.985 87.1713 49.93 84.0621C52.2561 81.6089 52.1811 78.7648 51.6933 75.6345C51.6533 75.3861 51.8683 75.15 52.1299 75.1819C55.2826 75.5048 58.1233 75.42 60.4494 72.9668Z",
    fill: "url(#paint8_linear_10106_6282)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M60.4329 72.9832C63.3715 69.8871 63.0257 65.2361 59.8509 62.2259C53.3407 56.0524 43.0241 60.3698 38.0661 60.8081C37.2915 60.8728 36.6171 61.5911 36.5936 62.3627C36.4141 67.3326 32.6668 77.8691 39.1737 84.0328C42.3485 87.043 47.0076 87.1418 49.9428 84.0359C52.2428 81.6024 52.1745 78.7779 51.7097 75.6835C51.6695 75.4024 51.9106 75.1466 52.1918 75.1718C55.3052 75.4753 58.1362 75.3938 60.4361 72.9603L60.4329 72.9832Z",
    fill: "url(#paint9_linear_10106_6282)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M60.4233 72.9865C63.352 69.8937 63.0161 65.2721 59.8578 62.2782C53.4623 56.2187 43.3479 60.3589 38.3901 60.8626C37.4913 60.9473 36.7127 61.7771 36.6667 62.6763C36.4349 67.6529 32.834 77.9764 39.2295 84.0358C42.3878 87.0297 47.024 87.1254 49.9528 84.0326C52.2397 81.6253 52.1747 78.8106 51.7133 75.7586C51.6633 75.4482 51.9369 75.1596 52.2542 75.1945C55.3316 75.4882 58.1363 75.3938 60.4233 72.9865Z",
    fill: "url(#paint10_linear_10106_6282)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M60.4068 73.0029C63.3356 69.9101 62.9965 65.3114 59.8545 62.3338C53.5739 56.3883 43.6682 60.3709 38.704 60.9204C37.6745 61.0383 36.7982 61.9664 36.733 63.003C36.4391 67.9897 32.9945 78.0968 39.2686 84.0553C42.4106 87.0329 47.0337 87.1221 49.9526 84.0326C52.2135 81.645 52.1584 78.8597 51.7167 75.8338C51.6698 75.5005 51.9663 75.1824 52.3031 75.2107C55.3412 75.4849 58.1361 75.3938 60.397 73.0062L60.4068 73.0029Z",
    fill: "url(#paint11_linear_10106_6282)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M60.4005 73.016C63.3228 69.9363 62.9968 65.3441 59.8712 62.3828C53.7119 56.5383 44.0051 60.3665 39.028 60.9749C37.8744 61.1128 36.8938 62.1524 36.816 63.3133C36.4731 68.3165 33.1749 78.2106 39.3309 84.0453C42.4565 87.0066 47.0534 87.0828 49.9756 84.0031C52.2137 81.645 52.1717 78.8662 51.7432 75.8795C51.6962 75.5135 52.0187 75.1757 52.3785 75.2072C55.3806 75.4717 58.1493 75.3676 60.3972 73.0062L60.4005 73.016Z",
    fill: "url(#paint12_linear_10106_6282)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M60.3939 73.0291C63.3064 69.9527 62.987 65.3801 59.8778 62.435C53.8333 56.7046 44.3352 60.3752 39.3517 61.0294C38.0773 61.1971 36.9892 62.3385 36.8889 63.6269C36.4937 68.6368 33.3419 78.318 39.3864 84.0484C42.4956 86.9934 47.0793 87.0631 49.9951 83.9965C52.2169 81.6548 52.1717 78.8989 51.7662 75.9481C51.7093 75.5527 52.0546 75.1854 52.4602 75.2233C55.4263 75.4781 58.1819 75.3675 60.4037 73.0258L60.3939 73.0291Z",
    fill: "url(#paint13_linear_10106_6282)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M60.3776 73.0455C63.2836 69.9822 62.9806 65.4259 59.8845 62.4873C53.9548 56.8709 44.6654 60.3839 39.6756 61.0839C38.2704 61.2847 37.0879 62.5343 36.9618 63.9405C36.5177 68.9669 33.5122 78.4351 39.442 84.0515C42.5347 86.9802 47.0956 87.0467 50.0114 83.9801C52.2071 81.6581 52.1816 78.9283 51.786 76.0069C51.729 75.5788 52.1004 75.1918 52.5255 75.223C55.4523 75.4584 58.1851 75.3446 60.3939 73.0291L60.3776 73.0455Z",
    fill: "url(#paint14_linear_10106_6282)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M60.3711 73.0586C63.2672 69.9987 62.9709 65.4619 59.8945 62.5494C54.0894 57.0438 44.9989 60.4024 39.9928 61.1515C38.4669 61.3822 37.1865 62.7301 37.0315 64.277C36.5482 69.3167 33.6761 78.5653 39.491 84.0677C42.5674 86.9801 47.1152 87.0401 50.0113 83.9801C52.194 81.6843 52.162 78.9676 51.7797 76.0854C51.7161 75.6377 52.1201 75.2179 52.5779 75.249C55.4687 75.4747 58.1883 75.3544 60.3613 73.0619L60.3711 73.0586Z",
    fill: "url(#paint15_linear_10106_6282)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M60.3548 73.075C63.2445 70.0281 62.9514 65.5011 59.9012 62.6017C54.2076 57.2003 45.3292 60.4111 40.3167 61.206C38.6601 61.4698 37.2853 62.926 37.1143 64.5873C36.5821 69.6435 33.853 78.6693 39.5466 84.0707C42.6066 86.9669 47.1413 87.0204 50.0276 83.9637C52.1843 81.6876 52.172 78.997 51.7995 76.1441C51.7358 75.6638 52.1626 75.2144 52.6433 75.2488C55.5079 75.4615 58.1916 75.3315 60.3482 73.0554L60.3548 73.075Z",
    fill: "url(#paint16_linear_10106_6282)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M60.3452 73.0783C63.2349 70.0314 62.9517 65.5338 59.9048 62.6442C54.326 57.3568 45.6661 60.4067 40.6277 61.254C38.8534 61.5574 37.3776 63.1022 37.1744 64.8945C36.6029 69.9638 34.0105 78.78 39.5893 84.0673C42.6328 86.9472 47.1446 86.9975 50.0343 83.9506C52.1747 81.6909 52.169 79.0199 51.8097 76.2062C51.7459 75.6932 52.1988 75.2241 52.7024 75.2617C55.531 75.4647 58.2015 75.3282 60.3321 73.0718L60.3452 73.0783Z",
    fill: "url(#paint17_linear_10106_6282)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.3385 73.0914C63.2183 70.0478 62.9418 65.5698 59.9113 62.6965C54.4473 57.5231 45.9994 60.4252 40.9546 61.3182C39.0497 61.6548 37.4892 63.3045 37.2537 65.2276C36.6333 70.3135 34.184 78.9069 39.6479 84.0802C42.6784 86.9536 47.1738 86.9875 50.0537 83.944C52.1712 81.7138 52.1787 79.0493 51.8359 76.2846C51.7753 75.7486 52.2411 75.2534 52.7872 75.2875C55.5798 75.4809 58.2242 75.3314 60.3418 73.1012L60.3385 73.0914Z",
    fill: "url(#paint18_linear_10106_6282)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M60.3223 73.1078C63.1956 70.0774 62.9322 65.6058 59.9181 62.7488C54.5754 57.6764 46.3297 60.4339 41.2785 61.3727C39.256 61.749 37.5978 63.4971 37.3268 65.5413C36.6573 70.6436 34.3511 79.0142 39.7036 84.0833C42.7177 86.9404 47.1869 86.9614 50.0602 83.9309C52.1517 81.7204 52.169 79.0853 51.846 76.3467C51.7755 75.7813 52.2739 75.2533 52.8429 75.2906C55.5897 75.4776 58.2308 75.3183 60.3223 73.1078Z",
    fill: "url(#paint19_linear_10106_6282)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M60.3159 73.1209C63.1794 70.0937 62.9226 65.6418 59.9282 62.8108C54.7003 57.8525 46.6731 60.4491 41.5959 61.4403C39.4461 61.8595 37.7 63.7027 37.4032 65.8647C36.6945 70.9802 34.5249 79.1411 39.7626 84.0962C42.7603 86.937 47.2164 86.9514 50.0832 83.9341C52.1584 81.74 52.1824 79.1244 51.8627 76.4283C51.7921 75.8303 52.3166 75.2826 52.9085 75.3231C55.6193 75.5003 58.2342 75.3281 60.3127 73.1438L60.3159 73.1209Z",
    fill: "url(#paint20_linear_10106_6282)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M60.2995 73.1373C63.1566 70.1232 62.9063 65.6909 59.9349 62.8631C54.8218 58.0188 47.0066 60.4676 41.9197 61.4948C39.6523 61.9536 37.8182 63.8919 37.4761 66.1783C36.7218 71.3201 34.6919 79.2485 39.805 84.0928C42.7863 86.9173 47.2195 86.9286 50.0863 83.9112C52.1387 81.7466 52.1791 79.1473 51.8694 76.4806C51.8019 75.8597 52.3492 75.2825 52.9738 75.3229C55.6486 75.4904 58.2504 75.3117 60.3028 73.1471L60.2995 73.1373Z",
    fill: "url(#paint21_linear_10106_6282)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M60.2931 73.1504C63.1501 70.1364 62.9065 65.7236 59.9416 62.9154C54.9434 58.1851 47.3467 60.473 42.2436 61.5493C39.8489 62.051 37.9268 64.0844 37.5524 66.5017C36.7589 71.6568 34.8755 79.3721 39.864 84.1057C42.8288 86.9139 47.2489 86.9187 50.106 83.9046C52.1421 81.7564 52.1891 79.1767 51.8926 76.5492C51.8152 75.8989 52.3853 75.2922 53.0425 75.3325C55.6814 75.4903 58.257 75.2986 60.2964 73.1602L60.2931 73.1504Z",
    fill: "url(#paint22_linear_10106_6282)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M60.2865 73.1635C63.1371 70.1626 62.8967 65.7596 59.958 62.9644C55.0811 58.3351 47.6899 60.4882 42.5674 61.6038C40.0551 62.1451 38.0451 64.2736 37.6351 66.812C36.7959 71.9934 35.0523 79.4761 39.9293 84.1054C42.8777 86.8974 47.2847 86.8957 50.1222 83.8882C52.1322 81.7597 52.1956 79.1963 51.9123 76.608C51.8348 75.925 52.431 75.2985 53.1209 75.3387C55.7238 75.4869 58.2862 75.2887 60.2963 73.1602L60.2865 73.1635Z",
    fill: "url(#paint23_linear_10106_6282)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M60.2669 73.1701C63.1077 70.1725 62.8837 65.7858 59.9517 63.0102C55.1895 58.4949 48.0168 60.4871 42.8781 61.6518C40.2418 62.2458 38.1405 64.4597 37.695 67.1191C36.8166 72.3137 35.2063 79.5769 39.9684 84.0922C42.9005 86.8678 47.2846 86.863 50.1254 83.8653C52.1224 81.763 52.1826 79.2225 51.9092 76.6636C51.8349 75.9577 52.4539 75.3017 53.1634 75.3353C55.7303 75.4738 58.2665 75.2626 60.2636 73.1603L60.2669 73.1701Z",
    fill: "url(#paint24_linear_10106_6282)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.2604 73.1832C63.0914 70.1889 62.8773 65.8316 59.9617 63.0723C55.3143 58.671 48.3634 60.5121 43.2052 61.7161C40.4546 62.3596 38.2621 64.6587 37.7712 67.4425C36.8472 72.6634 35.38 79.7039 40.0273 84.1051C42.943 86.8644 47.314 86.8531 50.145 83.8587C52.1159 81.7761 52.1925 79.2519 51.9323 76.7322C51.8579 75.9936 52.5029 75.3179 53.2354 75.3547C55.7663 75.4835 58.2894 75.2658 60.2604 73.1832Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5309 72.9502C58.1495 75.4657 55.2568 75.6552 51.6524 75.1573C52.3444 78.7316 52.305 81.6251 49.9236 84.1406C46.9623 87.2662 42.2118 87.22 38.8666 84.06C33.8453 79.2938 34.8809 72.2352 35.7249 66.5503C36.0926 64.0808 36.4091 61.9448 36.1101 60.5073L36.0836 60.429L36.1752 60.4417C37.6308 60.6494 39.7446 60.2205 42.1851 59.7252C47.811 58.5817 54.8156 57.159 59.8369 61.9252C63.1854 65.095 63.476 69.841 60.5113 72.9568L60.5309 72.9502ZM51.5081 75.0205L51.5899 75.0365C55.1976 75.5443 58.074 75.3712 60.4489 72.8687C63.3614 69.7924 63.0744 65.1215 59.775 62.0006C54.7931 57.2866 47.8277 58.6961 42.2214 59.833C39.8103 60.3184 37.7194 60.7504 36.2475 60.5592C36.5107 62.0197 36.2072 64.1294 35.8394 66.5663C35.005 72.2151 33.9628 79.2542 38.948 83.9779C42.2474 87.0989 46.9194 87.1388 49.8351 84.0722C52.2002 81.5731 52.22 78.6862 51.528 75.1119L51.5016 75.0336L51.5081 75.0205Z",
    fill: "url(#paint25_linear_10106_6282)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.937 73.5317C50.4259 76.018 50.502 78.2506 48.6842 80.1725C46.495 82.4815 43.003 82.382 40.599 80.1048C35.2629 75.052 39.284 66.2343 38.5859 62.7712C42.0857 63.2826 50.6788 58.8043 56.0018 63.8506C58.4058 66.1277 58.6856 69.6119 56.4963 71.9208C54.6785 73.8427 52.4424 73.8764 49.937 73.5317Z",
    fill: "url(#paint26_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.166 73.5636C50.0515 73.5476 49.9537 73.646 49.9738 73.7702C50.4199 76.1618 50.4369 78.3163 48.6744 80.1759C46.4852 82.4848 42.9933 82.3853 40.5892 80.1081C35.3449 75.1335 39.1477 66.5094 38.6093 62.9379C38.5927 62.8562 38.6677 62.7873 38.7462 62.7936C42.3469 63.1509 50.7477 58.8792 55.992 63.8539C58.396 66.1311 58.6758 69.6152 56.4866 71.9241C54.7241 73.7837 52.5634 73.8792 50.1562 73.5669L50.166 73.5636Z",
    fill: "url(#paint27_linear_10106_6282)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M50.2248 73.5765C50.0874 73.5573 49.9669 73.6852 49.9935 73.829C50.3872 76.1947 50.4368 78.3163 48.6907 80.1595C46.5112 82.4651 43.0324 82.3721 40.6579 80.1177C35.5153 75.2506 38.8545 66.8373 38.7181 63.2285C38.711 63.0454 38.8804 62.8683 39.057 62.8743C42.6693 62.8131 50.8855 59.0292 56.0216 63.9094C58.3961 66.1638 58.6692 69.6283 56.4898 71.9339C54.7436 73.7771 52.6155 73.8398 50.2346 73.5732L50.2248 73.5765Z",
    fill: "url(#paint28_linear_10106_6282)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M50.2806 73.5796C50.1236 73.567 49.9672 73.7179 50.0004 73.8813C50.3482 76.2078 50.4174 78.3229 48.6875 80.1497C46.5048 82.4455 43.0555 82.3753 40.7006 80.147C35.6663 75.3743 38.7935 67.1416 38.8109 63.5355C38.8132 63.251 39.0706 62.9788 39.3484 62.9616C42.9439 62.7533 51.0072 59.1955 56.0284 63.9616C58.3833 66.1899 58.64 69.6382 56.4573 71.934C54.7274 73.7608 52.6156 73.8071 50.2708 73.5829L50.2806 73.5796Z",
    fill: "url(#paint29_linear_10106_6282)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M50.3392 73.5924C50.1496 73.58 49.9802 73.7571 50.0102 73.9434C50.3252 76.2374 50.4074 78.3262 48.6938 80.1366C46.5209 82.4291 43.0879 82.3752 40.7593 80.1599C35.8365 75.4915 38.8041 67.4325 38.9097 63.8294C38.9215 63.4436 39.2766 63.0729 39.6492 63.0455C43.238 62.7524 51.1252 59.352 56.0481 64.0204C58.3767 66.2357 58.6235 69.6546 56.4506 71.9471C54.737 73.7575 52.6448 73.7972 50.3392 73.5924Z",
    fill: "url(#paint30_linear_10106_6282)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M50.3948 73.5955C50.1822 73.5799 49.99 73.7865 50.0169 73.9957C50.3089 76.2538 50.3878 78.3328 48.6872 80.117C46.5143 82.4095 43.1042 82.3588 40.7953 80.1696C35.9839 75.6054 38.8247 67.7201 38.999 64.1266C39.0235 63.6492 39.4633 63.1737 39.9405 63.1329C43.5192 62.7776 51.2434 59.5085 56.0645 64.0694C58.3735 66.2586 58.6039 69.6612 56.4408 71.9504C54.75 73.7313 52.6708 73.7775 50.3948 73.5955Z",
    fill: "url(#paint31_linear_10106_6282)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M50.4637 73.6051C50.2282 73.5863 50.0132 73.8224 50.0369 74.0544C50.3092 76.2865 50.3782 78.3361 48.707 80.1104C46.5405 82.3898 43.16 82.3619 40.8675 80.1889C36.1545 75.7225 38.8912 68.0142 39.1113 64.427C39.1454 63.8482 39.6764 63.2874 40.2548 63.2233C43.8235 62.806 51.3847 59.6683 56.0976 64.1347C58.3869 66.2978 58.6009 69.6841 56.4345 71.9635C54.76 73.728 52.7004 73.7676 50.467 73.6149L50.4637 73.6051Z",
    fill: "url(#paint32_linear_10106_6282)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M50.5192 73.6082C50.2641 73.596 50.023 73.8518 50.0435 74.1067C50.2928 76.3029 50.3683 78.3394 48.7101 80.0875C46.5534 82.3636 43.186 82.3422 40.923 80.192C36.3215 75.8299 38.9411 68.2919 39.2168 64.7078C39.2701 64.0243 39.889 63.3684 40.559 63.2844C44.1242 62.8246 51.5158 59.7986 56.1172 64.1608C58.3803 66.3109 58.5844 69.6678 56.4278 71.9439C54.7695 73.692 52.7296 73.725 50.5257 73.5951L50.5192 73.6082Z",
    fill: "url(#paint33_linear_10106_6282)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.5781 73.6211C50.3002 73.6057 50.0232 73.8845 50.0536 74.1688C50.2799 76.329 50.3488 78.346 48.7068 80.0777C46.5502 82.3538 43.2089 82.3454 40.9656 80.2213C36.4757 75.9634 38.9913 68.6023 39.2996 65.0181C39.3657 64.2431 40.0726 63.492 40.8438 63.3848C44.4057 62.8825 51.6178 59.9715 56.1175 64.2262C58.3608 66.3502 58.5486 69.6908 56.3919 71.9669C54.75 73.6986 52.733 73.7348 50.5585 73.6277L50.5781 73.6211Z",
    fill: "url(#paint34_linear_10106_6282)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M50.6337 73.6241C50.3231 73.6088 50.0331 73.9139 50.0701 74.2178C50.2832 76.3388 50.339 78.3493 48.7231 80.0613C46.573 82.3243 43.2481 82.3322 41.0343 80.2309C36.6428 76.0707 39.0674 68.893 39.4183 65.3054C39.5036 64.4257 40.292 63.5926 41.1743 63.4589C44.7327 62.9141 51.7752 60.1148 56.1667 64.275C58.3806 66.3763 58.5617 69.6973 56.4115 71.9603C54.7859 73.6756 52.782 73.7183 50.6533 73.6175L50.6337 73.6241Z",
    fill: "url(#paint35_linear_10106_6282)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M50.6926 73.637C50.3624 73.6283 50.0463 73.953 50.0801 74.2799C50.28 76.3617 50.3292 78.3526 48.7296 80.0482C46.5893 82.3079 43.2808 82.3321 41.0834 80.2471C36.8034 76.1911 39.1142 69.1936 39.5076 65.6026C39.6154 64.628 40.4918 63.6999 41.4655 63.5462C45.0205 62.9589 51.8934 60.2714 56.1734 64.3273C58.3709 66.4123 58.5323 69.7072 56.3821 71.9702C54.7826 73.6658 52.7918 73.715 50.6926 73.637Z",
    fill: "url(#paint36_linear_10106_6282)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M50.7481 73.6401C50.3949 73.6282 50.0561 73.9825 50.0867 74.3322C50.2669 76.388 50.3094 78.3592 48.7229 80.0286C46.5825 82.2883 43.3068 82.3124 41.1291 80.2535C36.9605 76.3018 39.1673 69.4812 39.6032 65.8867C39.7303 64.8074 40.6881 63.7973 41.7598 63.6106C45.3147 62.9906 52.018 60.4148 56.1865 64.3665C58.3642 66.4254 58.5093 69.704 56.3689 71.9638C54.7823 73.6331 52.8079 73.6986 50.7545 73.627L50.7481 73.6401Z",
    fill: "url(#paint37_linear_10106_6282)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M50.807 73.653C50.431 73.6379 50.0694 74.0216 50.1001 74.404C50.267 76.4206 50.303 78.3723 48.7327 80.0253C46.5989 82.2719 43.3428 82.322 41.1913 80.2761C37.131 76.4189 39.237 69.785 39.7089 66.2002C39.8586 65.026 40.8978 63.9339 42.0675 63.7142C45.6288 63.0484 52.1428 60.5909 56.2097 64.4351C58.3579 66.4712 58.4963 69.7302 56.3526 71.9801C54.7824 73.6331 52.8308 73.7018 50.8037 73.6432L50.807 73.653Z",
    fill: "url(#paint38_linear_10106_6282)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M50.8627 73.6561C50.4573 73.6509 50.0794 74.051 50.1069 74.4563C50.2606 76.4337 50.2835 78.3789 48.7295 80.0155C46.5957 82.2621 43.3625 82.3154 41.234 80.3054C37.2754 76.5557 39.2872 70.0954 39.8016 66.5072C39.9836 65.2349 41.0912 64.0542 42.3622 63.8113C45.9234 63.1128 52.2645 60.7573 56.2231 64.507C58.3549 66.5268 58.4736 69.7597 56.3398 72.0063C54.7858 73.6429 52.8473 73.7181 50.8693 73.6757L50.8627 73.6561Z",
    fill: "url(#paint39_linear_10106_6282)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M50.9214 73.669C50.4931 73.6606 50.0925 74.0902 50.1168 74.5184C50.2606 76.4664 50.2638 78.3855 48.7359 80.0024C46.6118 82.2457 43.3951 82.3153 41.2928 80.3183C37.4456 76.6728 39.3535 70.3894 39.9103 66.7978C40.115 65.4306 41.304 64.1679 42.6696 63.8822C46.2274 63.1412 52.3989 60.8974 56.246 64.5428C58.3483 66.5399 58.4604 69.7532 56.3363 71.9965C54.8085 73.6134 52.8864 73.7049 50.9312 73.6657L50.9214 73.669Z",
    fill: "url(#paint40_linear_10106_6282)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.977 73.672C50.5291 73.6703 50.1023 74.1196 50.1235 74.5707C50.2541 76.4795 50.254 78.3888 48.7391 79.9795C46.6215 82.2097 43.4211 82.2956 41.3385 80.3247C37.5996 76.7737 39.4198 70.6834 39.9962 67.0852C40.2333 65.6198 41.5038 64.2751 42.9576 63.9597C46.5152 63.186 52.5138 61.0441 56.2527 64.5951C58.3353 66.5661 58.4212 69.7664 56.3036 71.9966C54.792 73.5971 52.8831 73.6951 50.977 73.672Z",
    fill: "url(#paint41_linear_10106_6282)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M51.0359 73.6849C50.5651 73.68 50.1156 74.1588 50.1433 74.6295C50.2509 76.5024 50.2442 78.3921 48.7489 79.9762C46.6313 82.2064 43.467 82.302 41.4007 80.3474C37.7635 76.9039 39.4895 70.9872 40.1084 67.3856C40.3778 65.822 41.72 64.3986 43.2717 64.0502C46.8391 63.2405 52.6451 61.2072 56.2823 64.6506C58.3485 66.6053 58.4147 69.7795 56.3069 72.0065C54.8083 73.5807 52.9256 73.6917 51.0457 73.6816L51.0359 73.6849Z",
    fill: "url(#paint42_linear_10106_6282)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M51.0915 73.688C50.5913 73.693 50.1255 74.1882 50.15 74.6818C50.2477 76.5253 50.2344 78.3954 48.7521 79.9533C46.6443 82.1802 43.493 82.2823 41.4563 80.3504C37.9306 77.0112 39.5559 71.2812 40.2042 67.6698C40.5059 66.0079 41.9231 64.5157 43.5695 64.1244C47.1367 63.282 52.7698 61.3506 56.2955 64.6898C58.3322 66.6217 58.3918 69.7763 56.284 72.0033C54.8017 73.5612 52.9354 73.6884 51.0915 73.688Z",
    fill: "url(#paint43_linear_10106_6282)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M51.1504 73.7009C50.6273 73.7026 50.1354 74.2176 50.16 74.7438C50.2445 76.5482 50.2148 78.402 48.7585 79.9402C46.6573 82.154 43.5257 82.2822 41.5054 80.3666C38.0879 77.1218 39.6157 71.5883 40.3032 67.9636C40.6373 66.2036 42.1261 64.6327 43.8672 64.1985C47.4442 63.3202 52.8945 61.494 56.312 64.7388C58.329 66.6445 58.3722 69.7829 56.2709 71.9968C54.8147 73.5349 52.9615 73.6686 51.1536 73.678L51.1504 73.7009Z",
    fill: "url(#paint44_linear_10106_6282)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M51.2159 73.7007C50.6732 73.709 50.1552 74.2437 50.1767 74.7928C50.248 76.558 50.2051 78.4053 48.7652 79.9271C46.6639 82.1409 43.5553 82.2723 41.5677 80.3893C38.2618 77.2488 39.6856 71.8922 40.409 68.2772C40.7755 66.419 42.3491 64.7758 44.175 64.3021C47.7584 63.378 53.0326 61.6766 56.3353 64.8074C58.3261 66.7002 58.3594 69.8091 56.2581 72.023C54.8182 73.5447 52.978 73.685 51.2061 73.704L51.2159 73.7007Z",
    fill: "url(#paint45_linear_10106_6282)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M51.2747 73.7136C50.6993 73.722 50.1683 74.2828 50.1865 74.8549C50.2479 76.5907 50.1952 78.4086 48.7715 79.914C46.6801 82.1245 43.5878 82.2722 41.6167 80.4055C38.4124 77.3725 39.7453 72.1993 40.508 68.5711C40.9199 66.6212 42.552 64.8928 44.476 64.3861C48.0592 63.4293 53.1507 61.8332 56.3549 64.8661C58.326 66.7328 58.3429 69.8255 56.2515 72.0361C54.8278 73.5414 53.0139 73.6946 51.2747 73.7136Z",
    fill: "url(#paint46_linear_10106_6282)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M51.3336 73.7264C50.7387 73.7415 50.1816 74.322 50.1966 74.917C50.2448 76.6136 50.179 78.425 48.7683 79.9042C46.6736 82.1049 43.6173 82.2623 41.6659 80.4217C38.5731 77.4929 39.7955 72.5097 40.5973 68.8683C41.0416 66.8202 42.7487 65.0229 44.7673 64.4734C48.3602 63.4806 53.269 61.9897 56.3617 64.9184C58.3131 66.759 58.3136 69.8355 56.2189 72.0362C54.8115 73.5252 53.0107 73.6848 51.3107 73.7232L51.3336 73.7264Z",
    fill: "url(#paint47_linear_10106_6282)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.3892 73.7295C50.7714 73.7414 50.1915 74.3514 50.2165 74.9758C50.2646 76.6397 50.179 78.425 48.7879 79.8976C46.703 82.095 43.6631 82.2686 41.7379 80.441C38.7533 77.6067 39.8783 72.82 40.7193 69.1654C41.2091 67.0256 42.978 65.1529 45.088 64.5508C48.6906 63.522 53.4166 62.1363 56.4012 64.9706C58.3264 66.7982 58.317 69.8452 56.232 72.0427C54.8474 73.5021 53.0663 73.6879 51.4023 73.736L51.3892 73.7295Z",
    fill: "white"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5423 71.9599C54.7897 73.8162 52.6553 73.9574 50.0125 73.5935C50.5149 76.2171 50.4829 78.3553 48.7269 80.2018C46.5377 82.5107 43.0263 82.4833 40.5567 80.1409C36.8506 76.6225 37.6145 71.4119 38.2412 67.2186C38.513 65.4032 38.7464 63.8299 38.5304 62.7681L38.5039 62.6897L38.5955 62.7025C39.6618 62.8559 41.2268 62.5466 43.0237 62.1809C47.1696 61.3399 52.3348 60.2862 56.0507 63.8013C58.5204 66.1437 58.7413 69.6476 56.5521 71.9566L56.5423 71.9599ZM49.8584 73.46L49.9401 73.4761C52.5863 73.8497 54.7141 73.7216 56.4505 71.8817C58.5909 69.622 58.3734 66.1932 55.953 63.8998C52.2863 60.4335 47.1569 61.4642 43.0339 62.3084C41.2664 62.6641 39.7342 62.9733 38.6451 62.8495C38.835 63.931 38.6015 65.4716 38.3427 67.2608C37.7257 71.4181 36.965 76.6058 40.6219 80.0753C43.0423 82.3688 46.4784 82.3998 48.6188 80.1401C50.3552 78.3002 50.3709 76.1783 49.8554 73.5483L49.829 73.4699L49.8584 73.46Z",
    fill: "url(#paint48_linear_10106_6282)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2218 71.906C48.5312 73.5037 48.5883 74.9354 47.4122 76.1719C46.0049 77.6609 43.7553 77.59 42.2172 76.1337C38.7866 72.8825 41.3699 67.2114 40.9244 64.9832C43.1748 65.3157 48.6935 62.43 52.1241 65.6813C53.6656 67.1473 53.8529 69.3861 52.4422 70.8653C51.2661 72.1018 49.8343 72.1262 48.2185 71.8962L48.2218 71.906Z",
    fill: "url(#paint49_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6339 71.9635C48.4312 71.9446 48.2618 72.1217 48.2951 72.3177C48.5386 73.7521 48.4841 75.047 47.4155 76.1817C46.0082 77.6707 43.7587 77.5998 42.2205 76.1436C38.9047 73.0063 41.2078 67.6043 40.9645 65.2316C40.9477 65.1172 41.0455 65.0188 41.1665 65.0217C43.5437 65.1477 48.8116 62.5539 52.1274 65.6911C53.6689 67.1571 53.8562 69.396 52.4456 70.8751C51.3737 72.0001 50.0827 72.1189 48.6339 71.9635Z",
    fill: "url(#paint50_linear_10106_6282)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M48.7385 71.9501C48.4835 71.9378 48.2652 72.1642 48.2955 72.4158C48.4701 73.8079 48.4678 75.0634 47.4188 76.1588C46.0179 77.6347 43.7848 77.5801 42.2597 76.1303C39.0029 73.0387 41.1756 67.7351 41.0401 65.3588C41.0331 65.2084 41.1536 65.0805 41.304 65.0735C43.6742 65.0819 48.861 62.6354 52.1242 65.714C53.6493 67.1637 53.83 69.383 52.4292 70.8588C51.3899 71.951 50.138 72.0238 48.7319 71.9305L48.7385 71.9501Z",
    fill: "url(#paint51_linear_10106_6282)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M48.8365 71.9497C48.5259 71.9344 48.262 72.2198 48.2892 72.527C48.418 73.88 48.4351 75.0962 47.4285 76.1555C46.0374 77.6281 43.8174 77.58 42.3087 76.1465C39.1044 73.1135 41.1858 67.8953 41.1191 65.5286C41.1119 65.3455 41.2748 65.1815 41.4579 65.1743C43.8246 65.1076 48.9234 62.7562 52.1277 65.7892C53.6364 67.2226 53.8007 69.4256 52.4096 70.8981C51.4029 71.9575 50.1967 72.004 48.8267 71.9531L48.8365 71.9497Z",
    fill: "url(#paint52_linear_10106_6282)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M48.9314 71.9396C48.5685 71.931 48.2558 72.2656 48.2897 72.6251C48.3823 73.9357 48.419 75.1126 47.4351 76.1424C46.0408 77.6052 43.8469 77.5701 42.3547 76.1529C39.2127 73.1753 41.2126 68.0391 41.2014 65.6754C41.204 65.4564 41.3897 65.2628 41.6021 65.2458C43.9622 65.1267 48.9795 62.8574 52.1214 65.835C53.6137 67.2521 53.7714 69.4355 52.3804 70.908C51.4063 71.9346 50.2295 71.9712 48.9118 71.9462L48.9314 71.9396Z",
    fill: "url(#paint53_linear_10106_6282)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M49.036 71.9262C48.6208 71.9243 48.269 72.3047 48.2867 72.7133C48.3531 73.9783 48.3863 75.1127 47.4481 76.1162C46.0636 77.5757 43.8926 77.5437 42.407 76.1462C39.3273 73.224 41.2589 68.1762 41.2935 65.8189C41.2959 65.5672 41.5142 65.3409 41.7691 65.3204C44.1225 65.1491 49.055 62.9519 52.1445 65.8708C53.6203 67.2717 53.7747 69.4453 52.3902 70.9047C51.4487 71.8985 50.3111 71.9219 49.036 71.9262Z",
    fill: "url(#paint54_linear_10106_6282)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M49.1341 71.9259C48.6666 71.9307 48.2659 72.3603 48.2805 72.8245C48.3239 74.0536 48.3635 75.1422 47.4448 76.1064C46.07 77.5626 43.9122 77.5371 42.4527 76.1526C39.4256 73.289 41.2986 68.3265 41.379 65.9756C41.3911 65.6878 41.6322 65.432 41.9198 65.4115C44.2599 65.2009 49.1175 63.0727 52.1447 65.9362C53.6041 67.3208 53.7421 69.4781 52.3674 70.9342C51.4585 71.8952 50.3535 71.9185 49.1276 71.939L49.1341 71.9259Z",
    fill: "url(#paint55_linear_10106_6282)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M49.2385 71.9124C48.7187 71.924 48.2692 72.4028 48.2807 72.9226C48.3076 74.1027 48.3373 75.1619 47.4609 76.09C46.0927 77.5331 43.9479 77.5141 42.5049 76.1459C39.5367 73.3279 41.3545 68.4603 41.4676 66.1093C41.4796 65.7889 41.7532 65.5003 42.0702 65.4698C44.4102 65.2266 49.1765 63.1509 52.1446 65.9689C53.5877 67.3372 53.7191 69.4749 52.3508 70.918C51.4745 71.8461 50.4153 71.8758 49.2254 71.9059L49.2385 71.9124Z",
    fill: "url(#paint56_linear_10106_6282)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.3334 71.9023C48.7646 71.9304 48.2629 72.4486 48.2811 73.0207C48.2948 74.1616 48.3211 75.1783 47.4675 76.0769C46.0992 77.52 43.9774 77.5042 42.5507 76.1523C39.6351 73.3929 41.4041 68.6073 41.5532 66.266C41.5749 65.9095 41.8713 65.5914 42.2308 65.5575C44.5609 65.2849 49.2489 63.2684 52.1645 66.0277C53.5912 67.3797 53.716 69.4978 52.3477 70.9408C51.504 71.8362 50.4775 71.8658 49.3367 71.9121L49.3334 71.9023Z",
    fill: "url(#paint57_linear_10106_6282)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M49.4313 71.902C48.8103 71.9368 48.2728 72.5107 48.2716 73.1221C48.2785 74.2107 48.2851 75.2013 47.4739 76.0638C46.1121 77.4938 44.0067 77.4943 42.5964 76.1587C39.7431 73.4547 41.4633 68.751 41.6353 66.4128C41.6667 66.0204 41.9892 65.6826 42.3748 65.629C44.695 65.327 49.3014 63.3598 52.1547 66.0637C53.565 67.3994 53.6865 69.5077 52.3247 70.9377C51.5136 71.8002 50.5231 71.8395 49.428 71.8922L49.4313 71.902Z",
    fill: "url(#paint58_linear_10106_6282)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M49.5361 71.8886C48.8627 71.93 48.2764 72.5532 48.2721 73.2201C48.2658 74.2696 48.2689 75.2177 47.4773 76.0409C46.1253 77.4676 44.033 77.4746 42.6391 76.1552C39.848 73.5066 41.5097 68.8881 41.7177 66.5596C41.7489 66.1345 42.104 65.7639 42.5321 65.7069C44.8457 65.3853 49.3705 63.4674 52.1616 66.116C53.5555 67.4354 53.6606 69.5274 52.3086 70.9541C51.53 71.7838 50.5755 71.8328 49.5263 71.8919L49.5361 71.8886Z",
    fill: "url(#paint59_linear_10106_6282)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M49.6309 71.8784C48.9053 71.9266 48.2798 72.5957 48.2626 73.3215C48.2496 74.3187 48.2331 75.2407 47.4838 76.0278C46.1416 77.4512 44.0624 77.4647 42.6849 76.1616C39.943 73.5619 41.5724 69.0415 41.7999 66.7065C41.8409 66.2454 42.2188 65.8453 42.6762 65.7784C44.9897 65.4241 49.4232 63.5588 52.165 66.1585C53.5425 67.4616 53.641 69.534 52.2988 70.9574C51.5495 71.7445 50.6343 71.813 49.6309 71.8784Z",
    fill: "url(#paint60_linear_10106_6282)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M49.7354 71.865C48.9608 71.9297 48.2832 72.6382 48.2629 73.4196C48.2367 74.3776 48.2135 75.2473 47.4903 76.0147C46.1448 77.4283 44.0917 77.4548 42.7372 76.1549C40.0576 73.6106 41.6382 69.1721 41.8821 66.8534C41.9361 66.366 42.3466 65.9331 42.8334 65.8563C45.1403 65.4824 49.4922 63.6664 52.1717 66.2108C53.5328 67.4976 53.6247 69.5504 52.2792 70.964C51.5625 71.7183 50.6833 71.7965 49.7387 71.8748L49.7354 71.865Z",
    fill: "url(#paint61_linear_10106_6282)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M49.8335 71.8647C49.0066 71.9361 48.2899 72.6904 48.2632 73.5177C48.2303 74.4234 48.1873 75.267 47.5032 75.9885C46.1675 77.3988 44.1341 77.4187 42.7894 76.1482C40.1624 73.6625 41.7072 69.3124 41.9708 66.9871C42.0344 66.4638 42.4677 66.0014 42.984 65.9146C45.2842 65.5211 49.5512 63.7447 52.1685 66.2336C53.5132 67.5042 53.5886 69.5407 52.2627 70.9477C51.5786 71.6692 50.7354 71.757 49.8367 71.8418L49.8335 71.8647Z",
    fill: "url(#paint62_linear_10106_6282)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M49.9282 71.8546C49.0523 71.9425 48.2965 72.7427 48.2537 73.619C48.2174 74.4823 48.1612 75.2867 47.4999 75.9787C46.1707 77.3759 44.1536 77.4121 42.8254 76.1579C40.2606 73.7276 41.7567 69.4594 42.0465 67.147C42.1198 66.5877 42.5792 66.1056 43.1346 66.0057C45.4283 65.5926 49.6137 63.8654 52.1785 66.2957C53.5067 67.55 53.5789 69.5767 52.2497 70.9739C51.5982 71.6626 50.791 71.7601 49.938 71.8512L49.9282 71.8546Z",
    fill: "url(#paint63_linear_10106_6282)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.0329 71.8411C49.0982 71.9489 48.3098 72.7819 48.2541 73.7171C48.2046 74.5412 48.1352 75.3064 47.5163 75.9623C46.1969 77.3562 44.1929 77.3989 42.8811 76.161C40.3655 73.7795 41.8293 69.6095 42.1386 67.2906C42.2216 66.6953 42.7038 66.1837 43.2886 66.0738C45.5855 65.6378 49.6665 63.9568 52.182 66.3382C53.4939 67.5762 53.5594 69.5833 52.24 70.9772C51.6211 71.6331 50.8532 71.7501 50.0427 71.8378L50.0329 71.8411Z",
    fill: "url(#paint64_linear_10106_6282)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M50.1309 71.8408C49.1472 71.965 48.3165 72.8342 48.2479 73.8283C48.1916 74.6 48.1123 75.3359 47.5162 75.9623C46.1968 77.3562 44.2157 77.4021 42.917 76.1706C40.4637 73.8446 41.8787 69.7565 42.2143 67.4505C42.3103 66.829 42.8152 66.2879 43.4294 66.1681C45.7164 65.7028 49.7191 64.0808 52.1723 66.4069C53.4678 67.6286 53.5267 69.6161 52.2074 71.01C51.621 71.6331 50.8891 71.7598 50.1244 71.8539L50.1309 71.8408Z",
    fill: "url(#paint65_linear_10106_6282)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M50.2353 71.8274C49.2027 71.9681 48.3328 72.8832 48.2481 73.9264C48.1884 74.6556 48.0861 75.3556 47.529 75.9361C46.2161 77.3169 44.2515 77.3791 42.9691 76.1639C40.5782 73.8932 41.9477 69.8968 42.3061 67.594C42.4118 66.9366 42.9428 66.3757 43.593 66.233C45.8733 65.748 49.7912 64.1656 52.1919 66.433C53.4743 67.6482 53.5135 69.6096 52.2039 71.0002C51.6403 71.5938 50.9542 71.7269 50.2353 71.8274Z",
    fill: "url(#paint66_linear_10106_6282)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M50.3303 71.8172C49.2487 71.9745 48.3463 72.9224 48.2453 74.0147C48.1822 74.7014 48.0668 75.3622 47.5324 75.9132C46.2293 77.2907 44.2778 77.3594 43.0216 76.1572C40.6832 73.9452 42.0171 70.0372 42.3951 67.7278C42.5105 67.0343 43.0643 66.444 43.7471 66.3011C46.0339 65.8031 49.8571 64.2635 52.1955 66.4755C53.4615 67.6743 53.4975 69.626 52.1911 70.9937C51.66 71.5545 51.0132 71.7071 50.3368 71.8041L50.3303 71.8172Z",
    fill: "url(#paint67_linear_10106_6282)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M50.4283 71.8169C49.2913 72.0038 48.366 72.9812 48.2391 74.1258C48.1726 74.7701 48.0308 75.3852 47.5422 75.9099C46.2456 77.2743 44.3104 77.3593 43.0707 76.1734C40.7912 74.007 42.0829 70.2004 42.4839 67.8942C42.6089 67.1648 43.1888 66.5547 43.9075 66.3888C46.1877 65.8712 49.9261 64.3711 52.2055 66.5376C53.4551 67.7201 53.4844 69.6522 52.178 71.0199C51.6796 71.5479 51.0688 71.7102 50.4381 71.8136L50.4283 71.8169Z",
    fill: "url(#paint68_linear_10106_6282)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M50.5328 71.8035C49.35 72.0167 48.3922 73.0268 48.2393 74.2239C48.1694 74.8257 48.0144 75.4016 47.5485 75.8968C46.2519 77.2612 44.3364 77.3396 43.1163 76.1798C40.8894 74.072 42.1421 70.3441 42.566 68.0411C42.704 67.2854 43.3067 66.6459 44.0548 66.4701C46.3382 65.9295 49.9818 64.4723 52.2121 66.5899C53.4452 67.7561 53.4582 69.6719 52.1714 71.033C51.7055 71.5282 51.134 71.7099 50.5459 71.81L50.5328 71.8035Z",
    fill: "url(#paint69_linear_10106_6282)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M50.6277 71.7934C49.3992 72.0329 48.4088 73.0758 48.2299 74.3253C48.1468 74.8879 47.9786 75.4246 47.5518 75.874C46.265 77.235 44.3724 77.3166 43.1556 76.1666C40.991 74.1142 42.1983 70.4779 42.6352 68.1814C42.7829 67.3898 43.4117 66.7305 44.1957 66.5317C46.4725 65.9716 50.0346 64.5637 52.1992 66.6161C53.4159 67.7661 53.4223 69.6622 52.1355 71.0233C51.6989 71.4759 51.1765 71.6738 50.6243 71.7836L50.6277 71.7934Z",
    fill: "url(#paint70_linear_10106_6282)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.7356 71.7897C49.455 72.0687 48.4516 73.1378 48.2401 74.4201C48.1536 74.9402 47.9722 75.4377 47.5682 75.8576C46.2879 77.2055 44.4116 77.3034 43.2113 76.1697C41.109 74.1726 42.2708 70.6281 42.7273 68.325C42.888 67.5071 43.5396 66.8184 44.3529 66.6097C46.6231 66.0299 50.1037 64.6713 52.206 66.6684C53.4063 67.802 53.4061 69.6786 52.1291 71.0364C51.7251 71.4562 51.242 71.6736 50.7323 71.7799L50.7356 71.7897Z",
    fill: "white"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4783 70.9077C51.3511 72.095 49.9783 72.1977 48.2873 71.9712C48.6035 73.6538 48.5852 75.0237 47.4482 76.2143C46.0409 77.7033 43.7752 77.6814 42.178 76.1796C39.7904 73.9188 40.2826 70.5563 40.6822 67.8578C40.8548 66.6868 41.0051 65.6761 40.8655 65.003L40.8424 64.9345L40.9209 64.9407C41.6078 65.0365 42.6108 64.8403 43.7641 64.6043C46.4398 64.0624 49.7592 63.3909 52.1468 65.6518C53.7375 67.1667 53.8758 69.422 52.4685 70.911L52.4783 70.9077ZM48.1561 71.8409L48.2248 71.8504C49.9191 72.0867 51.2886 72.0069 52.3996 70.836C53.7678 69.393 53.6362 67.1899 52.0816 65.7174C49.7268 63.4891 46.4401 64.1605 43.784 64.6958C42.6601 64.9218 41.68 65.1213 40.9768 65.0419C41.0903 65.7346 40.9432 66.7224 40.7803 67.8574C40.3839 70.533 39.8915 73.8628 42.2431 76.0813C43.7977 77.5539 45.998 77.5759 47.3629 76.123C48.4738 74.9522 48.4823 73.5856 48.153 71.8965L48.1299 71.8279L48.1561 71.8409Z",
    fill: "url(#paint71_linear_10106_6282)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7951 70.5541C46.9515 71.3741 46.9802 72.1064 46.3775 72.7459C45.6543 73.5133 44.5066 73.4747 43.7097 72.7287C41.9485 71.064 43.2791 68.1498 43.0464 67.0064C44.1945 67.1758 47.0339 65.6951 48.7853 67.3631C49.5724 68.1124 49.6743 69.2563 48.9511 70.0237C48.3484 70.6633 47.6096 70.6723 46.7853 70.5574L46.7951 70.5541Z",
    fill: "url(#paint72_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0569 70.5859C46.9326 70.5732 46.8185 70.688 46.8386 70.8122C46.9489 71.5278 46.9151 72.172 46.3775 72.7459C45.6543 73.5133 44.5067 73.4747 43.7097 72.7287C41.9977 71.1128 43.2046 68.3168 43.0599 67.1109C43.0532 67.0586 43.0956 67.0225 43.1381 67.0191C44.3447 67.1034 47.0733 65.7473 48.7853 67.3631C49.5725 68.1124 49.6744 69.2563 48.9512 70.0237C48.4104 70.5879 47.7698 70.6619 47.0471 70.5892L47.0569 70.5859Z",
    fill: "url(#paint73_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.96,
    d: "M47.0701 70.5924C46.936 70.583 46.822 70.6978 46.8355 70.8351C46.9392 71.5311 46.9087 72.1851 46.3777 72.7459C45.6609 73.5002 44.5362 73.4648 43.7523 72.7253C42.0863 71.1485 43.1756 68.4248 43.1095 67.2252C43.1026 67.1402 43.1743 67.0615 43.2626 67.0645C44.4624 67.0637 47.1228 65.8288 48.7922 67.4154C49.576 68.1549 49.6615 69.2825 48.9546 70.0335C48.4334 70.5911 47.7797 70.6586 47.0701 70.5924Z",
    fill: "url(#paint74_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.91,
    d: "M47.0894 70.5858C46.9423 70.5699 46.8217 70.6978 46.8386 70.8449C46.9292 71.5344 46.8987 72.1884 46.3839 72.7328C45.677 73.4838 44.5751 73.4515 43.8044 72.7185C42.1842 71.1809 43.1921 68.5392 43.1587 67.3394C43.1615 67.2185 43.256 67.1103 43.3835 67.1C44.5734 67.0699 47.1621 65.9137 48.792 67.4481C49.5628 68.1811 49.6482 69.276 48.9413 70.027C48.4265 70.5715 47.7729 70.639 47.0861 70.576L47.0894 70.5858Z",
    fill: "url(#paint75_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87,
    d: "M47.0994 70.5825C46.9424 70.5699 46.8154 70.7109 46.8355 70.8678C46.9195 71.5377 46.8923 72.2015 46.3841 72.7328C45.6837 73.4707 44.6145 73.4384 43.8471 72.7151C42.2597 71.21 43.2155 68.6404 43.2083 67.4537C43.2077 67.2902 43.3445 67.1459 43.4982 67.1487C44.6815 67.099 47.2017 65.9986 48.7891 67.5037C49.5566 68.2269 49.6354 69.3022 48.9349 70.0401C48.4267 70.5715 47.7731 70.6391 47.1027 70.5923L47.0994 70.5825Z",
    fill: "url(#paint76_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.83,
    d: "M47.1189 70.5759C46.9521 70.5666 46.8153 70.7109 46.8388 70.8776C46.9063 71.5312 46.8791 72.195 46.3905 72.7197C45.6999 73.4543 44.6503 73.4154 43.8993 72.7084C42.3578 71.2424 43.2615 68.7449 43.2674 67.5647C43.2667 67.3685 43.4361 67.1914 43.629 67.181C44.8057 67.1116 47.251 66.0801 48.7989 67.5331C49.5533 68.2498 49.632 69.2924 48.9413 70.0271C48.4429 70.5551 47.7958 70.6096 47.1287 70.5726L47.1189 70.5759Z",
    fill: "url(#paint77_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.79,
    d: "M47.1289 70.5726C46.9523 70.5666 46.809 70.724 46.8226 70.894C46.8869 71.5378 46.8597 72.2016 46.3775 72.7132C45.6836 73.438 44.67 73.4087 43.9288 72.6985C42.4234 71.2749 43.2751 68.8495 43.2941 67.6757C43.3031 67.4436 43.4953 67.237 43.7306 67.2231C44.8909 67.1375 47.2775 66.1585 48.7829 67.5822C49.5208 68.2826 49.606 69.3121 48.9219 70.0337C48.4397 70.5453 47.7828 70.6031 47.1386 70.5693L47.1289 70.5726Z",
    fill: "url(#paint78_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74,
    d: "M47.1517 70.5757C46.9751 70.5698 46.8122 70.7338 46.8292 70.9136C46.8868 71.5378 46.8629 72.2114 46.3873 72.7099C45.7032 73.4314 44.7092 73.3955 43.9843 72.7016C42.5249 71.317 43.3245 68.9637 43.3565 67.7965C43.3621 67.5218 43.5902 67.2922 43.855 67.2684C45.012 67.173 47.3301 66.2499 48.7896 67.6344C49.5242 68.325 49.5995 69.3252 48.9153 70.0467C48.4397 70.5453 47.7828 70.603 47.1517 70.5757Z",
    fill: "url(#paint79_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M47.1614 70.5724C46.975 70.5698 46.8121 70.7338 46.8226 70.9267C46.8736 71.5313 46.8399 72.2082 46.3839 72.7001C45.7095 73.4183 44.7483 73.3823 44.0234 72.6884C42.6098 71.3429 43.3574 69.0617 43.4025 67.9009C43.4178 67.5903 43.6687 67.3312 43.9726 67.2942C45.1166 67.1923 47.3629 66.3151 48.7863 67.6573C49.5078 68.3415 49.5863 69.3187 48.9086 70.0271C48.4428 70.5224 47.7825 70.5704 47.1679 70.5593L47.1614 70.5724Z",
    fill: "url(#paint80_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.66,
    d: "M47.1811 70.5659C46.9816 70.5567 46.8155 70.7436 46.8259 70.9365C46.8737 71.5313 46.84 72.2082 46.3905 72.687C45.7226 73.3921 44.7842 73.3593 44.066 72.685C42.6885 71.3819 43.3938 69.1695 43.4422 68.0185C43.4574 67.6752 43.7376 67.3735 44.0873 67.3429C45.2279 67.2312 47.4058 66.4098 48.7833 67.7129C49.4917 68.3906 49.5701 69.3351 48.9022 70.0403C48.4527 70.5191 47.7826 70.5704 47.1909 70.5626L47.1811 70.5659Z",
    fill: "url(#paint81_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61,
    d: "M47.1908 70.5626C46.9815 70.5567 46.8056 70.7469 46.8194 70.9496C46.8605 71.5248 46.8301 72.2115 46.3773 72.6805C45.7192 73.3824 44.8004 73.3429 44.0986 72.6849C42.767 71.4209 43.4202 69.2805 43.4818 68.1361C43.5067 67.7568 43.8096 67.4255 44.1887 67.385C45.3162 67.2668 47.4223 66.4915 48.7637 67.7522C49.4688 68.4201 49.5373 69.3352 48.8694 70.0404C48.4264 70.5061 47.7596 70.5672 47.1777 70.5561L47.1908 70.5626Z",
    fill: "url(#paint82_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.57,
    d: "M47.2137 70.5657C46.9946 70.5632 46.8089 70.7567 46.8293 70.979C46.8638 71.5346 46.8237 72.2246 46.3904 72.687C45.729 73.379 44.8462 73.3493 44.1542 72.688C42.8587 71.4663 43.4795 69.3915 43.5443 68.2568C43.5691 67.8448 43.9046 67.4808 44.3262 67.4369C45.4504 67.3089 47.4881 66.5893 48.7835 67.811C49.4756 68.4723 49.5472 69.3646 48.8859 70.0567C48.4526 70.5191 47.7826 70.5704 47.2137 70.5657Z",
    fill: "url(#paint83_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M47.2236 70.5624C46.9948 70.5632 46.8026 70.7698 46.8131 70.9954C46.8444 71.5412 46.8042 72.2312 46.3774 72.6805C45.7259 73.3692 44.8724 73.3296 44.187 72.6878C42.9374 71.5053 43.5061 69.5026 43.5743 68.3777C43.6054 67.9199 43.9671 67.5362 44.4278 67.479C45.5389 67.3445 47.5146 66.6677 48.7642 67.8503C49.4496 68.492 49.5146 69.3647 48.8631 70.0535C48.4363 70.5028 47.7663 70.5541 47.2236 70.5624Z",
    fill: "url(#paint84_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49,
    d: "M47.243 70.5558C47.0044 70.5599 46.8122 70.7665 46.8163 71.0051C46.8409 71.5314 46.804 72.2312 46.3837 72.6674C45.7387 73.343 44.9082 73.3066 44.2358 72.6713C43.0322 71.5278 43.5488 69.5972 43.63 68.4788C43.6709 67.985 44.0651 67.5685 44.5487 67.5146C45.6566 67.3703 47.5539 66.7526 48.7674 67.8928C49.4397 68.528 49.508 69.3778 48.8629 70.0534C48.4524 70.4864 47.7759 70.5508 47.243 70.5558Z",
    fill: "url(#paint85_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44,
    d: "M47.2528 70.5525C47.0044 70.5599 46.8024 70.7698 46.8097 71.0182C46.8311 71.5347 46.7844 72.2378 46.3804 72.6576C45.7451 73.3299 44.9375 73.2967 44.2783 72.6679C43.1107 71.5668 43.5851 69.705 43.6794 68.5931C43.7202 68.0666 44.1469 67.6173 44.6698 67.5501C45.7645 67.3994 47.5999 66.8243 48.7675 67.9255C49.4267 68.5542 49.4948 69.3713 48.8498 70.047C48.4491 70.4766 47.7693 70.5312 47.2495 70.5427L47.2528 70.5525Z",
    fill: "url(#paint86_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M47.2726 70.5459C47.0241 70.5533 46.8058 70.7796 46.8132 71.028C46.8279 71.5249 46.7813 72.228 46.3871 72.6445C45.7616 73.3135 44.9834 73.2704 44.3274 72.6514C43.2058 71.5894 43.6281 69.7997 43.7257 68.6976C43.7761 68.1351 44.229 67.6661 44.7779 67.5792C45.8694 67.4186 47.6363 66.8994 48.758 67.9615C49.4139 68.5804 49.4754 69.3779 48.8369 70.0405C48.4427 70.457 47.7661 70.5214 47.266 70.5263L47.2726 70.5459Z",
    fill: "url(#paint87_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M47.2857 70.5524C47.0274 70.5631 46.7994 70.7927 46.81 71.0509C46.8182 71.5282 46.765 72.2444 46.3871 72.6445C45.7583 73.3037 45.0161 73.2703 44.3733 72.6578C43.2975 71.6348 43.6677 69.9172 43.7818 68.8314C43.8419 68.2329 44.3175 67.7344 44.909 67.6442C45.9873 67.4771 47.6825 67.0039 48.7713 68.0333C49.4141 68.6458 49.4658 69.4139 48.8468 70.0699C48.4689 70.47 47.7826 70.5377 47.2988 70.5589L47.2857 70.5524Z",
    fill: "url(#paint88_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31,
    d: "M47.3052 70.5458C47.0372 70.5598 46.8124 70.7992 46.8166 71.0705C46.8214 71.538 46.7682 72.2542 46.3968 72.6412C45.7779 73.2971 45.0552 73.257 44.4255 72.6511C43.3825 71.6607 43.7236 70.0184 43.8409 68.9424C43.9107 68.3079 44.4091 67.7799 45.0398 67.6764C46.1148 67.4995 47.7415 67.0821 48.7811 68.0627C49.4207 68.6654 49.4624 69.4041 48.8532 70.0568C48.4818 70.4438 47.7988 70.5213 47.3248 70.5392L47.3052 70.5458Z",
    fill: "url(#paint89_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27,
    d: "M47.3151 70.5425C47.0372 70.5598 46.8027 70.8025 46.8004 71.087C46.7986 71.5349 46.7454 72.251 46.3838 72.6347C45.7713 73.2776 45.0716 73.2407 44.4484 72.6543C43.4514 71.703 43.7404 70.1328 43.861 69.0666C43.9405 68.3961 44.4617 67.8386 45.125 67.735C46.1903 67.5614 47.7419 67.1803 48.7488 68.1282C49.3719 68.7146 49.4201 69.4403 48.8076 70.0831C48.446 70.4668 47.7597 70.5345 47.3086 70.5556L47.3151 70.5425Z",
    fill: "url(#paint90_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M47.3346 70.5359C47.0469 70.5565 46.8025 70.8025 46.8035 71.0967C46.7985 71.5348 46.7355 72.2543 46.3902 72.6216C45.7875 73.2612 45.1204 73.2242 44.4973 72.6378C43.5364 71.7289 43.7864 70.2372 43.9168 69.1677C44.006 68.4613 44.5533 67.884 45.2525 67.7574C46.3144 67.5741 47.7976 67.2487 48.7552 68.1478C49.3653 68.7277 49.4134 69.4207 48.8107 70.0602C48.4556 70.4308 47.7725 70.5083 47.3312 70.5261L47.3346 70.5359Z",
    fill: "url(#paint91_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19,
    d: "M47.3478 70.5424C47.0504 70.5663 46.8093 70.8221 46.8005 71.1196C46.7986 71.5348 46.7291 72.2674 46.3903 72.6216C45.7941 73.248 45.15 73.2142 44.5432 72.6441C43.6282 71.7743 43.8261 70.3548 43.9697 69.2918C44.0685 68.5493 44.6386 67.9426 45.3803 67.8126C46.4389 67.6194 47.8503 67.3401 48.7654 68.2099C49.3721 68.78 49.4136 69.4533 48.8174 70.0798C48.4786 70.434 47.776 70.5181 47.3609 70.5489L47.3478 70.5424Z",
    fill: "url(#paint92_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14,
    d: "M47.3673 70.5358C47.0601 70.563 46.8092 70.8221 46.8037 71.1294C46.7985 71.5348 46.7258 72.2576 46.3967 72.6085C45.8006 73.235 45.1891 73.201 44.5955 72.6374C43.7263 71.8067 43.882 70.4559 44.019 69.406C44.1276 68.6276 44.7238 68.0011 45.4916 67.8515C46.5371 67.6518 47.88 67.4282 48.7556 68.2459C49.3493 68.8095 49.3906 69.4501 48.8043 70.0733C48.4752 70.4242 47.7726 70.5083 47.3771 70.5325L47.3673 70.5358Z",
    fill: "url(#paint93_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M47.377 70.5325C47.0599 70.563 46.8026 70.8352 46.7971 71.1425C46.7853 71.5283 46.706 72.2642 46.3835 72.602C45.7971 73.2252 45.2052 73.1846 44.6247 72.6275C43.7917 71.8392 43.9051 70.5572 44.0552 69.5138C44.1734 68.6993 44.7924 68.0434 45.5994 67.8805C46.6416 67.6711 47.9128 67.4935 48.7458 68.2819C49.3263 68.839 49.3709 69.4568 48.7812 70.0701C48.4587 70.4079 47.7561 70.492 47.3737 70.5227L47.377 70.5325Z",
    fill: "white"
  })))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9838 70.0563C48.4039 70.6664 47.7045 70.7275 46.8443 70.6029C47.0041 71.4655 46.9868 72.1586 46.4102 72.7785C45.687 73.5459 44.5166 73.5367 43.6868 72.7582C42.4537 71.5919 42.719 69.7896 42.9205 68.478C43.0133 67.8794 43.0901 67.3626 43.017 67.0163L43.0005 66.9673L43.0659 66.967C43.4093 67.0149 43.9222 66.9184 44.5234 66.7922C45.8204 66.5295 47.6075 66.1672 48.8407 67.3335C49.6606 68.1154 49.7364 69.279 49.0034 70.0497L48.9838 70.0563ZM46.7394 70.5183L46.795 70.5214C47.665 70.6427 48.3612 70.6044 48.9215 70.0009C49.622 69.263 49.5495 68.1419 48.7624 67.3926C47.562 66.2589 45.8762 66.598 44.5171 66.8706C43.9454 66.987 43.4455 67.09 43.0923 67.0454C43.1458 67.3983 43.0755 67.902 42.9859 68.4777C42.7813 69.845 42.5352 71.5426 43.7291 72.6894C44.5162 73.4387 45.6442 73.4512 46.3446 72.7133C46.918 72.1164 46.9124 71.42 46.7526 70.5575L46.7361 70.5085L46.7394 70.5183Z",
    fill: "url(#paint94_linear_10106_6282)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5689 84.8998C55.3115 82.2263 54.4295 79.5125 53.241 77.0547C53.1225 76.8001 53.37 76.5312 53.6352 76.6382C56.1529 77.6988 58.9081 78.4284 61.586 78.5404C61.8508 78.5493 61.9794 78.866 61.7937 79.0595L56.086 85.0746C55.9003 85.2681 55.5796 85.158 55.5558 84.8933L55.5689 84.8998Z",
    fill: "url(#paint95_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 76,
    width: 9,
    height: 10
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5689 84.8998C55.3115 82.2263 54.4295 79.5125 53.241 77.0547C53.1225 76.8001 53.37 76.5312 53.6352 76.6382C56.1529 77.6988 58.9081 78.4284 61.586 78.5404C61.8508 78.5493 61.9794 78.866 61.7937 79.0595L56.086 85.0746C55.9003 85.2681 55.5796 85.158 55.5558 84.8933L55.5689 84.8998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10106_6282)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8757 79.141L56.168 85.156C56.054 85.2708 55.894 85.3139 55.7336 85.2588C55.5732 85.2038 55.4747 85.0733 55.461 84.9034C55.2239 82.4195 54.4236 79.7218 53.1464 77.0975C53.0706 76.9376 53.0995 76.7642 53.22 76.6363C53.3405 76.5084 53.5137 76.4719 53.6774 76.5367C56.3718 77.6686 59.1137 78.3264 61.5955 78.439C61.7622 78.4483 61.9031 78.5426 61.9657 78.6961C62.0186 78.8528 61.9962 79.0131 61.8822 79.1279L61.8757 79.141ZM53.3709 76.7927C53.322 76.8419 53.2962 76.927 53.339 77.0217C54.6262 79.6753 55.4363 82.4025 55.6768 84.8961C55.6836 84.9811 55.7263 85.0431 55.8114 85.0689C55.8867 85.0981 55.9651 85.0717 56.0237 85.0192L61.7314 79.0042C61.7868 78.9419 61.8028 78.8601 61.7699 78.7948C61.7435 78.7164 61.6747 78.6742 61.5864 78.6712C59.0753 78.5685 56.3105 77.9075 53.5899 76.7626C53.4884 76.7204 53.4133 76.7566 53.3644 76.8058L53.3709 76.7927Z",
    fill: "url(#paint96_linear_10106_6282)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6453 110.351C56.8224 110.628 55.8801 110.422 55.2439 109.829L8.55378 65.5625C8.09135 65.1292 7.82454 64.5319 7.80936 63.9042C7.79087 63.2668 8.02424 62.6644 8.45751 62.202L36.4028 32.7304C36.6537 32.4713 36.9472 32.2742 37.2737 32.1423C38.1226 31.8125 39.1074 32.0152 39.7633 32.6341L86.4501 76.8911C86.9125 77.3244 87.1794 77.9218 87.1945 78.5494C87.213 79.1869 86.9797 79.7892 86.5464 80.2516L58.6109 109.72C58.36 109.979 58.0665 110.176 57.74 110.308C57.7106 110.318 57.6812 110.328 57.6518 110.338L57.6453 110.351ZM37.4114 32.2595C37.4114 32.2595 37.3526 32.2793 37.3233 32.2892C37.0131 32.4047 36.7391 32.5952 36.5045 32.838L8.58212 62.3127C8.17164 62.7457 7.95775 63.3087 7.97282 63.9037C7.98789 64.4986 8.2382 65.047 8.66132 65.4608L55.3481 109.718C55.9582 110.298 56.8807 110.478 57.6741 110.177C57.9843 110.062 58.2583 109.871 58.4929 109.629L86.4284 80.1605C86.8389 79.7276 87.0528 79.1645 87.0377 78.5696C87.0226 77.9746 86.7723 77.4262 86.3394 77.0157L39.6624 32.7554C39.072 32.2016 38.1887 32.0084 37.4245 32.266L37.4114 32.2595Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 31,
    width: 81,
    height: 80
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4039 32.7173L8.46233 62.1997C7.55898 63.1529 7.59936 64.6579 8.55253 65.5612L55.2561 109.824C56.2093 110.727 57.7143 110.687 58.6176 109.734L86.5592 80.2514C87.4626 79.2982 87.4222 77.7932 86.469 76.8899L39.7655 32.6271C38.8123 31.7238 37.3073 31.7641 36.4039 32.7173Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.2559 81.092L59.9008 101.441C58.7815 102.069 57.3678 101.662 56.7397 100.543L24.5601 43.0389C23.9319 41.9197 24.3391 40.506 25.4584 39.8778L61.8036 19.5321C62.9229 18.9039 64.3366 19.3111 64.9648 20.4304L97.1541 77.9308C97.7823 79.0501 97.3751 80.4638 96.2559 81.092Z",
    fill: "#F3F3F3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.2299 81.1117L59.9268 101.356C58.8075 101.984 57.384 101.58 56.7656 100.458L24.7104 42.9992C24.0822 41.88 24.4861 40.4565 25.6087 39.8381L61.9216 19.5906C63.0409 18.9624 64.4644 19.3663 65.0828 20.4888L97.1248 77.9407C97.753 79.06 97.3491 80.4835 96.2266 81.1019L96.2299 81.1117Z",
    fill: "#E7E7E7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M96.1907 81.1249L59.9331 101.277C58.8138 101.906 57.3903 101.502 56.7686 100.369L24.8738 42.966C24.2456 41.8467 24.6495 40.4232 25.7819 39.8015L62.0297 19.6523C63.149 19.0241 64.5725 19.428 65.1942 20.5604L97.089 77.9637C97.7172 79.083 97.3133 80.5065 96.1809 81.1282L96.1907 81.1249Z",
    fill: "#DBDBDB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M96.1611 81.1348L59.9554 101.183C58.8231 101.804 57.4094 101.397 56.7877 100.265L25.0337 42.9229C24.412 41.7906 24.8192 40.3769 25.9417 39.7585L62.1474 19.7107C63.2798 19.0891 64.6935 19.4962 65.3119 20.6188L97.0692 77.9703C97.6909 79.1027 97.2837 80.5164 96.1513 81.1381L96.1611 81.1348Z",
    fill: "#CECECE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M96.1352 81.1545L59.9848 101.107C58.8524 101.729 57.4387 101.322 56.817 100.189L25.1972 42.8897C24.5755 41.7573 24.9827 40.3436 26.1151 39.7219L62.2622 19.7594C63.3945 19.1377 64.8082 19.5449 65.4299 20.6773L97.04 77.9802C97.6617 79.1126 97.2545 80.5263 96.1221 81.148L96.1352 81.1545Z",
    fill: "#C2C2C2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M96.0959 81.1677L59.9974 101.016C58.8651 101.637 57.4481 101.22 56.8264 100.088L25.3473 42.85C24.7256 41.7176 25.1426 40.3006 26.275 39.6789L62.3702 19.8212C63.5025 19.1995 64.9195 19.6165 65.5412 20.7488L97.0105 77.9901C97.6322 79.1225 97.2152 80.5395 96.0828 81.1612L96.0959 81.1677Z",
    fill: "#B6B6B6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M96.0666 81.1776L60.0103 100.924C58.8779 101.546 57.4511 101.132 56.8392 99.9964L25.5074 42.8069C24.8857 41.6746 25.2994 40.2478 26.4351 39.6359L62.4881 19.8796C63.6205 19.2579 65.0473 19.6716 65.669 20.804L96.9909 77.9967C97.6126 79.1291 97.1989 80.5559 96.0633 81.1678L96.0666 81.1776Z",
    fill: "#AAAAAA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M96.0305 81.2006L60.0295 100.852C58.8971 101.474 57.467 101.05 56.8453 99.9179L25.6707 42.7737C25.049 41.6413 25.4725 40.2112 26.6048 39.5895L62.6059 19.9381C63.7382 19.3164 65.1683 19.7399 65.79 20.8722L96.9745 78.0131C97.5962 79.1455 97.1727 80.5756 96.0403 81.1973L96.0305 81.2006Z",
    fill: "#9E9E9E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M96.0012 81.2105L60.0521 100.757C58.9197 101.379 57.4896 100.955 56.8646 99.8132L25.8307 42.7307C25.2058 41.5885 25.6325 40.1682 26.7747 39.5432L62.714 19.9998C63.8562 19.3748 65.2765 19.8016 65.9015 20.9438L96.9386 78.0361C97.5636 79.1783 97.1369 80.5986 95.9947 81.2236L96.0012 81.2105Z",
    fill: "#929292"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M95.9653 81.2335L60.0715 100.685C58.926 101.3 57.5057 100.874 56.884 99.7412L25.981 42.6909C25.3658 41.5454 25.7926 40.1251 26.925 39.5034L62.8319 20.0583C63.9774 19.4431 65.3977 19.8699 66.0194 21.0022L96.9191 78.0427C97.5343 79.1882 97.1075 80.6085 95.9751 81.2302L95.9653 81.2335Z",
    fill: "#868686"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M95.936 81.2434L60.0843 100.594C58.9388 101.209 57.5185 100.782 56.8935 99.6399L26.1444 42.6577C25.5292 41.5122 25.956 40.0919 27.0982 39.4669L62.9498 20.1167C64.0953 19.5015 65.5156 19.9283 66.1406 21.0705L96.893 78.0625C97.5082 79.2079 97.0814 80.6282 95.9393 81.2532L95.936 81.2434Z",
    fill: "#797979"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M95.8967 81.2566L60.1003 100.512C58.9548 101.127 57.5214 100.694 56.9062 99.5483L26.3044 42.6146C25.6892 41.4692 26.1225 40.0358 27.2679 39.4206L63.0578 20.1785C64.2033 19.5633 65.6367 19.9966 66.2519 21.142L96.8635 78.0724C97.4787 79.2178 97.0455 80.6512 95.9 81.2664L95.8967 81.2566Z",
    fill: "#6D6D6D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M95.8707 81.2763L60.1262 100.427C58.9807 101.042 57.5473 100.609 56.9321 99.4632L26.4645 42.5716C25.8493 41.4261 26.2826 39.9927 27.428 39.3775L63.1758 20.2369C64.3212 19.6217 65.7546 20.055 66.3698 21.2005L96.8342 78.0823C97.4494 79.2277 97.0161 80.6611 95.8707 81.2763Z",
    fill: "#616161"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M95.8315 81.2895L60.139 100.335C58.9936 100.95 57.5602 100.517 56.9417 99.3618L26.6181 42.5417C26.0029 41.3962 26.4362 39.9628 27.5914 39.3443L63.2937 20.2954C64.4392 19.6802 65.8726 20.1135 66.4911 21.2687L96.818 78.0987C97.4332 79.2441 96.9999 80.6775 95.8446 81.296L95.8315 81.2895Z",
    fill: "#555555"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M95.8055 81.3092L60.1585 100.263C58.9999 100.872 57.5763 100.435 56.9578 99.28L26.7782 42.4986C26.1597 41.3434 26.6061 39.9164 27.7614 39.2979L63.4019 20.3571C64.5605 19.7484 65.9841 20.185 66.6026 21.3403L96.7822 78.1217C97.3909 79.2802 96.9543 80.7038 95.799 81.3223L95.8055 81.3092Z",
    fill: "#494949"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M95.7663 81.3225L60.1713 100.172C59.0127 100.78 57.5891 100.344 56.9706 99.1884L26.9383 42.4556C26.3296 41.297 26.7662 39.8734 27.9214 39.2549L63.5165 20.4058C64.675 19.7971 66.0987 20.2337 66.7172 21.3889L96.7593 78.1185C97.368 79.277 96.9314 80.7007 95.7761 81.3192L95.7663 81.3225Z",
    fill: "#3D3D3D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M95.7369 81.3324L60.1971 100.086C59.0385 100.695 57.6018 100.252 56.9931 99.0935L27.1016 42.4223C26.4929 41.2638 26.9359 39.8271 28.0945 39.2184L63.6343 20.4643C64.7929 19.8555 66.2296 20.2986 66.8383 21.4572L96.7298 78.1284C97.3385 79.287 96.8954 80.7237 95.7369 81.3324Z",
    fill: "#313131"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M95.7011 81.3554L60.2034 100.008C59.0449 100.617 57.6082 100.174 56.9995 99.0151L27.2519 42.3826C26.6432 41.224 27.0863 39.7873 28.2448 39.1786L63.7425 20.526C64.9011 19.9173 66.3378 20.3604 66.9465 21.5189L96.7005 78.1383C97.3092 79.2969 96.8661 80.7336 95.7076 81.3423L95.7011 81.3554Z",
    fill: "#242424"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M95.6716 81.3653L60.2259 99.9131C59.0674 100.522 57.6274 100.069 57.0187 98.9104L27.4119 42.3396C26.8032 41.181 27.2561 39.741 28.4146 39.1323L63.8603 20.5845C65.0189 19.9757 66.4589 20.4286 67.0676 21.5872L96.6744 78.158C97.2831 79.3166 96.8302 80.7566 95.6716 81.3653Z",
    fill: "#181818"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M63.9719 20.6417L28.5774 39.0959C27.413 39.7031 26.9612 41.1393 27.5683 42.3037L57.0348 98.8193C57.642 99.9838 59.0781 100.436 60.2426 99.8284L95.637 81.3742C96.8015 80.7671 97.2533 79.3309 96.6462 78.1665L67.1796 21.6509C66.5725 20.4864 65.1363 20.0346 63.9719 20.6417Z",
    fill: "#0C0C0C"
  })))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2886 20.2108L28.2381 38.9272C27.0725 39.5323 26.6182 40.9677 27.2233 42.1332L56.8722 99.2415C57.4773 100.407 58.9127 100.861 60.0782 100.256L96.1288 81.5399C97.2943 80.9348 97.7486 79.4994 97.1435 78.3339L67.4946 21.2256C66.8895 20.06 65.4541 19.6057 64.2886 20.2108Z",
    fill: "url(#paint97_linear_10106_6282)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2916 43.7943L33.5891 44.7741L33.1355 45.0143L31.684 40.1577L32.3987 39.7859L35.5407 43.7672L35.0479 44.0206L34.4175 43.2184L33.3047 43.8008L33.2916 43.7943ZM33.1364 43.3339L34.122 42.8271L32.3031 40.5382L33.1397 43.3437L33.1364 43.3339Z",
    fill: "#ED1B23"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4467 46.5952C37.8391 47.7382 37.4833 48.851 37.3274 50.1363C36.2334 49.545 35.0258 49.1665 33.7862 49.017C34.3938 47.874 34.7497 46.7612 34.9055 45.4759C35.9995 46.0672 37.2071 46.4457 38.4467 46.5952Z",
    fill: "url(#paint98_linear_10106_6282)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9168 73.8524C86.5244 72.7094 86.8803 71.5967 87.0362 70.3113C88.1301 70.9026 89.3377 71.2811 90.5773 71.4306C89.9698 72.5736 89.6139 73.6864 89.458 74.9717C88.364 74.3804 87.1564 74.0019 85.9168 73.8524Z",
    fill: "url(#paint99_linear_10106_6282)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0523 73.4382C62.7062 70.3732 56.0003 68.2478 49.0361 67.104C52.1301 60.6498 54.1811 54.1763 55.3606 47.1237C61.7068 50.1886 68.4127 52.3141 75.3769 53.4579C72.2829 59.9121 70.2318 66.3856 69.0523 73.4382Z",
    fill: "url(#paint100_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 47,
    width: 27,
    height: 27
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3769 53.4579C68.4225 52.3108 61.7101 50.1984 55.3606 47.1237C54.1811 54.1763 52.1334 60.6596 49.0361 67.104C55.9905 68.2511 62.7029 70.3634 69.0523 73.4382C70.2318 66.3856 72.2795 59.9023 75.3769 53.4579Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0523 73.4382C62.7061 70.3732 56.0002 68.2478 49.036 67.104C52.1138 60.6989 54.1552 54.2613 55.3414 47.2611C55.351 47.1924 55.426 47.1562 55.4882 47.1788C61.8016 50.2112 68.4682 52.3172 75.3735 53.4481C72.2795 59.9023 70.2284 66.3758 69.049 73.4284L69.0523 73.4382Z",
    fill: "url(#paint101_linear_10106_6282)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M69.1148 73.5589C62.7686 70.494 56.0627 68.3685 49.0986 67.2247C52.1634 60.8459 54.1689 54.4313 55.3878 47.4636C55.4038 47.3491 55.5246 47.2866 55.6294 47.3386C61.9262 50.322 68.5536 52.4411 75.436 53.5689C72.342 60.023 70.291 66.4966 69.1115 73.5491L69.1148 73.5589Z",
    fill: "url(#paint102_linear_10106_6282)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M69.1805 73.6895C62.8343 70.6245 56.1284 68.4991 49.1643 67.3553C52.2161 61.0026 54.2086 54.6142 55.4375 47.6759C55.4631 47.5255 55.6296 47.4366 55.7703 47.4983C62.0573 50.4523 68.6422 52.5749 75.5017 53.6994C72.4077 60.1536 70.3567 66.6271 69.1772 73.6797L69.1805 73.6895Z",
    fill: "url(#paint103_linear_10106_6282)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M69.2431 73.8102C62.8969 70.7453 56.191 68.6198 49.2268 67.476C52.2656 61.1496 54.2549 54.7841 55.4839 47.8785C55.516 47.6822 55.7281 47.5671 55.9115 47.658C62.1689 50.5892 68.7375 52.6955 75.5643 53.8202C72.4703 60.2743 70.4192 66.7479 69.2398 73.8004L69.2431 73.8102Z",
    fill: "url(#paint104_linear_10106_6282)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M69.3057 73.931C62.9595 70.866 56.2536 68.7406 49.2894 67.5968C52.3153 61.2965 54.2916 54.9572 55.5338 48.0908C55.5722 47.8488 55.8333 47.7171 56.0527 47.8177C62.2938 50.7326 68.8263 52.8293 75.6269 53.9409C72.5329 60.3951 70.4819 66.8686 69.3024 73.9212L69.3057 73.931Z",
    fill: "url(#paint105_linear_10106_6282)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M69.3683 74.0517C63.0221 70.9868 56.3162 68.8613 49.352 67.7175C52.3649 61.4434 54.338 55.1271 55.5803 48.2934C55.6284 48.0153 55.9352 47.8574 56.2037 47.9741C62.4152 50.8663 68.9314 52.9466 75.6993 54.0584C72.6053 60.5125 70.5542 66.9861 69.3748 74.0386L69.3683 74.0517Z",
    fill: "url(#paint106_linear_10106_6282)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M69.4308 74.1725C63.0846 71.1075 56.3787 68.9821 49.4145 67.8383C52.4144 61.5904 54.3843 55.2969 55.6169 48.4992C55.6714 48.1754 56.0239 47.9911 56.3317 48.1274C62.5268 51.0032 69.007 53.0739 75.752 54.1824C72.658 60.6366 70.6069 67.1101 69.4275 74.1627L69.4308 74.1725Z",
    fill: "url(#paint107_linear_10106_6282)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.4932 74.2932C63.1471 71.2283 56.4411 69.1028 49.477 67.959C52.4639 61.7374 54.4339 55.4766 55.6666 48.7115C55.7373 48.3386 56.129 48.1411 56.476 48.2969C62.6417 51.1499 69.0956 53.2076 75.8178 54.313C72.7237 60.7671 70.6727 67.2407 69.4932 74.2932Z",
    fill: "url(#paint108_linear_10106_6282)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M69.5557 74.414C63.2095 71.3491 56.5036 69.2236 49.5394 68.0798C52.5134 61.8843 54.4802 55.6464 55.713 48.9141C55.7934 48.5052 56.2274 48.2716 56.6138 48.4468C62.7532 51.2869 69.1908 53.3282 75.8769 54.4239C72.7829 60.8781 70.7319 67.3516 69.5524 74.4042L69.5557 74.414Z",
    fill: "url(#paint109_linear_10106_6282)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M69.6182 74.5348C63.2721 71.4698 56.5661 69.3444 49.602 68.2006C52.5629 62.0313 54.5298 55.8261 55.7595 49.1166C55.8462 48.6619 56.3293 48.4118 56.7516 48.5968C62.8747 51.4205 69.2762 53.4522 75.9362 54.5349C72.8421 60.9891 70.7911 67.4626 69.6116 74.5152L69.6182 74.5348Z",
    fill: "url(#paint110_linear_10106_6282)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M69.6807 74.6555C63.3345 71.5906 56.6286 69.4651 49.6644 68.3213C52.6124 62.1782 54.5761 55.9959 55.8092 49.329C55.9023 48.8284 56.4343 48.5618 56.896 48.7663C62.9895 51.5672 69.3747 53.5826 76.0052 54.6752C72.9112 61.1294 70.8602 67.6029 69.6807 74.6555Z",
    fill: "url(#paint111_linear_10106_6282)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M69.7434 74.7763C63.3972 71.7113 56.6913 69.5859 49.7272 68.4421C52.6621 62.3252 54.6227 56.1658 55.8558 49.5315C55.9586 48.995 56.533 48.6923 57.034 48.9162C63.1013 51.7042 69.4603 53.7066 76.0548 54.7895C72.9608 61.2437 70.9098 67.7172 69.7303 74.7698L69.7434 74.7763Z",
    fill: "url(#paint112_linear_10106_6282)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M69.8092 74.9068C63.463 71.8419 56.7571 69.7164 49.7929 68.5726C52.7149 62.4819 54.6755 56.3552 55.9055 49.7438C56.0147 49.1615 56.6381 48.8423 57.1783 49.0857C63.2195 51.8607 69.5588 53.837 76.1206 54.92C73.0266 61.3742 70.9756 67.8477 69.7961 74.9003L69.8092 74.9068Z",
    fill: "url(#paint113_linear_10106_6282)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M69.8718 75.0276C63.5256 71.9626 56.8197 69.8372 49.8555 68.6934C52.7645 62.6289 54.7219 56.5251 55.9553 49.9562C56.0742 49.3379 56.74 48.9826 57.3195 49.2454C63.341 51.9944 69.6475 53.9708 76.1832 55.0408C73.0892 61.495 71.0381 67.9685 69.8587 75.0211L69.8718 75.0276Z",
    fill: "url(#paint114_linear_10106_6282)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.9341 75.1483C63.5879 72.0834 56.882 69.9579 49.9179 68.8141C52.8138 62.7758 54.7714 56.7047 56.0016 50.1587C56.1269 49.4946 56.8416 49.1228 57.4605 49.4052C63.4557 52.1411 69.7328 54.0947 76.2488 55.1713C73.1548 61.6255 71.1038 68.0991 69.9243 75.1516L69.9341 75.1483Z",
    fill: "url(#paint115_linear_10106_6282)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M69.9967 75.2691C63.6505 72.2041 56.9446 70.0787 49.9804 68.9349C52.8732 62.9195 54.8276 56.8713 56.0481 50.3613C56.1797 49.6514 56.9435 49.2631 57.5983 49.5551C63.5673 52.278 69.828 54.2154 76.3081 55.2823C73.2141 61.7365 71.163 68.21 69.9836 75.2626L69.9967 75.2691Z",
    fill: "url(#paint116_linear_10106_6282)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M70.0593 75.3898C63.7131 72.3249 57.0072 70.1994 50.043 69.0556C52.9228 63.0664 54.874 57.0411 56.0979 50.5736C56.2393 49.8277 57.0454 49.4033 57.7428 49.7246C63.6857 52.4346 69.9169 54.3491 76.374 55.4129C73.28 61.867 71.229 68.3406 70.0495 75.3931L70.0593 75.3898Z",
    fill: "url(#paint117_linear_10106_6282)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M70.1218 75.5106C63.7757 72.4456 57.0697 70.3202 50.1056 69.1764C52.9724 63.2134 54.9237 57.2207 56.1444 50.7761C56.2921 49.9845 57.1472 49.5435 57.8807 49.8745C63.8038 52.5584 70.0121 54.4697 76.4332 55.5238C73.3392 61.978 71.2882 68.4515 70.1087 75.5041L70.1218 75.5106Z",
    fill: "url(#paint118_linear_10106_6282)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M70.1844 75.6313C63.8382 72.5664 57.1323 70.4409 50.1681 69.2971C53.0219 63.3603 54.9831 57.3971 56.1909 50.9787C56.3483 50.151 57.249 49.6838 58.0185 50.0245C63.9089 52.7084 70.0975 54.5937 76.4958 55.6446C73.4018 62.0987 71.3507 68.5723 70.1713 75.6248L70.1844 75.6313Z",
    fill: "url(#paint119_linear_10106_6282)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M70.2469 75.7521C63.9007 72.6871 57.1948 70.5617 50.2306 69.4179C53.0715 63.5073 55.0295 57.5669 56.2373 51.1812C56.4109 50.3045 57.3476 49.8142 58.1596 50.1842C64.0304 52.8421 70.1829 54.7176 76.5583 55.7653C73.4643 62.2195 71.4133 68.693 70.2338 75.7456L70.2469 75.7521Z",
    fill: "url(#paint120_linear_10106_6282)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M70.3093 75.8728C63.9631 72.8079 57.2572 70.6824 50.293 69.5386C53.1209 63.6542 55.0659 57.7401 56.287 51.3936C56.467 50.471 57.4526 49.9642 58.3104 50.3406C64.155 52.9855 70.2911 54.8448 76.6305 55.8828C73.5365 62.3369 71.4855 68.8105 70.306 75.863L70.3093 75.8728Z",
    fill: "url(#paint121_linear_10106_6282)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.3718 75.9936C64.0257 72.9286 57.3197 70.8032 50.3556 69.6594C53.1704 63.8012 55.1156 57.9197 56.3334 51.5961C56.5231 50.6376 57.5511 50.0947 58.4515 50.5003C64.2666 53.1224 70.3766 54.9687 76.693 56.0035C73.599 62.4577 71.548 68.9312 70.3685 75.9838L70.3718 75.9936Z",
    fill: "white"
  })))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1182 73.5687L69.0167 73.5266C62.6836 70.4681 55.9646 68.3362 49.0266 67.2054L48.9219 67.1861L48.9641 67.0846C52.0386 60.6697 54.1058 54.1471 55.2821 47.1174L55.3014 47.0127L55.4029 47.0549C61.7359 50.1134 68.455 52.2453 75.3929 53.3761L75.4976 53.3954L75.4554 53.4969C72.3809 59.9117 70.3072 66.4475 69.1374 73.464L69.1182 73.5687ZM49.1699 67.0479C56.0458 68.1888 62.7124 70.2947 68.9931 73.3272C70.1631 66.376 72.2109 59.8927 75.2594 53.5302C68.3835 52.3894 61.7169 50.2834 55.4362 47.251C54.2695 54.2119 52.2185 60.6855 49.1699 67.0479Z",
    fill: "url(#paint122_linear_10106_6282)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0512 55.1789C66.8535 54.3234 61.8363 52.7415 57.0914 50.446C56.2068 55.7191 54.6766 60.5661 52.3618 65.383C57.5595 66.2385 62.5767 67.8203 67.3216 70.1158C68.2062 64.8428 69.7364 59.9958 72.0512 55.1789Z",
    fill: "url(#paint123_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 50,
    width: 21,
    height: 21
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0512 55.1789C66.8535 54.3234 61.8363 52.7415 57.0914 50.446C56.2068 55.7191 54.6766 60.5661 52.3618 65.383C57.5595 66.2385 62.5767 67.8203 67.3216 70.1158C68.2062 64.8428 69.7364 59.9958 72.0512 55.1789Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10106_6282)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.0511 55.1789C66.8763 54.3266 61.882 52.7479 57.1535 50.4687C57.1273 50.4557 57.0881 50.4689 57.0882 50.5016C56.2068 55.7518 54.6798 60.5759 52.3715 65.3797C57.5692 66.2352 62.5864 67.817 67.3313 70.1125C68.2159 64.8395 69.7461 59.9925 72.0609 55.1756L72.0511 55.1789Z",
    fill: "url(#paint124_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.0874 55.254C66.9485 54.4114 62.0065 52.7933 57.2815 50.5893C57.2029 50.5503 57.1115 50.6029 57.0955 50.6847C56.1517 55.8795 54.6835 60.6838 52.398 65.4581C57.5957 66.3135 62.6129 67.8954 67.3578 70.1909C68.2424 64.9178 69.7726 60.0709 72.0874 55.254Z",
    fill: "url(#paint125_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.127 55.3388C67.0208 54.4961 62.1245 52.8844 57.4225 50.7163C57.2948 50.6611 57.1447 50.7336 57.1157 50.8742C56.1588 56.0299 54.7134 60.8046 52.4375 65.5429C57.6353 66.3984 62.6524 67.9803 67.3973 70.2758C68.282 65.0027 69.8121 60.1557 72.127 55.3388Z",
    fill: "url(#paint126_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.1728 55.4106C67.1026 54.5776 62.2325 52.9789 57.56 50.8335C57.3799 50.7524 57.1776 50.8642 57.1423 51.0507C56.1819 56.1638 54.7462 60.9026 52.4833 65.6147C57.6811 66.4702 62.6982 68.052 67.4431 70.3475C68.3278 65.0745 69.8579 60.2275 72.1728 55.4106Z",
    fill: "url(#paint127_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.209 55.4857C67.1715 54.6525 62.3407 53.0733 57.701 50.9606C57.4817 50.8599 57.2108 50.9949 57.1625 51.2402C56.202 56.3207 54.7662 61.0268 52.5228 65.6996C57.7206 66.555 62.7377 68.1369 67.4827 70.4324C68.3673 65.1593 69.8974 60.3124 72.2123 55.4955L72.209 55.4857Z",
    fill: "url(#paint128_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.2487 55.5705C67.2472 54.7471 62.4426 53.1809 57.8324 51.0909C57.5607 50.9643 57.2343 51.1289 57.183 51.4298C56.2191 56.4678 54.793 61.1378 52.5625 65.7844C57.7603 66.6399 62.7775 68.2218 67.5224 70.5173C68.407 65.2442 69.9372 60.3972 72.252 55.5803L72.2487 55.5705Z",
    fill: "url(#paint129_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.2946 55.6423C67.3291 54.8286 62.5605 53.272 57.9798 51.2048C57.6589 51.062 57.2771 51.2562 57.2096 51.6063C56.2554 56.6082 54.8194 61.2489 52.6084 65.8562C57.8062 66.7117 62.8233 68.2936 67.5682 70.5891C68.4529 65.316 69.983 60.469 72.2979 55.6521L72.2946 55.6423Z",
    fill: "url(#paint130_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.3309 55.7174C67.3981 54.9035 62.6623 53.3796 58.1078 51.3254C57.7345 51.1566 57.2972 51.3804 57.2266 51.786C56.269 56.7455 54.8427 61.3502 52.6447 65.9313C57.8425 66.7868 62.8596 68.3686 67.6045 70.6641C68.4892 65.391 70.0193 60.5441 72.3342 55.7272L72.3309 55.7174Z",
    fill: "url(#paint131_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.3704 55.8023C67.4736 54.9981 62.764 53.4871 58.2488 51.4524C57.8265 51.2674 57.3336 51.5208 57.2469 51.9756C56.2989 56.899 54.8725 61.471 52.6842 66.0161C57.882 66.8716 62.8992 68.4535 67.6441 70.749C68.5287 65.4759 70.0589 60.629 72.3737 55.8121L72.3704 55.8023Z",
    fill: "url(#paint132_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.4162 55.874C67.5554 55.0795 62.8818 53.5782 58.3863 51.5696C57.9116 51.3587 57.3633 51.6417 57.2734 52.152C56.3221 57.033 54.8955 61.5723 52.7301 66.0879C57.9278 66.9434 62.945 68.5253 67.6899 70.8208C68.5745 65.5477 70.1047 60.7007 72.4195 55.8838L72.4162 55.874Z",
    fill: "url(#paint133_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.4526 55.9491C67.6244 55.1545 62.9803 53.676 58.5242 51.6869C58.0003 51.4598 57.3965 51.7724 57.2905 52.3318C56.3358 57.1703 54.9222 61.6834 52.7664 66.163C57.9642 67.0185 62.9813 68.6003 67.7262 70.8958C68.6109 65.6228 70.141 60.7758 72.4559 55.9589L72.4526 55.9491Z",
    fill: "url(#paint134_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.492 56.034C67.6999 55.2491 63.0853 53.7933 58.6553 51.8172C58.0889 51.5608 57.4296 51.903 57.3107 52.5213C56.3656 57.3238 54.9487 61.7944 52.8156 66.2446C58.0134 67.1 63.0306 68.6819 67.7755 70.9774C68.6601 65.7043 70.1903 60.8574 72.5051 56.0405L72.492 56.034Z",
    fill: "url(#paint135_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.5284 56.1091C67.7689 55.324 63.1838 53.8911 58.7931 51.9344C58.1776 51.6619 57.4629 52.0337 57.3245 52.6913C56.376 57.4513 54.9622 61.899 52.8487 66.3098C58.0465 67.1653 63.0636 68.7472 67.8085 71.0427C68.6932 65.7696 70.2233 60.9227 72.5382 56.1058L72.5284 56.1091Z",
    fill: "url(#paint136_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.5742 56.1808C67.8508 55.4055 63.3017 53.9822 58.9307 52.0516C58.2627 51.7531 57.4925 52.1545 57.3413 52.871C56.4025 57.595 54.9853 62.0003 52.8847 66.3849C58.0825 67.2404 63.0997 68.8223 67.8446 71.1177C68.7292 65.8447 70.2594 60.9977 72.5742 56.1808Z",
    fill: "url(#paint137_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.6137 56.2657C67.9263 55.5 63.4067 54.0996 59.0717 52.1787C58.3546 51.864 57.5256 52.2852 57.3713 53.0573C56.4291 57.7388 55.0151 62.1211 52.934 66.4665C58.1318 67.322 63.149 68.9038 67.8939 71.1993C68.7785 65.9262 70.3087 61.0793 72.6235 56.2624L72.6137 56.2657Z",
    fill: "url(#paint138_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.65 56.3408C67.9953 55.575 63.5052 54.1973 59.1997 52.2992C58.4303 51.9585 57.5491 52.4192 57.3786 53.2403C56.446 57.8859 55.0286 62.2257 52.9606 66.5449C58.1583 67.4003 63.1755 68.9822 67.9204 71.2777C68.805 66.0046 70.3352 61.1577 72.65 56.3408Z",
    fill: "url(#paint139_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.6961 56.4125C68.0773 55.6565 63.6135 54.2918 59.3473 52.4131C58.5287 52.0563 57.5888 52.5367 57.4152 53.4135C56.4825 58.0263 55.0748 62.3302 53.0164 66.6133C58.2142 67.4688 63.2314 69.0507 67.9763 71.3462C68.8609 66.0731 70.3911 61.2261 72.7059 56.4092L72.6961 56.4125Z",
    fill: "url(#paint140_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.7322 56.4876C68.1461 55.7314 63.7248 54.396 59.475 52.5337C58.6041 52.1508 57.612 52.6707 57.4222 53.5965C56.4959 58.1636 55.0783 62.438 53.0427 66.6917C58.2405 67.5472 63.2577 69.129 68.0026 71.4245C68.8872 66.1515 70.4174 61.3045 72.7322 56.4876Z",
    fill: "url(#paint141_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.7717 56.5725C68.2216 55.826 63.8265 54.5036 59.616 52.6607C58.696 52.2617 57.6451 52.8014 57.4522 53.7828C56.5259 58.3172 55.1179 62.5556 53.092 66.7733C58.2898 67.6288 63.3069 69.2106 68.0519 71.5061C68.9365 66.233 70.4666 61.3861 72.7815 56.5692L72.7717 56.5725Z",
    fill: "url(#paint142_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.8081 56.6475C68.294 55.9107 63.9251 54.6013 59.7441 52.7812C58.775 52.366 57.6686 52.9353 57.4595 53.9658C56.5396 58.4544 55.1217 62.6635 53.1186 66.8516C58.3164 67.7071 63.3335 69.289 68.0784 71.5845C68.9631 66.3114 70.4932 61.4644 72.8081 56.6475Z",
    fill: "url(#paint143_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M72.8541 56.7193C68.3727 55.9824 64.0366 54.7056 59.8916 52.8952C58.8701 52.454 57.718 53.0496 57.4961 54.139C56.5858 58.5916 55.1679 62.768 53.1744 66.9201C58.3722 67.7756 63.3894 69.3575 68.1343 71.653C69.0189 66.3799 70.5491 61.5329 72.8639 56.716L72.8541 56.7193Z",
    fill: "url(#paint144_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 56.8042C68.448 56.077 64.1479 54.8098 60.0226 53.0255C58.9618 52.5648 57.7445 53.1933 57.5064 54.3319C56.5927 58.7419 55.1844 62.8823 53.204 67.0083C58.4017 67.8638 63.4189 69.4456 68.1638 71.7411C69.0484 66.468 70.5786 61.6211 72.8934 56.8042Z",
    fill: "white"
  })))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3742 70.2072L67.2956 70.1682C62.5638 67.8792 57.5336 66.2909 52.3489 65.4419L52.2671 65.4258L52.3061 65.3472C54.6079 60.5565 56.1478 55.6736 57.0292 50.4234L57.0453 50.3416L57.1239 50.3806C61.8557 52.6696 66.8859 54.2579 72.0706 55.1069L72.1524 55.123L72.1134 55.2016C69.8149 60.0021 68.262 64.8785 67.3903 70.1254L67.3742 70.2072ZM52.4531 65.3304C57.5953 66.1828 62.5798 67.7648 67.269 70.0245C68.1474 64.8299 69.6775 59.9829 71.9468 55.225C66.8046 54.3726 61.8234 52.8004 57.1309 50.5309C56.2559 55.7353 54.7224 60.5725 52.4433 65.3337L52.4531 65.3304Z",
    fill: "url(#paint145_linear_10106_6282)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7256 56.8999C65.2844 56.336 61.9626 55.2846 58.8222 53.7684C58.2422 57.2587 57.2198 60.4726 55.6874 63.662C59.1286 64.2259 62.4505 65.2772 65.5908 66.7935C66.1709 63.3032 67.1932 60.0893 68.7256 56.8999Z",
    fill: "url(#paint146_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 53,
    width: 14,
    height: 14
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7256 56.8999C65.2844 56.336 61.9626 55.2846 58.8222 53.7684C58.2422 57.2587 57.2198 60.4726 55.6874 63.662C59.1286 64.2259 62.4505 65.2772 65.5908 66.7935C66.1709 63.3032 67.1932 60.0893 68.7256 56.8999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10106_6282)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.7256 56.8999C65.2942 56.3327 61.9855 55.2878 58.8582 53.7781C58.8451 53.7716 58.8157 53.7815 58.8092 53.7946C58.2259 57.2751 57.2068 60.4661 55.6841 63.6522C59.1253 64.2161 62.4472 65.2675 65.5875 66.7837C66.1676 63.2934 67.1899 60.0795 68.7223 56.8901L68.7256 56.8999Z",
    fill: "url(#paint147_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.7653 56.9848C65.3568 56.4208 62.0741 55.3562 58.9405 53.8922C58.9012 53.8728 58.8457 53.9024 58.8393 53.9482C58.2265 57.4059 57.2465 60.5836 55.7271 63.7469C59.1683 64.3107 62.4901 65.3621 65.6305 66.8784C66.2105 63.3881 67.2329 60.1742 68.7653 56.9848Z",
    fill: "url(#paint148_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.8013 57.0598C65.4059 56.5024 62.1462 55.441 59.0289 53.9933C58.9634 53.9608 58.8786 54.0003 58.8625 54.0821C58.2397 57.5104 57.2696 60.6849 55.7533 63.8252C59.1945 64.3891 62.5164 65.4405 65.6567 66.9567C66.2368 63.4665 67.2591 60.2526 68.7915 57.0631L68.8013 57.0598Z",
    fill: "url(#paint149_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.8475 57.1316C65.475 56.5773 62.2283 55.5224 59.1242 54.0812C59.0325 54.0358 58.9215 54.095 58.9022 54.1997C58.2827 57.6051 57.3059 60.76 55.8093 63.8937C59.2505 64.4576 62.5723 65.509 65.7127 67.0252C66.2927 63.5349 67.315 60.321 68.8475 57.1316Z",
    fill: "url(#paint150_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.8835 57.2067C65.5241 56.6589 62.3003 55.6072 59.2126 54.1823C59.0947 54.1238 58.9543 54.193 58.9254 54.3337C58.2992 57.7195 57.3388 60.858 55.8453 63.9688C59.2865 64.5327 62.6084 65.584 65.7487 67.1003C66.3288 63.61 67.3511 60.3961 68.8835 57.2067Z",
    fill: "url(#paint151_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.9198 57.2817C65.5833 56.7372 62.3726 55.6919 59.3012 54.2833C59.1572 54.2119 58.9907 54.3007 58.9586 54.4643C58.3389 57.837 57.3685 60.9461 55.8816 64.0439C59.3228 64.6077 62.6446 65.6591 65.785 67.1753C66.365 63.6851 67.3874 60.4712 68.9198 57.2817Z",
    fill: "url(#paint152_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M68.9559 57.3568C65.6292 56.8089 62.4447 55.7767 59.3865 54.3746C59.2195 54.3 59.0139 54.402 58.9851 54.5754C58.3588 57.9285 57.3949 61.0245 55.9242 64.1058C59.3654 64.6697 62.6873 65.7211 65.8276 67.2373C66.4077 63.747 67.43 60.5332 68.9624 57.3437L68.9559 57.3568Z",
    fill: "url(#paint153_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.002 57.4286C65.6982 56.8839 62.5301 55.8679 59.485 54.4724C59.2918 54.3847 59.0568 54.4967 59.0183 54.706C58.3952 58.0363 57.4378 61.1192 55.9605 64.1809C59.4017 64.7448 62.7236 65.7962 65.8639 67.3124C66.444 63.8221 67.4663 60.6082 68.9987 57.4188L69.002 57.4286Z",
    fill: "url(#paint154_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.0383 57.5037C65.7573 56.9622 62.5926 55.956 59.5736 54.5734C59.3542 54.4728 59.0931 54.6044 59.0514 54.8367C58.4315 58.144 57.4675 61.2073 56.0099 64.2625C59.4511 64.8263 62.7729 65.8777 65.9133 67.394C66.4933 63.9037 67.5156 60.6898 69.0481 57.5004L69.0383 57.5037Z",
    fill: "url(#paint155_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.0779 57.5885C65.81 57.0535 62.6681 56.0506 59.6623 54.6745C59.4167 54.5609 59.1295 54.7122 59.0748 54.9707C58.4581 58.2551 57.4908 61.3086 56.0364 64.3408C59.4776 64.9047 62.7994 65.9561 65.9398 67.4723C66.5198 63.982 67.5421 60.7682 69.0746 57.5787L69.0779 57.5885Z",
    fill: "url(#paint156_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.1237 57.6603C65.8787 57.1285 62.7499 56.132 59.7507 54.7755C59.4789 54.6489 59.1624 54.8102 59.1078 55.1013C58.4845 58.3662 57.5335 61.4033 56.0822 64.4126C59.5234 64.9765 62.8452 66.0279 65.9856 67.5441C66.5656 64.0538 67.5879 60.8399 69.1204 57.6505L69.1237 57.6603Z",
    fill: "url(#paint157_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.16 57.7354C65.9282 57.21 62.8256 56.2266 59.8394 54.8765C59.5448 54.7468 59.1988 54.9179 59.1312 55.2353C58.5111 58.4772 57.5535 61.4947 56.1218 64.4975C59.563 65.0613 62.8849 66.1127 66.0252 67.629C66.6052 64.1387 67.6276 60.9248 69.16 57.7354Z",
    fill: "url(#paint158_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.1963 57.8104C65.984 57.2785 62.8881 56.3146 59.9281 54.9776C59.6073 54.8348 59.2319 55.0159 59.1644 55.3659C58.5508 58.5948 57.5866 61.5927 56.1581 64.5726C59.5993 65.1364 62.9211 66.1878 66.0615 67.704C66.6415 64.2138 67.6639 60.9999 69.1963 57.8104Z",
    fill: "url(#paint159_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.2324 57.8855C66.0333 57.3601 62.9602 56.3994 60.0134 55.0689C59.6663 54.9131 59.2551 55.1172 59.1844 55.4901C58.574 58.6961 57.6162 61.6809 56.1909 64.6378C59.6321 65.2017 62.954 66.2531 66.0943 67.7693C66.6744 64.279 67.6967 61.0652 69.2291 57.8757L69.2324 57.8855Z",
    fill: "url(#paint160_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.2785 57.9573C66.1022 57.435 63.0422 56.4809 60.1118 55.1666C59.7385 54.9979 59.3012 55.2216 59.2273 55.6175C58.6103 58.8038 57.6558 61.7658 56.2403 64.7194C59.6815 65.2833 63.0033 66.3347 66.1437 67.8509C66.7237 64.3606 67.746 61.1467 69.2785 57.9573Z",
    fill: "url(#paint161_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.3147 58.0324C66.1614 57.5133 63.108 56.5787 60.2005 55.2677C59.801 55.0859 59.3343 55.3196 59.2507 55.7514C58.6369 58.9149 57.6791 61.867 56.2766 64.7945C59.7177 65.3583 63.0396 66.4097 66.18 67.926C66.76 64.4357 67.7823 61.2218 69.3147 58.0324Z",
    fill: "url(#paint162_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.351 58.1074C66.2107 57.5949 63.1802 56.6635 60.2858 55.3589C59.8634 55.174 59.3673 55.4176 59.2806 55.8723C58.6699 59.0129 57.7153 61.9421 56.3095 64.8598C59.7507 65.4236 63.0725 66.475 66.2129 67.9912C66.7929 64.501 67.8152 61.2871 69.3477 58.0976L69.351 58.1074Z",
    fill: "url(#paint163_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.3869 58.1825C66.2696 57.6731 63.2522 56.7482 60.3742 55.46C59.9256 55.262 59.4034 55.5253 59.3135 56.003C58.6995 59.1337 57.7481 62.0401 56.3586 64.9413C59.7997 65.5052 63.1216 66.5566 66.2619 68.0728C66.842 64.5825 67.8643 61.3686 69.3967 58.1792L69.3869 58.1825Z",
    fill: "url(#paint164_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.4364 58.2641C66.3289 57.7514 63.3377 56.8395 60.476 55.5675C60.0013 55.3566 59.4497 55.6298 59.3501 56.1434C58.7393 59.2513 57.7846 62.1478 56.408 65.0229C59.8492 65.5868 63.1711 66.6381 66.3114 68.1544C66.8915 64.6641 67.9138 61.4502 69.4462 58.2608L69.4364 58.2641Z",
    fill: "url(#paint165_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.4726 58.3391C66.3879 57.8297 63.4033 56.9373 60.5515 55.6621C60.0506 55.4382 59.4729 55.7311 59.3701 56.2676C58.7625 59.3526 57.811 62.2262 56.4344 65.1013C59.8756 65.6651 63.1975 66.7165 66.3378 68.2327C66.9178 64.7425 67.9402 61.5286 69.4726 58.3391Z",
    fill: "url(#paint166_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M69.5089 58.4142C66.4471 57.9079 63.4756 57.0221 60.6402 55.7631C60.113 55.5262 59.5092 55.8388 59.3934 56.4015C58.7891 59.4636 57.8342 62.3275 56.4707 65.1763C59.9119 65.7402 63.2337 66.7916 66.3741 68.3078C66.9541 64.8175 67.9764 61.6037 69.5089 58.4142Z",
    fill: "url(#paint167_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 58.4893C66.4963 57.9895 63.5477 57.1069 60.7287 55.8642C60.1786 55.6241 59.5422 55.9368 59.4265 56.5322C58.8155 59.5747 57.8671 62.4254 56.5068 65.2514C59.948 65.8153 63.2698 66.8667 66.4102 68.3829C66.9902 64.8926 68.0125 61.6787 69.545 58.4893Z",
    fill: "white"
  })))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6434 66.8849L65.5649 66.8459C62.4376 65.3361 59.1027 64.2783 55.6746 63.7209L55.5928 63.7048L55.6317 63.6262C57.1577 60.4499 58.1734 57.2164 58.76 53.7457L58.7761 53.6639L58.8547 53.7029C61.9819 55.2127 65.3169 56.2705 68.745 56.8279L68.8268 56.844L68.7878 56.9226C67.2619 60.0989 66.2429 63.3226 65.6595 66.8031L65.6434 66.8849ZM55.7788 63.6094C59.1644 64.1702 62.4503 65.2119 65.548 66.6988C66.1283 63.2739 67.1343 60.0764 68.631 56.9427C65.2454 56.3819 61.9595 55.3402 58.8617 53.8533C58.2815 57.2782 57.2721 60.4659 55.7788 63.6094Z",
    fill: "url(#paint168_linear_10106_6282)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4033 58.6307C63.7154 58.3486 62.0921 57.8375 60.5432 57.094C60.258 58.8048 59.7631 60.379 59.0131 61.941C60.701 62.2231 62.3243 62.7342 63.8732 63.4776C64.1584 61.7668 64.6533 60.1926 65.4033 58.6307Z",
    fill: "url(#paint169_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 57,
    width: 7,
    height: 7
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4033 58.6307C63.7154 58.3486 62.0921 57.8375 60.5432 57.094C60.258 58.8048 59.7631 60.379 59.0131 61.941C60.701 62.2231 62.3243 62.7342 63.8732 63.4776C64.1584 61.7668 64.6533 60.1926 65.4033 58.6307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4032 58.6307C63.7284 58.3551 62.1182 57.8505 60.5955 57.12C60.5693 57.107 60.5432 57.1267 60.5367 57.1398C60.2449 58.831 59.7565 60.3921 59.013 61.941C60.7009 62.2231 62.3242 62.7342 63.873 63.4776C64.1583 61.7668 64.6532 60.1926 65.4032 58.6307Z",
    fill: "url(#paint170_linear_10106_6282)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M65.4327 58.6862C63.771 58.4171 62.1869 57.8928 60.661 57.1852C60.6217 57.1657 60.576 57.192 60.5599 57.2411C60.2516 58.916 59.7795 60.4607 59.0425 61.9965C60.7304 62.2785 62.3537 62.7896 63.9026 63.5331C64.1878 61.8223 64.6827 60.2481 65.4327 58.6862Z",
    fill: "url(#paint171_linear_10106_6282)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M65.4657 58.7514C63.8236 58.4758 62.2428 57.9613 60.7333 57.2699C60.6711 57.2473 60.6058 57.2802 60.593 57.3391C60.2781 58.9944 59.8158 60.5358 59.0853 62.0585C60.7732 62.3405 62.3965 62.8516 63.9453 63.5951C64.2306 61.8843 64.7255 60.3101 65.4755 58.7481L65.4657 58.7514Z",
    fill: "url(#paint172_linear_10106_6282)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M65.4952 58.8069C63.8662 58.5378 62.2985 58.0297 60.8022 57.3449C60.7236 57.306 60.6322 57.3586 60.6161 57.4404C60.3078 59.0826 59.8388 60.6044 59.1148 62.1139C60.8027 62.396 62.426 62.9071 63.9749 63.6506C64.2601 61.9398 64.7551 60.3656 65.505 58.8036L65.4952 58.8069Z",
    fill: "url(#paint173_linear_10106_6282)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M65.5282 58.8722C63.9123 58.6095 62.3544 58.0982 60.8613 57.4232C60.7598 57.381 60.6489 57.4402 60.6296 57.5449C60.3179 59.1774 59.8555 60.6861 59.138 62.1825C60.8259 62.4646 62.4492 62.9757 63.9981 63.7192C64.2833 62.0084 64.7782 60.4342 65.5282 58.8722Z",
    fill: "url(#paint174_linear_10106_6282)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M65.5578 58.9277C63.9517 58.6617 62.42 58.1634 60.9302 57.4981C60.8156 57.4495 60.6753 57.5186 60.6528 57.6462C60.3346 59.259 59.8786 60.7546 59.1709 62.2478C60.8588 62.5298 62.4821 63.0409 64.031 63.7844C64.3162 62.0736 64.8111 60.4994 65.5611 58.9375L65.5578 58.9277Z",
    fill: "url(#paint175_linear_10106_6282)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M65.5908 58.9929C63.9978 58.7335 62.4759 58.2318 61.0025 57.5829C60.8715 57.518 60.7051 57.6068 60.6761 57.7475C60.3644 59.3472 59.9051 60.833 59.1908 62.3066C60.8787 62.5886 62.502 63.0997 64.0509 63.8432C64.3361 62.1324 64.831 60.5582 65.581 58.9962L65.5908 58.9929Z",
    fill: "url(#paint176_linear_10106_6282)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.6203 59.0484C64.0403 58.7954 62.5315 58.3003 61.068 57.6481C60.9141 57.5799 60.7379 57.6721 60.7057 57.8356C60.3874 59.4158 59.9346 60.8885 59.2301 62.3588C60.918 62.6408 62.5413 63.1519 64.0901 63.8954C64.3754 62.1846 64.8703 60.6104 65.6203 59.0484Z",
    fill: "url(#paint177_linear_10106_6282)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M65.6533 59.1137C64.093 58.8541 62.5875 58.3688 61.1403 57.7328C60.9733 57.6582 60.7677 57.7602 60.7324 57.9467C60.4205 59.5137 59.9644 60.9766 59.2631 62.424C60.951 62.7061 62.5743 63.2172 64.1232 63.9607C64.4084 62.2499 64.9033 60.6757 65.6533 59.1137Z",
    fill: "url(#paint178_linear_10106_6282)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M65.6863 59.179C64.1391 58.9259 62.6467 58.447 61.2126 57.8176C61.0194 57.73 60.7975 57.8484 60.759 58.0578C60.4438 59.615 59.9909 61.055 59.2994 62.4991C60.9873 62.7811 62.6106 63.2922 64.1595 64.0357C64.4447 62.3249 64.9396 60.7507 65.6896 59.1888L65.6863 59.179Z",
    fill: "url(#paint179_linear_10106_6282)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M65.7158 59.2344C64.1783 58.9781 62.7023 58.5155 61.2781 57.8828C61.0718 57.7886 60.8205 57.917 60.7755 58.1394C60.4635 59.6738 60.0106 61.1138 59.3256 62.5448C61.0135 62.8268 62.6368 63.3379 64.1856 64.0814C64.4709 62.3706 64.9658 60.7964 65.7158 59.2344Z",
    fill: "url(#paint180_linear_10106_6282)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M65.7488 59.2997C64.2245 59.0498 62.7583 58.584 61.3504 57.9675C61.1212 57.8702 60.8503 58.0052 60.8021 58.2505C60.4966 59.7718 60.0404 61.202 59.3586 62.6101C61.0465 62.8921 62.6698 63.4032 64.2187 64.1467C64.5039 62.4359 64.9988 60.8617 65.7488 59.2997Z",
    fill: "url(#paint181_linear_10106_6282)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M65.7784 59.3552C64.2671 59.1118 62.814 58.6524 61.4095 58.0458C61.1639 57.9322 60.8767 58.0835 60.8253 58.3518C60.5165 59.8632 60.0635 61.2706 59.3915 62.6753C61.0794 62.9574 62.7027 63.4685 64.2515 64.212C64.5368 62.5012 65.0317 60.927 65.7817 59.365L65.7784 59.3552Z",
    fill: "url(#paint182_linear_10106_6282)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M65.8113 59.4205C64.3099 59.1738 62.8731 58.7307 61.4784 58.1208C61.2099 58.004 60.9031 58.1619 60.8485 58.4531C60.5429 59.9416 60.0899 61.3489 59.4211 62.7308C61.109 63.0129 62.7323 63.524 64.2812 64.2674C64.5664 62.5566 65.0613 60.9825 65.8113 59.4205Z",
    fill: "url(#paint183_linear_10106_6282)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.8409 59.476C64.3526 59.2358 62.9256 58.7894 61.5473 58.1957C61.2657 58.0724 60.9295 58.2403 60.8684 58.5445C60.5595 60.0233 60.1097 61.4077 59.4507 62.7863C61.1386 63.0683 62.7619 63.5794 64.3108 64.3229C64.596 62.6121 65.0909 61.0379 65.8409 59.476Z",
    fill: "url(#paint184_linear_10106_6282)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M65.8737 59.5412C64.4049 59.2944 62.9846 58.8676 61.6194 58.2805C61.3149 58.154 60.9624 58.3383 60.8948 58.6556C60.5924 60.1213 60.1393 61.4959 59.4835 62.8516C61.1714 63.1336 62.7947 63.6447 64.3435 64.3882C64.6288 62.6774 65.1237 61.1032 65.8737 59.5412Z",
    fill: "url(#paint185_linear_10106_6282)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M65.9034 59.5967C64.4477 59.3564 63.0372 58.9263 61.685 58.3456C61.3642 58.2029 60.9954 58.4035 60.9148 58.7471C60.6058 60.1931 60.1592 61.5547 59.5132 62.907C61.2011 63.1891 62.8244 63.7002 64.3732 64.4437C64.6585 62.7329 65.1534 61.1587 65.9034 59.5967Z",
    fill: "url(#paint186_linear_10106_6282)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M65.9364 59.662C64.4938 59.4282 63.0964 59.0046 61.7573 58.4304C61.4136 58.2844 61.0252 58.4917 60.9513 58.8548C60.6487 60.2878 60.1988 61.6395 59.5593 62.9788C61.2472 63.2609 62.8705 63.772 64.4193 64.5154C64.7046 62.8046 65.1995 61.2304 65.9495 59.6685L65.9364 59.662Z",
    fill: "url(#paint187_linear_10106_6282)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M65.9691 59.7273C64.5364 59.4901 63.1554 59.0828 61.8294 58.5151C61.4725 58.3627 61.0548 58.5799 60.9743 58.9561C60.6685 60.3793 60.2218 61.7081 59.5887 63.0343C61.2766 63.3163 62.8999 63.8274 64.4488 64.5709C64.734 62.8601 65.229 61.2859 65.9789 59.724L65.9691 59.7273Z",
    fill: "url(#paint188_linear_10106_6282)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M65.9988 59.7827C64.5792 59.5521 63.208 59.1415 61.8951 58.5803C61.512 58.4149 61.078 58.6484 60.9943 59.0476C60.6917 60.4478 60.245 61.7767 59.6184 63.0898C61.3063 63.3718 62.9296 63.8829 64.4785 64.6264C64.7637 62.9156 65.2587 61.3414 66.0086 59.7794L65.9988 59.7827Z",
    fill: "url(#paint189_linear_10106_6282)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M66.0317 59.848C64.6218 59.6141 63.267 59.2198 61.9574 58.6684C61.5613 58.4964 61.1076 58.7366 61.011 59.1619C60.7149 60.5491 60.2615 61.8584 59.6415 63.1584C61.3294 63.4404 62.9526 63.9515 64.5015 64.695C64.7868 62.9842 65.2817 61.41 66.0317 59.848Z",
    fill: "url(#paint190_linear_10106_6282)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.0613 59.9035C64.6743 59.6728 63.3228 59.2882 62.0263 58.7433C61.6073 58.5682 61.1341 58.815 61.0342 59.2632C60.7348 60.6406 60.288 61.9367 59.6744 63.2236C61.3623 63.5057 62.9856 64.0168 64.5344 64.7603C64.8197 63.0495 65.3146 61.4753 66.0646 59.9133L66.0613 59.9035Z",
    fill: "white"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9028 63.5331L63.8504 63.5071C62.3146 62.7701 60.688 62.2492 59.0034 61.977L58.9445 61.9641L58.9705 61.9117C59.714 60.3628 60.2154 58.7756 60.504 57.0746L60.507 57.019L60.5594 57.0449C62.0952 57.7819 63.7218 58.3028 65.4064 58.5751L65.462 58.5782L65.436 58.6306C64.6925 60.1794 64.1911 61.7667 63.9026 63.4677L63.8995 63.5233L63.9028 63.5331ZM59.0784 61.9081C60.7303 62.1804 62.3307 62.6884 63.8403 63.4124C64.1289 61.744 64.6173 60.183 65.3478 58.6603C63.6959 58.3879 62.0955 57.88 60.586 57.156C60.2973 58.8243 59.8089 60.3854 59.0784 61.9081Z",
    fill: "url(#paint191_linear_10106_6282)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7302 100.386C59.6813 100.402 59.6323 100.419 59.5833 100.435C58.5217 100.717 57.379 100.207 56.8658 99.2346L27.2212 42.131C26.9316 41.5631 26.8707 40.9291 27.068 40.317C27.2556 39.7083 27.679 39.2165 28.2371 38.9302L64.2805 20.2136C64.4371 20.1281 64.6037 20.072 64.7735 20.0256C65.8351 19.7442 66.9778 20.2536 67.4911 21.2262L97.1421 78.3166C97.4317 78.8845 97.4959 79.5284 97.2953 80.1306C97.1077 80.7393 96.6843 81.2311 96.1262 81.5174L60.0828 100.234C59.9719 100.293 59.8576 100.343 59.74 100.382L59.7302 100.386ZM64.6728 20.2123C64.565 20.2486 64.4573 20.285 64.3594 20.3507L28.3127 39.0575C27.784 39.3339 27.3932 39.7929 27.212 40.3558C27.0308 40.9187 27.0819 41.5234 27.3583 42.0521L57.0093 99.1426C57.4832 100.063 58.5473 100.533 59.5501 100.272C59.7101 100.229 59.8635 100.166 60.0137 100.094L96.0571 81.3771C96.5858 81.1007 96.9766 80.6417 97.1545 80.0689C97.3357 79.506 97.2846 78.9014 97.0082 78.3727L67.3507 21.2953C66.8768 20.3749 65.8128 19.9044 64.81 20.1661C64.761 20.1826 64.712 20.1991 64.6728 20.2123Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 19,
    width: 72,
    height: 82
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2886 20.2109L28.2381 38.9272C27.0725 39.5323 26.6182 40.9677 27.2233 42.1332L56.8722 99.2415C57.4773 100.407 58.9127 100.861 60.0782 100.256L96.1288 81.5399C97.2943 80.9348 97.7486 79.4994 97.1435 78.3339L67.4946 21.2256C66.8895 20.0601 65.4541 19.6058 64.2886 20.2109Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M50.1761 26.197L61.6526 91.3702C61.8774 92.6466 63.0944 93.4992 64.3708 93.2744L106.055 85.9342C107.331 85.7094 108.184 84.4924 107.959 83.216L96.4825 18.0428C96.2577 16.7663 95.0407 15.9137 93.7643 16.1385L52.0803 23.4787C50.8038 23.7035 49.9513 24.9205 50.1761 26.197Z",
    fill: "#F3F3F3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.962 85.9372L64.4043 93.1807C63.1267 93.404 61.911 92.5483 61.6843 91.2609L50.3671 26.2235C50.1438 24.9459 50.9995 23.7301 52.2868 23.5035L93.8448 16.26C95.1223 16.0367 96.3381 16.8925 96.5647 18.1798L107.892 83.214C108.115 84.4915 107.259 85.7073 105.972 85.9339L105.962 85.9372Z",
    fill: "#E7E7E7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M105.874 85.9343L64.4331 93.0727C63.1556 93.2961 61.9365 92.4305 61.7132 91.153L50.5336 26.2327C50.3103 24.9552 51.1758 23.7361 52.4534 23.5128L93.894 16.3743C95.1715 16.151 96.3906 17.0165 96.6139 18.2941L107.793 83.2143C108.017 84.4919 107.151 85.711 105.874 85.9343Z",
    fill: "#DBDBDB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M105.776 85.9346L64.4559 92.9778C63.175 93.1914 61.9592 92.3356 61.7326 91.0483L50.7137 26.2485C50.5001 24.9676 51.3559 23.7518 52.6432 23.5252L93.9632 16.482C95.244 16.2684 96.4598 17.1242 96.6864 18.4115L107.718 83.2178C107.932 84.4987 107.076 85.7145 105.789 85.9411L105.776 85.9346Z",
    fill: "#CECECE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M105.687 85.9316L64.4881 92.8797C63.2072 93.0932 61.9882 92.2276 61.7746 90.9468L50.8803 26.2577C50.6668 24.9769 51.5323 23.7578 52.8132 23.5443L94.0125 16.5962C95.2933 16.3827 96.5124 17.2482 96.7259 18.5291L107.617 83.2084C107.83 84.4892 106.965 85.7083 105.684 85.9218L105.687 85.9316Z",
    fill: "#C2C2C2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M105.599 85.9287L64.5173 92.7717C63.2364 92.9852 62.0174 92.1197 61.8005 90.829L51.0603 26.2735C50.8468 24.9926 51.7123 23.7735 53.003 23.5567L94.0849 16.7137C95.3658 16.5001 96.5848 17.3657 96.8017 18.6563L107.545 83.2217C107.759 84.5025 106.893 85.7216 105.603 85.9385L105.599 85.9287Z",
    fill: "#B6B6B6"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M105.501 85.929L64.5399 92.6768C63.259 92.8903 62.0367 92.015 61.8329 90.7308L51.2369 26.2794C51.0233 24.9986 51.8987 23.7762 53.1828 23.5724L94.1442 16.8246C95.425 16.6111 96.6474 17.4864 96.8511 18.7706L107.444 83.2122C107.657 84.4931 106.782 85.7155 105.498 85.9192L105.501 85.929Z",
    fill: "#AAAAAA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M105.413 85.926L64.5688 92.5688C63.2847 92.7725 62.0656 91.907 61.8586 90.613L51.4068 26.2984C51.2031 25.0143 52.0687 23.7952 53.3626 23.5882L94.2066 16.9454C95.4907 16.7417 96.7098 17.6072 96.9169 18.9011L107.372 83.2255C107.576 84.5097 106.71 85.7288 105.416 85.9358L105.413 85.926Z",
    fill: "#9E9E9E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M105.315 85.9263L64.5915 92.4739C63.2976 92.681 62.0948 91.799 61.8813 90.5182L51.5835 26.3044C51.3765 25.0104 52.2584 23.8077 53.5393 23.5941L94.2626 17.0465C95.5566 16.8395 96.7594 17.7215 96.9729 19.0023L107.277 83.203C107.484 84.4969 106.602 85.6997 105.321 85.9132L105.315 85.9263Z",
    fill: "#929292"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M105.227 85.9234L64.6238 92.3757C63.3299 92.5828 62.1271 91.7008 61.9201 90.4069L51.7633 26.3201C51.5563 25.0262 52.4382 23.8234 53.7322 23.6164L94.3349 17.164C95.6288 16.957 96.8316 17.8389 97.0387 19.1329L107.205 83.2163C107.412 84.5102 106.53 85.713 105.236 85.9201L105.227 85.9234Z",
    fill: "#868686"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M105.138 85.9204L64.6529 92.2677C63.359 92.4748 62.1529 91.583 61.9491 90.2989L51.9301 26.3294C51.7231 25.0354 52.6148 23.8294 53.899 23.6256L94.3843 17.2783C95.6783 17.0712 96.8844 17.963 97.0881 19.2471L107.107 83.2166C107.314 84.5106 106.422 85.7167 105.138 85.9204Z",
    fill: "#797979"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M105.04 85.9207L64.6753 92.1729C63.3781 92.3701 62.1753 91.4882 61.978 90.1909L52.1098 26.3451C51.9126 25.0479 52.7945 23.8451 54.0918 23.6479L94.4565 17.3957C95.7537 17.1985 96.9565 18.0804 97.1538 19.3777L107.022 83.2235C107.219 84.5207 106.337 85.7235 105.04 85.9207Z",
    fill: "#6D6D6D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M104.952 85.9177L64.7077 92.0747C63.4105 92.2719 62.2044 91.3802 62.0104 90.0927L52.2766 26.3544C52.0794 25.0571 52.9711 23.851 54.2586 23.6571L94.5026 17.5002C95.7999 17.3029 97.006 18.1947 97.1999 19.4821L106.93 83.2107C107.128 84.5079 106.236 85.714 104.948 85.9079L104.952 85.9177Z",
    fill: "#616161"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M104.854 85.9181L64.7369 91.9667C63.4397 92.1639 62.2336 91.2722 62.0363 89.9749L52.4566 26.3701C52.2594 25.0729 53.1511 23.8668 54.4484 23.6696L94.5653 17.6209C95.8625 17.4237 97.0686 18.3154 97.2659 19.6127L106.846 83.2175C107.043 84.5147 106.151 85.7208 104.854 85.9181Z",
    fill: "#555555"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M104.765 85.9151L64.7691 91.8685C63.4718 92.0657 62.2625 91.1642 62.0783 89.8735L52.633 26.3761C52.4358 25.0788 53.3373 23.8694 54.6281 23.6853L94.6243 17.7319C95.9216 17.5346 97.131 18.4362 97.3151 19.7269L106.757 83.2145C106.954 84.5118 106.053 85.7212 104.762 85.9053L104.765 85.9151Z",
    fill: "#494949"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M104.674 85.9023L64.7983 91.7605C63.4977 91.948 62.2916 91.0562 62.1042 89.7557L52.8032 26.3951C52.6158 25.0946 53.5075 23.8885 54.8081 23.701L94.6837 17.8428C95.9842 17.6554 97.1903 18.5472 97.3778 19.8477L106.669 83.2115C106.856 84.5121 105.965 85.7182 104.664 85.9056L104.674 85.9023Z",
    fill: "#3D3D3D"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M104.576 85.9027L64.8174 91.6558C63.5169 91.8433 62.3173 90.9384 62.1298 89.6379L52.9796 26.4011C52.7922 25.1005 53.697 23.9009 54.9976 23.7135L94.7559 17.9603C96.0564 17.7729 97.256 18.6777 97.4435 19.9783L106.587 83.2282C106.775 84.5287 105.87 85.7283 104.569 85.9158L104.576 85.9027Z",
    fill: "#313131"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M104.488 85.8997L64.8499 91.5577C63.5494 91.7451 62.3498 90.8403 62.1623 89.5397L53.1596 26.4168C52.9722 25.1163 53.877 23.9167 55.1776 23.7292L94.8152 18.0713C96.1158 17.8838 97.3154 18.7887 97.5028 20.0892L106.509 83.2219C106.696 84.5225 105.791 85.7221 104.491 85.9095L104.488 85.8997Z",
    fill: "#242424"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M104.39 85.9L64.8692 91.453C63.5687 91.6404 62.3658 90.7258 62.1783 89.4252L53.3264 26.4261C53.139 25.1255 54.0536 23.9226 55.3542 23.7352L94.8745 18.1822C96.1751 17.9948 97.3779 18.9094 97.5654 20.21L106.421 83.2189C106.608 84.5195 105.693 85.7224 104.393 85.9098L104.39 85.9Z",
    fill: "#181818"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M62.2206 89.3379L53.5088 26.4505C53.3286 25.1499 54.2373 23.949 55.5379 23.7689L94.9436 18.31C96.2442 18.1298 97.4451 19.0385 97.6252 20.339L106.337 83.2264C106.517 84.527 105.609 85.7279 104.308 85.908L64.9022 91.3669C63.6017 91.5471 62.4008 90.6384 62.2206 89.3379Z",
    fill: "#0C0C0C"
  })))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1396 26.0272L61.8356 89.7829C62.0131 91.0841 63.2118 91.995 64.513 91.8176L104.76 86.3281C106.061 86.1506 106.972 84.9519 106.794 83.6507L98.0985 19.895C97.921 18.5938 96.7223 17.6828 95.4211 17.8603L55.1743 23.3498C53.8731 23.5273 52.9621 24.726 53.1396 26.0272Z",
    fill: "url(#paint192_linear_10106_6282)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2934 29.6395L58.2445 30.6597L57.7348 30.7333L58.0022 25.6682L58.7963 25.5642L60.4144 30.3647L59.8621 30.4417L59.5352 29.4718L58.2836 29.6428L58.2934 29.6395ZM58.2951 29.1589L59.3898 29.0081L58.4553 26.2356L58.2951 29.1589Z",
    fill: "#1B1B1B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M62.23 34.5858C62.3273 35.3276 61.813 36.0028 61.0712 36.1001C60.6758 36.157 60.2961 36.0341 60.0174 35.7898C60.1854 36.1587 60.5599 36.687 61.0598 36.6167C61.0799 36.7409 61.0899 36.8029 61.0899 36.8029L60.0671 36.9404L59.8579 36.9673L58.8351 37.1047C58.8351 37.1047 58.8186 37.0558 58.805 36.9185C59.2952 36.8515 59.5286 36.2491 59.5795 35.8501C59.3779 36.1581 59.0386 36.3815 58.6432 36.4384C57.9014 36.5357 57.2262 36.0215 57.1289 35.2797C57.0251 34.5509 57.5296 33.879 58.2452 33.7688C58.1663 33.6317 58.1135 33.475 58.09 33.3083C57.9927 32.5665 58.507 31.8913 59.2488 31.794C59.9906 31.6967 60.6658 32.211 60.7631 32.9528C60.7866 33.1195 60.7773 33.2862 60.7419 33.44C61.4674 33.3591 62.1295 33.8669 62.2235 34.5989L62.23 34.5858Z",
    fill: "url(#paint193_linear_10106_6282)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7003 75.0847C97.603 74.3429 98.1173 73.6677 98.8591 73.5704C99.2545 73.5135 99.6342 73.6365 99.9129 73.8807C99.7449 73.5119 99.3705 72.9835 98.8705 73.0538C98.8505 72.9297 98.8404 72.8676 98.8404 72.8676L99.8633 72.7301L100.072 72.7032L101.095 72.5658C101.095 72.5658 101.112 72.6148 101.125 72.752C100.635 72.8191 100.402 73.4214 100.351 73.8204C100.552 73.5124 100.892 73.289 101.287 73.2321C102.029 73.1348 102.704 73.6491 102.801 74.3909C102.905 75.1196 102.401 75.7915 101.685 75.9018C101.764 76.0388 101.817 76.1955 101.84 76.3622C101.938 77.104 101.423 77.7792 100.681 77.8765C99.9397 77.9738 99.2645 77.4595 99.1672 76.7177C99.1437 76.5511 99.153 76.3843 99.1885 76.2305C98.4629 76.3114 97.8008 75.8036 97.7068 75.0716L97.7003 75.0847Z",
    fill: "url(#paint194_linear_10106_6282)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M77.747 70.9767C79.2237 68.7225 80.2348 66.0579 80.8438 63.3979C80.905 63.1263 81.2775 63.0662 81.4058 63.3175C82.7052 65.7161 84.3966 68.0153 86.423 69.787C86.623 69.9596 86.526 70.2869 86.2646 70.3204L78.0461 71.4432C77.7846 71.4768 77.6006 71.1897 77.7437 70.9669L77.747 70.9767Z",
    fill: "url(#paint195_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 63,
    width: 10,
    height: 9
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M77.747 70.9767C79.2237 68.7225 80.2348 66.0579 80.8438 63.3979C80.905 63.1263 81.2775 63.0662 81.4058 63.3175C82.7052 65.7161 84.3966 68.0153 86.423 69.787C86.623 69.9596 86.526 70.2869 86.2646 70.3204L78.0461 71.4432C77.7846 71.4768 77.6006 71.1897 77.7437 70.9669L77.747 70.9767Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M77.747 70.9767C79.2237 68.7225 80.2348 66.0579 80.8438 63.3979C80.905 63.1263 81.2775 63.0662 81.4058 63.3175C82.7052 65.7161 84.3966 68.0153 86.423 69.787C86.623 69.9596 86.526 70.2869 86.2646 70.3204L78.0461 71.4432C77.7846 71.4768 77.6006 71.1897 77.7437 70.9669L77.747 70.9767Z",
    fill: "url(#paint196_linear_10106_6282)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M77.7931 71.0812C79.247 68.8564 80.2386 66.2311 80.851 63.6136C80.9219 63.3061 81.3304 63.2557 81.4785 63.5331C82.7647 65.8925 84.4331 68.1558 86.4201 69.908C86.6332 70.0871 86.5233 70.4405 86.252 70.4774L78.1152 71.5836C77.8342 71.6237 77.6435 71.317 77.8029 71.0779L77.7931 71.0812Z",
    fill: "url(#paint197_linear_10106_6282)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M77.8295 71.1889C79.2508 68.997 80.2361 66.4175 80.8388 63.836C80.9128 63.5055 81.3605 63.4419 81.5283 63.7454C82.8111 66.0623 84.4467 68.293 86.4042 70.0225C86.6239 70.2211 86.5173 70.5844 86.2231 70.6181L78.1713 71.7174C77.8805 71.7609 77.6734 71.4379 77.8393 71.1856L77.8295 71.1889Z",
    fill: "url(#paint198_linear_10106_6282)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M77.866 71.2967C79.2645 69.1343 80.2204 66.5973 80.8364 64.055C80.9234 63.6984 81.4038 63.6347 81.588 63.9544C82.8575 66.2322 84.4701 68.427 86.3884 70.1369C86.6212 70.3421 86.5015 70.7316 86.1976 70.7686L78.2176 71.8546C77.9039 71.8948 77.6936 71.5621 77.866 71.2967Z",
    fill: "url(#paint199_linear_10106_6282)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M77.9119 71.4011C79.2778 69.2715 80.2339 66.7673 80.8434 64.2708C80.9435 63.8879 81.4533 63.8143 81.6473 64.1635C82.9037 66.402 84.4933 68.5609 86.382 70.2481C86.6313 70.4696 86.5051 70.8721 86.1816 70.9157L78.2866 71.9949C77.9631 72.0385 77.7363 71.6894 77.9152 71.4109L77.9119 71.4011Z",
    fill: "url(#paint200_linear_10106_6282)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M77.9482 71.5089C79.2881 69.399 80.228 66.9439 80.8409 64.4898C80.9409 64.0743 81.4964 64.0071 81.7069 64.3725C82.95 66.5719 84.5166 68.6949 86.3759 70.3593C86.6284 70.5906 86.499 71.016 86.1624 71.0531L78.3491 72.1157C78.006 72.1659 77.7693 71.7874 77.958 71.5056L77.9482 71.5089Z",
    fill: "url(#paint201_linear_10106_6282)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M77.9847 71.6167C79.3018 69.5363 80.2254 67.1302 80.8385 64.7089C80.9514 64.2672 81.5462 64.1867 81.7665 64.5815C82.9998 66.7515 84.5401 68.8289 86.36 70.4738C86.6257 70.7115 86.4898 71.1501 86.1369 71.2036L78.3988 72.2626C78.0426 72.3063 77.7928 71.9214 77.9847 71.6167Z",
    fill: "url(#paint202_linear_10106_6282)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M78.0309 71.7211C79.3252 69.6702 80.2294 67.3035 80.836 64.9279C80.9522 64.4633 81.5861 64.3696 81.8262 64.7906C83.0462 66.9213 84.5635 68.9628 86.354 70.5849C86.636 70.839 86.4838 71.2939 86.1211 71.3507L78.4647 72.3932C78.0889 72.4435 77.8325 72.0389 78.0309 71.7211Z",
    fill: "url(#paint203_linear_10106_6282)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M78.067 71.8289C79.3288 69.8108 80.2331 67.4767 80.8334 65.147C80.9625 64.6562 81.6291 64.5624 81.8856 64.9996C83.0924 67.0912 84.5867 69.0968 86.3379 70.6994C86.6232 70.9633 86.4776 71.4378 86.092 71.4914L78.5205 72.527C78.1349 72.5806 77.8622 72.1598 78.067 71.8289Z",
    fill: "url(#paint204_linear_10106_6282)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M78.1132 71.9334C79.3521 69.9448 80.2402 67.6598 80.8406 65.3628C80.9794 64.8359 81.6788 64.742 81.9451 65.2087C83.1388 67.2611 84.6002 69.2341 86.3317 70.8106C86.6301 71.081 86.4716 71.5817 86.0762 71.6386L78.5864 72.6576C78.1812 72.7178 77.9018 72.2774 78.1132 71.9334Z",
    fill: "url(#paint205_linear_10106_6282)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M78.1495 72.0411C79.3656 70.082 80.2343 67.8364 80.8348 65.572C80.9768 65.0223 81.7186 64.925 82.0014 65.4079C83.1818 67.4211 84.6203 69.3582 86.3222 70.912C86.637 71.1986 86.472 71.7125 86.0537 71.7662L78.6391 72.7816C78.2208 72.8353 77.9283 72.3884 78.1462 72.0313L78.1495 72.0411Z",
    fill: "url(#paint206_linear_10106_6282)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M78.1858 72.1489C79.3792 70.2193 80.2415 68.0194 80.8323 65.791C80.9873 65.2151 81.7585 65.1079 82.0643 65.6267C83.2348 67.6105 84.6469 69.502 86.3096 71.0363C86.6277 71.3327 86.4595 71.8694 86.0314 71.9264L78.6985 72.9253C78.2704 72.9823 77.9582 72.5093 78.1923 72.1358L78.1858 72.1489Z",
    fill: "url(#paint207_linear_10106_6282)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M78.232 72.2534C79.4026 70.3532 80.2454 68.1927 80.8298 66.0101C80.988 65.4113 81.8017 65.3007 82.1239 65.8358C83.2714 67.7837 84.6703 69.636 86.3035 71.1474C86.6347 71.4504 86.4633 72.01 86.0156 72.0736L78.7676 73.0656C78.3199 73.1292 78.0012 72.6366 78.2418 72.2501L78.232 72.2534Z",
    fill: "url(#paint208_linear_10106_6282)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M78.2683 72.3611C79.4096 70.5036 80.2525 68.3757 80.8272 66.2292C80.9984 65.6041 81.8415 65.4836 82.1736 66.0481C83.3079 67.9568 84.6871 69.783 86.281 71.275C86.6286 71.5942 86.4409 72.1703 85.9801 72.2274L78.804 73.2061C78.3432 73.2632 78.0114 72.7641 78.2585 72.3644L78.2683 72.3611Z",
    fill: "url(#paint209_linear_10106_6282)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M78.3144 72.4656C79.4329 70.6376 80.2563 68.549 80.8344 66.4449C81.0153 65.7839 81.8944 65.6731 82.2429 66.2538C83.364 68.1234 84.7104 69.917 86.2846 71.3829C86.6355 71.7119 86.4544 72.3075 85.974 72.3712L78.8829 73.3431C78.4025 73.4068 78.064 72.8882 78.3177 72.4754L78.3144 72.4656Z",
    fill: "url(#paint210_linear_10106_6282)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M78.3508 72.5734C79.4465 70.7748 80.2635 68.7321 80.832 66.664C81.0161 65.9801 81.9343 65.856 82.3025 66.4629C83.4006 68.2965 84.7338 70.0509 86.2785 71.4941C86.6458 71.8394 86.4485 72.4514 85.955 72.5086L78.9455 73.4639C78.4554 73.5309 78.1005 72.9959 78.3606 72.5701L78.3508 72.5734Z",
    fill: "url(#paint211_linear_10106_6282)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M78.387 72.6811C79.4599 70.9121 80.2574 68.9086 80.8293 66.883C81.0264 66.1729 81.9773 66.0488 82.3619 66.6719C83.4501 68.4762 84.757 70.1849 86.2624 71.6085C86.6428 71.9604 86.4389 72.5855 85.9292 72.6591L79.0047 73.6075C78.4949 73.6812 78.1334 73.1266 78.4001 72.6876L78.387 72.6811Z",
    fill: "url(#paint212_linear_10106_6282)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M78.4333 72.7856C79.4834 71.0461 80.2746 69.0884 80.827 67.1021C81.037 66.3658 82.0173 66.2317 82.4118 66.8842C83.4868 68.6493 84.7707 70.3222 86.2466 71.723C86.6303 72.0846 86.4233 72.7327 85.9037 72.8096L79.0511 73.7447C78.5282 73.8118 78.1537 73.2508 78.4235 72.7889L78.4333 72.7856Z",
    fill: "url(#paint213_linear_10106_6282)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M78.4696 72.8934C79.497 71.1833 80.2687 69.2649 80.8245 67.3211C81.0377 66.5619 82.0605 66.4245 82.4714 67.0933C83.5234 68.8225 84.7843 70.4594 86.2405 71.8342C86.6406 72.2121 86.427 72.8732 85.8846 72.947L79.117 73.8752C78.5745 73.949 78.1933 73.3683 78.4696 72.8934Z",
    fill: "url(#paint214_linear_10106_6282)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.5059 73.0011C79.5137 71.3304 80.2757 69.448 80.8218 67.5401C81.0481 66.7548 82.1003 66.6074 82.5309 67.3023C83.5697 68.9923 84.8108 70.6032 86.2244 71.9487C86.6278 72.3364 86.4111 73.0204 85.8588 73.0974L79.1729 74.0091C78.6207 74.0861 78.2198 73.4794 78.5059 73.0011Z",
    fill: "url(#paint215_linear_10106_6282)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M78.552 73.1056C79.5371 71.4644 80.2894 69.618 80.8258 67.7461C81.065 66.9345 82.15 66.787 82.6003 67.508C83.6193 69.172 84.8342 70.7372 86.2281 72.0566C86.6479 72.4606 86.4247 73.1577 85.8528 73.2413L79.2388 74.1396C78.6636 74.2135 78.2594 73.597 78.5618 73.1023L78.552 73.1056Z",
    fill: "url(#paint216_linear_10106_6282)"
  })))), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9177 68.8606C81.1156 68.4121 81.3005 67.957 81.469 67.5184C81.537 67.3318 81.7887 67.3015 81.9069 67.4581C82.1893 67.8429 82.4816 68.2244 82.7967 68.6091C82.9247 68.7624 82.8372 68.9882 82.6412 69.0216L81.1805 69.2194C80.9811 69.2429 80.8399 69.0505 80.921 68.8704L80.9177 68.8606Z",
    fill: "url(#paint217_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 67,
    width: 3,
    height: 3
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9177 68.8606C81.1156 68.4121 81.3005 67.957 81.469 67.5184C81.537 67.3318 81.7887 67.3015 81.9069 67.4581C82.1893 67.8429 82.4816 68.2244 82.7967 68.6091C82.9247 68.7624 82.8372 68.9882 82.6412 69.0216L81.1805 69.2194C80.9811 69.2429 80.8399 69.0505 80.921 68.8704L80.9177 68.8606Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9177 68.8606C81.1156 68.4121 81.3005 67.957 81.469 67.5184C81.537 67.3318 81.7887 67.3015 81.9069 67.4581C82.1893 67.8429 82.4816 68.2244 82.7967 68.6091C82.9247 68.7624 82.8372 68.9882 82.6412 69.0216L81.1805 69.2194C80.9811 69.2429 80.8399 69.0505 80.921 68.8704L80.9177 68.8606Z",
    fill: "url(#paint218_linear_10106_6282)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M80.9277 68.9227C81.1257 68.4741 81.304 68.0322 81.4758 67.6033C81.5504 67.4037 81.8118 67.3701 81.9333 67.5364C82.2124 67.9114 82.5047 68.293 82.8165 68.6679C82.9479 68.8309 82.8538 69.0699 82.6447 69.0968L81.2069 69.2977C80.9977 69.3246 80.8499 69.1126 80.9277 68.9227Z",
    fill: "url(#paint219_linear_10106_6282)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.9343 68.975C81.1257 68.5395 81.3041 68.0976 81.4661 67.672C81.5406 67.4724 81.8216 67.4322 81.9465 67.6083C82.2125 67.9768 82.5015 68.3486 82.8133 68.7235C82.9479 68.8963 82.8572 69.1451 82.6383 69.1752L81.22 69.3696C81.0011 69.3998 80.8402 69.1813 80.9245 68.9783L80.9343 68.975Z",
    fill: "url(#paint220_linear_10106_6282)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M80.9443 69.0371C81.1357 68.6016 81.3108 68.1826 81.4729 67.757C81.5539 67.5442 81.8447 67.5007 81.9728 67.6867C82.2389 68.0552 82.5245 68.4171 82.8233 68.7856C82.971 68.9649 82.864 69.2301 82.6451 69.2602L81.2464 69.448C81.0177 69.4814 80.8535 69.2531 80.9443 69.0371Z",
    fill: "url(#paint221_linear_10106_6282)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M80.951 69.0893C81.1359 68.667 81.3111 68.2479 81.4731 67.8224C81.5606 67.5965 81.8547 67.5628 81.996 67.7552C82.2587 68.114 82.5443 68.4759 82.8398 68.8346C82.9908 69.0237 82.8871 69.2986 82.6453 69.3256L81.2695 69.5166C81.031 69.5533 80.8504 69.3087 80.951 69.0893Z",
    fill: "url(#paint222_linear_10106_6282)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M80.961 69.1514C81.146 68.7291 81.3146 68.3231 81.4701 67.9107C81.5543 67.675 81.8681 67.6347 82.0224 67.8336C82.2818 68.1826 82.5577 68.5478 82.8498 68.8966C83.0041 69.0955 82.894 69.3836 82.6521 69.4106L81.296 69.5949C81.0443 69.6252 80.8637 69.3806 80.961 69.1514Z",
    fill: "url(#paint223_linear_10106_6282)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M80.9581 69.207C81.1365 68.7978 81.3051 68.3918 81.4607 67.9794C81.5547 67.7404 81.8782 67.6968 82.0358 67.9055C82.2953 68.2545 82.5645 68.6001 82.8469 68.9522C83.011 69.1478 82.8976 69.4588 82.6362 69.4924L81.3029 69.6799C81.0415 69.7135 80.8542 69.4493 80.9614 69.2168L80.9581 69.207Z",
    fill: "url(#paint224_linear_10106_6282)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M80.968 69.2691C81.1465 68.8598 81.3086 68.467 81.4675 68.0643C81.568 67.8122 81.9013 67.7654 82.0622 67.9839C82.3183 68.323 82.5778 68.672 82.8568 69.0143C83.0242 69.2197 82.9011 69.534 82.6429 69.5773L81.3293 69.7583C81.0581 69.7952 80.8577 69.5245 80.9713 69.2789L80.968 69.2691Z",
    fill: "url(#paint225_linear_10106_6282)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M80.9748 69.3214C81.1467 68.9253 81.3089 68.5324 81.4579 68.133C81.5551 67.8712 81.9113 67.8275 82.0723 68.046C82.3186 68.3884 82.5846 68.7243 82.8603 69.0568C83.031 69.272 82.9111 69.5961 82.6301 69.6363L81.3361 69.8106C81.055 69.8508 80.8514 69.5703 80.9617 69.3149L80.9748 69.3214Z",
    fill: "url(#paint226_linear_10106_6282)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M80.9848 69.3835C81.1568 68.9873 81.3124 68.6076 81.4648 68.218C81.5685 67.943 81.9345 67.8961 82.1118 68.1308C82.3548 68.4635 82.6175 68.7895 82.8834 69.1254C83.0672 69.3471 82.9311 69.6876 82.6501 69.7277L81.3789 69.9053C81.0881 69.9487 80.8778 69.6487 80.9881 69.3933L80.9848 69.3835Z",
    fill: "url(#paint227_linear_10106_6282)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M80.9914 69.4358C81.1569 69.0527 81.3125 68.673 81.4584 68.2965C81.5719 68.0182 81.9444 67.9581 82.125 68.2027C82.3648 68.5256 82.6176 68.8549 82.8802 69.181C83.0674 69.4125 82.9345 69.7627 82.6339 69.8095L81.3823 69.9804C81.0817 70.0272 80.8584 69.7207 80.9816 69.4391L80.9914 69.4358Z",
    fill: "url(#paint228_linear_10106_6282)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M81.0015 69.4979C81.1703 69.1246 81.3259 68.7448 81.462 68.3717C81.5722 68.0836 81.9676 68.0267 82.1515 68.2811C82.3912 68.604 82.6408 68.9235 82.9001 69.2398C83.0905 69.4811 82.9512 69.8444 82.6473 69.8814L81.4153 70.0457C81.1114 70.0827 80.8782 69.7794 80.9982 69.4881L81.0015 69.4979Z",
    fill: "url(#paint229_linear_10106_6282)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M81.0081 69.5501C81.1671 69.1802 81.3261 68.8102 81.4654 68.4468C81.5821 68.1457 81.9775 68.0888 82.1745 68.3497C82.411 68.6627 82.6474 68.9758 82.9067 69.292C83.1103 69.5398 82.9644 69.9163 82.6409 69.9599L81.4318 70.1274C81.1181 70.1677 80.8686 69.8481 80.9983 69.5534L81.0081 69.5501Z",
    fill: "url(#paint230_linear_10106_6282)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M81.0084 69.6155C81.1706 69.2553 81.3198 68.8887 81.4493 68.5286C81.5725 68.2144 81.981 68.164 82.178 68.4248C82.4014 68.7314 82.6476 69.0412 82.8939 69.3509C83.1007 69.6085 82.9483 69.9981 82.6248 70.0416L81.4353 70.2026C81.1118 70.2461 80.859 69.9168 80.9855 69.6123L81.0084 69.6155Z",
    fill: "url(#paint231_linear_10106_6282)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M81.015 69.6678C81.1675 69.3109 81.32 68.9541 81.4528 68.6038C81.5727 68.2798 82.0008 68.2227 82.2142 68.4999C82.4376 68.8065 82.6805 69.1064 82.9234 69.4064C83.1336 69.6738 82.9845 70.0731 82.6479 70.1102L81.4813 70.2743C81.148 70.3212 80.8919 69.9821 81.0248 69.6645L81.015 69.6678Z",
    fill: "url(#paint232_linear_10106_6282)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M81.0253 69.7299C81.181 69.3828 81.3237 69.0293 81.4566 68.679C81.5862 68.3516 82.0241 68.2913 82.2375 68.5685C82.4576 68.8653 82.6907 69.1685 82.9304 69.4587C83.1536 69.7326 82.9882 70.1483 82.6418 70.1887L81.4948 70.3462C81.1517 70.3964 80.8792 70.041 81.022 69.7201L81.0253 69.7299Z",
    fill: "url(#paint233_linear_10106_6282)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M81.032 69.7822C81.1779 69.4384 81.3239 69.0947 81.4503 68.7575C81.5864 68.417 82.0341 68.3534 82.2542 68.6502C82.4742 68.9469 82.7007 69.2306 82.9306 69.5241C83.1571 69.8078 82.9917 70.2235 82.6388 70.277L81.5114 70.4279C81.1552 70.4716 80.8827 70.1162 81.0222 69.7855L81.032 69.7822Z",
    fill: "url(#paint234_linear_10106_6282)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M81.0418 69.8443C81.1911 69.5103 81.3273 69.1698 81.4569 68.8425C81.5898 68.4922 82.0604 68.4318 82.2804 68.7285C82.4972 69.0155 82.7139 69.3025 82.9502 69.5829C83.1801 69.8763 83.0082 70.3052 82.6422 70.3522L81.5377 70.5063C81.1717 70.5533 80.8828 70.1815 81.0418 69.8443Z",
    fill: "url(#paint235_linear_10106_6282)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M81.0486 69.8965C81.1881 69.5659 81.3276 69.2352 81.4572 68.9078C81.5966 68.5445 82.077 68.4808 82.3036 68.7971C82.517 69.0743 82.7338 69.3613 82.957 69.6351C83.1999 69.9351 83.0216 70.3771 82.6458 70.4274L81.5609 70.5748C81.1851 70.6251 80.8928 70.2436 81.0486 69.8965Z",
    fill: "url(#paint236_linear_10106_6282)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.0553 69.9488C81.1981 69.628 81.3277 69.3006 81.4509 68.9863C81.6001 68.6197 82.0903 68.5526 82.3267 68.8657C82.5303 69.1462 82.7405 69.4135 82.9637 69.6874C83.2099 69.9972 83.0349 70.4489 82.6395 70.5058L81.5873 70.6532C81.2017 70.7068 80.9061 70.3155 81.0553 69.9488Z",
    fill: "url(#paint237_linear_10106_6282)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M81.0654 70.0109C81.1984 69.6933 81.3314 69.3758 81.4545 69.0615C81.6004 68.6851 82.1004 68.6147 82.3499 68.9343C82.5502 69.205 82.7604 69.4723 82.9836 69.7462C83.2331 70.0658 83.0516 70.5306 82.6562 70.5875L81.6236 70.7283C81.2282 70.7852 80.9163 70.3776 81.0752 70.0076L81.0654 70.0109Z",
    fill: "url(#paint238_linear_10106_6282)"
  })))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6446 69.0641L81.1838 69.2619C81.0695 69.2786 80.968 69.2364 80.9056 69.1484C80.8432 69.0603 80.8264 68.9459 80.8686 68.8445C81.06 68.409 81.2449 67.9539 81.4199 67.5022C81.462 67.4007 81.5468 67.3285 81.6612 67.3118C81.7755 67.295 81.877 67.3372 81.9427 67.435C82.2285 67.8297 82.5305 68.2079 82.8293 68.5763C82.9015 68.6611 82.9182 68.7755 82.8761 68.877C82.8339 68.9784 82.7491 69.0507 82.6348 69.0674L82.6446 69.0641ZM81.6713 67.4065C81.5994 67.4199 81.5374 67.4626 81.5181 67.5346C81.343 67.9863 81.1582 68.4414 80.9668 68.8768C80.9343 68.9423 80.9509 69.024 80.9903 69.0762C81.0331 69.1381 81.1083 69.1673 81.1802 69.154L82.6409 68.9562C82.7128 68.9429 82.7748 68.9002 82.7942 68.8282C82.8233 68.7529 82.81 68.681 82.7575 68.6223C82.449 68.2572 82.1534 67.8659 81.8677 67.4713C81.825 67.4093 81.7497 67.3801 81.6778 67.3934L81.6713 67.4065Z",
    fill: "url(#paint239_linear_10106_6282)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M86.278 70.425L78.0595 71.5478C77.9027 71.5679 77.7488 71.4998 77.6567 71.3562C77.568 71.2225 77.574 71.0459 77.6585 70.9083C79.0214 68.8343 80.0915 66.2152 80.7358 63.3688C80.7778 63.2019 80.9114 63.0805 81.078 63.0571C81.2447 63.0336 81.415 63.1181 81.4972 63.2649C82.8887 65.8397 84.6093 68.0636 86.4816 69.7018C86.6062 69.8125 86.6492 69.9726 86.604 70.1297C86.5587 70.2867 86.4316 70.3951 86.2649 70.4185L86.278 70.425ZM81.1147 63.2629C81.0526 63.2729 80.9677 63.3124 80.9485 63.4171C80.2912 66.2898 79.2146 68.9219 77.8387 71.0221C77.7964 71.0909 77.7935 71.1792 77.8362 71.2412C77.8822 71.313 77.9575 71.3421 78.0327 71.3386L86.2512 70.2158C86.3329 70.1992 86.3948 70.1565 86.4207 70.0714C86.4499 69.9961 86.4202 69.908 86.3514 69.8657C84.4627 68.2112 82.7224 65.9612 81.3145 63.3701C81.2619 63.2788 81.1768 63.2529 81.1049 63.2662L81.1147 63.2629Z",
    fill: "url(#paint240_linear_10106_6282)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7708 64.862C85.1207 65.502 82.7232 62.2408 80.863 59.3112C80.7216 59.0861 80.3752 59.1265 80.2878 59.385C79.2692 62.7395 77.8792 66.4809 73.1965 67.1211C69.1379 67.6708 65.3981 64.8293 64.8385 60.774C64.5705 58.846 65.0675 56.922 66.2294 55.3521C68.1333 52.7793 70.7867 52.3977 72.9925 52.1124C73.2213 52.0789 73.3414 51.8203 73.2099 51.6246C72.1355 50.0229 71.6475 48.8018 71.4331 47.2595C70.8769 43.2139 73.7249 39.461 77.7803 38.9015C81.8389 38.3517 85.5787 41.1933 86.1383 45.2486C86.3495 46.8139 86.1674 48.0862 85.5883 49.9288C85.5204 50.1481 85.7043 50.3698 85.933 50.3363C88.0897 50.0348 90.7988 49.689 93.3227 51.6421C94.86 52.8368 95.8564 54.5629 96.1146 56.4942C96.6644 60.5529 93.8228 64.2927 89.7675 64.8522L89.7708 64.862Z",
    fill: "url(#paint241_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 38,
    width: 33,
    height: 30
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7707 64.862C85.1598 65.4888 82.7625 62.293 80.9089 59.383C80.7445 59.122 80.3491 59.1789 80.2618 59.4701C79.2464 62.8017 77.8464 66.4811 73.1964 67.1211C69.1377 67.6708 65.3979 64.8293 64.8384 60.774C64.5704 58.846 65.0674 56.922 66.2293 55.3521C68.1202 52.8055 70.7245 52.4077 72.9172 52.1159C73.1786 52.0824 73.3182 51.7844 73.1671 51.5626C72.1255 49.9935 71.6375 48.7725 71.4297 47.2497C70.8735 43.2041 73.7215 39.4512 77.7768 38.8917C81.8355 38.3419 85.5753 41.1835 86.1348 45.2388C86.3427 46.7943 86.1638 48.0438 85.5978 49.8601C85.5202 50.1154 85.7335 50.3599 85.9917 50.3165C88.1386 50.0183 90.8216 49.6922 93.3095 51.6357C94.8468 52.8303 95.8432 54.5564 96.1014 56.4877C96.6512 60.5464 93.8096 64.2862 89.7543 64.8457L89.7707 64.862Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9543 65.0183C84.8957 65.7088 82.5345 62.5553 80.5821 59.4167C79.5572 62.8497 78.2774 66.3031 73.71 67.2207C69.3941 68.0754 65.1508 65.229 64.5346 60.8436C64.2566 58.8536 64.7534 56.8642 65.9445 55.2517C67.8386 52.6822 70.1447 52.0795 72.3571 51.7811C72.6708 51.7408 72.833 51.3806 72.6556 51.1131C71.6369 49.5473 71.4502 48.4756 71.2489 46.9397C70.6724 42.7046 73.6964 38.7942 77.9647 38.3483C82.0531 37.9194 85.7085 40.9313 86.2714 45.0291C86.4759 46.5421 86.6003 47.5584 86.0571 49.3453C85.9763 49.6235 86.1962 49.8875 86.4805 49.8572C88.5033 49.579 90.7131 49.4997 93.0494 51.0905C94.3241 51.9592 95.7722 53.8603 96.1957 55.3432C97.4925 59.9028 94.4573 64.3952 89.9641 65.015L89.9543 65.0183Z",
    fill: "url(#paint242_linear_10106_6282)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M89.9609 65.0052C84.9121 65.6924 82.5936 62.6008 80.5885 59.3709C79.5411 62.8988 78.2677 66.3064 73.6937 67.2044C69.4268 68.0426 65.2326 65.2123 64.6133 60.8826C64.3386 58.9023 64.8322 56.9358 66.007 55.3397C67.8784 52.7998 70.1649 52.2036 72.3968 51.8986C72.753 51.8549 72.9412 51.4424 72.7408 51.139C71.7287 49.5927 71.5453 48.5308 71.331 47.0211C70.7448 42.8221 73.7362 38.9118 77.9619 38.4693C82.0177 38.0405 85.65 41.0165 86.2129 45.0816C86.4141 46.5848 86.532 47.6142 85.9854 49.3913C85.8851 49.7088 86.1543 50.0217 86.4778 49.9781C88.5103 49.6967 90.7005 49.624 93.0041 51.1822C94.2885 52.0476 95.7269 53.952 96.1503 55.4349C97.4208 59.9488 94.4116 64.3888 89.9576 64.9954L89.9609 65.0052Z",
    fill: "url(#paint243_linear_10106_6282)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M89.9607 65.0052C84.9316 65.6858 82.646 62.6595 80.5818 59.3514C79.5053 62.9872 78.2415 66.3261 73.651 67.2078C69.4233 68.0328 65.2782 65.2187 64.6754 60.938C64.3975 58.9806 64.8977 57.0337 66.0628 55.4409C67.9113 52.9304 70.1783 52.3409 72.4331 52.0391C72.8383 51.9789 73.046 51.527 72.8192 51.178C71.8268 49.6578 71.6238 48.6025 71.4063 47.1157C70.8105 42.9526 73.7627 39.0555 77.9622 38.6001C81.9819 38.1616 85.6077 41.118 86.1476 45.1472C86.3488 46.6504 86.4437 47.6767 85.907 49.4504C85.7905 49.817 86.0957 50.1723 86.4715 50.122C88.5237 49.834 90.6845 49.7711 92.965 51.2935C94.2462 52.1491 95.6943 54.0502 96.1015 55.5495C97.3424 60.0079 94.3592 64.3955 89.9574 64.9954L89.9607 65.0052Z",
    fill: "url(#paint244_linear_10106_6282)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M89.9576 64.9954C84.9415 65.6824 82.6855 62.7117 80.5687 59.3122C79.4599 63.0461 78.2122 66.336 73.6054 67.2014C69.4234 68.0001 65.3307 65.212 64.7313 60.9737C64.46 59.036 64.9439 57.1054 66.1058 55.5356C67.9315 53.0546 70.169 52.475 72.4532 52.1633C72.9009 52.0996 73.1346 51.5954 72.8849 51.2104C71.9121 49.7164 71.6896 48.6677 71.4754 47.1907C70.8665 43.0538 73.7828 39.1797 77.9497 38.7244C81.9465 38.2827 85.5395 41.2065 86.0792 45.203C86.2804 46.7062 86.3656 47.7358 85.8256 49.4997C85.7027 49.9121 86.0343 50.3131 86.4623 50.2561C88.5276 49.9745 90.672 49.8954 92.9132 51.3983C94.2042 52.2505 95.6425 54.155 96.0497 55.6542C97.2643 60.067 94.307 64.4022 89.9478 64.9987L89.9576 64.9954Z",
    fill: "url(#paint245_linear_10106_6282)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M89.964 64.9823C84.9675 65.6628 82.7444 62.7573 80.5685 59.2795C79.4273 63.1116 78.1925 66.3426 73.5824 67.1982C69.4395 67.9837 65.409 65.2183 64.813 61.0225C64.5483 59.1043 65.0258 57.1869 66.1812 55.6301C67.9841 53.1786 70.2021 52.6056 72.5059 52.2873C73.0058 52.217 73.2524 51.6538 72.9796 51.233C72.0135 49.7585 71.7845 48.7229 71.5671 47.2688C70.9485 43.1679 73.8256 39.307 77.9663 38.8387C81.9305 38.3972 85.5004 41.2851 86.0433 45.2587C86.2412 46.7521 86.3068 47.7883 85.7733 49.5391C85.6309 49.9908 86.0117 50.4407 86.4789 50.3704C88.554 50.0856 90.669 50.0164 92.8839 51.4736C94.1749 52.3258 95.6132 54.2303 96.0204 55.7295C97.2087 60.0966 94.2741 64.3696 89.9672 64.9594L89.964 64.9823Z",
    fill: "url(#paint246_linear_10106_6282)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M89.9639 64.9823C84.9773 65.6595 82.7871 62.8192 80.5684 59.2468C79.4046 63.1739 78.1729 66.3492 73.5497 67.1984C69.4525 67.9575 65.4646 65.2214 64.8851 61.0746C64.6139 59.1695 65.098 57.2717 66.237 55.7313C68.0205 53.3191 70.2156 52.7429 72.5325 52.4311C73.0749 52.3573 73.3475 51.7418 73.0517 51.2851C72.1053 49.8367 71.8567 48.8077 71.6328 47.3667C71.0012 43.292 73.8425 39.4541 77.9602 38.9826C81.8982 38.5281 85.4517 41.3997 85.9815 45.3341C86.1892 46.8242 86.2352 47.867 85.6983 49.608C85.5496 50.1055 85.9566 50.6011 86.4762 50.5241C88.5708 50.2327 90.6662 50.1701 92.8386 51.598C94.1393 52.4469 95.5679 54.3547 95.9619 55.8474C97.1108 60.1623 94.2251 64.3861 89.9573 64.9628L89.9639 64.9823Z",
    fill: "url(#paint247_linear_10106_6282)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M89.9606 64.9725C84.9968 65.6528 82.8362 62.8681 80.5584 59.2174C79.3622 63.2426 78.1467 66.3689 73.5071 67.2018C69.4589 67.9444 65.5201 65.2245 64.9473 61.1299C64.6828 59.2444 65.1603 57.3597 66.2831 55.8357C68.0438 53.4531 70.2192 52.8835 72.5557 52.565C73.1407 52.4879 73.4392 51.8199 73.1171 51.3176C72.1904 49.8952 71.9222 48.8729 71.7049 47.4514C71.0637 43.4127 73.8755 39.5848 77.9475 39.1069C81.8528 38.6524 85.3833 41.4882 85.9129 45.3899C86.1206 46.88 86.1535 47.9163 85.6166 49.6574C85.4517 50.2039 85.8916 50.732 86.4569 50.6615C88.5647 50.3765 90.6372 50.3107 92.7865 51.7028C94.0873 52.5517 95.5125 54.4497 95.9099 55.9522C97.0227 60.2247 94.1694 64.383 89.9475 64.966L89.9606 64.9725Z",
    fill: "url(#paint248_linear_10106_6282)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M89.9672 64.9594C85.0132 65.6365 82.8954 62.9137 80.5551 59.1749C79.3266 63.2983 78.124 66.3657 73.4712 67.1921C69.4623 67.9215 65.5823 65.2144 65.013 61.1624C64.755 59.2965 65.2293 57.4347 66.3423 55.914C68.0803 53.5608 70.2263 53.0011 72.5922 52.6728C73.2294 52.5889 73.5441 51.8719 73.1991 51.3336C72.2789 49.9309 72.0042 48.9216 71.7838 47.5231C71.1328 43.5204 73.9055 39.7056 77.9512 39.2148C81.8205 38.7506 85.3412 41.557 85.8642 45.4391C86.0719 46.9292 86.0852 47.9721 85.5548 49.7001C85.3704 50.2859 85.8595 50.8629 86.4673 50.789C88.5849 50.5007 90.6378 50.4415 92.7543 51.801C94.0615 52.6368 95.4901 54.5446 95.8776 56.0504C96.9608 60.2674 94.1369 64.3832 89.9639 64.9497L89.9672 64.9594Z",
    fill: "url(#paint249_linear_10106_6282)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M89.9671 64.9594C85.0327 65.6298 82.938 62.9757 80.5582 59.152C79.2973 63.3736 78.1075 66.3821 73.4515 67.1987C69.4882 67.9018 65.6542 65.2338 65.098 61.221C64.8336 59.3682 65.3047 57.5293 66.4145 56.0315C68.1297 53.7078 70.2561 53.1547 72.6449 52.8296C73.3213 52.7325 73.6653 51.9728 73.2939 51.3889C72.3935 50.0123 72.0992 49.0096 71.8722 47.6242C71.2083 43.6476 73.9451 39.8559 77.9581 39.3651C81.8045 38.8978 85.2924 41.6715 85.8153 45.521C86.0197 47.0013 86.0265 48.0573 85.4928 49.7755C85.302 50.4071 85.8174 51.0298 86.4742 50.9393C88.6114 50.6445 90.6316 50.5854 92.7186 51.9221C94.0259 52.7579 95.4544 54.6656 95.8322 56.1748C96.8891 60.3461 94.0878 64.3997 89.9573 64.9627L89.9671 64.9594Z",
    fill: "url(#paint250_linear_10106_6282)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M89.9639 64.9496C85.0426 65.6265 82.9873 63.0245 80.5451 59.1128C79.2616 63.4293 78.0749 66.3822 73.4058 67.1923C69.4784 67.8724 65.7066 65.2271 65.1571 61.2666C64.8993 59.4333 65.3639 57.6075 66.4672 56.1228C68.1596 53.8286 70.2664 53.2821 72.6748 52.9504C73.3937 52.8499 73.7702 52.0248 73.3693 51.4181C72.4886 50.0675 72.1845 49.0681 71.9543 47.7056C71.2807 43.7651 73.9783 39.9865 77.9652 39.4828C81.7756 39.0058 85.247 41.7632 85.7665 45.5702C85.9709 47.0505 85.9548 48.1033 85.4276 49.8084C85.2207 50.4891 85.7819 51.1509 86.4813 51.057C88.6315 50.7686 90.6288 50.7063 92.683 52.0105C94.0001 52.843 95.4188 54.754 95.7966 56.2632C96.8272 60.3889 94.0519 64.39 89.9736 64.9463L89.9639 64.9496Z",
    fill: "url(#paint251_linear_10106_6282)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M89.9703 64.9365C85.0686 65.6068 83.0364 63.0734 80.5449 59.0801C79.2291 63.4948 78.0553 66.3888 73.3731 67.1924C69.4946 67.856 65.7719 65.2269 65.2292 61.3186C64.9779 59.505 65.4361 57.6923 66.5231 56.224C68.1926 53.9593 70.2799 53.4194 72.7079 53.0811C73.4791 52.9739 73.8717 52.0997 73.438 51.4603C72.5639 50.1294 72.2533 49.1431 72.02 47.8035C71.3334 43.8891 74.0049 40.1303 77.9492 39.63C81.7368 39.1497 85.1852 41.8713 85.6981 45.6587C85.9025 47.139 85.8766 48.1951 85.3461 49.8904C85.1197 50.6104 85.7203 51.3243 86.4719 51.2237C88.632 50.9321 90.6162 50.8633 92.6278 52.1381C93.9449 52.9707 95.3603 54.8719 95.7381 56.3811C96.7292 60.4546 93.9897 64.4 89.9638 64.9496L89.9703 64.9365Z",
    fill: "url(#paint252_linear_10106_6282)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M89.9703 64.9366C85.0784 65.6035 83.0889 63.1321 80.535 59.0507C79.1868 63.5636 78.0292 66.4085 73.3306 67.1958C69.488 67.8364 65.8177 65.2333 65.2784 61.3675C65.0337 59.5735 65.4854 57.7739 66.5561 56.322C68.2029 54.0868 70.2706 53.5535 72.7181 53.2086C73.5318 53.0979 73.9504 52.1713 73.4904 51.4863C72.636 50.1815 72.3058 49.2018 72.066 47.8752C71.3697 43.9969 73.9987 40.2415 77.9202 39.7379C81.6717 39.2481 85.1004 41.9435 85.6132 45.6983C85.8143 47.1688 85.7688 48.2314 85.2481 49.9234C85.0153 50.6892 85.6423 51.4489 86.4462 51.3415C88.6258 51.0433 90.5807 50.9844 92.5693 52.2233C93.8928 53.0428 95.3116 54.9538 95.6697 56.4696C96.6346 60.4974 93.921 64.3904 89.9343 64.9269L89.9703 64.9366Z",
    fill: "url(#paint253_linear_10106_6282)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M89.9671 64.9267C85.0948 65.5871 83.1382 63.1809 80.535 59.018C79.1545 63.6291 78.0097 66.4151 73.3078 67.1926C69.5142 67.8167 65.8963 65.2395 65.3604 61.4163C65.1092 59.6353 65.5708 57.8651 66.6317 56.4165C68.2557 54.2108 70.294 53.6874 72.7743 53.3424C73.6402 53.2251 74.0751 52.2494 73.5921 51.5285C72.7476 50.253 72.4076 49.2766 72.1743 47.9697C71.465 44.1176 74.0582 40.3851 77.9534 39.8686C81.6821 39.3755 85.0911 42.0449 85.5907 45.7604C85.7917 47.2309 85.7365 48.2969 85.2223 49.9758C84.9733 50.7907 85.6462 51.5894 86.4794 51.4722C88.6722 51.1804 90.6041 51.1184 92.5599 52.3247C93.8835 53.1441 95.3022 55.0552 95.6604 56.571C96.5956 60.5433 93.9081 64.3839 89.9769 64.9234L89.9671 64.9267Z",
    fill: "url(#paint254_linear_10106_6282)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M89.977 64.9234C85.1177 65.5903 83.1908 63.2396 80.5349 58.9854C79.122 63.6946 77.9935 66.4315 73.2752 67.1927C69.5208 67.8036 65.9617 65.2393 65.4326 61.4683C65.188 59.707 65.6333 57.9532 66.691 56.5275C68.2955 54.3611 70.3109 53.8345 72.8108 53.4829C73.7159 53.3523 74.18 52.334 73.6707 51.5674C72.8426 50.3083 72.4863 49.3483 72.2466 48.0544C71.5276 44.2383 74.0816 40.5191 77.9441 40.0027C81.6401 39.5097 85.0261 42.1432 85.5289 45.8358C85.7299 47.3063 85.6518 48.3691 85.1441 50.0349C84.8756 50.8891 85.5846 51.7302 86.4734 51.6161C88.676 51.321 90.5948 51.2524 92.5113 52.4393C93.8447 53.2554 95.2536 55.1698 95.602 56.6888C96.5109 60.6155 93.8591 64.4004 89.9574 64.93L89.977 64.9234Z",
    fill: "url(#paint255_linear_10106_6282)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9736 64.9137C85.134 65.5739 83.2399 63.2885 80.525 58.956C79.0895 63.7601 77.964 66.4414 73.2326 67.1962C69.5239 67.7807 66.0075 65.2457 65.4948 61.5237C65.2568 59.782 65.6956 58.0412 66.7469 56.6286C68.3384 54.4884 70.3211 53.962 72.8438 53.6135C73.7915 53.4796 74.2782 52.3991 73.7492 51.6064C72.9408 50.3733 72.5649 49.4199 72.322 48.149C71.5934 44.3689 74.1179 40.6596 77.9445 40.1334C81.6044 39.6308 84.9708 42.2382 85.4734 45.8981C85.6745 47.3687 85.5865 48.4347 85.0755 50.0907C84.8007 50.9907 85.5458 51.8742 86.4771 51.7566C88.6894 51.4583 90.5887 51.3963 92.4724 52.5506C93.8057 53.3667 95.2212 55.268 95.5631 56.8001C96.4457 60.6811 93.8166 64.4038 89.9671 64.9268L89.9736 64.9137Z",
    fill: "url(#paint256_linear_10106_6282)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M89.9704 64.9039C85.1405 65.5608 83.2794 63.3407 80.5216 58.9135C79.0538 63.8158 77.9445 66.448 73.1967 67.1865C69.5305 67.7676 66.0729 65.2455 65.5604 61.5562C65.3159 59.8275 65.7613 58.1064 66.7963 56.7102C68.365 54.5995 70.3281 54.0797 72.8737 53.7344C73.8737 53.5937 74.3766 52.4641 73.8213 51.6258C73.0228 50.4221 72.6371 49.472 72.4008 48.2207C71.6592 44.4667 74.1478 40.7804 77.9417 40.2544C81.5788 39.7486 84.9221 42.3201 85.4148 45.9507C85.6126 47.4114 85.505 48.4841 85.0038 50.1367C84.7128 51.0858 85.494 52.0117 86.4776 51.8874C88.7095 51.5824 90.5794 51.5304 92.4368 52.639C93.7766 53.442 95.1856 55.3564 95.5242 56.8787C96.3772 60.7042 93.7774 64.3844 89.9704 64.9039Z",
    fill: "url(#paint257_linear_10106_6282)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M89.9802 64.9006C85.1699 65.5509 83.3417 63.396 80.5248 58.8906C79.0246 63.8911 77.9315 66.4742 73.1771 67.1931C69.5566 67.7479 66.1514 65.2518 65.6456 61.6147C65.4077 59.9057 65.8466 58.1976 66.8751 56.8146C68.421 54.7334 70.3645 54.2201 72.9298 53.8682C73.9722 53.7242 74.5011 52.5422 73.9228 51.6679C73.1407 50.4805 72.7387 49.5469 72.4959 48.3086C71.7446 44.5907 74.1941 40.9176 77.9618 40.3786C81.5628 39.863 84.8897 42.4183 85.3824 46.0161C85.5801 47.4769 85.4628 48.5529 84.9583 50.1957C84.6477 51.1841 85.4683 52.1621 86.501 52.0214C88.746 51.7229 90.5896 51.6578 92.4175 52.7437C93.7574 53.5467 95.1663 55.461 95.4951 56.9867C96.3218 60.7665 93.7447 64.3845 89.99 64.8972L89.9802 64.9006Z",
    fill: "url(#paint258_linear_10106_6282)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M89.9766 64.8908C85.1795 65.5476 83.3907 63.4449 80.5114 58.8514C78.9788 63.9501 77.8986 66.4743 73.1311 67.1867C69.5498 67.7283 66.1937 65.2484 65.7043 61.6603C65.4731 59.9709 65.9088 58.2857 66.9177 56.9092C68.4408 54.8575 70.355 54.3542 72.9496 53.9924C74.0345 53.8449 74.5894 52.6105 73.9848 51.6906C73.2224 50.5293 72.8106 49.5989 72.5548 48.3869C71.7905 44.6951 74.2041 41.045 77.9358 40.4964C81.5139 39.9776 84.8178 42.497 85.3006 46.0655C85.4983 47.5262 85.3581 48.599 84.8601 50.2287C84.5432 51.2629 85.3999 52.2833 86.475 52.1391C88.7298 51.8374 90.5637 51.7756 92.349 52.8322C93.6986 53.6319 95.1075 55.5462 95.4265 57.0752C96.2138 60.8028 93.6758 64.3749 89.97 64.8712L89.9766 64.8908Z",
    fill: "url(#paint259_linear_10106_6282)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M89.9833 64.8777C85.2058 65.5279 83.4401 63.4938 80.5114 58.8187C78.9563 64.0123 77.8825 66.4907 73.0986 67.1868C69.5662 67.7119 66.2592 65.2481 65.7766 61.7124C65.552 60.0425 65.9714 58.3738 66.977 57.0202C68.4774 54.998 70.3719 54.5012 72.9895 54.1427C74.1234 53.9787 74.6977 52.705 74.0701 51.7492C73.3176 50.6172 72.8961 49.6902 72.6469 48.4977C71.8729 44.842 74.2571 41.2018 77.9561 40.6532C81.4982 40.1248 84.7824 42.6181 85.2651 46.1538C85.4595 47.6048 85.3128 48.6907 84.8115 50.3106C84.4784 51.3939 85.3712 52.4567 86.4888 52.3091C88.7632 52.0007 90.5644 51.9391 92.3202 52.9728C93.6665 53.7628 95.0754 55.6771 95.3977 57.2159C96.1685 60.8945 93.6433 64.4077 89.9834 64.9103L89.9833 64.8777Z",
    fill: "url(#paint260_linear_10106_6282)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M89.9832 64.8777C85.2155 65.5246 83.4925 63.5525 80.5112 58.786C78.927 64.0876 77.8628 66.4974 73.0658 67.1869C69.5693 67.689 66.3278 65.2577 65.8453 61.7547C65.6142 60.0979 66.0402 58.4487 67.0394 57.1082C68.5169 55.1156 70.3919 54.6254 73.029 54.2602C74.2054 54.0928 74.8024 52.7569 74.1518 51.7653C73.4157 50.6496 72.9779 49.739 72.7222 48.5596C71.9385 44.9398 74.2835 41.3129 77.9563 40.7513C81.4658 40.223 84.7269 42.6804 85.2128 46.1933C85.4073 47.6442 85.2474 48.7236 84.7461 50.3436C84.3935 51.4661 85.3257 52.5811 86.4923 52.417C88.7798 52.1151 90.5679 52.047 92.2909 53.0481C93.647 53.8348 95.0462 55.7524 95.3587 57.2945C96.1032 60.9274 93.6039 64.3882 89.993 64.8744L89.9832 64.8777Z",
    fill: "url(#paint261_linear_10106_6282)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M89.9801 64.8679C85.2254 65.5213 83.532 63.6046 80.5015 58.7566C78.8849 64.1564 77.8369 66.5171 73.0299 67.1772C69.5824 67.6628 66.3803 65.251 65.9142 61.7969C65.6897 60.1597 66.1092 58.5237 67.0921 57.1996C68.5469 55.2364 70.4023 54.7529 73.059 54.3811C74.2876 54.207 74.9107 52.8187 74.2272 51.7944C73.5109 50.7049 73.0534 49.8008 72.7945 48.6443C71.9979 45.0508 74.307 41.4468 77.9471 40.8854C81.4304 40.3441 84.6752 42.7852 85.1478 46.2589C85.3423 47.7098 85.1628 48.7958 84.668 50.4027C84.309 51.571 85.274 52.7186 86.4864 52.5608C88.7837 52.2556 90.5489 52.1843 92.2424 53.1627C93.6083 53.946 95.0075 55.8637 95.3069 57.3993C96.0217 60.9768 93.5485 64.3851 89.9801 64.8679Z",
    fill: "url(#paint262_linear_10106_6282)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.9864 64.8548C85.2513 65.5016 83.5908 63.6502 80.4979 58.7141C78.849 64.2121 77.8138 66.5139 72.9938 67.1675C69.592 67.6268 66.4422 65.241 65.9731 61.8425C65.7551 60.2249 66.1682 58.602 67.1446 57.291C68.5766 55.3573 70.4123 54.8803 73.0886 54.5019C74.3598 54.3244 75.0088 52.8837 74.2991 51.8138C73.5926 50.7536 73.1253 49.8529 72.8698 48.7062C72.0732 45.1453 74.33 41.5481 77.9473 40.9835C81.3978 40.4423 84.6196 42.8475 85.0921 46.2885C85.2866 47.7394 85.0941 48.8189 84.5992 50.4258C84.2241 51.6432 85.2252 52.8332 86.4899 52.6687C88.8068 52.3569 90.5425 52.2955 92.2 53.2315C93.5626 54.005 94.965 55.9325 95.2644 57.4681C95.953 60.9999 93.5122 64.3427 89.9896 64.8319L89.9864 64.8548Z",
    fill: "white"
  })))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5229 63.0909C85.7779 63.6004 83.9843 61.0302 81.4071 56.8476C80.8286 55.908 79.4202 56.099 79.1098 57.1528C77.6617 62.0812 76.6705 64.8373 72.9583 65.3466C68.0239 66.017 64.7227 60.3984 67.6681 56.4163C69.2661 54.263 71.2664 54.1125 75.5441 53.5652C76.0474 53.5047 76.2971 52.9187 76.0048 52.5044C74.1554 49.8985 73.3508 48.8059 73.1536 46.5377C72.9834 44.544 73.9184 42.5924 75.628 41.547C79.4649 39.2064 83.8342 41.6176 84.367 45.4965C84.6151 47.333 84.1747 48.5833 83.1777 51.5486C83.0224 52.0265 83.413 52.5058 83.9097 52.4256C88.0303 51.8332 90.118 51.424 92.2224 53.0712C96.1394 56.1149 94.4441 62.414 89.5229 63.0909Z",
    fill: "url(#paint263_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 40,
    width: 29,
    height: 26
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5229 63.0909C85.7779 63.6004 83.9843 61.0302 81.4071 56.8476C80.8286 55.908 79.4202 56.099 79.1098 57.1528C77.6617 62.0812 76.6705 64.8373 72.9583 65.3466C68.0239 66.017 64.7227 60.3984 67.6681 56.4163C69.2661 54.263 71.2664 54.1125 75.5441 53.5652C76.0474 53.5047 76.2971 52.9187 76.0048 52.5044C74.1554 49.8985 73.3508 48.8059 73.1536 46.5377C72.9834 44.544 73.9184 42.5924 75.628 41.547C79.4649 39.2064 83.8342 41.6176 84.367 45.4965C84.6151 47.333 84.1747 48.5833 83.1777 51.5486C83.0224 52.0265 83.413 52.5058 83.9097 52.4256C88.0303 51.8332 90.118 51.424 92.2224 53.0712C96.1394 56.1149 94.4441 62.414 89.5229 63.0909Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5864 63.5386C85.6455 64.0814 83.7241 61.4561 81.0287 57.0842C80.6507 56.4807 79.7422 56.6014 79.5353 57.2821C78.0969 62.2072 77.0054 65.2481 73.0219 65.7943C70.5613 66.1328 68.2494 65.0028 66.9835 62.8657C65.7144 60.7187 66.0102 58.2625 67.3174 56.1527C69.34 52.8962 75.6762 52.9861 75.6762 52.9861C75.7378 52.8453 75.6394 52.7476 75.5474 52.604C73.7473 50.0796 72.9327 48.925 72.7319 46.5816C72.4601 43.5094 74.6215 40.6971 77.9873 40.2281C81.3041 39.7756 84.3818 42.1094 84.8343 45.4262C85.0925 47.3575 84.6392 48.6668 83.626 51.6812C83.571 51.8416 83.7023 52.0046 83.8689 51.9811C87.9372 51.3954 90.2373 50.9365 92.5285 52.7171C94.4821 54.2406 95.2945 56.6833 94.652 59.0819C94.0029 61.4935 92.0765 63.1902 89.6158 63.5287L89.5864 63.5386Z",
    fill: "url(#paint264_linear_10106_6282)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M89.6027 63.5222C85.6715 64.0617 83.7471 61.4919 81.0516 57.1201C80.6407 56.4513 79.7421 56.5687 79.5158 57.3214C78.0676 62.2498 76.9595 65.2417 72.9957 65.7813C70.5546 66.1132 68.2754 64.9831 67.0326 62.8818C65.7897 60.7806 66.0562 58.3343 67.3602 56.2473C69.334 53.0728 75.4837 53.1274 75.6308 53.1105C75.7349 52.9663 75.6692 52.8685 75.5804 52.702C73.9309 50.236 73.005 49.0425 72.7876 46.6174C72.5159 43.5779 74.6611 40.8147 77.9746 40.3524C81.2489 39.9033 84.284 42.2078 84.7331 45.4822C85.0046 47.4853 84.4666 48.8668 83.5707 51.7762C83.5386 51.9398 83.7026 52.1027 83.8888 52.0726C87.9996 51.4834 90.205 51.0674 92.4569 52.8285C94.4072 54.3422 95.1869 56.7524 94.554 59.1149C93.9178 61.4677 92.0274 63.174 89.5765 63.5092L89.6027 63.5222Z",
    fill: "url(#paint265_linear_10106_6282)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M89.619 63.5058C85.6977 64.042 83.78 61.5245 81.0845 57.1527C80.6276 56.4121 79.7616 56.5294 79.5061 57.3574C78.0482 62.2891 76.9236 65.232 72.9793 65.765C70.5481 66.0936 68.3081 64.9503 67.0915 62.8947C65.875 60.8391 66.112 58.4027 67.4128 56.3387C69.3477 53.2427 75.3045 53.2751 75.5953 53.2316C75.7321 53.0873 75.6958 52.9795 75.6363 52.8032C74.1342 50.3857 73.0904 49.1664 72.8696 46.6662C72.611 43.6658 74.727 40.9452 78.0013 40.4961C81.2364 40.0603 84.2354 42.3224 84.6713 45.5575C84.9561 47.6326 84.33 49.0765 83.5679 51.8972C83.5717 52.0704 83.7456 52.23 83.9743 52.1966C88.1243 51.5942 90.2383 51.2307 92.4607 52.9691C94.3946 54.4665 95.1481 56.8636 94.5281 59.1673C93.9081 61.471 92.0536 63.187 89.6223 63.5156L89.619 63.5058Z",
    fill: "url(#paint266_linear_10106_6282)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M89.6352 63.4894C85.7237 64.0223 83.8127 61.5571 81.1074 57.1886C80.6078 56.386 79.7614 56.4967 79.4963 57.3934C78.0417 62.3349 76.8875 65.2223 72.9661 65.7586C70.548 66.0936 68.3438 64.9273 67.1536 62.9174C65.9634 60.9075 66.171 58.481 67.4751 56.4268C69.3841 53.4159 75.1413 53.4064 75.5694 53.3494C75.752 53.2115 75.7418 53.084 75.702 52.901C74.3471 50.5321 73.1954 49.2838 72.9709 46.7083C72.7125 43.7407 74.809 41.0594 78.0343 40.6268C81.227 40.1944 84.1834 42.4272 84.6223 45.6068C84.9205 47.7537 84.2096 49.2698 83.5648 51.9854C83.5916 52.1619 83.7883 52.3247 84.0464 52.2813C88.2389 51.6755 90.2484 51.3582 92.4511 53.0705C94.3719 54.5614 95.1024 56.9226 94.4888 59.1805C93.8752 61.4384 92.0632 63.151 89.6417 63.4763L89.6352 63.4894Z",
    fill: "url(#paint267_linear_10106_6282)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M89.6482 63.4632C85.7465 63.9928 83.8324 61.5832 81.1304 57.2245C80.5881 56.3599 79.7711 56.4607 79.4768 57.4327C78.0124 62.3775 76.8417 65.2159 72.9399 65.7456C70.5414 66.074 68.3666 64.8978 67.1929 62.9369C66.029 60.9727 66.2072 58.5561 67.5082 56.5247C69.3815 53.6022 74.9391 53.5509 75.5241 53.4738C75.7394 53.3357 75.7618 53.2082 75.7481 53.0055C74.5438 50.6949 73.271 49.411 73.0397 46.7506C72.7847 43.8254 74.8617 41.1834 78.0348 40.7576C81.1849 40.3285 84.1085 42.5288 84.5342 45.6692C84.8326 47.8815 84.0468 49.4665 83.5358 52.0934C83.5854 52.2731 83.8017 52.4293 84.0958 52.3956C88.3406 51.7831 90.249 51.5217 92.4189 53.2014C94.3266 54.6858 95.0275 57.0242 94.4268 59.2232C93.8294 61.432 92.0501 63.1445 89.6417 63.4763L89.6482 63.4632Z",
    fill: "url(#paint268_linear_10106_6282)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M89.6646 63.4468C85.7726 63.9731 83.8653 61.6158 81.1633 57.2571C80.5881 56.3272 79.7809 56.4248 79.4672 57.4687C78.0028 62.4135 76.8058 65.2063 72.9236 65.7293C70.5349 66.0544 68.3993 64.865 67.2519 62.9498C66.1143 61.0312 66.2631 58.6245 67.5576 56.6063C69.3821 53.7657 74.7533 53.6791 75.4853 53.5851C75.7464 53.4534 75.7949 53.3061 75.8008 53.0969C74.7438 50.8348 73.363 49.5219 73.1184 46.7896C72.8635 43.8971 74.9243 41.3042 78.0549 40.8818C81.1724 40.4528 84.0436 42.6271 84.4659 45.725C84.7776 48.0092 83.9037 49.6566 83.5133 52.1883C83.5891 52.3809 83.825 52.5305 84.1485 52.487C88.4358 51.871 90.2495 51.6525 92.3899 53.3094C94.291 54.7742 94.9624 57.0899 94.3714 59.2528C93.7869 61.4027 92.0436 63.125 89.6548 63.4501L89.6646 63.4468Z",
    fill: "url(#paint269_linear_10106_6282)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M89.6808 63.4304C85.8019 63.9632 83.8882 61.6517 81.1862 57.2929C80.5682 56.3011 79.7904 56.3888 79.4476 57.508C77.9767 62.4659 76.7599 65.1999 72.9006 65.7261C70.5217 66.0479 68.4155 64.8486 67.3042 62.9757C66.1929 61.1029 66.3025 58.7094 67.6036 56.7108C69.3925 53.9586 74.5739 53.8268 75.4431 53.7192C75.7369 53.5875 75.8149 53.4303 75.8501 53.2111C74.9403 50.9976 73.4418 49.6589 73.2035 46.8481C72.9487 43.9883 74.9933 41.4445 78.0716 41.0288C81.1466 40.6033 83.985 42.745 84.3941 45.8037C84.7191 48.1598 83.7604 49.8794 83.4972 52.3028C83.5959 52.4986 83.8547 52.6514 84.2207 52.6044C88.5505 51.9851 90.2695 51.8093 92.3804 53.4434C94.2684 54.9017 94.9071 57.1848 94.342 59.2954C93.7737 61.3962 92.0664 63.1281 89.6874 63.45L89.6808 63.4304Z",
    fill: "url(#paint270_linear_10106_6282)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M89.6972 63.414C85.8281 63.9435 83.9211 61.6842 81.2093 57.3288C80.5487 56.2751 79.7905 56.3561 79.4283 57.5473C77.9476 62.5085 76.7142 65.1935 72.8746 65.7131C70.5185 66.0381 68.4384 64.8191 67.3534 62.9919C66.2651 61.155 66.3487 58.7812 67.6432 56.7956C69.3931 54.122 74.3816 53.968 75.3946 53.8338C75.7244 53.7117 75.8415 53.5413 75.9028 53.3025C75.1437 51.1473 73.5338 49.7698 73.2789 46.8773C73.0276 44.06 75.0527 41.5555 78.0885 41.1432C81.1243 40.7309 83.9201 42.8433 84.3322 45.8464C84.6575 48.2678 83.6238 50.0564 83.4846 52.3944C83.6095 52.6032 83.8977 52.7461 84.2866 52.7023C88.6588 52.0795 90.2734 51.9499 92.3548 53.5612C94.2297 55.013 94.8388 57.2733 94.2867 59.325C93.7247 61.38 92.0599 63.1085 89.6907 63.4271L89.6972 63.414Z",
    fill: "url(#paint271_linear_10106_6282)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M89.7134 63.3976C85.8541 63.9238 83.9571 61.7266 81.2421 57.3614C80.5387 56.2457 79.8099 56.3168 79.4283 57.58C77.9476 62.5412 76.6978 65.1772 72.8581 65.6968C70.5118 66.0185 68.4709 64.7863 67.4122 63.0048C66.3502 61.2135 66.4044 58.8496 67.7056 56.8837C69.4165 54.2887 74.2087 54.1026 75.3786 53.9483C75.7508 53.8228 75.8876 53.6458 75.9783 53.397C75.3664 51.2904 73.6388 49.8871 73.3804 46.9195C73.1389 44.1316 75.138 41.6794 78.1215 41.2738C81.1148 40.865 83.8778 42.9448 84.2768 45.9087C84.6154 48.402 83.4937 50.2529 83.4848 52.4924C83.6424 52.7012 83.9437 52.8505 84.362 52.7968C88.7865 52.1674 90.3 52.0936 92.3486 53.6724C94.2169 55.1046 94.7965 57.3421 94.2507 59.348C93.7049 61.354 92.0728 63.0823 89.7265 63.4041L89.7134 63.3976Z",
    fill: "url(#paint272_linear_10106_6282)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M89.7298 63.3812C85.8804 63.9041 83.9803 61.7625 81.2652 57.3973C80.5191 56.2196 79.8099 56.2841 79.409 57.6193C77.9218 62.5936 76.6521 65.1708 72.8353 65.6936C70.4988 66.012 68.4971 64.7666 67.4647 63.0308C66.4291 61.2852 66.4539 58.9312 67.7518 56.9882C69.4271 54.4815 74.0197 54.2536 75.3366 54.0825C75.7416 53.9569 75.9175 53.7667 76.0245 53.5015C75.5632 51.4532 73.7243 50.0111 73.4624 46.9682C73.2243 44.2228 75.204 41.81 78.1352 41.4111C81.086 41.0056 83.8064 43.0562 84.1987 45.9678C84.5505 48.533 83.3343 50.4595 83.4559 52.6004C83.6364 52.8123 83.9606 52.9649 84.4116 52.9111C88.8786 52.2782 90.2973 52.2473 92.3164 53.8033C94.1716 55.229 94.7218 57.4437 94.1987 59.3875C93.6691 61.3443 92.0696 63.0726 89.7364 63.4008L89.7298 63.3812Z",
    fill: "url(#paint273_linear_10106_6282)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M89.7459 63.3648C85.9063 63.8844 84.0129 61.7951 81.288 57.4332C80.5057 56.1804 79.8096 56.2514 79.386 57.6488C77.8988 62.6231 76.6028 65.1546 72.8056 65.6708C70.4887 65.9826 68.5164 64.7273 67.5103 63.0372C66.501 61.3372 66.4964 58.9932 67.7878 57.0632C69.4241 54.6352 73.8303 54.372 75.2812 54.1775C75.732 54.0583 75.9275 53.8615 76.0605 53.5766C75.7465 51.5768 73.7996 50.1056 73.5211 46.9811C73.2831 44.2684 75.2466 41.9046 78.1353 41.5092C81.0437 41.1071 83.7313 43.1251 84.1201 45.9942C84.482 48.6215 83.181 50.6201 83.433 52.6626C83.6397 52.8875 83.9835 53.0335 84.4737 52.9664C88.9799 52.3204 90.3073 52.3421 92.2969 53.8752C94.139 55.2945 94.6661 57.4733 94.1527 59.3811C93.6262 61.2823 92.0758 63.0268 89.7491 63.3419L89.7459 63.3648Z",
    fill: "url(#paint274_linear_10106_6282)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M89.7722 63.3451C85.9456 63.8712 84.0459 61.8277 81.3308 57.4625C80.5058 56.1477 79.8391 56.2088 79.3863 57.6815C77.8893 62.6591 76.5768 65.1416 72.8025 65.661C70.4987 65.9793 68.5656 64.7108 67.5825 63.0565C66.5995 61.4023 66.5622 59.0583 67.8537 57.1611C69.4511 54.8116 73.6609 54.5164 75.2589 54.3051C75.7424 54.1857 75.9771 53.9757 76.1297 53.6842C75.963 51.733 73.8983 50.2361 73.6163 47.0364C73.3817 44.3661 75.3257 42.0417 78.1622 41.6529C81.0313 41.2641 83.673 43.243 84.0584 46.0696C84.4238 48.7721 83.0479 50.8396 83.4172 52.7771C83.6469 53.0052 84.0135 53.1543 84.5364 53.0872C89.0851 52.4377 90.308 52.5055 92.2779 54.0126C94.1134 55.4123 94.6045 57.5814 94.104 59.4303C93.5937 61.2824 92.076 63.0268 89.7722 63.3451Z",
    fill: "url(#paint275_linear_10106_6282)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M89.7885 63.3287C85.9717 63.8515 84.0787 61.8603 81.3538 57.4983C80.4861 56.1216 79.8356 56.1663 79.3668 57.7208C77.8633 62.7115 76.531 65.1353 72.7763 65.648C70.4823 65.963 68.5884 64.6813 67.6316 63.0727C66.6749 61.4642 66.5984 59.1334 67.8932 57.246C69.4418 54.9784 73.4685 54.6576 75.2103 54.4196C75.7395 54.3067 75.9905 54.0803 76.1726 53.7789C76.1564 51.886 73.9805 50.3502 73.6949 47.0753C73.4604 44.4378 75.3882 42.1624 78.1822 41.7771C81.0089 41.3917 83.6177 43.338 83.99 46.1254C84.3687 48.8998 82.9047 51.0297 83.4078 52.8785C83.6636 53.1196 84.0597 53.2588 84.6021 53.1851C89.2031 52.5289 90.3216 52.6428 92.262 54.1271C94.0844 55.5203 94.5525 57.6535 94.0583 59.4566C93.5642 61.2596 92.0792 63.0039 89.7852 63.3189L89.7885 63.3287Z",
    fill: "url(#paint276_linear_10106_6282)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M89.8048 63.3123C85.9978 63.8318 84.1115 61.8928 81.3768 57.5342C80.4664 56.0955 79.8453 56.1303 79.3473 57.7601C77.8438 62.7508 76.4852 65.1289 72.7501 65.635C70.4757 65.9434 68.6111 64.6518 67.6807 63.0889C66.7502 61.526 66.6444 59.2052 67.9458 57.3373C69.4588 55.1582 73.2957 54.7922 75.1845 54.5374C75.7464 54.4244 76.0399 54.1945 76.2383 53.8768C76.3694 52.0324 74.0757 50.4709 73.7832 47.111C73.562 44.5126 75.4605 42.2799 78.2022 41.9013C80.9864 41.5192 83.5527 43.4363 83.9313 46.1779C84.3233 49.0242 82.7712 51.2165 83.395 52.9701C83.6737 53.2143 84.0927 53.3568 84.6776 53.2796C89.3211 52.62 90.3482 52.7866 92.246 54.2416C94.0553 55.6282 94.4906 57.7289 94.0126 59.4829C93.5347 61.2368 92.0824 62.981 89.8113 63.2992L89.8048 63.3123Z",
    fill: "url(#paint277_linear_10106_6282)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.8211 63.2959C86.0239 63.8121 84.1345 61.9287 81.3998 57.5701C80.4565 56.0661 79.8452 56.0976 79.3376 57.7961C77.8243 62.7901 76.4492 65.1192 72.737 65.6286C70.4724 65.9337 68.647 64.6288 67.7429 63.1116C66.829 61.5977 66.7035 59.2835 67.9985 57.4287C69.4724 55.3281 73.1131 54.9302 75.149 54.6585C75.7469 54.5552 76.0665 54.3056 76.2942 53.9779C76.5726 52.1822 74.1709 50.5915 73.8651 47.1598C73.644 44.5941 75.5264 42.4105 78.2158 42.0385C80.9574 41.6599 83.4909 43.5444 83.853 46.237C84.2453 49.1487 82.6215 51.4197 83.3757 53.0748C83.6871 53.3189 84.1192 53.4678 84.7335 53.3808C89.4195 52.7178 90.3519 52.9271 92.2202 54.3594C94.0131 55.7297 94.4223 57.8174 93.9605 59.5223C93.4889 61.2305 92.0824 62.981 89.8178 63.2861L89.8211 63.2959Z",
    fill: "url(#paint278_linear_10106_6282)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M89.8373 63.2795C86.0499 63.7923 84.1672 61.9613 81.4325 57.6027C80.4465 56.0367 79.8646 56.0583 79.3279 57.8321C77.8179 62.8359 76.4132 65.1095 72.7205 65.6123C70.469 65.9238 68.6795 64.596 67.7919 63.1278C66.9043 61.6595 66.7494 59.3552 68.0412 57.5233C69.4762 55.5014 72.9206 55.0714 75.1035 54.7829C75.7439 54.6761 76.0929 54.4167 76.3402 54.0824C76.7692 52.3449 74.2464 50.7188 73.947 47.2085C73.726 44.6756 75.5921 42.541 78.2423 42.1823C80.9448 41.8169 83.4324 43.6622 83.7911 46.3124C84.1967 49.2959 82.4848 51.6294 83.3597 53.1892C83.6973 53.4464 84.1489 53.5887 84.796 53.5015C89.5244 52.8351 90.3524 53.0906 92.201 54.4967C93.9906 55.8573 94.3669 57.9124 93.9115 59.5715C93.4528 61.2208 92.0823 62.981 89.8308 63.2926L89.8373 63.2795Z",
    fill: "url(#paint279_linear_10106_6282)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M89.8535 63.2631C86.0792 63.7825 84.1901 61.9972 81.4554 57.6386C80.4267 56.0107 79.8644 56.0256 79.3083 57.8714C77.7885 62.8785 76.3672 65.1031 72.6942 65.5993C70.4623 65.9043 68.7022 64.5665 67.8409 63.1439C66.9796 61.7214 66.7822 59.4205 68.0839 57.618C69.4701 55.6779 72.7314 55.2224 75.058 54.9073C75.7345 54.8102 76.1128 54.5408 76.3829 54.1771C76.9592 52.4882 74.3284 50.8329 74.0123 47.241C73.7947 44.7505 75.6414 42.6553 78.2393 42.3033C80.8993 41.9413 83.3476 43.7671 83.7094 46.3618C84.1283 49.4171 82.3284 51.813 83.337 53.2841C83.6975 53.5444 84.172 53.69 84.8485 53.5929C89.6194 52.923 90.3527 53.2214 92.1718 54.6047C93.945 55.949 94.2951 57.9911 93.8526 59.5913C93.4101 61.1915 92.0723 62.9516 89.8404 63.2566L89.8535 63.2631Z",
    fill: "url(#paint280_linear_10106_6282)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M89.8698 63.2467C86.1053 63.7628 84.2229 62.0298 81.4817 57.6843C80.4103 55.9944 79.8774 55.9994 79.2921 57.9205C77.7625 62.9309 76.3346 65.1032 72.6746 65.6059C70.4525 65.9076 68.7316 64.5566 67.8966 63.1797C67.0616 61.8029 66.8349 59.5119 68.1301 57.7225C69.4773 55.861 72.5521 55.3701 75.016 55.0415C75.7349 54.941 76.1427 54.6617 76.4324 54.2913C77.1592 52.6608 74.4074 50.97 74.0878 47.3029C73.8703 44.8451 75.7008 42.7989 78.2562 42.4503C80.8737 42.0917 83.2892 43.885 83.6378 46.4405C84.0667 49.5579 82.1853 52.0358 83.3211 53.3986C83.7078 53.6719 84.2019 53.8108 84.9208 53.7104C89.744 53.0338 90.3729 53.3782 92.1625 54.7388C93.9226 56.0766 94.2497 58.0828 93.8135 59.6372C93.3774 61.1916 92.0854 62.9581 89.8633 63.2598L89.8698 63.2467Z",
    fill: "url(#paint281_linear_10106_6282)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M89.8862 63.2303C86.1315 63.743 84.2559 62.0624 81.5147 57.7168C80.4103 55.9617 79.8872 55.9634 79.2826 57.9564C77.7563 62.9767 76.2987 65.0935 72.6584 65.5896C70.4461 65.888 68.7644 64.5238 67.9557 63.1926C67.1436 61.8516 66.8908 59.5803 68.1926 57.8105C69.5009 56.0276 72.3794 55.5047 75.0002 55.1559C75.7518 55.0553 76.1889 54.7662 76.508 54.3859C77.3822 52.8039 74.519 51.0742 74.1992 47.3417C73.9949 44.9231 75.7961 42.9195 78.2993 42.5777C80.8743 42.2225 83.2472 43.9865 83.5923 46.4995C84.0248 49.6921 82.0652 52.2291 83.3216 53.4967C83.7311 53.7732 84.258 53.912 84.9998 53.8147C89.8622 53.1249 90.403 53.5318 92.1598 54.8598C93.9166 56.1877 94.2044 58.1745 93.7811 59.67C93.3612 61.1753 92.1019 62.9417 89.8895 63.24L89.8862 63.2303Z",
    fill: "url(#paint282_linear_10106_6282)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M89.9024 63.2139C86.1575 63.7233 84.2788 62.0983 81.5376 57.7527C80.3872 55.9258 79.8968 55.9274 79.263 57.9958C77.7269 63.0193 76.2529 65.0871 72.6321 65.5766C70.4329 65.8815 68.7871 64.4943 68.0047 63.2088C67.2189 61.9135 66.9236 59.6456 68.232 57.8954C69.4916 56.1944 72.1836 55.6362 74.9515 55.2705C75.7489 55.1763 76.2154 54.8773 76.5508 54.4805C77.5722 52.9471 74.601 51.1884 74.2646 47.3742C74.0604 44.9883 75.8455 43.0338 78.2963 42.6987C80.8322 42.3567 83.1689 44.0783 83.5074 46.539C83.9531 49.8035 81.9055 52.4029 83.2956 53.5818C83.7379 53.8582 84.2778 54.0035 85.049 53.8963C89.9539 53.2031 90.3902 53.6561 92.1175 54.9613C93.8579 56.273 94.126 58.2336 93.7124 59.6931C93.3087 61.1493 92.0821 62.9156 89.8926 63.2172L89.9024 63.2139Z",
    fill: "url(#paint283_linear_10106_6282)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M89.9188 63.1975C86.1837 63.7036 84.3116 62.1308 81.5607 57.7886C80.3676 55.8997 79.8968 55.8947 79.25 58.0219C77.7173 63.0553 76.2136 65.0677 72.6157 65.5603C70.4361 65.8586 68.823 64.4713 68.0636 63.2217C67.3042 61.9721 66.9795 59.7141 68.2847 57.9868C69.5052 56.3644 72.0108 55.7708 74.9159 55.3916C75.746 55.2973 76.2419 54.9883 76.6067 54.5817C77.7787 53.1066 74.6865 51.3123 74.3563 47.4197C74.1556 45.0762 75.9211 43.1611 78.3295 42.8293C80.8228 42.4908 83.117 44.1831 83.452 46.6013C83.9078 49.9279 81.7787 52.6093 83.2862 53.6831C83.7546 53.9725 84.3142 54.1112 85.118 54.0039C90.0654 53.3073 90.4071 53.8031 92.1049 55.0855C93.8322 56.3907 94.0675 58.3188 93.6701 59.7292C93.2792 61.1265 92.0886 62.9025 89.909 63.2008L89.9188 63.1975Z",
    fill: "url(#paint284_linear_10106_6282)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.9352 63.181C86.2132 63.6937 84.3347 62.1667 81.5936 57.8212C80.3578 55.8703 79.9164 55.8554 79.2405 58.0579C77.6979 63.0946 76.1777 65.058 72.5995 65.544C70.4296 65.839 68.8557 64.4385 68.1226 63.2345C67.3895 62.0306 67.0354 59.7825 68.3341 58.0683C69.5157 56.5245 71.8283 55.9087 74.8772 55.5029C75.7433 55.4183 76.2751 55.0863 76.6594 54.6731C77.9787 53.2465 74.7785 51.4231 74.435 47.4586C74.2344 45.1479 75.9838 43.2818 78.3398 42.9568C80.7907 42.6216 83.0521 44.2814 83.3739 46.6604C83.8332 50.0622 81.6258 52.8027 83.267 53.7878C83.7584 54.0804 84.3408 54.2223 85.1839 54.1018C90.1835 53.3985 90.4207 53.9404 92.089 55.2C93.813 56.4954 94.0091 58.404 93.6245 59.7555C93.24 61.107 92.0952 62.8894 89.9254 63.1844L89.9352 63.181Z",
    fill: "white"
  })))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2848 61.3165C86.53 61.6886 85.3696 59.7995 82.5756 55.2973C82.339 54.9188 82.5727 54.4146 83.0204 54.351C88.2194 53.6241 89.611 53.286 91.1352 54.4741C93.7968 56.5445 92.6637 60.854 89.2946 61.3132L89.2848 61.3165ZM72.7203 63.5722C69.3512 64.0314 67.0988 60.1975 69.1167 57.4772C70.2395 55.9532 71.4457 55.9067 76.9063 55.179C77.3539 55.1154 77.715 55.5391 77.589 55.9744C76.0987 61.0043 75.524 63.1836 72.7301 63.5689L72.7203 63.5722ZM80.3901 53.8301C80.2085 54.2623 79.6235 54.3395 79.3346 53.9677C77.7356 51.9428 75.2532 48.7211 74.9851 46.7604C74.7035 44.6625 76.1747 42.7156 78.2726 42.4339C80.3706 42.1523 82.3175 43.6235 82.5991 45.7214C82.8638 47.6396 81.3762 51.5122 80.3868 53.8203L80.3901 53.8301Z",
    fill: "url(#paint285_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 42,
    width: 25,
    height: 22
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2848 61.3165C86.53 61.6886 85.3696 59.7995 82.5756 55.2973C82.339 54.9188 82.5727 54.4146 83.0204 54.351C88.2194 53.6241 89.611 53.286 91.1352 54.4741C93.7968 56.5445 92.6637 60.854 89.2946 61.3132L89.2848 61.3165ZM72.7203 63.5722C69.3512 64.0314 67.0988 60.1975 69.1167 57.4772C70.2395 55.9532 71.4457 55.9067 76.9063 55.179C77.3539 55.1154 77.715 55.5391 77.589 55.9744C76.0987 61.0043 75.524 63.1836 72.7301 63.5689L72.7203 63.5722ZM80.3901 53.8301C80.2085 54.2623 79.6235 54.3395 79.3346 53.9677C77.7356 51.9428 75.2532 48.7211 74.9851 46.7604C74.7035 44.6625 76.1747 42.7156 78.2726 42.4339C80.3706 42.1523 82.3175 43.6235 82.5991 45.7214C82.8638 47.6396 81.3762 51.5122 80.3868 53.8203L80.3901 53.8301Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M89.285 61.3164C86.5303 61.6886 85.3699 59.7995 82.5759 55.2973C82.3392 54.9188 82.5729 54.4146 83.0206 54.351C88.2196 53.6241 89.6112 53.286 91.1354 54.4741C93.797 56.5445 92.6639 60.854 89.2948 61.3131L89.285 61.3164Z",
    fill: "url(#paint286_linear_10106_6282)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M89.2851 61.3164C86.5304 61.6886 85.4061 59.8419 82.6155 55.3821C82.3788 55.0037 82.6059 54.4798 83.083 54.4063C88.2722 53.6828 89.6017 53.3546 91.1226 54.533C93.7776 56.5838 92.6411 60.8508 89.2818 61.3066L89.2851 61.3164Z",
    fill: "url(#paint287_linear_10106_6282)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M89.2851 61.3164C86.5434 61.6951 85.4323 59.8876 82.668 55.4735C82.4314 55.0951 82.6486 54.5418 83.1616 54.478C88.3279 53.7512 89.6183 53.4363 91.1228 54.5984C93.7614 56.6329 92.6346 60.8639 89.2851 61.3164Z",
    fill: "url(#paint288_linear_10106_6282)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M89.285 61.3165C86.5531 61.6918 85.4683 59.93 82.7075 55.5584C82.4741 55.1897 82.6912 54.6038 83.2336 54.5301C88.3804 53.8099 89.6184 53.5017 91.1196 54.654C93.7516 56.6689 92.6116 60.8607 89.285 61.3165Z",
    fill: "url(#paint289_linear_10106_6282)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M89.2851 61.3164C86.563 61.6885 85.4947 59.9757 82.7471 55.6432C82.5137 55.2746 82.7242 54.6691 83.296 54.5854C88.433 53.8686 89.6187 53.5671 91.1166 54.7096C93.742 56.7049 92.6019 60.864 89.2851 61.3164Z",
    fill: "url(#paint290_linear_10106_6282)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M89.2948 61.3131C86.5825 61.6819 85.5405 60.0147 82.8094 55.7313C82.576 55.3626 82.7766 54.7277 83.3942 54.6505C88.5116 53.9402 89.6451 53.6455 91.1363 54.7684C93.7453 56.7474 92.6116 60.8607 89.2948 61.3131Z",
    fill: "url(#paint291_linear_10106_6282)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M89.2947 61.3132C86.5922 61.6786 85.5701 60.0702 82.8489 55.8162C82.6188 55.4573 82.8193 54.7897 83.4565 54.7059C88.5509 53.9924 89.6354 53.7142 91.1234 54.8273C93.7225 56.7769 92.592 60.8673 89.2849 61.3165L89.2947 61.3132Z",
    fill: "url(#paint292_linear_10106_6282)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M89.2948 61.3132C86.6021 61.6753 85.6062 60.1126 82.8982 55.8977C82.6682 55.5389 82.862 54.8517 83.5384 54.7546C88.6231 54.0445 89.6553 53.7729 91.14 54.8763C93.7325 56.8063 92.5985 60.8542 89.3046 61.3098L89.2948 61.3132Z",
    fill: "url(#paint293_linear_10106_6282)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M89.2948 61.3131C86.6152 61.6817 85.6424 60.155 82.941 55.9924C82.711 55.6336 82.8949 54.917 83.604 54.8198C88.6691 54.1162 89.6457 53.8416 91.1271 54.9351C93.7032 56.8489 92.5789 60.8608 89.2948 61.3131Z",
    fill: "url(#paint294_linear_10106_6282)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M89.2947 61.3131C86.6152 61.6818 85.6686 60.2007 82.9903 56.074C82.7636 55.7249 82.9376 54.9789 83.6794 54.8816C88.7249 54.1847 89.659 53.9135 91.1273 55.0005C93.6968 56.8946 92.5626 60.8772 89.2947 61.3131Z",
    fill: "url(#paint295_linear_10106_6282)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M89.2948 61.3132C86.625 61.6785 85.7048 60.243 83.0299 56.1588C82.8031 55.8098 82.9804 55.0409 83.7516 54.9337C88.7872 54.2401 89.6592 53.9789 91.1242 55.0561C93.6871 56.9306 92.5495 60.8707 89.2948 61.3132Z",
    fill: "url(#paint296_linear_10106_6282)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M89.2982 61.3229C86.6382 61.6849 85.7345 60.2985 83.0826 56.2502C82.8592 55.911 83.0232 55.1029 83.8271 54.9956C88.8399 54.2988 89.6727 54.0508 91.1311 55.1084C93.6776 56.9666 92.5497 60.8707 89.3047 61.3098L89.2982 61.3229Z",
    fill: "url(#paint297_linear_10106_6282)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M89.2982 61.3229C86.648 61.6816 85.7739 60.3507 83.1254 56.3449C82.902 56.0056 83.0594 55.178 83.9025 55.0574C88.8956 54.3672 89.6762 54.1259 91.1313 55.1738C93.6711 57.0124 92.5398 60.874 89.308 61.3196L89.2982 61.3229Z",
    fill: "url(#paint298_linear_10106_6282)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M89.3078 61.3196C86.6674 61.675 85.8098 60.3931 83.1745 56.4264C82.9511 56.0872 83.1019 55.2399 83.9777 55.1193C88.961 54.4324 89.6893 54.1978 91.1313 55.2392C93.6613 57.0484 92.5331 60.8871 89.3111 61.3294L89.3078 61.3196Z",
    fill: "url(#paint299_linear_10106_6282)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.3078 61.3196C86.6805 61.6815 85.8459 60.4355 83.2239 56.508C83.0037 56.1786 83.1511 55.2888 84.0498 55.1714C89.0136 54.4911 89.6895 54.2632 91.1249 55.285C93.6385 57.0779 92.5167 60.8708 89.2947 61.3132L89.3078 61.3196Z",
    fill: "url(#paint300_linear_10106_6282)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M89.308 61.3196C86.6905 61.6782 85.8724 60.4811 83.2669 56.6027C83.0467 56.2732 83.1875 55.3639 84.1254 55.2332C89.0761 54.5464 89.7031 54.3351 91.1351 55.347C93.6421 57.1204 92.5105 60.8839 89.308 61.3196Z",
    fill: "url(#paint301_linear_10106_6282)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M89.3078 61.3196C86.6903 61.6782 85.9083 60.5235 83.316 56.6842C83.0959 56.3548 83.2301 55.4258 84.2006 55.2951C89.1317 54.6149 89.7031 54.4005 91.1352 55.4124C93.6257 57.1695 92.5005 60.8872 89.3111 61.3294L89.3078 61.3196Z",
    fill: "url(#paint302_linear_10106_6282)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M89.3078 61.3196C86.7001 61.6749 85.9346 60.5692 83.3555 56.7691C83.1387 56.4494 83.2728 55.4878 84.2727 55.3472C89.1842 54.6736 89.7033 54.4659 91.1288 55.4582C93.6127 57.1957 92.4874 60.8807 89.3078 61.3196Z",
    fill: "url(#paint303_linear_10106_6282)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M89.3079 61.3196C86.71 61.6716 85.9742 60.6214 83.4049 56.8507C83.1881 56.531 83.3123 55.54 84.3449 55.3992C89.2466 54.7289 89.7134 54.528 91.1258 55.5138C93.6032 57.2317 92.4777 60.884 89.3046 61.3098L89.3079 61.3196Z",
    fill: "url(#paint304_linear_10106_6282)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M89.3079 61.3196C86.7198 61.6683 86.0004 60.6671 83.4477 56.9453C83.2309 56.6257 83.3484 55.6151 84.4105 55.4644C89.2926 54.8007 89.7071 54.6064 91.126 55.5792C93.5869 57.2808 92.4678 60.8873 89.3079 61.3196Z",
    fill: "url(#paint305_linear_10106_6282)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M89.3079 61.3196C86.7329 61.6748 86.0365 60.7094 83.4872 57.0302C83.2737 56.7203 83.3814 55.6803 84.4859 55.5263C89.3451 54.8594 89.7204 54.6783 91.1229 55.6348C93.574 57.307 92.4581 60.8906 89.3079 61.3196Z",
    fill: "url(#paint306_linear_10106_6282)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.3178 61.3163C86.7526 61.6682 86.0727 60.7518 83.5464 57.1085C83.3329 56.7986 83.4405 55.7259 84.5679 55.575C89.4173 54.9115 89.7306 54.7404 91.1297 55.6871C93.5742 57.3397 92.445 60.8841 89.3178 61.3163Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7237 63.582C69.3546 64.0412 67.1023 60.2073 69.1201 57.487C70.2429 55.963 71.4491 55.9165 76.9097 55.1888C77.3574 55.1251 77.7184 55.5489 77.5924 55.9842C76.1021 61.0141 75.5275 63.1934 72.7335 63.5787L72.7237 63.582Z",
    fill: "url(#paint307_linear_10106_6282)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M72.7238 63.582C69.3645 64.0379 67.1221 60.2334 69.1303 57.5491C70.2564 56.0349 71.4234 56.0016 76.861 55.2707C77.3316 55.2102 77.6895 55.6569 77.5601 56.0824C76.0697 61.0796 75.508 63.2 72.714 63.5853L72.7238 63.582Z",
    fill: "url(#paint308_linear_10106_6282)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M72.7238 63.582C69.3743 64.0346 67.1451 60.2693 69.1468 57.5981C70.2697 56.1068 71.4007 56.0638 76.8188 55.3395C77.2991 55.2757 77.6669 55.7518 77.5441 56.1642C76.06 61.1156 75.5047 63.1902 72.7205 63.5722L72.7238 63.582Z",
    fill: "url(#paint309_linear_10106_6282)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M72.7236 63.582C69.3872 64.0411 67.1679 60.3052 69.1664 57.6569C70.2926 56.1754 71.3713 56.1391 76.7796 55.418C77.2796 55.3477 77.6539 55.8434 77.5246 56.2688C76.0372 61.1778 75.498 63.2033 72.7236 63.582Z",
    fill: "url(#paint310_linear_10106_6282)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M72.7238 63.582C69.3972 64.0378 67.178 60.3346 69.1831 57.7059C70.3028 56.2375 71.3521 56.2111 76.7375 55.4868C77.2604 55.4197 77.6316 55.9383 77.5087 56.3506C76.0179 61.2171 75.4851 63.1968 72.7205 63.5722L72.7238 63.582Z",
    fill: "url(#paint311_linear_10106_6282)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M72.7238 63.582C69.4069 64.0345 67.2009 60.3704 69.193 57.7679C70.3063 56.3126 71.3229 56.2864 76.6887 55.5687C77.2312 55.495 77.6122 56.043 77.4796 56.4586C75.9951 61.2793 75.4687 63.2132 72.714 63.5853L72.7238 63.582Z",
    fill: "url(#paint312_linear_10106_6282)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M72.7238 63.582C69.4168 64.0312 67.224 60.4063 69.2129 57.8267C70.3294 56.3812 71.2938 56.3616 76.6498 55.6473C77.2118 55.567 77.593 56.1476 77.4669 56.5502C75.979 61.3284 75.4688 63.2132 72.7238 63.582Z",
    fill: "url(#paint313_linear_10106_6282)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.7238 63.582C69.4265 64.0279 67.247 60.4422 69.2294 57.8757C70.3394 56.4433 71.2711 56.4238 76.6173 55.7128C77.2022 55.6357 77.5802 56.2392 77.4541 56.6418C75.9726 61.3741 75.4687 63.2132 72.7335 63.5787L72.7238 63.582Z",
    fill: "url(#paint314_linear_10106_6282)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M72.7238 63.582C69.4396 64.0344 67.2667 60.4683 69.2492 57.9345C70.3625 56.5119 71.2452 56.5089 76.5783 55.7914C77.1828 55.7077 77.5674 56.3308 77.4413 56.7334C75.9597 61.433 75.4687 63.2132 72.7368 63.5885L72.7238 63.582Z",
    fill: "url(#paint315_linear_10106_6282)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M72.7237 63.582C69.4494 64.0311 67.2798 60.5075 69.2558 57.9868C70.3627 56.5773 71.2127 56.5744 76.5262 55.8635C77.1536 55.783 77.535 56.429 77.4089 56.8315C75.9239 61.4887 75.4491 63.2198 72.727 63.5918L72.7237 63.582Z",
    fill: "url(#paint316_linear_10106_6282)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M72.7238 63.582C69.4593 64.0278 67.3029 60.5434 69.2757 58.0456C70.3859 56.6459 71.1934 56.6464 76.484 55.9323C77.131 55.8452 77.5223 56.5206 77.3929 56.9133C75.9143 61.5247 75.4459 63.21 72.7336 63.5787L72.7238 63.582Z",
    fill: "url(#paint317_linear_10106_6282)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M72.7237 63.582C69.4689 64.0245 67.3225 60.5695 69.2921 58.0946C70.3958 56.7079 71.1641 56.7217 76.4416 56.0011C77.1082 55.9074 77.4997 56.6155 77.3702 57.0082C75.8882 61.5771 75.4327 63.2035 72.7237 63.582Z",
    fill: "url(#paint318_linear_10106_6282)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M72.7237 63.582C69.4788 64.0212 67.3455 60.6054 69.3022 58.1566C70.3993 56.7831 71.135 56.797 76.3929 56.083C77.0726 55.9957 77.4673 56.7137 77.3477 57.1031C75.8622 61.6295 75.4229 63.2068 72.7237 63.582Z",
    fill: "url(#paint319_linear_10106_6282)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M72.7238 63.582C69.4886 64.0179 67.3588 60.6445 69.3187 58.2056C70.4192 56.8419 71.1025 56.8625 76.3507 56.1518C77.05 56.0579 77.4546 56.8052 77.3251 57.198C75.8461 61.6786 75.4033 63.2134 72.7238 63.582Z",
    fill: "url(#paint320_linear_10106_6282)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.7236 63.582C69.5016 64.0243 67.3783 60.6706 69.3384 58.2644C70.4324 56.9138 71.083 56.9345 76.3115 56.2304C77.0304 56.1299 77.4352 56.9099 77.3122 57.2896C75.8331 61.7375 75.4032 63.2134 72.7236 63.582Z",
    fill: "url(#paint321_linear_10106_6282)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M72.7237 63.582C69.5115 64.0211 67.4015 60.7065 69.3551 58.3134C70.4523 56.9726 71.0638 57.0065 76.2694 56.2992C77.0112 56.2019 77.4128 57.0048 77.2898 57.3845C75.8072 61.7899 75.3935 63.2167 72.7237 63.582Z",
    fill: "url(#paint322_linear_10106_6282)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M72.7238 63.582C69.5213 64.0178 67.4246 60.7424 69.3651 58.3755C70.4559 57.0477 71.0249 57.0851 76.2207 56.3811C76.9821 56.2772 77.3936 57.1095 77.2673 57.4793C75.7911 61.839 75.3838 63.22 72.7238 63.582Z",
    fill: "url(#paint323_linear_10106_6282)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M72.7237 63.582C69.531 64.0145 67.4441 60.7685 69.3848 58.4342C70.4691 57.1196 71.0054 57.1571 76.1816 56.4597C76.9626 56.3492 77.3708 57.2044 77.2446 57.5742C75.765 61.8914 75.3739 63.2233 72.7139 63.5853L72.7237 63.582Z",
    fill: "url(#paint324_linear_10106_6282)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M72.7238 63.582C69.5311 64.0144 67.4574 60.8077 69.4014 58.4832C70.489 57.1784 70.9861 57.229 76.1492 56.5252C76.9531 56.4179 77.368 57.2927 77.2417 57.6625C75.7685 61.9339 75.3838 63.22 72.7336 63.5787L72.7238 63.582Z",
    fill: "url(#paint325_linear_10106_6282)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M72.7236 63.582C69.5441 64.0209 67.4803 60.8436 69.4211 58.542C70.5022 57.2503 70.9568 57.3043 76.1101 56.6038C76.9336 56.4899 77.3486 57.3973 77.219 57.7574C75.7424 61.9863 75.3738 63.2233 72.7334 63.5787L72.7236 63.582Z",
    fill: "url(#paint326_linear_10106_6282)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M72.7238 63.582C69.5541 64.0176 67.5002 60.8697 69.428 58.5943C70.5124 57.3124 70.9245 57.3698 76.0583 56.6759C76.9013 56.5554 77.3164 57.4955 77.1966 57.8523C75.7166 62.0387 75.3642 63.2266 72.7238 63.582Z",
    fill: "url(#paint327_linear_10106_6282)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.7238 63.582C69.5639 64.0143 67.5232 60.9055 69.4478 58.6531C70.529 57.394 70.8953 57.4451 76.016 56.7447C76.8722 56.6307 77.3036 57.5871 77.1708 57.9374C75.7004 62.0878 75.3413 63.2234 72.7205 63.5722L72.7238 63.582Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3838 53.8433C80.2021 54.2754 79.6172 54.3526 79.3282 53.9808C77.7293 51.956 75.2469 48.7342 74.9788 46.7735C74.6971 44.6756 76.1683 42.7287 78.2663 42.447C80.3642 42.1654 82.3111 43.6366 82.5928 45.7345C82.8575 47.6527 81.3699 51.5253 80.3805 53.8335L80.3838 53.8433Z",
    fill: "url(#paint328_linear_10106_6282)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M80.3838 53.8433C80.2021 54.2754 79.627 54.3493 79.3282 53.9808C77.7359 51.9756 75.2699 48.7701 75.0084 46.829C74.7203 44.7442 76.1981 42.8169 78.2829 42.5287C80.3678 42.2406 82.3016 43.7053 82.5897 45.7901C82.8511 47.6985 81.3732 51.5351 80.3838 53.8433Z",
    fill: "url(#paint329_linear_10106_6282)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M80.3837 53.8433C80.1987 54.2656 79.6269 54.3493 79.3413 53.9873C77.7522 51.9918 75.3059 48.8125 75.0379 46.8845C74.7564 44.8192 76.2146 42.8985 78.2994 42.6104C80.3843 42.3222 82.305 43.7804 82.5865 45.8457C82.8446 47.7443 81.3699 51.558 80.3837 53.8433Z",
    fill: "url(#paint330_linear_10106_6282)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M80.3773 53.8564C80.1924 54.2787 79.6205 54.3624 79.3349 54.0004C77.7622 52.0212 75.3128 48.8648 75.0579 46.9433C74.7796 44.8878 76.2346 42.99 78.3097 42.7052C80.3847 42.4203 82.289 43.8622 82.5771 45.9144C82.8319 47.8032 81.3668 51.5809 80.3871 53.8531L80.3773 53.8564Z",
    fill: "url(#paint331_linear_10106_6282)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M80.3773 53.8564C80.1924 54.2787 79.627 54.3493 79.3447 53.9971C77.7754 52.0277 75.3489 48.9071 75.0875 46.9987C74.8126 44.9531 76.2611 43.0684 78.3263 42.7868C80.3916 42.5053 82.2926 43.9374 82.5675 45.9831C82.8255 47.849 81.3572 51.6169 80.3806 53.8661L80.3773 53.8564Z",
    fill: "url(#paint332_linear_10106_6282)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M80.3772 53.8563C80.1923 54.2787 79.6269 54.3493 79.3446 53.9971C77.7818 52.0473 75.3718 48.943 75.1039 47.0477C74.8257 45.025 76.2743 43.1403 78.3297 42.862C80.3852 42.5838 82.2796 43.9963 82.5512 46.0322C82.8059 47.8883 81.3472 51.6202 80.3772 53.8563Z",
    fill: "url(#paint333_linear_10106_6282)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M80.3773 53.8564C80.1988 54.2656 79.6368 54.346 79.3544 53.9938C77.7983 52.0636 75.3949 48.9789 75.1401 47.0901C74.8652 45.0771 76.3008 43.2186 78.3431 42.9339C80.3888 42.659 82.2701 44.065 82.5449 46.078C82.7963 47.9243 81.3408 51.6333 80.374 53.8466L80.3773 53.8564Z",
    fill: "url(#paint334_linear_10106_6282)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M80.3676 53.8597C80.1891 54.2689 79.6271 54.3493 79.3447 53.9971C77.8017 52.0734 75.4081 49.0181 75.1502 47.1522C74.8819 45.1588 76.3077 43.3036 78.3435 43.032C80.3761 42.7505 82.2574 44.1566 82.5256 46.15C82.7704 47.9767 81.3279 51.6595 80.3611 53.8728L80.3676 53.8597Z",
    fill: "url(#paint335_linear_10106_6282)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M80.3674 53.8597C80.189 54.2689 79.6269 54.3493 79.3446 53.9971C77.8082 52.093 75.431 49.054 75.1763 47.1979C74.9016 45.2176 76.334 43.382 78.3567 43.1039C80.3795 42.8257 82.2444 44.2155 82.5191 46.1957C82.7704 48.0094 81.3213 51.6726 80.3674 53.8597Z",
    fill: "url(#paint336_linear_10106_6282)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M80.3674 53.8597C80.1889 54.2689 79.6334 54.3362 79.3543 53.9938C77.8212 52.0995 75.454 49.0899 75.2026 47.2436C74.9312 45.2731 76.357 43.4506 78.37 43.1757C80.3829 42.9009 82.2445 44.2809 82.5126 46.2415C82.7606 48.0454 81.3212 51.6726 80.3641 53.8499L80.3674 53.8597Z",
    fill: "url(#paint337_linear_10106_6282)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M80.3708 53.8695C80.1891 54.2689 79.6368 54.346 79.3578 54.0036C77.8313 52.1289 75.4804 49.1356 75.2357 47.3088C74.9708 45.358 76.3869 43.5387 78.3901 43.2672C80.3932 42.9957 82.2482 44.356 82.5163 46.3167C82.761 48.1107 81.3248 51.7151 80.3708 53.8695Z",
    fill: "url(#paint338_linear_10106_6282)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M80.3609 53.8728C80.1792 54.2722 79.6367 54.346 79.3577 54.0036C77.8443 52.1354 75.5034 49.1714 75.2521 47.3578C74.9906 45.4167 76.3936 43.6237 78.3968 43.3522C80.4 43.0807 82.2321 44.4378 82.5034 46.3756C82.7414 48.15 81.3182 51.7282 80.3707 53.8695L80.3609 53.8728Z",
    fill: "url(#paint339_linear_10106_6282)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M80.3609 53.8728C80.189 54.2689 79.6367 54.346 79.3577 54.0036C77.8509 52.155 75.5165 49.2106 75.2719 47.4166C75.0071 45.4984 76.4102 43.7054 78.4036 43.4372C80.397 43.1689 82.2224 44.5065 82.4904 46.4345C82.735 48.1958 81.315 51.7511 80.3609 53.8728Z",
    fill: "url(#paint340_linear_10106_6282)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M80.361 53.8728C80.189 54.2689 79.6368 54.346 79.3675 54.0003C77.8673 52.1713 75.5494 49.2432 75.308 47.459C75.0466 45.5506 76.4465 43.7805 78.4268 43.5057C80.407 43.231 82.2325 44.5686 82.4841 46.4803C82.7254 48.2318 81.3052 51.7543 80.361 53.8728Z",
    fill: "url(#paint341_linear_10106_6282)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M80.3511 53.8761C80.1759 54.2624 79.6334 54.3362 79.361 54.0134C77.8641 52.1942 75.5658 49.2922 75.318 47.5211C75.0599 45.6225 76.4533 43.8654 78.4237 43.594C80.3942 43.3226 82.2033 44.6439 82.4614 46.5425C82.6993 48.2842 81.2889 51.7708 80.3511 53.8761Z",
    fill: "url(#paint342_linear_10106_6282)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M80.3512 53.8761C80.176 54.2624 79.6335 54.3362 79.3709 54.0101C77.8904 52.2072 75.589 49.3281 75.3575 47.5732C75.106 45.6942 76.4896 43.9405 78.4502 43.6724C80.4109 43.4043 82.2167 44.7158 82.4682 46.5948C82.6996 48.3169 81.2956 51.7904 80.361 53.8728L80.3512 53.8761Z",
    fill: "url(#paint343_linear_10106_6282)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M80.3544 53.8858C80.1792 54.2722 79.6465 54.3427 79.3741 54.0199C77.8969 52.2267 75.6152 49.3738 75.3772 47.632C75.1192 45.7661 76.4996 44.0353 78.4505 43.7705C80.4014 43.5057 82.1941 44.8106 82.4487 46.6668C82.6866 48.3758 81.2825 51.8165 80.3446 53.8891L80.3544 53.8858Z",
    fill: "url(#paint344_linear_10106_6282)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M80.3544 53.8859C80.1791 54.2722 79.6465 54.3427 79.374 54.0199C77.9034 52.2463 75.6381 49.4096 75.3937 47.681C75.1423 45.8347 76.5129 44.1072 78.454 43.8457C80.3951 43.5842 82.1811 44.8695 82.4358 46.7257C82.6704 48.4249 81.2695 51.8427 80.3446 53.8892L80.3544 53.8859Z",
    fill: "url(#paint345_linear_10106_6282)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M80.3446 53.8892C80.1661 54.2657 79.6367 54.346 79.3741 54.0199C77.9166 52.2528 75.6514 49.4488 75.4233 47.7365C75.1752 45.9 76.5426 44.1953 78.4706 43.9273C80.4019 43.6691 82.1847 44.9447 82.4327 46.7812C82.6607 48.4609 81.2728 51.8525 80.3446 53.8892Z",
    fill: "url(#paint346_linear_10106_6282)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M80.3447 53.8892C80.1759 54.2624 79.6433 54.3329 79.3741 54.0199C77.9232 52.2724 75.6744 49.4847 75.4399 47.7855C75.1853 45.9621 76.556 44.2672 78.4742 44.0025C80.3924 43.7378 82.1621 45.0069 82.4166 46.8303C82.6413 48.5002 81.2566 51.8689 80.3349 53.8925L80.3447 53.8892Z",
    fill: "url(#paint347_linear_10106_6282)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M80.3446 53.8892C80.1759 54.2624 79.6432 54.3329 79.3839 54.0166C77.9396 52.2887 75.7072 49.5173 75.4793 47.8376C75.2313 46.0338 76.5922 44.3423 78.5039 44.0907C80.4156 43.8391 82.1787 45.0886 82.4266 46.8924C82.6578 48.5492 81.273 51.8852 80.3577 53.8957L80.3446 53.8892Z",
    fill: "url(#paint348_linear_10106_6282)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.3447 53.8892C80.1759 54.2624 79.653 54.3296 79.3839 54.0166C77.9429 52.2985 75.7237 49.5663 75.4958 47.8866C75.2511 46.0926 76.599 44.4273 78.5074 44.1659C80.4158 43.9045 82.156 45.1508 82.4007 46.9448C82.6285 48.5918 81.2469 51.9049 80.3349 53.8925L80.3447 53.8892Z",
    fill: "white"
  })))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2914 61.3687C86.5268 61.7442 85.3731 59.9074 82.6021 55.441L82.5298 55.3236C82.4115 55.1344 82.3845 54.8925 82.4884 54.6829C82.5825 54.4767 82.775 54.3354 83.0037 54.302C83.4514 54.2384 83.8795 54.1813 84.2749 54.1244C84.8173 54.0507 85.314 53.9706 85.765 53.9168C88.8726 53.4911 89.9581 53.5071 91.1578 54.4447C92.4132 55.418 92.9285 56.979 92.5119 58.5267C92.092 60.0647 90.8664 61.1542 89.2914 61.3687ZM85.7784 54.0213C85.3307 54.0849 84.8307 54.1553 84.2883 54.229C83.8929 54.2859 83.4746 54.3396 83.0171 54.4065C82.8309 54.4366 82.6645 54.5581 82.5801 54.7284C82.499 54.9085 82.5127 55.1111 82.6114 55.2743L82.6837 55.3917C85.4382 59.8091 86.569 61.6427 89.2681 61.2675C90.8007 61.0564 92.0035 59.9964 92.4039 58.4977C92.8043 56.999 92.3023 55.4772 91.0861 54.5234C89.9192 53.6184 88.8436 53.5991 85.7653 54.0148L85.7784 54.0213Z",
    fill: "url(#paint349_linear_10106_6282)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7301 63.6343C71.155 63.8488 69.6683 63.128 68.8562 61.7544C68.0441 60.3807 68.1236 58.7393 69.0674 57.4611C69.9819 56.2255 70.9454 55.9444 74.2753 55.4984C74.7132 55.4381 75.1936 55.3743 75.7165 55.3072C76.0825 55.2602 76.4779 55.2033 76.8864 55.1529C77.1151 55.1194 77.341 55.2069 77.4854 55.3765C77.6331 55.5558 77.6895 55.7877 77.6215 56.007L77.5084 56.3833C76.1119 61.1089 75.4751 63.2655 72.7203 63.6376L72.7301 63.6343ZM74.2986 55.5996C71.0013 56.0455 70.0704 56.2938 69.1559 57.5294C68.2316 58.7683 68.1519 60.3771 68.9509 61.7115C69.74 63.0493 71.1874 63.7506 72.7199 63.5395C75.4126 63.1774 76.0042 61.1779 77.4233 56.3575L77.5364 55.9811C77.5947 55.7978 77.5482 55.5953 77.4235 55.4519C77.2988 55.3084 77.1089 55.2306 76.9096 55.2542C76.4913 55.3079 76.1057 55.3615 75.7397 55.4085C75.2168 55.4756 74.7364 55.5393 74.2986 55.5996Z",
    fill: "url(#paint350_linear_10106_6282)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9042 54.2666C79.6656 54.3034 79.4365 54.2061 79.2854 54.0169C77.2728 51.4769 75.1775 48.6266 74.9294 46.79C74.6378 44.6627 76.1351 42.6961 78.2625 42.4046C80.3898 42.113 82.3564 43.6103 82.6479 45.7376C82.8993 47.5839 81.5808 51.1813 80.4357 53.8692C80.3449 54.0853 80.146 54.2396 79.9075 54.2764L79.9042 54.2666ZM78.2759 42.5091C76.2008 42.794 74.7491 44.7016 75.034 46.7766C75.3155 48.8419 78.1587 52.422 79.3637 53.9578C79.4917 54.1111 79.6849 54.1987 79.8809 54.1653C80.0803 54.1418 80.2433 54.0105 80.3244 53.8304C81.4728 51.1522 82.7849 47.568 82.5336 45.7543C82.2487 43.6793 80.3411 42.2276 78.2661 42.5124L78.2759 42.5091Z",
    fill: "url(#paint351_linear_10106_6282)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0368 59.5453C87.9192 59.6929 87.2448 59.4075 85.0425 55.884C87.9934 55.4785 89.1465 55.2099 90.0217 55.8968C91.441 57.0003 90.8308 59.3007 89.0368 59.5453ZM72.4723 61.8011C70.6685 62.0491 69.4748 59.9967 70.5456 58.5448C71.1835 57.6861 72.0563 57.6537 75.3404 57.2014C74.1443 61.2266 73.6291 61.6403 72.4821 61.7978L72.4723 61.8011ZM76.7497 46.5257C76.5988 45.3983 77.3865 44.3691 78.5008 44.2117C79.6151 44.0543 80.6574 44.8485 80.8148 45.9628C81.0023 47.296 80.3367 48.655 79.4352 50.8681C77.8725 48.9183 76.9374 47.9243 76.7464 46.5159L76.7497 46.5257Z",
    fill: "url(#paint352_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 44,
    width: 21,
    height: 18
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0368 59.5453C87.9192 59.6929 87.2448 59.4075 85.0425 55.884C87.9934 55.4785 89.1465 55.2099 90.0217 55.8968C91.441 57.0003 90.8308 59.3007 89.0368 59.5453ZM72.4723 61.8011C70.6685 62.0491 69.4748 59.9967 70.5456 58.5448C71.1835 57.6861 72.0563 57.6537 75.3404 57.2014C74.1443 61.2266 73.6291 61.6403 72.4821 61.7978L72.4723 61.8011ZM76.7497 46.5257C76.5988 45.3983 77.3865 44.3691 78.5008 44.2117C79.6151 44.0543 80.6574 44.8485 80.8148 45.9628C81.0023 47.296 80.3367 48.655 79.4352 50.8681C77.8725 48.9183 76.9374 47.9243 76.7464 46.5159L76.7497 46.5257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0366 59.5453C87.9321 59.6994 87.2577 59.414 85.1081 55.9819C85.0818 55.9362 85.1044 55.874 85.1567 55.8673C88.0259 55.4784 89.1594 55.2164 90.0182 55.887C91.4375 56.9905 90.8274 59.2909 89.0333 59.5355L89.0366 59.5453Z",
    fill: "url(#paint353_linear_10106_6282)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M89.0368 59.5453C87.942 59.6961 87.3427 59.3745 85.1608 56.0732C85.1181 56.0113 85.1538 55.9229 85.2289 55.9194C88.0556 55.5339 89.1729 55.2882 90.0251 55.9392C91.4411 57.033 90.8308 59.3006 89.0368 59.5453Z",
    fill: "url(#paint354_linear_10106_6282)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M89.0367 59.5453C87.9518 59.6928 87.3916 59.358 85.2134 56.1646C85.1543 56.0863 85.2029 55.9718 85.2977 55.9616C88.0721 55.5829 89.1795 55.3405 90.0284 55.9817C91.4378 57.0559 90.8307 59.3007 89.0367 59.5453Z",
    fill: "url(#paint355_linear_10106_6282)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M89.0367 59.5453C87.9615 59.6895 87.4243 59.3578 85.2561 56.2593C85.1904 56.1614 85.2423 56.0239 85.3566 56.0072C88.0885 55.6319 89.1764 55.3961 90.0122 56.0308C91.415 57.0854 90.8078 59.2975 89.0236 59.5388L89.0367 59.5453Z",
    fill: "url(#paint356_linear_10106_6282)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M89.0367 59.5453C87.9714 59.6862 87.4439 59.3512 85.3088 56.3506C85.2267 56.2365 85.2915 56.0728 85.4255 56.0495C88.1149 55.6776 89.1963 55.4549 90.0157 56.0733C91.4152 57.1181 90.798 59.3008 89.0236 59.5388L89.0367 59.5453Z",
    fill: "url(#paint357_linear_10106_6282)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M89.0366 59.5453C87.9844 59.6927 87.4569 59.3577 85.3614 56.442C85.2628 56.3116 85.3407 56.1217 85.4975 56.1015C88.1346 55.7364 89.2062 55.517 90.0223 56.1256C91.4054 57.1541 90.798 59.3008 89.0366 59.5453Z",
    fill: "url(#paint358_linear_10106_6282)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M89.0365 59.5453C87.9941 59.6894 87.4699 59.3642 85.4139 56.5334C85.3087 56.3833 85.3898 56.1706 85.5662 56.1438C88.1608 55.782 89.2161 55.5791 90.0256 56.1681C91.4021 57.177 90.7979 59.3008 89.0365 59.5453Z",
    fill: "url(#paint359_linear_10106_6282)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M89.0367 59.5453C88.0041 59.6861 87.4832 59.3707 85.4666 56.6247C85.3451 56.4584 85.4293 56.2227 85.6352 56.1861C88.1775 55.831 89.223 55.6313 90.0194 56.2139C91.3893 57.2032 90.7784 59.3074 89.0236 59.5388L89.0367 59.5453Z",
    fill: "url(#paint360_linear_10106_6282)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M89.0367 59.5453C88.0138 59.6828 87.4963 59.3772 85.5192 56.7161C85.3813 56.5335 85.4752 56.2618 85.7072 56.2381C88.2104 55.8963 89.2363 55.7032 90.0261 56.2662C91.3927 57.2456 90.7784 59.3074 89.0367 59.5453Z",
    fill: "url(#paint361_linear_10106_6282)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M89.0366 59.5453C88.0236 59.6795 87.4995 59.387 85.5751 56.8173C85.4208 56.6183 85.5277 56.3205 85.7793 56.2902C88.2301 55.9551 89.2463 55.7653 90.0327 56.3185C91.3927 57.2783 90.7817 59.3172 89.0399 59.5551L89.0366 59.5453Z",
    fill: "url(#paint362_linear_10106_6282)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M89.0366 59.5453C88.0367 59.686 87.5159 59.4033 85.6277 56.9086C85.4668 56.6901 85.5769 56.3694 85.8481 56.3325C88.2565 56.0008 89.2628 55.8143 90.0264 56.3643C91.3831 57.3143 90.7686 59.3107 89.0302 59.5584L89.0366 59.5453Z",
    fill: "url(#paint363_linear_10106_6282)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M89.0367 59.5453C88.0465 59.6827 87.5193 59.4131 85.6804 57C85.5031 56.7652 85.6261 56.4182 85.9202 56.3846C88.2861 56.0562 89.2761 55.8862 90.0331 56.4165C91.3734 57.3503 90.7621 59.3238 89.04 59.5551L89.0367 59.5453Z",
    fill: "url(#paint364_linear_10106_6282)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M89.0365 59.5453C88.0562 59.6794 87.5224 59.4229 85.7329 57.0914C85.5391 56.8403 85.6752 56.4671 85.9889 56.4268C88.3025 56.1052 89.2827 55.9385 90.0364 56.459C91.3701 57.3732 90.762 59.3238 89.0398 59.5551L89.0365 59.5453Z",
    fill: "url(#paint365_linear_10106_6282)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M89.0367 59.5453C88.0661 59.6761 87.5259 59.4327 85.7856 57.1827C85.5755 56.9153 85.7245 56.516 86.0578 56.4691C88.3289 56.1509 89.2929 56.0006 90.0366 56.4917C91.367 57.3961 90.7555 59.3042 89.0367 59.5453Z",
    fill: "url(#paint366_linear_10106_6282)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M89.0367 59.5453C88.076 59.6728 87.5423 59.449 85.8383 57.2741C85.6117 56.9904 85.764 56.5682 86.1267 56.5114C88.3455 56.1999 89.2996 56.0528 90.0303 56.5375C91.3541 57.4223 90.736 59.3108 89.0334 59.5355L89.0367 59.5453Z",
    fill: "url(#paint367_linear_10106_6282)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M89.0365 59.5453C88.0889 59.6793 87.5454 59.4588 85.8907 57.3654C85.6477 57.0655 85.813 56.617 86.1986 56.5634C88.3782 56.2652 89.3128 56.1247 90.0368 56.5898C91.354 57.455 90.7358 59.3108 89.0365 59.5453Z",
    fill: "url(#paint368_linear_10106_6282)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M89.0367 59.5453C88.0988 59.676 87.5489 59.4686 85.9435 57.4568C85.6841 57.1405 85.8623 56.6659 86.2675 56.6057C88.3949 56.3141 89.3294 56.1737 90.0404 56.6323C91.3509 57.4779 90.7359 59.3108 89.0367 59.5453Z",
    fill: "url(#paint369_linear_10106_6282)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M89.0366 59.5453C88.1086 59.6727 87.5554 59.4882 85.996 57.5482C85.7301 57.2123 85.9115 56.7148 86.3363 56.648C88.4211 56.3598 89.3361 56.226 90.034 56.6781C91.3379 57.5041 90.7261 59.3141 89.0366 59.5453Z",
    fill: "url(#paint370_linear_10106_6282)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M89.0366 59.5453C88.1184 59.6694 87.5588 59.498 86.0487 57.6395C85.7663 57.2874 85.9574 56.7539 86.4084 56.7C88.4508 56.4153 89.3494 56.2979 90.0407 56.7304C91.3413 57.5466 90.7163 59.3174 89.0366 59.5453Z",
    fill: "url(#paint371_linear_10106_6282)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.0365 59.5453C88.1281 59.6661 87.5653 59.5176 86.1012 57.7309C85.8024 57.3625 86.0065 56.8027 86.4771 56.7423C88.4672 56.4643 89.356 56.3502 90.044 56.7729C91.338 57.5695 90.7162 59.3174 89.0365 59.5453Z",
    fill: "url(#paint372_linear_10106_6282)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M89.0367 59.5453C88.1413 59.6726 87.5687 59.5274 86.1539 57.8223C85.8388 57.4375 86.0559 56.8516 86.546 56.7846C88.4936 56.51 89.3727 56.3991 90.0475 56.8153C91.335 57.5924 90.713 59.3076 89.0465 59.542L89.0367 59.5453Z",
    fill: "url(#paint373_linear_10106_6282)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4754 61.8109C70.6716 62.0589 69.478 60.0065 70.5487 58.5546C71.1866 57.6959 72.0071 57.6703 75.2913 57.2179C75.3402 57.2014 75.3502 57.2308 75.3372 57.257C74.1377 61.2724 73.6191 61.6436 72.4721 61.8011L72.4754 61.8109Z",
    fill: "url(#paint374_linear_10106_6282)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M70.5619 58.5938C71.1933 57.7482 72.0138 57.7225 75.2358 57.2802C75.3077 57.2669 75.334 57.3126 75.3178 57.3616C74.0166 61.2369 73.6191 61.6436 72.4819 61.7978C70.6879 62.0425 69.4943 60.0228 70.5619 58.5938Z",
    fill: "url(#paint375_linear_10106_6282)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M70.5686 58.6461C71.1935 57.8136 72.0205 57.7748 75.1707 57.3458C75.2655 57.3357 75.3082 57.3976 75.279 57.4729C73.9512 61.2371 73.5897 61.6535 72.4623 61.8044C70.6781 62.0458 69.4847 60.0588 70.5555 58.6396L70.5686 58.6461Z",
    fill: "url(#paint376_linear_10106_6282)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M70.582 58.6852C71.2004 57.8658 72.0274 57.8271 75.1155 57.4081C75.2299 57.3914 75.2923 57.4794 75.2599 57.5776C73.9416 61.2404 73.5899 61.6535 72.4756 61.8109C70.6913 62.0523 69.5143 60.0815 70.5853 58.695L70.582 58.6852Z",
    fill: "url(#paint377_linear_10106_6282)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M70.5886 58.7375C71.2039 57.941 72.0374 57.8892 75.0503 57.4737C75.1973 57.4569 75.2663 57.5645 75.221 57.6889C73.9121 61.2503 73.5604 61.6634 72.4657 61.8142C70.6913 62.0523 69.5144 60.1142 70.5788 58.7408L70.5886 58.7375Z",
    fill: "url(#paint378_linear_10106_6282)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M70.6019 58.7767C71.2106 57.9933 72.0441 57.9415 74.9949 57.536C75.1616 57.5126 75.2503 57.6463 75.2017 57.7936C73.9024 61.2536 73.5605 61.6634 72.4755 61.8109C70.7142 62.0555 69.5439 60.137 70.6019 58.7767Z",
    fill: "url(#paint379_linear_10106_6282)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M70.6085 58.829C71.2205 58.0554 72.0507 57.9938 74.9428 57.6081C75.129 57.5781 75.2407 57.7477 75.1726 57.9016C73.8958 61.2667 73.5506 61.6667 72.4657 61.8142C70.7043 62.0588 69.5439 60.1697 70.6085 58.829Z",
    fill: "url(#paint380_linear_10106_6282)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M70.6216 58.8682C71.2272 58.1077 72.0574 58.046 74.884 57.6606C75.0932 57.6337 75.2213 57.8197 75.15 57.9964C73.8924 61.2569 73.5374 61.6602 72.4721 61.8011C70.7206 62.0423 69.5701 60.1827 70.6183 58.8584L70.6216 58.8682Z",
    fill: "url(#paint381_linear_10106_6282)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M70.6251 58.9107C71.2242 58.1633 72.0544 58.1016 74.8189 57.7262C75.0477 57.6927 75.1955 57.9048 75.1112 58.1077C73.8762 61.2733 73.5179 61.6668 72.4624 61.8044C70.7108 62.0456 69.5702 60.2154 70.6251 58.9107Z",
    fill: "url(#paint382_linear_10106_6282)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M70.6416 58.9597C71.2341 58.2254 72.0708 58.1506 74.7635 57.7885C75.0152 57.7583 75.1794 57.9866 75.0919 58.2124C73.8892 61.2798 73.508 61.6701 72.4754 61.8109C70.7337 62.0488 69.5932 60.2513 70.6514 58.9564L70.6416 58.9597Z",
    fill: "url(#paint383_linear_10106_6282)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M70.6451 59.0022C71.2312 58.2809 72.0679 58.2062 74.6985 57.8541C74.9697 57.8173 75.1536 58.0716 75.0531 58.3237C73.8731 61.2962 73.4886 61.6767 72.4559 61.8175C70.724 62.0521 69.5934 60.284 70.6386 59.0153L70.6451 59.0022Z",
    fill: "url(#paint384_linear_10106_6282)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M70.6615 59.0511C71.2444 58.3528 72.0876 58.265 74.643 57.9164C74.9371 57.8827 75.1375 58.1534 75.024 58.4317C73.8665 61.3093 73.4689 61.6833 72.4558 61.8175C70.7239 62.0521 69.6032 60.3134 70.6517 59.0544L70.6615 59.0511Z",
    fill: "url(#paint385_linear_10106_6282)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M70.665 59.0936C71.2414 58.4084 72.0846 58.3206 74.5779 57.982C74.8917 57.9417 75.1117 58.2385 74.9917 58.5299C73.8666 61.3093 73.4526 61.667 72.4526 61.8077C70.7305 62.039 69.6197 60.3296 70.665 59.0936Z",
    fill: "url(#paint386_linear_10106_6282)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M70.6816 59.1426C71.2514 58.4705 72.1011 58.3696 74.5226 58.0443C74.8657 57.9941 75.0989 58.3301 74.9627 58.6379C73.8601 61.3224 73.433 61.6736 72.4527 61.8077C70.7403 62.0357 69.6297 60.359 70.6685 59.1361L70.6816 59.1426Z",
    fill: "url(#paint387_linear_10106_6282)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M70.685 59.1851C71.2484 58.5261 72.0981 58.4252 74.4673 58.1066C74.8333 58.0596 75.0829 58.4119 74.9434 58.7425C73.8634 61.3322 73.433 61.6736 72.4527 61.8077C70.7436 62.0455 69.6396 60.3884 70.685 59.1851Z",
    fill: "url(#paint388_linear_10106_6282)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M70.6981 59.2243C71.2647 58.5751 72.1144 58.4741 74.4084 58.1591C74.794 58.1055 75.0634 58.4839 74.9109 58.8407C73.8666 61.342 73.41 61.6704 72.4525 61.8077C70.7533 62.0422 69.6591 60.4145 70.6981 59.2243Z",
    fill: "url(#paint389_linear_10106_6282)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M70.7049 59.2766C71.2651 58.6405 72.1148 58.5395 74.3467 58.2345C74.7552 58.1841 75.041 58.5788 74.8853 58.9585C73.8635 61.3649 73.4036 61.6835 72.456 61.8175C70.7567 62.052 69.6725 60.4537 70.7082 59.2864L70.7049 59.2766Z",
    fill: "url(#paint390_linear_10106_6282)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M70.718 59.3158C71.2717 58.6927 72.1181 58.582 74.2912 58.2968C74.7193 58.2398 75.028 58.6703 74.8528 59.0567C73.8536 61.3682 73.3904 61.677 72.4525 61.8077C70.7631 62.0389 69.6888 60.47 70.718 59.3158Z",
    fill: "url(#paint391_linear_10106_6282)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M70.7249 59.3681C71.2754 58.7679 72.1282 58.6441 74.2262 58.3625C74.6739 58.2988 75.0023 58.7554 74.8239 59.1647C73.8571 61.378 73.371 61.6837 72.4429 61.811C70.7633 62.0389 69.6857 60.4929 70.7249 59.3681Z",
    fill: "url(#paint392_linear_10106_6282)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.738 59.4072C71.2821 58.8202 72.1349 58.6964 74.1708 58.4248C74.6414 58.3643 74.9862 58.8372 74.7948 59.2727C73.8505 61.3911 73.3611 61.687 72.4429 61.811C70.7632 62.0389 69.7054 60.519 70.7282 59.4105L70.738 59.4072Z",
    fill: "url(#paint393_linear_10106_6282)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M70.7446 59.4595C71.2821 58.8856 72.1415 58.7487 74.1055 58.4903C74.5956 58.4233 74.9635 58.9321 74.7656 59.3807C73.857 61.4107 73.3414 61.6935 72.4427 61.811C70.7729 62.0356 69.7152 60.5484 70.7446 59.4595Z",
    fill: "url(#paint394_linear_10106_6282)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7529 46.5355C76.602 45.408 77.3897 44.3788 78.504 44.2215C79.6183 44.0641 80.6606 44.8583 80.818 45.9726C81.0056 47.3058 80.3399 48.6648 79.4385 50.8779C77.8757 48.9281 76.9407 47.9341 76.7496 46.5257L76.7529 46.5355Z",
    fill: "url(#paint395_linear_10106_6282)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M76.7759 46.5713C76.6185 45.457 77.4062 44.4278 78.5238 44.2802C79.6381 44.1228 80.6673 44.9106 80.8247 46.0249C81.009 47.3483 80.3498 48.6942 79.4549 50.8942C77.8987 48.964 76.9768 47.9765 76.7792 46.5811L76.7759 46.5713Z",
    fill: "url(#paint396_linear_10106_6282)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M76.7988 46.6072C76.6447 45.5027 77.426 44.4866 78.5305 44.3325C79.635 44.1784 80.6609 44.9564 80.815 46.0609C80.9959 47.3745 80.3432 48.7073 79.4515 50.8844C77.9085 48.9607 76.9931 47.9927 76.7988 46.6072Z",
    fill: "url(#paint397_linear_10106_6282)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M76.8121 46.6464C76.6614 45.5517 77.4328 44.5389 78.5373 44.3848C79.632 44.234 80.6546 45.0022 80.8054 46.0969C80.9797 47.3909 80.3369 48.7204 79.4516 50.8844C77.9152 48.9803 77.0031 48.0221 76.8219 46.6431L76.8121 46.6464Z",
    fill: "url(#paint398_linear_10106_6282)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M76.835 46.6823C76.6875 45.5974 77.4524 44.5977 78.5472 44.4469C79.6419 44.2961 80.6514 45.0577 80.7988 46.1427C80.9699 47.4269 80.3237 48.7466 79.4514 50.8844C77.9314 48.9966 77.0194 48.0384 76.835 46.6823Z",
    fill: "url(#paint399_linear_10106_6282)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M76.8483 46.7215C76.7041 45.6464 77.4593 44.65 78.5442 44.5025C79.6291 44.355 80.6255 45.1101 80.7795 46.182C80.957 47.4531 80.3075 48.763 79.4418 50.8877C77.9283 49.0195 77.0294 48.0678 76.8483 46.7215Z",
    fill: "url(#paint400_linear_10106_6282)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M76.8681 46.7476C76.7272 45.6823 77.4856 44.6957 78.5574 44.5417C79.6326 44.3975 80.6256 45.1428 80.7763 46.2049C80.9506 47.4662 80.3076 48.763 79.4483 50.8746C77.9513 49.0226 77.0556 48.0808 76.8779 46.7443L76.8681 46.7476Z",
    fill: "url(#paint401_linear_10106_6282)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.8911 46.7835C76.7437 45.7312 77.5021 44.7446 78.5675 44.6038C79.6426 44.4596 80.6226 45.1984 80.7733 46.2604C80.9442 47.512 80.311 48.8055 79.4516 50.8844C77.9612 49.052 77.0786 48.1167 76.8911 46.7835Z",
    fill: "url(#paint402_linear_10106_6282)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M76.9043 46.8226C76.757 45.7704 77.5122 44.8067 78.5742 44.656C79.6396 44.5152 80.6163 45.2442 80.7636 46.2964C80.9313 47.5382 80.3046 48.8186 79.4517 50.8844C77.9744 49.0585 77.0951 48.133 76.9141 46.8193L76.9043 46.8226Z",
    fill: "url(#paint403_linear_10106_6282)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M76.9272 46.8585C76.7831 45.8161 77.5286 44.8557 78.5808 44.7083C79.633 44.561 80.6097 45.29 80.7538 46.3324C80.9181 47.5644 80.2979 48.8317 79.4482 50.8746C77.9775 49.0683 77.1015 48.1526 76.9239 46.8487L76.9272 46.8585Z",
    fill: "url(#paint404_linear_10106_6282)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M76.9503 46.8944C76.8095 45.8618 77.5485 44.9145 78.5909 44.7704C79.6333 44.6263 80.6067 45.3456 80.7475 46.3782C80.9183 47.5971 80.2948 48.8546 79.4516 50.8844C77.9973 49.0944 77.1247 48.1885 76.9503 46.8944Z",
    fill: "url(#paint405_linear_10106_6282)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M76.9634 46.9336C76.8259 45.9108 77.555 44.9668 78.5975 44.8227C79.6399 44.6786 80.5904 45.3947 80.7377 46.4142C80.9052 47.6233 80.2882 48.8677 79.4515 50.8844C78.0038 49.114 77.1442 48.2146 76.9732 46.9303L76.9634 46.9336Z",
    fill: "url(#paint406_linear_10106_6282)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M76.9864 46.9695C76.8522 45.9565 77.5749 45.0256 78.6042 44.875C79.6335 44.7244 80.584 45.4405 80.728 46.4502C80.8922 47.6495 80.2817 48.8808 79.4482 50.8746C78.0169 49.1205 77.1606 48.2309 76.9831 46.9597L76.9864 46.9695Z",
    fill: "url(#paint407_linear_10106_6282)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M76.9998 47.0087C76.8591 46.0087 77.5818 45.0778 78.6144 44.9371C79.647 44.7963 80.5811 45.4961 80.7218 46.496C80.8827 47.6855 80.2787 48.9037 79.4517 50.8844C78.027 49.1499 77.1805 48.2569 77.0096 47.0054L76.9998 47.0087Z",
    fill: "url(#paint408_linear_10106_6282)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M77.0227 47.0446C76.8853 46.0544 77.5982 45.1268 78.621 44.9894C79.634 44.8552 80.5746 45.5419 80.7153 46.5418C80.8729 47.7215 80.2754 48.9266 79.4515 50.8844C78.0399 49.1564 77.2001 48.283 77.0324 47.0413L77.0227 47.0446Z",
    fill: "url(#paint409_linear_10106_6282)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M77.0423 47.0706C76.9083 46.0903 77.6244 45.1725 78.6277 45.0416C79.6407 44.9075 80.5682 45.5876 80.7056 46.5778C80.8697 47.7444 80.2689 48.9397 79.4515 50.8844C78.0465 49.176 77.21 48.3124 77.0456 47.0804L77.0423 47.0706Z",
    fill: "url(#paint410_linear_10106_6282)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M77.0557 47.1098C76.9249 46.1393 77.6313 45.2248 78.6345 45.0939C79.6345 44.9533 80.5619 45.6334 80.696 46.6138C80.8568 47.7706 80.2625 48.9528 79.4516 50.8844C78.063 49.1923 77.2298 48.3385 77.0655 47.1065L77.0557 47.1098Z",
    fill: "url(#paint411_linear_10106_6282)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M77.0785 47.1457C76.9477 46.1752 77.6509 45.2836 78.6411 45.1462C79.6312 45.0089 80.5456 45.6825 80.6861 46.6498C80.8436 47.7968 80.246 48.9692 79.4482 50.8746C78.0662 49.2021 77.246 48.3548 77.0752 47.1359L77.0785 47.1457Z",
    fill: "url(#paint412_linear_10106_6282)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M77.0918 47.1849C76.9643 46.2242 77.6577 45.3359 78.6414 45.2116C79.6315 45.0742 80.5361 45.7512 80.6701 46.6989C80.8243 47.8361 80.2331 48.9954 79.4418 50.8877C78.0762 49.2315 77.256 48.3842 77.0918 47.1849Z",
    fill: "url(#paint413_linear_10106_6282)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M77.1149 47.2208C76.9809 46.2731 77.6776 45.3946 78.6579 45.2606C79.6383 45.1265 80.5396 45.7937 80.6702 46.7316C80.8211 47.859 80.2365 49.0052 79.4516 50.8844C78.0926 49.2478 77.2856 48.407 77.1247 47.2175L77.1149 47.2208Z",
    fill: "url(#paint414_linear_10106_6282)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M77.1379 47.2567C77.0072 46.3188 77.6941 45.4436 78.6646 45.3129C79.6352 45.1821 80.5332 45.8395 80.6638 46.7773C80.8212 47.8917 80.2366 49.0379 79.4516 50.8844C78.1057 49.2542 77.3053 48.4331 77.1379 47.2567Z",
    fill: "url(#paint415_linear_10106_6282)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.151 47.2959C77.0237 46.3678 77.7041 45.5057 78.6746 45.3749C79.6354 45.2475 80.5301 45.8951 80.6574 46.8231C80.8115 47.9276 80.2334 49.0608 79.4549 50.8942C78.1156 49.2836 77.3185 48.4722 77.1641 47.3024L77.151 47.2959Z",
    fill: "white"
  })))), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0502 59.5845C87.913 59.7387 87.2386 59.4533 85.0166 55.9037L84.9968 55.845L85.0393 55.8415C85.3824 55.7914 85.7059 55.7478 86.0099 55.7108C86.2713 55.6772 86.5196 55.6372 86.7386 55.607C88.4999 55.3624 89.3465 55.3171 90.0414 55.8575C90.7101 56.3849 90.9908 57.2176 90.7713 58.0553C90.5485 58.8831 89.8835 59.4673 89.0404 59.5878L89.0502 59.5845ZM85.118 55.9132C87.2874 59.3714 87.9487 59.6503 89.0434 59.4995C89.8571 59.3889 90.496 58.8245 90.7091 58.0326C90.9189 57.2309 90.6579 56.4243 89.9991 55.9263C89.3304 55.3989 88.4969 55.4507 86.7552 55.6887C86.5264 55.7221 86.2846 55.7491 86.0265 55.7925C85.7455 55.8326 85.4415 55.8696 85.1213 55.923L85.118 55.9132Z",
    fill: "url(#paint416_linear_10106_6282)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4857 61.8403C71.6393 61.951 70.8436 61.5646 70.3998 60.8305C69.9658 60.0931 70.0053 59.207 70.5163 58.522C71.05 57.8075 71.7491 57.6482 73.7948 57.3733C74.0039 57.3464 74.2229 57.3163 74.4614 57.2795C74.7327 57.2426 75.0268 57.209 75.3372 57.1589L75.396 57.1391L75.3799 57.2209C74.174 61.2494 73.6523 61.6762 72.4824 61.8305L72.4857 61.8403ZM73.8114 57.455C71.7985 57.7298 71.1059 57.876 70.5884 58.5741C70.1002 59.2296 70.0605 60.083 70.4749 60.7943C70.899 61.5023 71.6587 61.879 72.4724 61.7684C73.5998 61.6175 74.1052 61.2071 75.2852 57.2637C74.9944 57.3072 74.7232 57.344 74.4716 57.3743C74.233 57.4111 74.0108 57.4314 73.8049 57.4681L73.8114 57.455Z",
    fill: "url(#paint417_linear_10106_6282)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4553 50.9596L79.4159 50.9074C79.2287 50.6759 79.0449 50.4542 78.8775 50.2488C77.63 48.7164 76.8815 47.7904 76.7139 46.5487C76.5564 45.4017 77.3571 44.3463 78.5041 44.1888C79.6511 44.0313 80.7065 44.832 80.864 45.979C81.0216 47.1587 80.5385 48.347 79.799 50.1346C79.6952 50.3768 79.5947 50.6289 79.4812 50.9072L79.4586 50.9694L79.4553 50.9596ZM78.5174 44.2607C77.4129 44.4147 76.6415 45.4275 76.7956 46.5321C76.9599 47.764 77.7051 48.6802 78.9362 50.1963C79.0905 50.3952 79.2546 50.5908 79.4253 50.806C79.5291 50.5637 79.6231 50.3248 79.7107 50.0989C80.4403 48.3147 80.93 47.1459 80.7757 45.976C80.6216 44.8715 79.6088 44.1001 78.5043 44.2542L78.5174 44.2607Z",
    fill: "url(#paint418_linear_10106_6282)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M105.195 86.2177C105.048 86.2672 104.907 86.3037 104.751 86.3238L64.5109 91.8138C63.8834 91.8944 63.2519 91.7363 62.7504 91.3489C62.2391 90.9648 61.9201 90.4069 61.8298 89.7827L53.1388 26.0311C52.9847 24.9266 53.6383 23.8553 54.6864 23.4693L54.7354 23.4528C54.8823 23.4033 55.0228 23.3668 55.1797 23.3467L95.4194 17.8567C96.7135 17.6824 97.9164 18.597 98.1005 19.8878L106.798 83.6263C106.952 84.7308 106.299 85.8021 105.25 86.1881L105.201 86.2046L105.195 86.2177ZM54.7849 23.5998L54.7359 23.6163C53.7629 23.9661 53.1549 24.9783 53.2957 26.011L61.9931 89.7495C62.0703 90.3344 62.3696 90.8663 62.8481 91.2178C63.3201 91.5824 63.9058 91.7341 64.4874 91.6471L104.727 86.1571C104.864 86.1436 105.005 86.1072 105.142 86.061L105.191 86.0444C106.164 85.6946 106.772 84.6824 106.631 83.6498L97.9339 19.9112C97.7663 18.7021 96.6486 17.8461 95.4265 18.0071L55.19 23.5069C55.0527 23.5204 54.9123 23.5568 54.7751 23.6031L54.7849 23.5998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_10106_6282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 17,
    width: 54,
    height: 75
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1396 26.0272L61.8356 89.7829C62.0131 91.0841 63.2118 91.995 64.513 91.8176L104.76 86.3281C106.061 86.1506 106.972 84.9519 106.794 83.6507L98.0985 19.895C97.921 18.5938 96.7223 17.6828 95.4211 17.8603L55.1743 23.3498C53.8731 23.5273 52.9621 24.726 53.1396 26.0272Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_10106_6282)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M110.439 94.138L68.3285 85.7593C67.0428 85.5054 66.1985 84.2626 66.4524 82.9769L79.3965 17.9006C79.6538 16.6247 80.8999 15.7901 82.1889 16.0539L124.299 24.4326C125.585 24.6865 126.429 25.9293 126.175 27.215L113.225 92.3044C112.968 93.5803 111.722 94.4149 110.433 94.1511L110.439 94.138Z",
    fill: "#F3F3F3"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.334 94.086L68.3872 85.6741C67.0983 85.4104 66.2637 84.1643 66.5209 82.8884L79.5473 17.959C79.8045 16.6831 81.0539 15.8583 82.3494 16.1089L124.297 24.5208C125.586 24.7846 126.42 26.0307 126.163 27.3066L113.137 92.236C112.879 93.5119 111.63 94.3367 110.334 94.086Z",
    fill: "#E7E7E7"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M110.226 94.0243L68.4391 85.5693C67.1501 85.3056 66.3155 84.0595 66.5728 82.7836L79.688 18.0206C79.9452 16.7447 81.2044 15.9166 82.4934 16.1804L124.28 24.6353C125.569 24.8991 126.404 26.1452 126.147 27.4211L113.032 92.1841C112.774 93.4599 111.515 94.288 110.226 94.0243Z",
    fill: "#DBDBDB"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M110.122 93.9723L68.4945 85.4743C67.2055 85.2106 66.371 83.9645 66.638 82.6853L79.8387 18.0789C80.0959 16.803 81.3551 15.975 82.6441 16.2387L124.271 24.7367C125.56 25.0005 126.395 26.2465 126.128 27.5257L112.927 92.1321C112.67 93.408 111.411 94.2361 110.122 93.9723Z",
    fill: "#CECECE"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M110.013 93.9106L68.5595 85.376C67.2705 85.1123 66.4424 83.8531 66.6997 82.5772L79.9794 18.1406C80.2465 16.8614 81.4992 16.0464 82.7881 16.3102L124.242 24.8447C125.531 25.1084 126.359 26.3676 126.102 27.6435L112.822 92.0801C112.555 93.3593 111.302 94.1743 110.013 93.9106Z",
    fill: "#C2C2C2"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M109.909 93.8586L68.6148 85.2811C67.3258 85.0173 66.4977 83.7581 66.7648 82.4789L80.1333 18.2087C80.4004 16.9295 81.6629 16.1113 82.9421 16.3783L124.236 24.9559C125.525 25.2196 126.353 26.4788 126.086 27.758L112.721 92.038C112.454 93.3172 111.191 94.1355 109.912 93.8684L109.909 93.8586Z",
    fill: "#B6B6B6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M109.794 93.81L68.6601 85.1894C67.3678 84.9158 66.5528 83.6631 66.8199 82.3839L80.2739 18.2704C80.541 16.9912 81.8035 16.1729 83.0958 16.4465L124.23 25.067C125.522 25.3406 126.337 26.5933 126.07 27.8725L112.616 91.986C112.349 93.2652 111.086 94.0835 109.794 93.81Z",
    fill: "#AAAAAA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M109.686 93.7482L68.7155 85.0944C67.433 84.8175 66.6083 83.5681 66.8753 82.2889L80.4247 18.3287C80.6918 17.0495 81.9542 16.2312 83.2465 16.5048L124.217 25.1586C125.499 25.4355 126.324 26.6849 126.057 27.9641L112.518 91.921C112.251 93.2002 110.988 94.0184 109.696 93.7449L109.686 93.7482Z",
    fill: "#9E9E9E"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M109.581 93.6962L68.7805 84.9961C67.498 84.7192 66.67 83.46 66.9468 82.1775L80.5654 18.3904C80.8423 17.1079 82.1081 16.2994 83.3906 16.5762L124.191 25.2764C125.474 25.5533 126.302 26.8124 126.025 28.0949L112.406 91.8821C112.129 93.1646 110.864 93.9731 109.581 93.6962Z",
    fill: "#929292"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M109.476 93.6443L68.8358 84.9011C67.5533 84.6242 66.7351 83.3617 67.0119 82.0792L80.7161 18.4487C80.9929 17.1662 82.2587 16.3577 83.5412 16.6346L124.182 25.3778C125.464 25.6546 126.283 26.9171 126.006 28.1996L112.302 91.8301C112.025 93.1126 110.759 93.9211 109.476 93.6443Z",
    fill: "#868686"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M109.368 93.5825L68.8909 84.8061C67.6084 84.5292 66.7902 83.2667 67.067 81.9842L80.86 18.5201C81.1369 17.2377 82.4026 16.4292 83.6884 16.7158L124.166 25.4923C125.448 25.7691 126.266 27.0316 125.99 28.3141L112.197 91.7782C111.92 93.0607 110.654 93.8692 109.368 93.5825Z",
    fill: "#797979"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M109.263 93.5306L68.9463 84.7111C67.6605 84.4244 66.852 83.1586 67.1321 81.8859L81.0106 18.5785C81.2875 17.296 82.5664 16.494 83.8489 16.7709L124.166 25.5904C125.452 25.877 126.26 27.1428 125.98 28.4155L112.111 91.7196C111.835 93.0021 110.556 93.8041 109.273 93.5273L109.263 93.5306Z",
    fill: "#6D6D6D"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M109.159 93.4786L69.0113 84.6128C67.7255 84.3261 66.917 83.0603 67.1971 81.7876L81.1514 18.6401C81.438 17.3543 82.7071 16.5556 83.9929 16.8423L124.14 25.7081C125.426 25.9948 126.234 27.2606 125.958 28.5431L112 91.6808C111.713 92.9666 110.444 93.7653 109.159 93.4786Z",
    fill: "#616161"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M109.05 93.4169L69.0666 84.5178C67.7808 84.2311 66.9723 82.9654 67.2589 81.6796L81.2922 18.7018C81.5821 17.4258 82.8479 16.6173 84.1337 16.9039L124.118 25.803C125.403 26.0897 126.212 27.3555 125.925 28.6412L111.882 91.6223C111.592 92.8983 110.326 93.7068 109.041 93.4202L109.05 93.4169Z",
    fill: "#555555"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M108.946 93.3649L69.1219 84.4228C67.8361 84.1361 67.0342 82.8573 67.3241 81.5813L81.4429 18.7601C81.7329 17.4841 83.0084 16.6723 84.2844 16.9623L124.108 25.9044C125.394 26.191 126.196 27.4699 125.906 28.7459L111.784 91.5573C111.494 92.8333 110.219 93.645 108.939 93.3453L108.946 93.3649Z",
    fill: "#494949"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M108.828 93.3064L69.1738 84.318C67.888 84.0314 67.086 82.7525 67.3759 81.4765L81.5868 18.8316C81.8768 17.5556 83.1557 16.7536 84.4317 17.0435L124.086 26.032C125.372 26.3186 126.174 27.5975 125.884 28.8735L111.676 91.5282C111.386 92.8042 110.107 93.6062 108.831 93.3162L108.828 93.3064Z",
    fill: "#3D3D3D"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M108.723 93.2545L69.2323 84.2328C67.953 83.9331 67.1445 82.6673 67.4443 81.388L81.7374 18.8899C82.0274 17.6139 83.3063 16.8119 84.5921 17.0986L124.083 26.1203C125.362 26.42 126.171 27.6858 125.871 28.9651L111.574 91.4534C111.284 92.7294 110.006 93.5314 108.72 93.2447L108.723 93.2545Z",
    fill: "#313131"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M108.618 93.2025L69.2876 84.1378C68.0083 83.838 67.2096 82.569 67.506 81.2799L81.8782 18.9515C82.178 17.6722 83.4471 16.8735 84.7362 17.17L124.067 26.2347C125.346 26.5345 126.145 27.8036 125.848 29.0927L111.466 91.4243C111.167 92.7036 109.898 93.5023 108.608 93.2058L108.618 93.2025Z",
    fill: "#242424"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M108.51 93.1408L69.3397 84.033C68.0604 83.7333 67.2584 82.4544 67.5582 81.1751L82.029 19.0099C82.3287 17.7306 83.6076 16.9286 84.8869 17.2284L124.057 26.3361C125.337 26.6359 126.139 27.9147 125.839 29.194L111.378 91.3559C111.078 92.6352 109.796 93.4274 108.52 93.1375L108.51 93.1408Z",
    fill: "#181818"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M67.6388 81.0823L82.1845 19.0813C82.4843 17.803 83.7643 17.0095 85.0425 17.3094L124.045 26.4595C125.323 26.7593 126.117 28.0393 125.817 29.3175L111.271 91.3185C110.971 92.5968 109.691 93.3903 108.413 93.0904L69.4107 83.9403C68.1324 83.6405 67.3389 82.3605 67.6388 81.0823Z",
    fill: "#0C0C0C"
  })))), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0723 18.6679L67.2553 81.2848C66.9529 82.5627 67.7437 83.8438 69.0217 84.1462L108.55 93.4997C109.828 93.8021 111.109 93.0113 111.411 91.7333L126.228 29.1165C126.53 27.8385 125.74 26.5574 124.462 26.255L84.9338 16.9015C83.6559 16.5991 82.3747 17.39 82.0723 18.6679Z",
    fill: "url(#paint419_linear_10106_6282)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M83.887 30.0572C83.3061 29.402 82.4988 28.4958 82.7695 27.3245C82.9694 26.4934 83.7229 25.9776 84.5311 26.1743C85.0284 26.2904 85.3171 26.5967 85.5276 26.9622C85.8733 26.7256 86.2619 26.5837 86.7723 26.7063C87.5772 26.8932 88.0245 27.7025 87.8344 28.5302C87.5637 29.7016 86.4373 30.1467 85.6211 30.4763C85.1314 30.6741 84.8574 30.8647 84.5542 31.1305C84.4059 30.755 84.2184 30.4255 83.9001 30.0636L83.887 30.0572Z",
    fill: "url(#paint420_linear_10106_6282)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M85.586 23.8986L85.1707 24.8351L84.6734 24.719L86.747 20.0926L87.5289 20.2763L87.3073 25.3477L86.7642 25.2253L86.8131 24.2051L85.5926 23.9182L85.586 23.8986ZM85.7644 23.4567L86.8441 23.7146L86.9585 20.7849L85.7644 23.4567Z",
    fill: "#ED1B23"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1507 40.4945C87.8711 39.4823 83.9147 42.245 82.8605 46.6915C80.5267 56.5661 91.8395 63.7174 93.6495 68.2458C97.3036 65.0068 110.615 63.6839 112.952 53.8191C114.006 49.3726 111.694 45.1335 107.424 44.118C103.867 43.2766 101.248 44.9233 98.6204 47.2272C97.3018 43.995 95.7106 41.3457 92.1442 40.5076L92.1507 40.4945Z",
    fill: "url(#paint421_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1507 40.4945C87.8711 39.4823 83.9147 42.245 82.8605 46.6915C80.5267 56.5661 91.8395 63.7174 93.6495 68.2458C97.3036 65.0068 110.615 63.6839 112.952 53.8191C114.006 49.3726 111.694 45.1335 107.424 44.118C103.962 43.2992 101.391 44.8313 98.8388 47.0336C98.7279 47.1255 98.561 47.0835 98.5083 46.9595C97.2065 43.8417 95.6059 41.3264 92.1442 40.5076L92.1507 40.4945Z",
    fill: "url(#paint422_linear_10106_6282)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M92.1642 40.5991C87.9075 39.59 83.9576 42.3397 82.9099 46.7731C80.5857 56.6117 91.8429 63.7272 93.6496 68.2458C97.2873 65.0232 110.543 63.6972 112.871 53.8684C113.918 49.435 111.622 45.2122 107.365 44.2032C103.94 43.3941 101.401 44.9261 98.8586 47.0923C98.7315 47.2007 98.5319 47.1588 98.466 46.9956C97.1676 43.9202 95.5801 41.4115 92.1544 40.6024L92.1642 40.5991Z",
    fill: "url(#paint423_linear_10106_6282)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M92.1777 40.7036C87.934 39.7011 84.0135 42.4408 82.9691 46.8514C80.6546 56.6539 91.8593 63.7435 93.6594 68.2425C97.2776 65.0265 110.481 63.7072 112.799 53.9144C113.843 49.5039 111.56 45.2876 107.317 44.2851C103.927 43.4857 101.408 45.0111 98.8981 47.1445C98.7448 47.2725 98.5093 47.221 98.4367 47.0382C97.1417 44.0053 95.5805 41.5096 92.1908 40.7101L92.1777 40.7036Z",
    fill: "url(#paint424_linear_10106_6282)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M92.1909 40.8082C87.9702 39.8089 84.0595 42.5453 83.0182 46.9329C80.7134 56.6995 91.8658 63.763 93.656 68.2327C97.2578 65.0331 110.396 63.714 112.714 53.9539C113.752 49.5565 111.479 45.3696 107.258 44.3703C103.904 43.5805 101.415 45.096 98.9144 47.1935C98.7351 47.3412 98.4733 47.2767 98.3811 47.0678C97.0895 44.0774 95.5446 41.5979 92.1909 40.8082Z",
    fill: "url(#paint425_linear_10106_6282)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M92.2044 40.9128C88.0066 39.9166 84.1122 42.6367 83.0709 47.0243C80.7725 56.7451 91.8724 63.7826 93.6496 68.2458C97.2416 65.0495 110.318 63.7404 112.626 54.0163C113.661 49.6418 111.401 45.4614 107.203 44.4653C103.885 43.6852 101.415 45.1941 98.9343 47.2523C98.7387 47.4164 98.4311 47.3455 98.329 47.1072C97.0473 44.1462 95.5123 41.6961 92.1914 40.9063L92.2044 40.9128Z",
    fill: "url(#paint426_linear_10106_6282)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M92.2179 41.0174C88.0331 40.0277 84.1583 42.7411 83.13 47.1026C80.8314 56.7907 91.8888 63.7989 93.6593 68.2425C97.2351 65.0626 110.256 63.7505 112.544 54.0657C113.573 49.7042 111.329 45.5401 107.144 44.5505C103.863 43.7801 101.409 45.2726 98.9639 47.3078C98.7422 47.4916 98.4084 47.4077 98.2899 47.1531C97.0116 44.2346 95.4897 41.791 92.2179 41.0174Z",
    fill: "url(#paint427_linear_10106_6282)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M92.2314 41.1219C88.0695 40.1355 84.2143 42.8423 83.1794 47.1841C80.8905 56.8362 91.8955 63.8185 93.6594 68.2425C97.2156 65.0692 110.184 63.7638 112.463 54.115C113.494 49.7633 111.248 45.6221 107.086 44.6357C103.837 43.8652 101.406 45.3609 98.9838 47.3665C98.736 47.5701 98.3663 47.4765 98.2378 47.1925C96.9727 44.3132 95.4673 41.8859 92.2216 41.1252L92.2314 41.1219Z",
    fill: "url(#paint428_linear_10106_6282)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M92.2447 41.2265C88.1058 40.2432 84.257 42.937 83.2319 47.2755C80.9528 56.8916 91.9021 63.8381 93.6627 68.2523C97.2025 65.0954 110.105 63.7902 112.385 54.1741C113.413 49.8454 111.179 45.7106 107.044 44.7372C103.831 43.9764 101.416 45.4557 99.0199 47.4416C98.7559 47.6615 98.3436 47.5714 98.202 47.2482C96.9501 44.4081 95.4512 42.0004 92.2382 41.2396L92.2447 41.2265Z",
    fill: "url(#paint429_linear_10106_6282)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M92.245 41.3246C88.1192 40.3478 84.2998 43.0316 83.2779 47.3472C81.0084 56.9274 91.9053 63.8479 93.6593 68.2425C97.1829 65.102 110.03 63.7937 112.3 54.2136C113.322 49.898 111.108 45.7893 106.982 44.8126C103.814 44.0582 101.41 45.5341 99.0462 47.4873C98.7561 47.7269 98.3176 47.6238 98.1694 47.281C96.9274 44.4703 95.4384 42.092 92.2712 41.3376L92.245 41.3246Z",
    fill: "url(#paint430_linear_10106_6282)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M92.2586 41.4292C88.1556 40.4556 84.3461 43.1361 83.3274 47.4288C81.0676 56.9729 91.9219 63.8642 93.6464 68.236C97.1601 65.0988 109.945 63.8005 112.205 54.2564C113.22 49.9539 111.013 45.8648 106.91 44.8913C103.779 44.1466 101.391 45.6061 99.0498 47.5298C98.7335 47.7891 98.2591 47.6763 98.1009 47.3041C96.8722 44.5326 95.3865 42.1641 92.2586 41.4292Z",
    fill: "url(#paint431_linear_10106_6282)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M92.2718 41.5337C88.182 40.5666 84.3985 43.2274 83.3863 47.5071C81.1362 57.0152 91.9348 63.8707 93.656 68.2327C97.1535 65.1119 109.873 63.8138 112.123 54.3057C113.136 50.0261 110.941 45.9435 106.851 44.9765C103.756 44.2414 101.384 45.6846 99.0792 47.5853C98.7466 47.861 98.2362 47.7385 98.0583 47.3402C96.8428 44.6079 95.3735 42.2556 92.2685 41.5239L92.2718 41.5337Z",
    fill: "url(#paint432_linear_10106_6282)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M92.2852 41.6383C88.2183 40.6744 84.4446 43.3319 83.4389 47.5985C81.1984 57.0706 91.9446 63.9001 93.6592 68.2425C97.1371 65.1283 109.805 63.837 112.045 54.3648C113.051 50.0983 110.873 46.032 106.806 45.0682C103.747 44.3428 101.394 45.7794 99.1088 47.6407C98.7501 47.9362 98.2037 47.804 98.0192 47.3861C96.8038 44.6865 95.3542 42.3603 92.295 41.635L92.2852 41.6383Z",
    fill: "url(#paint433_linear_10106_6282)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M92.2987 41.7429C88.2547 40.7822 84.5006 43.4331 83.4883 47.68C81.2575 57.1162 91.9513 63.9197 93.6593 68.2425C97.1209 65.1447 109.733 63.8503 111.964 54.4141C112.966 50.1705 110.795 46.1238 106.751 45.1631C103.727 44.4475 101.401 45.8644 99.132 47.7093C98.7472 48.0245 98.1746 47.8793 97.9704 47.4353C96.7682 44.7749 95.3253 42.4683 92.302 41.7527L92.2987 41.7429Z",
    fill: "url(#paint434_linear_10106_6282)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M92.3121 41.8474C88.2811 40.8932 84.5434 43.5277 83.5473 47.7583C81.3263 57.1584 91.9677 63.936 93.6593 68.2425C97.1111 65.148 109.661 63.8636 111.882 54.4635C112.888 50.2296 110.723 46.2026 106.692 45.2483C103.705 44.5424 101.395 45.9428 99.1582 47.755C98.7572 48.0865 98.1388 47.935 97.9247 47.4616C96.7357 44.8404 95.2961 42.5436 92.3088 41.8376L92.3121 41.8474Z",
    fill: "url(#paint435_linear_10106_6282)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.3255 41.952C88.3174 41.001 84.5993 43.6289 83.5999 47.8497C81.3886 57.2138 91.9743 63.9556 93.6625 68.2523C97.0981 65.1742 109.582 63.89 111.794 54.5259C112.793 50.3051 110.645 46.2944 106.627 45.3467C103.676 44.6504 101.382 46.0344 99.1715 47.8269C98.7444 48.1781 98.1031 48.0234 97.8693 47.5239C96.6935 44.9419 95.2703 42.6614 92.319 41.9651L92.3255 41.952Z",
    fill: "url(#paint436_linear_10106_6282)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M92.3293 42.0599C88.3441 41.1121 84.6357 43.7367 83.6396 47.9345C81.4379 57.2627 91.9712 63.9785 93.6496 68.2458C97.0655 65.1743 109.498 63.8968 111.699 54.5687C112.695 50.3708 110.55 46.3699 106.565 45.422C103.65 44.7355 101.376 46.1129 99.1881 47.8759C98.7317 48.237 98.0577 48.0823 97.8238 47.5502C96.6579 44.9976 95.2445 42.7465 92.3293 42.0599Z",
    fill: "url(#paint437_linear_10106_6282)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M92.3394 42.1547C88.3673 41.2133 84.685 43.8182 83.6953 48.003C81.5033 57.2951 91.9842 63.985 93.656 68.2327C97.0557 65.1776 109.432 63.8971 111.624 54.6049C112.614 50.4202 110.485 46.4355 106.516 45.5039C103.637 44.827 101.379 46.1881 99.2242 47.9182C98.7514 48.2958 98.0414 48.1314 97.7878 47.5732C96.6351 45.0597 95.2284 42.8283 92.3458 42.1416L92.3394 42.1547Z",
    fill: "url(#paint438_linear_10106_6282)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M92.3527 42.2592C88.4035 41.3211 84.731 43.9227 83.7446 48.0846C81.5525 57.344 91.9875 63.9948 93.6462 68.236C97.0295 65.1973 109.341 63.917 111.533 54.6575C112.519 50.4957 110.407 46.5273 106.448 45.5925C103.605 44.9252 101.363 46.2699 99.2342 47.9803C98.7353 48.3776 97.9893 48.2035 97.7291 47.6258C96.5896 45.1514 95.1862 42.9298 92.3527 42.2592Z",
    fill: "url(#paint439_linear_10106_6282)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M92.3661 42.3638C88.4301 41.4322 84.7869 44.0239 83.7972 48.1759C81.6115 57.3896 91.9974 64.0241 93.6495 68.2458C97.023 65.2104 109.272 63.9401 111.454 54.7166C112.434 50.5679 110.329 46.6191 106.403 45.6841C103.592 45.0168 101.37 46.3549 99.2638 48.0358C98.7388 48.4528 97.9666 48.2657 97.6867 47.6618C96.5571 45.2169 95.1636 43.0246 92.3661 42.3638Z",
    fill: "url(#paint440_linear_10106_6282)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M92.3796 42.4684C88.4664 41.5399 84.8298 44.1185 83.8564 48.2542C81.6803 57.4319 92.0139 64.0404 93.6593 68.2425C97.0166 65.2235 109.21 63.9501 111.373 54.7659C112.346 50.6303 110.257 46.6978 106.344 45.7693C103.57 45.1117 101.364 46.4334 99.2934 48.0913C98.7522 48.5246 97.9342 48.3312 97.6444 47.698C96.528 45.2922 95.1509 43.1162 92.3763 42.4586L92.3796 42.4684Z",
    fill: "url(#paint441_linear_10106_6282)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M92.3932 42.573C88.5029 41.6477 84.8859 44.2197 83.9058 48.3358C81.7395 57.4774 92.0173 64.0502 93.6594 68.2425C96.9971 65.2301 109.129 63.9667 111.292 54.8153C112.262 50.7025 110.176 46.7798 106.289 45.8643C103.56 45.2131 101.361 46.5216 99.3167 48.1599C98.7493 48.6129 97.9052 48.4065 97.5989 47.757C96.5056 45.3871 95.1253 43.234 92.3867 42.5861L92.3932 42.573Z",
    fill: "url(#paint442_linear_10106_6282)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.4066 42.6775C88.5294 41.7588 84.9319 44.3242 83.9682 48.4238C81.8115 57.5295 92.0369 64.0763 93.6692 68.2392C96.9906 65.2432 109.066 63.9768 111.22 54.8613C112.193 50.7583 110.114 46.8552 106.24 45.9462C103.547 45.3047 101.368 46.6066 99.3429 48.2055C98.7495 48.6783 97.8726 48.472 97.5532 47.7833C96.4698 45.4428 95.0961 43.3093 92.4066 42.6775Z",
    fill: "white"
  }))), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9951 49.9036C99.9314 48.2036 101.856 46.9875 104.477 47.6097C107.631 48.3576 109.329 51.4839 108.555 54.7558C106.84 62.0324 97.0223 63.0069 94.3233 65.3895C92.9913 62.0527 84.6467 56.7811 86.3747 49.511C87.1484 46.2391 90.0708 44.1958 93.2249 44.9437C95.8457 45.5659 97.0259 47.5137 97.9918 49.8938L97.9951 49.9036Z",
    fill: "url(#paint443_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9063 49.6717C97.9426 49.7795 98.0866 49.8183 98.1778 49.7329C100.056 48.1182 101.935 46.9938 104.487 47.6064C107.641 48.3543 109.339 51.4806 108.565 54.7525C106.85 62.0291 97.0323 63.0036 94.3333 65.3862C93.0013 62.0494 84.6567 56.7778 86.3847 49.5077C87.1584 46.2358 90.0808 44.1925 93.2349 44.9404C95.7739 45.5465 96.9603 47.3831 97.9161 49.6684L97.9063 49.6717Z",
    fill: "url(#paint444_linear_10106_6282)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M97.8672 49.7176C97.9232 49.8515 98.0901 49.8934 98.2009 49.8015C100.059 48.226 101.916 47.0984 104.428 47.6916C107.56 48.4363 109.25 51.543 108.474 54.8051C106.759 62.0491 97.0062 63.0233 94.3366 65.396C93.0079 62.069 84.7288 56.8299 86.4438 49.5859C87.211 46.3271 90.1171 44.3002 93.2484 45.0449C95.7514 45.6414 96.9148 47.4748 97.8672 49.7176Z",
    fill: "url(#paint445_linear_10106_6282)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M97.8249 49.7538C97.8875 49.9072 98.0904 49.9588 98.2175 49.8505C100.053 48.3045 101.9 47.1802 104.367 47.767C107.475 48.5085 109.149 51.5989 108.379 54.8479C106.674 62.0559 96.9866 63.0299 94.3268 65.3993C93.0048 62.0919 84.7912 56.8853 86.4932 49.6675C87.2637 46.4185 90.1404 44.4015 93.2585 45.1397C95.7353 45.7232 96.8759 47.5534 97.8184 49.7669L97.8249 49.7538Z",
    fill: "url(#paint446_linear_10106_6282)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M97.7857 49.7996C97.868 49.9792 98.0938 50.034 98.2372 49.9093C100.05 48.3928 101.874 47.2653 104.314 47.8391C107.406 48.5643 109.068 51.6482 108.304 54.8841C106.608 62.0561 96.9865 63.0299 94.3463 65.3927C93.0406 62.1016 84.8795 56.9209 86.5718 49.7392C87.3357 46.5033 90.206 44.4994 93.2881 45.2279C95.729 45.8016 96.8466 47.6287 97.7955 49.7963L97.7857 49.7996Z",
    fill: "url(#paint447_linear_10106_6282)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M97.7433 49.8357C97.8322 50.0349 98.094 50.0994 98.2537 49.9583C100.053 48.468 101.848 47.3504 104.253 47.9145C107.322 48.6365 108.967 51.7041 108.209 54.9269C106.517 62.076 96.9605 63.0496 94.3365 65.396C93.0375 62.1245 84.9287 56.9698 86.6211 49.8207C87.3819 46.6077 90.2292 44.6006 93.2983 45.3227C95.7031 45.8867 96.8044 47.6975 97.7433 49.8357Z",
    fill: "url(#paint448_linear_10106_6282)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M97.701 49.8719C97.7966 50.0906 98.0845 50.1681 98.2703 50.0073C100.044 48.5367 101.819 47.4257 104.191 47.9899C107.237 48.7087 108.875 51.7568 108.111 54.96C106.428 62.0731 96.9377 63.0464 94.3235 65.3895C93.0409 62.1343 84.9845 57.0056 86.6672 49.8925C87.4215 46.6926 90.2526 44.7019 93.2987 45.4208C95.6675 45.9751 96.7557 47.7794 97.6814 49.8785L97.701 49.8719Z",
    fill: "url(#paint449_linear_10106_6282)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M97.6619 49.9178C97.7673 50.1659 98.0847 50.2335 98.2901 50.066C100.031 48.6282 101.806 47.5173 104.129 48.0653C107.152 48.7809 108.774 51.8127 108.026 54.9995C106.353 62.0766 96.918 63.053 94.33 65.3764C93.0506 62.131 85.0597 57.0348 86.7327 49.9577C87.4903 46.7675 90.3018 44.7835 93.325 45.4991C95.6612 46.0536 96.7428 47.8383 97.6553 49.8982L97.6619 49.9178Z",
    fill: "url(#paint450_linear_10106_6282)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M97.6195 49.9539C97.7413 50.2183 98.0849 50.2989 98.3066 50.115C100.025 48.7067 101.777 47.5926 104.077 48.1374C107.087 48.8465 108.696 51.8718 107.941 55.039C106.278 62.0801 96.9082 63.0563 94.3299 65.3764C93.067 62.1473 85.1285 57.077 86.7918 50.0359C87.5429 46.8589 90.3348 44.8814 93.3352 45.5939C95.6353 46.1387 96.7005 47.9071 97.6064 49.9474L97.6195 49.9539Z",
    fill: "url(#paint451_linear_10106_6282)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M97.5805 49.9998C97.7122 50.2936 98.0885 50.374 98.3395 50.1803C100.032 48.7917 101.767 47.694 104.031 48.2291C107.019 48.935 108.611 51.944 107.863 55.0981C106.203 62.1163 96.8986 63.0923 94.3366 65.396C93.0803 62.1865 85.2039 57.1389 86.8576 50.1338C87.6055 46.9797 90.3778 45.0088 93.3651 45.7148C95.6292 46.2499 96.6813 48.0118 97.574 50.0129L97.5805 49.9998Z",
    fill: "url(#paint452_linear_10106_6282)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M97.538 50.0359C97.6763 50.3493 98.0886 50.4394 98.356 50.2293C100.025 48.8702 101.738 47.7692 103.969 48.3045C106.934 49.0072 108.52 51.9966 107.778 55.1376C106.128 62.1198 96.8887 63.0956 94.3463 65.3927C93.1063 62.1994 85.2824 57.1779 86.9362 50.2054C87.6776 47.0644 90.4401 45.0969 93.4045 45.7996C95.6326 46.3251 96.6716 48.0805 97.5609 50.0391L97.538 50.0359Z",
    fill: "url(#paint453_linear_10106_6282)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M97.4956 50.072C97.6503 50.4016 98.079 50.5081 98.3724 50.2783C100.019 48.9487 101.722 47.851 103.914 48.3668C106.855 49.0663 108.425 52.0394 107.69 55.1673C106.049 62.1136 96.8657 63.0924 94.343 65.3829C93.1096 62.2092 85.3414 57.2234 86.992 50.2739C87.7269 47.146 90.4731 45.1948 93.4113 45.8846C95.6034 46.4003 96.6358 48.1362 97.5054 50.0687L97.4956 50.072Z",
    fill: "url(#paint454_linear_10106_6282)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M97.4565 50.1179C97.6212 50.4769 98.0825 50.5833 98.3923 50.337C100.013 49.0272 101.699 47.9459 103.855 48.452C106.774 49.1484 108.337 52.1018 107.599 55.2199C105.958 62.1335 96.8495 63.1088 94.3365 65.396C93.1162 62.2288 85.4037 57.2788 87.0413 50.3555C87.7795 47.2374 90.4964 45.2961 93.4247 45.9892C95.5809 46.4952 96.6001 48.2245 97.4565 50.1179Z",
    fill: "url(#paint455_linear_10106_6282)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M97.4143 50.154C97.5856 50.5326 98.0829 50.6487 98.4089 50.386C100.007 49.1057 101.67 48.0212 103.794 48.5274C106.699 49.2173 108.246 52.1545 107.514 55.2595C105.886 62.1468 96.8333 63.1252 94.3464 65.3927C93.1328 62.2451 85.4825 57.3178 87.1104 50.4304C87.8454 47.3352 90.5491 45.3875 93.4448 46.0807C95.5682 46.5868 96.5711 48.2998 97.4274 50.1605L97.4143 50.154Z",
    fill: "url(#paint456_linear_10106_6282)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M97.3751 50.1999C97.5563 50.6079 98.0863 50.7239 98.4287 50.4448C100 49.1841 101.648 48.1161 103.732 48.6028C106.611 49.2797 108.144 52.2104 107.416 55.2925C105.798 62.1438 96.8104 63.122 94.3333 65.3862C93.136 62.2549 85.5381 57.3535 87.1563 50.5022C87.8849 47.4201 90.5723 45.4887 93.4515 46.1656C95.539 46.6621 96.5353 48.3555 97.3718 50.1901L97.3751 50.1999Z",
    fill: "url(#paint457_linear_10106_6282)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M97.3327 50.236C97.5303 50.6603 98.0767 50.7925 98.4484 50.5036C99.9972 49.2724 101.632 48.1979 103.683 48.6847C106.539 49.3584 108.066 52.2695 107.334 55.3418C105.726 62.1571 96.8038 63.1351 94.3332 65.3862C93.1426 62.2745 85.6068 57.3958 87.2154 50.5805C87.9374 47.5114 90.6053 45.5867 93.4616 46.2604C95.5131 46.7472 96.4963 48.4341 97.3196 50.2295L97.3327 50.236Z",
    fill: "url(#paint458_linear_10106_6282)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M97.2904 50.2721C97.4946 50.716 98.077 50.8579 98.465 50.5526C99.9877 49.3411 101.606 48.283 103.621 48.7601C106.455 49.4306 107.968 52.3352 107.249 55.3813C105.641 62.164 96.7843 63.1418 94.3431 65.3829C93.1558 62.281 85.6757 57.4381 87.2844 50.6554C88.0097 47.5962 90.6613 45.6879 93.4947 46.3584C95.5102 46.8355 96.477 48.5061 97.3002 50.2688L97.2904 50.2721Z",
    fill: "url(#paint459_linear_10106_6282)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M97.2512 50.318C97.4653 50.7913 98.0804 50.9331 98.4847 50.6114C99.9814 49.4196 101.58 48.3681 103.559 48.8355C106.38 49.4995 107.877 52.3878 107.155 55.4241C105.559 62.1806 96.7679 63.1581 94.3332 65.3862C93.1623 62.3006 85.7346 57.4837 87.3336 50.737C88.0557 47.7007 90.6844 45.7891 93.4949 46.4565C95.4744 46.9239 96.4379 48.5847 97.2381 50.3115L97.2512 50.318Z",
    fill: "url(#paint460_linear_10106_6282)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M97.2089 50.3541C97.4394 50.8437 98.0807 50.9985 98.5013 50.6603C99.9653 49.5014 101.554 48.4531 103.497 48.9109C106.295 49.5717 107.776 52.4437 107.06 55.467C105.474 62.1874 96.7385 63.1681 94.3234 65.3895C93.1591 62.3235 85.7969 57.539 87.3829 50.8186C88.0986 47.7953 90.7076 45.8904 93.5051 46.5512C95.4486 47.009 96.399 48.6633 97.1893 50.3607L97.2089 50.3541Z",
    fill: "url(#paint461_linear_10106_6282)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M97.1665 50.3902C97.4069 50.9092 98.0809 51.0639 98.5178 50.7093C99.9557 49.5701 101.535 48.5251 103.445 48.983C106.22 49.6406 107.694 52.493 106.975 55.5065C105.389 62.1942 96.7287 63.1714 94.3332 65.3862C93.1853 62.3365 85.8755 57.578 87.4518 50.8935C88.161 47.8834 90.7537 45.9949 93.5381 46.6492C95.4489 47.107 96.3894 48.732 97.1698 50.4L97.1665 50.3902Z",
    fill: "url(#paint462_linear_10106_6282)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M97.1273 50.4361C97.3841 50.9714 98.0712 51.1326 98.5375 50.7681C99.9527 49.6583 101.512 48.62 103.387 49.0682C106.138 49.7226 107.596 52.5587 106.894 55.5558C105.317 62.2075 96.7124 63.1878 94.3365 65.396C93.1951 62.3659 85.9476 57.6301 87.524 50.9783C88.2364 47.978 90.8096 46.096 93.5613 46.7505C95.4361 47.1986 96.3634 48.8171 97.1306 50.4459L97.1273 50.4361Z",
    fill: "url(#paint463_linear_10106_6282)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M97.0851 50.4722C97.3485 51.0271 98.0716 51.1979 98.5542 50.8171C99.9433 49.727 101.483 48.6953 103.322 49.1338C106.06 49.7817 107.502 52.6016 106.796 55.5888C105.232 62.2144 96.6929 63.1944 94.3235 65.3895C93.1953 62.3659 85.9936 57.6691 87.5668 51.0403C88.2728 48.053 90.8297 46.1875 93.5649 46.8256C95.4038 47.2641 96.3278 48.8728 97.072 50.4657L97.0851 50.4722Z",
    fill: "url(#paint464_linear_10106_6282)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M97.0461 50.5181C97.3194 51.1024 98.0751 51.2731 98.5773 50.8857C99.9436 49.8251 101.464 48.8 103.276 49.2255C105.992 49.8702 107.417 52.6738 106.714 55.6381C105.16 62.2277 96.6767 63.2108 94.3333 65.3862C93.2117 62.3822 86.0722 57.7081 87.6357 51.1152C88.3385 48.1509 90.8725 46.2822 93.5882 46.9269C95.391 47.3557 96.2987 48.9481 97.0428 50.5083L97.0461 50.5181Z",
    fill: "white"
  }))), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3138 65.4908L94.2874 65.4125C93.8786 64.3938 92.8055 63.1845 91.5584 61.7829C88.6935 58.5591 85.1297 54.5564 86.3256 49.4948C87.1218 46.128 90.0968 44.1434 93.2378 44.8848C95.7637 45.4844 96.9794 47.2785 98.0144 49.7989C100.065 48.0168 101.964 46.9512 104.49 47.5508C107.631 48.2922 109.41 51.4019 108.614 54.7687C107.418 59.8303 102.436 61.8151 98.436 63.4141C96.6958 64.1098 95.1939 64.7033 94.3725 65.4383L94.3138 65.4908ZM93.212 45.0026C90.1299 44.274 87.2169 46.216 86.4336 49.5238C85.2505 54.5266 88.7947 58.5032 91.6432 61.7107C92.8574 63.0797 93.9239 64.2694 94.3556 65.2913C95.2032 64.5692 96.6855 63.9823 98.3865 63.2998C102.366 61.7074 107.31 59.7358 108.496 54.7429C109.279 51.435 107.546 48.3971 104.464 47.6686C101.961 47.0721 100.078 48.154 98.0312 49.9459L97.9725 49.9984L97.9461 49.9201C96.9111 47.3996 95.7151 45.599 93.212 45.0026Z",
    fill: "url(#paint465_linear_10106_6282)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M97.386 52.4655C98.6312 51.3693 99.8644 50.5937 101.559 50.9934C103.588 51.477 104.68 53.4872 104.177 55.5878C103.071 60.2698 96.7571 60.8926 95.0263 62.4251C94.1723 60.2801 88.8091 56.8947 89.9148 52.2126C90.4145 50.1022 92.29 48.8046 94.3153 49.2784C96.0003 49.6814 96.7597 50.931 97.386 52.4655Z",
    fill: "url(#paint466_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3266 52.3218C97.353 52.4002 97.4479 52.4228 97.5163 52.367C98.7159 51.3298 99.9265 50.6163 101.562 51.0032C103.591 51.4868 104.683 53.497 104.18 55.5976C103.074 60.2797 96.7603 60.9024 95.0294 62.4349C94.1755 60.2899 88.8123 56.9045 89.918 52.2224C90.4177 50.1121 92.2932 48.8144 94.3184 49.2882C95.9544 49.675 96.7136 50.8592 97.3266 52.3218Z",
    fill: "url(#paint467_linear_10106_6282)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M97.2941 52.3546C97.3271 52.4526 97.4547 52.4751 97.5297 52.4061C98.7294 51.4017 99.9137 50.6752 101.527 51.0589C103.542 51.536 104.621 53.5397 104.125 55.6272C103.019 60.2766 96.7604 60.9024 95.0394 62.4316C94.1887 60.2964 88.8648 56.9305 89.9608 52.2844C90.454 50.1871 92.3197 48.8928 94.3352 49.3699C95.9351 49.747 96.6747 50.9378 97.2974 52.3644L97.2941 52.3546Z",
    fill: "url(#paint468_linear_10106_6282)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M97.2515 52.3907C97.301 52.505 97.4416 52.5339 97.5362 52.4584C98.7132 51.4835 99.8942 50.7472 101.471 51.1212C103.474 51.5918 104.549 53.5857 104.05 55.6634C102.957 60.2866 96.7309 60.9123 95.0163 62.4284C94.169 60.303 88.8844 56.9566 89.9772 52.3334C90.4736 50.2459 92.3198 48.9582 94.3221 49.4288C95.8992 49.8027 96.6159 50.9903 97.2417 52.394L97.2515 52.3907Z",
    fill: "url(#paint469_linear_10106_6282)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M97.2191 52.4235C97.2751 52.5574 97.4518 52.596 97.5626 52.5041C98.7266 51.5554 99.8912 50.8028 101.445 51.1736C103.425 51.641 104.497 53.6251 104.004 55.6897C102.914 60.29 96.731 60.9123 95.036 62.4218C94.1953 60.3159 88.9466 56.9792 90.0363 52.379C90.5262 50.3046 92.3625 49.0201 94.3518 49.4842C95.906 49.855 96.6096 51.0361 97.2255 52.4104L97.2191 52.4235Z",
    fill: "url(#paint470_linear_10106_6282)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M97.1865 52.4563C97.2589 52.6065 97.4487 52.6516 97.5792 52.5531C98.7301 51.6306 99.8719 50.8748 101.403 51.2424C103.373 51.7131 104.439 53.6776 103.942 55.7324C102.856 60.3098 96.7147 60.9287 95.0295 62.4349C94.1921 60.3388 88.9861 57.0314 90.0627 52.4573C90.5462 50.396 92.3825 49.1116 94.3522 49.5823C95.8802 49.9401 96.5642 51.1278 97.18 52.4694L97.1865 52.4563Z",
    fill: "url(#paint471_linear_10106_6282)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M97.1441 52.4924C97.2231 52.6622 97.4358 52.7105 97.5825 52.5956C98.7172 51.6895 99.8491 50.937 101.344 51.2949C103.301 51.7591 104.354 53.7171 103.873 55.7555C102.8 60.3067 96.7016 60.9222 95.0262 62.4251C94.2019 60.3355 89.0254 57.0509 90.0988 52.4997C90.5856 50.4482 92.4023 49.1704 94.3589 49.6346C95.864 49.9892 96.5349 51.1704 97.1408 52.4826L97.1441 52.4924Z",
    fill: "url(#paint472_linear_10106_6282)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M97.1114 52.5252C97.197 52.7146 97.4457 52.7726 97.6087 52.6413C98.7206 51.7646 99.8492 51.0024 101.318 51.3473C103.262 51.805 104.311 53.7533 103.828 55.7818C102.757 60.3101 96.7015 60.9222 95.0326 62.412C94.2115 60.3322 89.0743 57.0671 90.1479 52.5486C90.6282 50.5102 92.4384 49.2455 94.3819 49.7032C95.851 50.0481 96.5219 51.2293 97.1212 52.5219L97.1114 52.5252Z",
    fill: "url(#paint473_linear_10106_6282)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M97.0822 52.5678C97.1842 52.7735 97.4459 52.838 97.6286 52.7001C98.7242 51.8398 99.8332 51.0842 101.279 51.4259C103.213 51.8869 104.246 53.8189 103.769 55.8343C102.702 60.3397 96.6885 60.9484 95.0392 62.4316C94.2248 60.3714 89.1269 57.1258 90.1841 52.6237C90.6677 50.5951 92.4583 49.3369 94.3887 49.7882C95.8349 50.1299 96.4927 51.3046 97.0822 52.5678Z",
    fill: "url(#paint474_linear_10106_6282)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M97.0397 52.6039C97.1484 52.8292 97.4428 52.8936 97.6319 52.7425C98.7112 51.8987 99.8105 51.1464 101.23 51.4751C103.151 51.9296 104.181 53.8518 103.704 55.8673C102.65 60.3465 96.6689 60.955 95.0294 62.4349C94.2182 60.3845 89.1596 57.1583 90.2137 52.6791C90.6908 50.6636 92.4716 49.4088 94.3922 49.8633C95.8155 50.2018 96.4602 51.3701 97.0397 52.6039Z",
    fill: "url(#paint475_linear_10106_6282)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M97.0072 52.6368C97.1224 52.8816 97.4431 52.959 97.6583 52.7882C98.7148 51.9739 99.8074 51.202 101.198 51.5406C103.106 51.9886 104.122 53.9043 103.652 55.9067C102.597 60.3532 96.6624 60.9681 95.0392 62.4316C94.2314 60.391 89.2121 57.1843 90.2662 52.7378C90.7368 50.7354 92.5079 49.4839 94.4154 49.9319C95.8125 50.2574 96.4376 51.4323 97.0203 52.6432L97.0072 52.6368Z",
    fill: "url(#paint476_linear_10106_6282)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M96.9745 52.6695C97.1062 52.9306 97.4399 53.0145 97.6747 52.8372C98.7149 52.0393 99.788 51.2739 101.162 51.5963C103.047 52.0411 104.07 53.9437 103.596 55.9363C102.545 60.3599 96.6623 60.9681 95.0391 62.4316C94.2477 60.4073 89.2546 57.2136 90.2958 52.7933C90.7697 50.8007 92.5211 49.5557 94.409 50.0104C95.7734 50.336 96.3952 51.5011 96.968 52.6826L96.9745 52.6695Z",
    fill: "url(#paint477_linear_10106_6282)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M96.9324 52.7057C97.0706 52.9863 97.4371 53.0701 97.6784 52.8797C98.6925 52.1015 99.7655 51.3361 101.107 51.6586C102.982 52.1067 103.989 53.993 103.521 55.9725C102.483 60.3699 96.6332 60.978 95.0296 62.4349C94.2414 60.4204 89.2909 57.256 90.3256 52.8488C90.793 50.8693 92.5347 49.6276 94.4095 50.0758C95.751 50.3982 96.3695 51.5535 96.9226 52.709L96.9324 52.7057Z",
    fill: "url(#paint478_linear_10106_6282)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M96.8997 52.7385C97.0446 53.0387 97.4339 53.1257 97.7046 52.9254C98.7024 52.1636 99.7657 51.4015 101.081 51.711C102.943 52.1526 103.946 54.0291 103.475 55.9988C102.441 60.3733 96.6364 60.9878 95.036 62.4218C94.2512 60.4171 89.3399 57.2722 90.3747 52.8976C90.8454 50.9279 92.5708 49.7027 94.4325 50.1444C95.7478 50.4538 96.3565 51.6124 96.8997 52.7385Z",
    fill: "url(#paint479_linear_10106_6282)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M96.867 52.7713C97.0283 53.0878 97.4438 53.1878 97.721 52.9744C98.7059 52.2387 99.756 51.4702 101.039 51.7798C102.887 52.2149 103.878 54.0849 103.413 56.0415C102.382 60.3931 96.62 61.0042 95.0392 62.4316C94.2577 60.4367 89.3858 57.3112 90.4075 52.9629C90.8718 51.0063 92.5873 49.7844 94.4359 50.2195C95.7283 50.5258 96.3239 51.6779 96.8703 52.7811L96.867 52.7713Z",
    fill: "url(#paint480_linear_10106_6282)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.8281 52.8172C96.996 53.1533 97.4344 53.2565 97.7312 53.0364C98.6899 52.3205 99.7303 51.5553 100.996 51.8485C102.832 52.2772 103.809 54.1407 103.351 56.0842C102.333 60.4096 96.6039 61.0206 95.0328 62.4447C94.2677 60.4661 89.4253 57.3634 90.4439 53.038C90.9016 51.0945 92.6074 49.8758 94.4429 50.3045C95.7091 50.5978 96.2949 51.7531 96.8314 52.8269L96.8281 52.8172Z",
    fill: "url(#paint481_linear_10106_6282)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M96.7955 52.85C96.9699 53.2057 97.4312 53.3121 97.7541 53.0723C98.6966 52.3728 99.7238 51.6011 100.957 51.8945C102.783 52.3264 103.754 54.1703 103.293 56.104C102.277 60.4066 96.6005 61.0108 95.036 62.4218C94.2742 60.453 89.471 57.3698 90.4864 53.0673C90.9475 51.1336 92.6434 49.9182 94.4593 50.3535C95.6929 50.6469 96.2754 51.7925 96.8019 52.8369L96.7955 52.85Z",
    fill: "url(#paint482_linear_10106_6282)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M96.7628 52.8828C96.9537 53.2548 97.4379 53.3644 97.7705 53.1213C98.6869 52.4415 99.7142 51.6698 100.925 51.96C102.728 52.3887 103.695 54.2228 103.24 56.1434C102.228 60.4231 96.5939 61.0239 95.0392 62.4316C94.2807 60.4726 89.5169 57.4089 90.5193 53.1325C90.9738 51.2119 92.66 49.9999 94.4628 50.4287C95.6734 50.7189 96.2428 51.858 96.7628 52.8828Z",
    fill: "url(#paint483_linear_10106_6282)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M96.7206 52.9189C96.918 53.3105 97.4252 53.4233 97.7774 53.1736C98.6775 52.5102 99.6852 51.7451 100.87 52.0223C102.659 52.4445 103.623 54.2688 103.165 56.1796C102.163 60.4233 96.5647 61.0338 95.0197 62.4382C94.2678 60.4988 89.54 57.4448 90.5425 53.2011C91.0004 51.2903 92.6703 50.0947 94.46 50.517C95.6444 50.7942 96.204 51.9365 96.7141 52.932L96.7206 52.9189Z",
    fill: "url(#paint484_linear_10106_6282)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M96.6878 52.9517C96.9017 53.3596 97.4252 53.4886 97.8002 53.2095C98.6742 52.5658 99.6819 51.8007 100.843 52.0747C102.623 52.5002 103.571 54.3082 103.12 56.206C102.12 60.4267 96.5645 61.0338 95.0359 62.4218C94.2873 60.4922 89.5922 57.4707 90.5981 53.2369C91.0494 51.3392 92.7095 50.1469 94.4861 50.5627C95.6476 50.8367 96.1941 51.9725 96.6943 52.9386L96.6878 52.9517Z",
    fill: "url(#paint485_linear_10106_6282)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M96.6552 52.9845C96.8757 53.412 97.4319 53.5409 97.8167 53.2585C98.6745 52.6312 99.6723 51.8693 100.798 52.1337C102.565 52.5527 103.509 54.351 103.054 56.2389C102.058 60.4367 96.5547 61.0371 95.0261 62.4251C94.2906 60.502 89.625 57.5033 90.6212 53.3055C91.0627 51.4111 92.7163 50.2319 94.4831 50.6509C95.612 50.9251 96.1552 52.0511 96.6454 52.9878L96.6552 52.9845Z",
    fill: "url(#paint486_linear_10106_6282)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M96.613 53.0206C96.8499 53.4644 97.4192 53.5998 97.8236 53.3108C98.6683 52.7097 99.64 51.9348 100.756 52.2024C102.509 52.615 103.441 54.4068 102.993 56.2816C102.009 60.4532 96.5386 61.0535 95.0295 62.4349C94.3006 60.5314 89.6711 57.5424 90.664 53.3675C91.1089 51.4828 92.7429 50.3102 94.4966 50.7228C95.5992 50.9839 96.1326 52.1133 96.6163 53.0304L96.613 53.0206Z",
    fill: "url(#paint487_linear_10106_6282)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.5836 53.0632C96.8271 53.5266 97.4291 53.6619 97.8498 53.3564C98.6684 52.775 99.6401 52.0002 100.72 52.2581C102.46 52.6642 103.388 54.4462 102.947 56.3079C101.967 60.4566 96.5384 61.0535 95.0359 62.4218C94.3103 60.5281 89.72 57.5586 90.7098 53.4065C91.1482 51.535 92.7723 50.3657 94.5163 50.7816C95.596 51.0395 96.1261 52.1591 96.5901 53.0501L96.5836 53.0632Z",
    fill: "white"
  }))), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0068 62.5298L94.9804 62.4514C94.7167 61.7985 94.0308 61.0259 93.2268 60.1296C91.3825 58.0565 89.0821 55.4716 89.8591 52.2095C90.3781 50.0272 92.2929 48.749 94.3313 49.2293C95.9541 49.6096 96.7459 50.761 97.4084 52.3706C98.7254 51.2284 99.9393 50.5574 101.562 50.9378C103.601 51.4181 104.745 53.4216 104.226 55.604C103.449 58.866 100.249 60.1518 97.67 61.1739C96.5534 61.6158 95.5936 62.0047 95.0622 62.4675L95.0035 62.52L95.0068 62.5298ZM94.3055 49.3471C92.3358 48.8764 90.4765 50.1249 89.9768 52.2353C89.2226 55.4352 91.4935 57.9973 93.3214 60.0541C94.0959 60.9276 94.7653 61.6839 95.0618 62.3367C95.616 61.8772 96.5596 61.5046 97.637 61.076C100.187 60.0637 103.37 58.7944 104.121 55.5847C104.621 53.4743 103.516 51.523 101.55 51.0621C99.9496 50.6849 98.7422 51.3755 97.4384 52.5241L97.3797 52.5766L97.3533 52.4983C96.6907 50.8887 95.9284 49.7274 94.3186 49.3536L94.3055 49.3471Z",
    fill: "url(#paint488_linear_10106_6282)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8799 54.6216C97.5187 54.0572 98.1484 53.6595 99.0155 53.8691C100.059 54.1173 100.612 55.142 100.357 56.2315C99.7899 58.6266 96.5511 58.9546 95.671 59.7421C95.2325 58.6353 92.4772 56.902 93.0446 54.507C93.3025 53.4272 94.2647 52.7538 95.2986 53.0054C96.1624 53.2052 96.5536 53.8479 96.8734 54.6347L96.8799 54.6216Z",
    fill: "url(#paint489_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8436 54.5466C96.8436 54.5466 96.9157 54.5986 96.9385 54.5691C97.5579 54.044 98.1746 53.6725 99.0155 53.8691C100.059 54.1173 100.612 55.142 100.357 56.2315C99.7899 58.6266 96.5511 58.9546 95.671 59.7421C95.2325 58.6353 92.4772 56.902 93.0446 54.507C93.3025 53.4272 94.2647 52.7538 95.2986 53.0054C96.1297 53.2053 96.5273 53.8022 96.8371 54.5597L96.8436 54.5466Z",
    fill: "url(#paint490_linear_10106_6282)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.96,
    d: "M96.8079 54.6023C96.8244 54.6512 96.8964 54.6706 96.9388 54.6345C97.5583 54.142 98.1716 53.7607 98.9863 53.9444C100.017 54.1861 100.563 55.1912 100.312 56.2579C99.7572 58.6267 96.538 58.9481 95.6645 59.7225C95.2227 58.6386 92.5001 56.9052 93.0676 54.5429C93.3191 53.4762 94.2649 52.8192 95.2956 53.0609C96.1136 53.2544 96.4851 53.871 96.8144 54.5892L96.8079 54.6023Z",
    fill: "url(#paint491_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.91,
    d: "M96.7819 54.6547C96.805 54.7232 96.8966 54.736 96.9488 54.6966C97.5651 54.227 98.1654 53.8392 98.9702 54.0262C99.9911 54.2712 100.527 55.2469 100.273 56.3038C99.718 58.6399 96.5446 58.9677 95.6678 59.7323C95.2293 58.6582 92.5362 56.9476 93.0907 54.6114C93.3357 53.5579 94.2555 52.9206 95.2861 53.1623C96.0812 53.3526 96.4527 53.9692 96.7852 54.6644L96.7819 54.6547Z",
    fill: "url(#paint492_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87,
    d: "M96.7494 54.7201C96.7856 54.7952 96.8903 54.8145 96.9523 54.7718C97.5556 54.3284 98.1657 53.9373 98.9476 54.121C99.9554 54.3596 100.475 55.319 100.237 56.3594C99.6919 58.6596 96.5414 58.9905 95.6841 59.7486C95.249 58.6843 92.5821 56.9867 93.1236 54.6767C93.3718 53.633 94.2656 53.0154 95.2831 53.2506C96.0651 53.4343 96.4268 54.0543 96.7625 54.7266L96.7494 54.7201Z",
    fill: "url(#paint493_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.83,
    d: "M96.7136 54.7758C96.7531 54.8607 96.8709 54.8865 96.9525 54.8372C97.5395 54.4102 98.1496 54.0191 98.9086 54.1996C99.9164 54.4382 100.416 55.3715 100.171 56.3924C99.6298 58.6696 96.5087 58.9906 95.6579 59.7356C95.2294 58.6909 92.5854 56.9965 93.1172 54.7225C93.3622 53.7017 94.2364 53.0906 95.2441 53.3292C96.0032 53.5097 96.3649 54.1297 96.7038 54.7791L96.7136 54.7758Z",
    fill: "url(#paint494_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.79,
    d: "M96.6876 54.8282C96.7402 54.9196 96.8711 54.9519 96.9591 54.8894C97.5397 54.4756 98.153 54.0943 98.8892 54.2716C99.8839 54.5037 100.377 55.4174 100.129 56.4285C99.5971 58.6697 96.5022 59.0038 95.6579 59.7356C95.2326 58.7007 92.6148 57.0192 93.1468 54.778C93.3853 53.7702 94.2431 53.1756 95.2378 53.4077C95.9838 53.5817 96.3455 54.2017 96.6778 54.8315L96.6876 54.8282Z",
    fill: "url(#paint495_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74,
    d: "M96.6519 54.8839C96.7111 54.9949 96.8648 55.0303 96.9594 54.9548C97.5237 54.5573 98.137 54.1761 98.8601 54.3469C99.845 54.5823 100.319 55.4699 100.087 56.4646C99.5677 58.6796 96.4924 59.0071 95.6644 59.7225C95.2458 58.7072 92.6509 57.0289 93.1731 54.8237C93.4052 53.829 94.2467 53.2508 95.2316 53.4862C95.9546 53.657 96.3261 54.2737 96.6519 54.8839Z",
    fill: "url(#paint496_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M96.616 54.9396C96.6786 55.0604 96.8552 55.099 96.9596 55.0202C97.5076 54.6391 98.1307 54.2545 98.8342 54.432C99.806 54.6609 100.273 55.5289 100.038 56.5138C99.5187 58.6961 96.4859 59.0202 95.6579 59.7356C95.2426 58.7301 92.6674 57.0779 93.1864 54.8956C93.4218 53.9107 94.2372 53.3522 95.209 53.5811C95.919 53.7454 96.2807 54.3654 96.6096 54.9527L96.616 54.9396Z",
    fill: "url(#paint497_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.66,
    d: "M96.5935 55.0018C96.6691 55.1291 96.8491 55.1775 96.973 55.0921C97.5145 54.7241 98.1312 54.3526 98.8183 54.5138C99.7802 54.7459 100.237 55.5846 100.005 56.5466C99.4959 58.6929 96.4893 59.0299 95.6678 59.7323C95.246 58.7399 92.7068 57.0974 93.2128 54.9412C93.4417 53.9695 94.2409 53.4274 95.2028 53.6595C95.8899 53.8207 96.2614 54.4373 96.5837 55.0051L96.5935 55.0018Z",
    fill: "url(#paint498_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61,
    d: "M96.5576 55.0575C96.6365 55.1946 96.8394 55.2462 96.9732 55.1575C97.4983 54.8059 98.1248 54.4311 98.7923 54.5989C99.7509 54.8212 100.182 55.6469 99.9563 56.5958C99.4599 58.716 96.4729 59.0464 95.6677 59.7323C95.2525 58.7595 92.7362 57.1202 93.2424 54.9967C93.468 54.0479 94.2378 53.5157 95.1964 53.738C95.8737 53.9025 96.2419 54.5093 96.5543 55.0477L96.5576 55.0575Z",
    fill: "url(#paint499_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.57,
    d: "M96.5218 55.1132C96.6073 55.2699 96.8298 55.3149 96.9733 55.2229C97.4822 54.8877 98.112 54.5227 98.7631 54.6742C99.7119 54.8998 100.13 55.6863 99.9139 56.6319C99.4174 58.7194 96.4664 59.0595 95.6676 59.7323C95.2557 58.7693 92.7656 57.143 93.2621 55.0555C93.4813 54.1197 94.2348 53.6039 95.1803 53.8198C95.8347 53.9811 96.2127 54.5846 96.5185 55.1034L96.5218 55.1132Z",
    fill: "url(#paint500_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M96.4959 55.1656C96.5945 55.3287 96.8203 55.3836 96.9834 55.2849C97.476 54.9662 98.1155 54.5979 98.747 54.7559C99.6828 54.9751 100.094 55.742 99.8715 56.668C99.3848 58.7195 96.4566 59.0628 95.6677 59.7323C95.2591 58.7791 92.7952 57.1658 93.282 55.1143C93.5044 54.1883 94.2318 53.6922 95.1676 53.9114C95.8089 54.0662 96.1869 54.6697 96.4861 55.1689L96.4959 55.1656Z",
    fill: "url(#paint501_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49,
    d: "M96.4634 55.2311C96.5653 55.404 96.814 55.4621 96.9836 55.3503C97.4599 55.048 98.1027 54.6895 98.7212 54.841C99.6471 55.0635 100.039 55.8043 99.8227 56.7172C99.3391 58.7458 96.4403 59.0792 95.6677 59.7323C95.2657 58.7987 92.8247 57.1885 93.3018 55.1731C93.5178 54.2602 94.2288 53.7805 95.1515 53.9932C95.7699 54.1448 96.1577 54.745 96.4503 55.2246L96.4634 55.2311Z",
    fill: "url(#paint502_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44,
    d: "M96.4276 55.2868C96.5426 55.4662 96.8043 55.5308 96.9838 55.4157C97.4536 55.1265 98.0964 54.7679 98.6919 54.9163C99.6048 55.1323 99.9897 55.8535 99.7802 56.7533C99.3063 58.7459 96.4436 59.089 95.6676 59.7323C95.2689 58.8085 92.8574 57.2211 93.328 55.2187C93.5375 54.319 94.2323 53.8557 95.1452 54.0717C95.7505 54.2168 96.1383 54.817 96.4242 55.277L96.4276 55.2868Z",
    fill: "url(#paint503_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M96.3919 55.3425C96.5103 55.5317 96.7851 55.6027 96.9841 55.4811C97.4377 55.2082 98.0838 54.8595 98.6662 55.0014C99.5791 55.2174 99.9443 55.9125 99.7315 56.8025C99.2706 58.7689 96.4274 59.1054 95.6613 59.7454C95.2659 58.8314 92.8806 57.257 93.3415 55.2906C93.5445 54.404 94.223 53.9571 95.1228 54.1665C95.7052 54.3084 96.0995 54.8956 96.3821 55.3458L96.3919 55.3425Z",
    fill: "url(#paint504_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M96.366 55.3949C96.4909 55.6037 96.7853 55.6681 96.9942 55.5432C97.4281 55.2769 98.0873 54.9347 98.6469 55.0734C99.5466 55.2829 99.8954 55.9617 99.6956 56.8255C99.2346 58.7592 96.4274 59.1053 95.6743 59.7192C95.2855 58.8247 92.9231 57.2536 93.3743 55.3232C93.5839 54.4561 94.233 54.0191 95.123 54.2319C95.6923 54.3673 96.0866 54.9545 96.3627 55.3851L96.366 55.3949Z",
    fill: "url(#paint505_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31,
    d: "M96.3334 55.4604C96.4714 55.6757 96.779 55.7466 96.9976 55.6184C97.4152 55.3685 98.0778 55.0361 98.6242 55.1683C99.5141 55.3811 99.8531 56.0305 99.6499 56.8845C99.1986 58.7822 96.4143 59.1316 95.671 59.7421C95.2757 58.8607 92.9395 57.3026 93.3908 55.4049C93.5939 54.5509 94.2137 54.1238 95.1036 54.3366C95.65 54.4688 96.0639 55.0494 96.3236 55.4637L96.3334 55.4604Z",
    fill: "url(#paint506_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27,
    d: "M96.2977 55.5161C96.4391 55.7412 96.7695 55.8153 96.9979 55.6838C97.4091 55.447 98.0716 55.1146 98.5951 55.2436C99.472 55.4499 99.8043 56.0797 99.5979 56.9239C99.1596 58.7954 96.3949 59.1382 95.6613 59.7454C95.2694 58.8738 92.9593 57.3287 93.4108 55.4637C93.6074 54.6228 94.2108 54.2121 95.1008 54.4249C95.6341 54.5506 96.048 55.1312 96.3011 55.5259L96.2977 55.5161Z",
    fill: "url(#paint507_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M96.2716 55.5685C96.426 55.8001 96.7597 55.884 97.0077 55.7458C97.4026 55.5255 98.0685 55.2028 98.5789 55.3254C99.4459 55.535 99.7585 56.1387 99.5651 56.9567C99.1267 58.7955 96.398 59.1479 95.6676 59.7323C95.2823 58.8803 92.9984 57.3481 93.4336 55.4995C93.6335 54.6685 94.2109 54.2775 95.0877 54.4838C95.5981 54.6063 96.0218 55.1835 96.2683 55.5587L96.2716 55.5685Z",
    fill: "url(#paint508_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19,
    d: "M96.2359 55.6242C96.4035 55.8623 96.7503 55.9527 97.0048 55.8014C97.3801 55.5877 98.0492 55.2748 98.5465 55.3909C99.4103 55.5907 99.7065 56.1781 99.5098 56.9863C99.081 58.7891 96.385 59.1415 95.6645 59.7225C95.2824 58.8803 93.0248 57.3611 93.4502 55.5485C93.6437 54.7305 94.2047 54.356 95.0718 54.5656C95.5691 54.6816 95.9928 55.2588 96.2326 55.6144L96.2359 55.6242Z",
    fill: "url(#paint509_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14,
    d: "M96.2 55.6799C96.3708 55.9278 96.7275 56.0149 97.0049 55.8668C97.3638 55.6695 98.0461 55.3631 98.5205 55.476C99.3745 55.6791 99.6575 56.2274 99.4706 57.0322C99.0548 58.8089 96.3784 59.1546 95.6676 59.7323C95.2888 58.8999 93.0574 57.3937 93.4732 55.6171C93.6634 54.822 94.2049 54.4541 95.0589 54.6572C95.5333 54.77 95.9668 55.3439 96.2 55.6799Z",
    fill: "url(#paint510_linear_10106_6282)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1775 55.7421C96.3647 56.0063 96.7312 56.09 97.0184 55.9387C97.361 55.7577 98.0433 55.4514 98.5046 55.5577C99.3455 55.7544 99.6121 56.2864 99.4317 57.0781C99.0158 58.8221 96.3753 59.1775 95.6678 59.7323C95.2956 58.9195 93.0871 57.4165 93.503 55.6726C93.6867 54.8906 94.2119 54.539 95.056 54.7454C95.5174 54.8518 95.9508 55.4257 96.1775 55.7421Z",
    fill: "white"
  })))), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M95.658 59.801L95.6415 59.752C95.5064 59.4158 95.1552 59.0214 94.7385 58.5618C93.8426 57.5546 92.612 56.1692 93.0052 54.4875C93.2695 53.362 94.2579 52.7015 95.3147 52.9563C96.1458 53.1562 96.5499 53.74 96.8926 54.5627C97.5674 53.9753 98.194 53.6332 99.0283 53.8429C100.072 54.0911 100.671 55.1222 100.406 56.2477C100.013 57.9295 98.2891 58.6087 97.0386 59.1066C96.4705 59.3308 95.971 59.5319 95.7037 59.7747L95.6613 59.8108L95.658 59.801ZM95.2953 53.0283C94.2876 52.7897 93.3449 53.4238 93.087 54.5036C92.7001 56.1395 93.8619 57.4499 94.7972 58.5093C95.1877 58.9559 95.5355 59.3405 95.6805 59.6734C95.9642 59.4469 96.4441 59.2524 96.9926 59.0348C98.3019 58.5171 99.9245 57.8611 100.311 56.2252C100.569 55.1454 100.007 54.1567 98.9992 53.9182C98.1812 53.7248 97.5677 54.0734 96.893 54.6608L96.8506 54.6969L96.8341 54.6479C96.4913 53.8252 96.1068 53.2348 95.2888 53.0414L95.2953 53.0283Z",
    fill: "url(#paint511_linear_10106_6282)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6272 68.3734L93.5909 68.2656C93.0272 66.8846 91.5702 65.2483 89.8801 63.3414C85.9946 58.9671 81.1607 53.5268 82.7854 46.6624C83.862 42.0883 87.8971 39.3972 92.1669 40.4127C95.6024 41.2185 97.255 43.6617 98.6592 47.0832C101.443 44.6611 104.011 43.2173 107.45 44.0329C111.716 45.0386 114.12 49.2578 113.041 53.8221C111.416 60.6865 104.654 63.3802 99.2213 65.5496C96.864 66.486 94.8267 67.3036 93.7087 68.2914L93.6239 68.3636L93.6272 68.3734ZM92.1446 40.573C87.9598 39.5833 84.0063 42.2251 82.9522 46.7043C81.3436 53.4869 86.1545 58.8913 90.0105 63.2429C91.6645 65.1074 93.1018 66.7176 93.6917 68.1116C94.8458 67.1335 96.857 66.3356 99.1653 65.4157C104.559 63.2595 111.281 60.5791 112.89 53.7964C113.954 49.3139 111.599 45.1763 107.418 44.1965C104.015 43.3906 101.463 44.8507 98.6861 47.2924L98.6013 47.3646L98.565 47.2568C97.1608 43.8353 95.5409 41.392 92.1381 40.5861L92.1446 40.573Z",
    fill: "url(#paint512_linear_10106_6282)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M109.852 93.4305C109.431 93.5725 108.979 93.5936 108.551 93.4872L69.0361 84.1354C67.7568 83.8356 66.9646 82.5534 67.2644 81.2741L82.0705 18.6795C82.2574 17.8747 82.8405 17.2417 83.6242 16.9776C84.0455 16.8356 84.4966 16.8144 84.9252 16.9209L124.44 26.2727C125.719 26.5725 126.511 27.8546 126.212 29.1339L111.399 91.7416C111.212 92.5465 110.629 93.1794 109.845 93.4436L109.852 93.4305ZM83.6803 17.1114C82.9455 17.3591 82.4048 17.9559 82.221 18.7052L67.4084 81.3129C67.1247 82.5104 67.8676 83.711 69.0618 83.9849L108.576 93.3367C108.979 93.4302 109.407 93.4058 109.799 93.2738C110.534 93.0261 111.074 92.4293 111.258 91.68L126.071 29.0723C126.355 27.8748 125.615 26.684 124.417 26.4003L84.8963 17.0616C84.4938 16.9681 84.0721 16.9793 83.6705 17.1147L83.6803 17.1114Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10106_6282",
    x: -3.25342,
    y: -2.41412,
    width: 159.561,
    height: 135.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10106_6282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10106_6282",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10106_6282",
    x1: 61.6187,
    y1: 107.916,
    x2: 33.3652,
    y2: 34.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10106_6282",
    x1: 16.8626,
    y1: 66.1642,
    x2: 20.7795,
    y2: 69.8764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10106_6282",
    x1: 78.2444,
    y1: 76.4278,
    x2: 74.3274,
    y2: 72.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10106_6282",
    x1: 55.1574,
    y1: 78.4384,
    x2: 36.1428,
    y2: 60.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10106_6282",
    x1: 36.2899,
    y1: 60.5896,
    x2: 55.192,
    y2: 78.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10106_6282",
    x1: 37.1425,
    y1: 60.7791,
    x2: 55.7025,
    y2: 79.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10106_6282",
    x1: 37.1682,
    y1: 60.332,
    x2: 55.1815,
    y2: 79.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10106_6282",
    x1: 37.9381,
    y1: 60.4688,
    x2: 55.5609,
    y2: 79.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10106_6282",
    x1: 37.9323,
    y1: 60.0169,
    x2: 54.9595,
    y2: 79.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10106_6282",
    x1: 38.6281,
    y1: 60.1335,
    x2: 55.2078,
    y2: 79.8946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10106_6282",
    x1: 39.293,
    y1: 60.2178,
    x2: 55.3997,
    y2: 80.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10106_6282",
    x1: 39.2116,
    y1: 59.7682,
    x2: 54.6653,
    y2: 80.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10106_6282",
    x1: 39.7979,
    y1: 59.843,
    x2: 54.7402,
    y2: 80.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10106_6282",
    x1: 40.3468,
    y1: 59.8992,
    x2: 54.7563,
    y2: 80.7816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10106_6282",
    x1: 40.8625,
    y1: 59.9347,
    x2: 54.7266,
    y2: 81.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10106_6282",
    x1: 41.3201,
    y1: 59.9612,
    x2: 54.6292,
    y2: 81.3374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10106_6282",
    x1: 41.7519,
    y1: 59.9818,
    x2: 54.4888,
    y2: 81.5643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10106_6282",
    x1: 42.1455,
    y1: 60.0054,
    x2: 54.3019,
    y2: 81.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10106_6282",
    x1: 42.4954,
    y1: 60.0252,
    x2: 54.0656,
    y2: 81.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10106_6282",
    x1: 43.3885,
    y1: 60.3641,
    x2: 54.4766,
    y2: 82.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10106_6282",
    x1: 43.6733,
    y1: 60.3688,
    x2: 54.1603,
    y2: 82.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10106_6282",
    x1: 43.9162,
    y1: 60.3693,
    x2: 53.8086,
    y2: 82.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10106_6282",
    x1: 44.646,
    y1: 60.6516,
    x2: 54.0373,
    y2: 83.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10106_6282",
    x1: 44.8249,
    y1: 60.6564,
    x2: 53.6181,
    y2: 83.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10106_6282",
    x1: 45.4497,
    y1: 60.8788,
    x2: 53.7362,
    y2: 83.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10106_6282",
    x1: 55.1389,
    y1: 78.3601,
    x2: 36.0118,
    y2: 60.2326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10106_6282",
    x1: 52.561,
    y1: 75.9777,
    x2: 38.5515,
    y2: 62.7003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10106_6282",
    x1: 38.6535,
    y1: 62.8298,
    x2: 52.5955,
    y2: 76.0432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10106_6282",
    x1: 39.4551,
    y1: 63.1158,
    x2: 53.0961,
    y2: 76.6397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10106_6282",
    x1: 39.3968,
    y1: 62.7471,
    x2: 52.5729,
    y2: 76.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10106_6282",
    x1: 40.1088,
    y1: 62.9777,
    x2: 52.9481,
    y2: 76.9223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10106_6282",
    x1: 40.0209,
    y1: 62.5918,
    x2: 52.3648,
    y2: 76.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10106_6282",
    x1: 40.6476,
    y1: 62.777,
    x2: 52.6233,
    y2: 77.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10106_6282",
    x1: 41.2309,
    y1: 62.949,
    x2: 52.8189,
    y2: 77.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10106_6282",
    x1: 41.0545,
    y1: 62.5498,
    x2: 52.125,
    y2: 77.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10106_6282",
    x1: 41.5561,
    y1: 62.693,
    x2: 52.2107,
    y2: 77.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10106_6282",
    x1: 42.0179,
    y1: 62.8155,
    x2: 52.2526,
    y2: 77.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10106_6282",
    x1: 42.4392,
    y1: 62.9061,
    x2: 52.2447,
    y2: 77.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10106_6282",
    x1: 42.8147,
    y1: 62.988,
    x2: 52.1857,
    y2: 78.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10106_6282",
    x1: 43.1397,
    y1: 63.0636,
    x2: 52.0744,
    y2: 78.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10106_6282",
    x1: 43.4464,
    y1: 63.1152,
    x2: 51.9388,
    y2: 78.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10106_6282",
    x1: 43.6963,
    y1: 63.1788,
    x2: 51.7486,
    y2: 78.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10106_6282",
    x1: 44.5037,
    y1: 63.5779,
    x2: 52.1926,
    y2: 79.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10106_6282",
    x1: 44.6865,
    y1: 63.5979,
    x2: 51.9335,
    y2: 79.0216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10106_6282",
    x1: 44.8223,
    y1: 63.624,
    x2: 51.6357,
    y2: 79.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10106_6282",
    x1: 45.4682,
    y1: 63.9448,
    x2: 51.9159,
    y2: 79.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10106_6282",
    x1: 45.5414,
    y1: 63.9463,
    x2: 51.5615,
    y2: 79.4614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10106_6282",
    x1: 46.0812,
    y1: 64.2017,
    x2: 51.7416,
    y2: 79.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10106_6282",
    x1: 52.5426,
    y1: 75.8995,
    x2: 38.4205,
    y2: 62.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10106_6282",
    x1: 49.8973,
    y1: 73.4531,
    x2: 40.8927,
    y2: 64.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10106_6282",
    x1: 41.0173,
    y1: 65.07,
    x2: 49.9393,
    y2: 73.5257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10106_6282",
    x1: 41.6948,
    y1: 65.3943,
    x2: 50.4168,
    y2: 74.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10106_6282",
    x1: 41.5047,
    y1: 65.0226,
    x2: 49.9289,
    y2: 73.7622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10106_6282",
    x1: 42.0859,
    y1: 65.2757,
    x2: 50.2872,
    y2: 74.1831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10106_6282",
    x1: 41.8415,
    y1: 64.8767,
    x2: 49.7296,
    y2: 73.8469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10106_6282",
    x1: 42.3379,
    y1: 65.0752,
    x2: 49.9831,
    y2: 74.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10106_6282",
    x1: 42.7926,
    y1: 65.2418,
    x2: 50.1846,
    y2: 74.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10106_6282",
    x1: 42.4582,
    y1: 64.8214,
    x2: 49.5163,
    y2: 74.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10106_6282",
    x1: 42.8203,
    y1: 64.9475,
    x2: 49.6171,
    y2: 74.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10106_6282",
    x1: 43.1498,
    y1: 65.0561,
    x2: 49.6711,
    y2: 74.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10106_6282",
    x1: 43.4407,
    y1: 65.1276,
    x2: 49.6825,
    y2: 74.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10106_6282",
    x1: 43.6817,
    y1: 65.1771,
    x2: 49.6446,
    y2: 74.7543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10106_6282",
    x1: 43.8791,
    y1: 65.224,
    x2: 49.5569,
    y2: 74.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10106_6282",
    x1: 44.0568,
    y1: 65.2556,
    x2: 49.4477,
    y2: 74.9026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10106_6282",
    x1: 44.1921,
    y1: 65.2761,
    x2: 49.2933,
    y2: 74.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10106_6282",
    x1: 44.8729,
    y1: 65.658,
    x2: 49.7367,
    y2: 75.4145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10106_6282",
    x1: 44.9496,
    y1: 65.6348,
    x2: 49.5253,
    y2: 75.3732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10106_6282",
    x1: 44.9767,
    y1: 65.6273,
    x2: 49.2678,
    y2: 75.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10106_6282",
    x1: 45.5159,
    y1: 65.9305,
    x2: 49.5648,
    y2: 75.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10106_6282",
    x1: 45.487,
    y1: 65.8997,
    x2: 49.2597,
    y2: 75.6228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10106_6282",
    x1: 45.925,
    y1: 66.1384,
    x2: 49.4592,
    y2: 75.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10106_6282",
    x1: 49.8787,
    y1: 73.3748,
    x2: 40.7691,
    y2: 64.7413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10106_6282",
    x1: 47.6387,
    y1: 71.3125,
    x2: 43.0239,
    y2: 66.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10106_6282",
    x1: 47.6357,
    y1: 71.3424,
    x2: 43.0283,
    y2: 66.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_10106_6282",
    x1: 48.1118,
    y1: 71.7851,
    x2: 43.6186,
    y2: 67.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_10106_6282",
    x1: 47.6259,
    y1: 71.4615,
    x2: 43.3073,
    y2: 66.9811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_10106_6282",
    x1: 47.9872,
    y1: 71.821,
    x2: 43.7929,
    y2: 67.2657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_10106_6282",
    x1: 47.4504,
    y1: 71.4393,
    x2: 43.4295,
    y2: 66.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_10106_6282",
    x1: 47.7113,
    y1: 71.716,
    x2: 43.8235,
    y2: 67.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_10106_6282",
    x1: 47.9222,
    y1: 71.9462,
    x2: 44.1756,
    y2: 67.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_10106_6282",
    x1: 47.288,
    y1: 71.5048,
    x2: 43.7255,
    y2: 66.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_10106_6282",
    x1: 47.4105,
    y1: 71.6653,
    x2: 43.9944,
    y2: 66.9578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_10106_6282",
    x1: 47.4859,
    y1: 71.7991,
    x2: 44.2166,
    y2: 67.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_10106_6282",
    x1: 47.5116,
    y1: 71.8838,
    x2: 44.3934,
    y2: 67.1291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_10106_6282",
    x1: 47.4981,
    y1: 71.9326,
    x2: 44.5299,
    y2: 67.1653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_10106_6282",
    x1: 47.4504,
    y1: 71.9661,
    x2: 44.6319,
    y2: 67.1901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_10106_6282",
    x1: 47.3686,
    y1: 71.9633,
    x2: 44.7025,
    y2: 67.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_10106_6282",
    x1: 47.2528,
    y1: 71.9498,
    x2: 44.7327,
    y2: 67.1794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_10106_6282",
    x1: 47.7151,
    y1: 72.3582,
    x2: 45.3194,
    y2: 67.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_10106_6282",
    x1: 47.5342,
    y1: 72.2788,
    x2: 45.2852,
    y2: 67.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_10106_6282",
    x1: 47.3263,
    y1: 72.1987,
    x2: 45.2217,
    y2: 67.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_10106_6282",
    x1: 47.6448,
    y1: 72.4824,
    x2: 45.6694,
    y2: 67.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_10106_6282",
    x1: 47.3912,
    y1: 72.3628,
    x2: 45.5549,
    y2: 67.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_10106_6282",
    x1: 47.6213,
    y1: 72.5832,
    x2: 45.9034,
    y2: 67.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_10106_6282",
    x1: 47.6126,
    y1: 71.2271,
    x2: 42.9152,
    y2: 66.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_10106_6282",
    x1: 53.3009,
    y1: 76.7117,
    x2: 58.9587,
    y2: 82.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_10106_6282",
    x1: 53.2258,
    y1: 76.6406,
    x2: 59.0338,
    y2: 82.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_10106_6282",
    x1: 71.6998,
    y1: 96.4012,
    x2: 52.6025,
    y2: 23.9003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_10106_6282",
    x1: 34.8981,
    y1: 45.4855,
    x2: 37.318,
    y2: 50.1466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E42900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_10106_6282",
    x1: 89.4255,
    y1: 74.9003,
    x2: 87.0104,
    y2: 70.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E42900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_10106_6282",
    x1: 55.3658,
    y1: 47.1253,
    x2: 69.0327,
    y2: 73.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D91F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF684D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_10106_6282",
    x1: 55.3991,
    y1: 47.1895,
    x2: 69.0326,
    y2: 73.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_10106_6282",
    x1: 55.6015,
    y1: 47.2988,
    x2: 69.0328,
    y2: 73.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_10106_6282",
    x1: 55.8094,
    y1: 47.418,
    x2: 69.0379,
    y2: 73.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_10106_6282",
    x1: 56.0082,
    y1: 47.5395,
    x2: 69.0246,
    y2: 74.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_10106_6282",
    x1: 56.2039,
    y1: 47.6699,
    x2: 69.0124,
    y2: 74.2046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_10106_6282",
    x1: 56.4025,
    y1: 47.779,
    x2: 68.9985,
    y2: 74.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_10106_6282",
    x1: 56.5878,
    y1: 47.8953,
    x2: 68.971,
    y2: 74.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_10106_6282",
    x1: 56.7911,
    y1: 48.0194,
    x2: 68.9573,
    y2: 74.7071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_10106_6282",
    x1: 56.9741,
    y1: 48.1468,
    x2: 68.9275,
    y2: 74.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_10106_6282",
    x1: 57.1584,
    y1: 48.2728,
    x2: 68.8859,
    y2: 75.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_10106_6282",
    x1: 57.3422,
    y1: 48.4008,
    x2: 68.8527,
    y2: 75.2091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_10106_6282",
    x1: 57.5185,
    y1: 48.5262,
    x2: 68.8128,
    y2: 75.3589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_10106_6282",
    x1: 57.7108,
    y1: 48.6546,
    x2: 68.7845,
    y2: 75.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_10106_6282",
    x1: 57.8744,
    y1: 48.7814,
    x2: 68.7277,
    y2: 75.6618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_10106_6282",
    x1: 58.0538,
    y1: 48.9039,
    x2: 68.6869,
    y2: 75.8054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_10106_6282",
    x1: 58.2197,
    y1: 49.0383,
    x2: 68.6293,
    y2: 75.9496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_10106_6282",
    x1: 58.3867,
    y1: 49.1635,
    x2: 68.5731,
    y2: 76.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_10106_6282",
    x1: 58.5411,
    y1: 49.2941,
    x2: 68.5012,
    y2: 76.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_10106_6282",
    x1: 58.7148,
    y1: 49.4326,
    x2: 68.4492,
    y2: 76.3427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_10106_6282",
    x1: 58.8598,
    y1: 49.5748,
    x2: 68.3691,
    y2: 76.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_10106_6282",
    x1: 59.0062,
    y1: 49.7108,
    x2: 68.2944,
    y2: 76.6141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_10106_6282",
    x1: 55.3039,
    y1: 47.006,
    x2: 69.0994,
    y2: 73.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BA1C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E63000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_10106_6282",
    x1: 57.0903,
    y1: 50.4468,
    x2: 67.3083,
    y2: 70.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C71D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_10106_6282",
    x1: 57.1045,
    y1: 50.4743,
    x2: 67.3082,
    y2: 70.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#480A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#724343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_10106_6282",
    x1: 57.2687,
    y1: 50.5684,
    x2: 67.3093,
    y2: 70.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_10106_6282",
    x1: 57.4255,
    y1: 50.6671,
    x2: 67.3018,
    y2: 70.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_10106_6282",
    x1: 57.582,
    y1: 50.7632,
    x2: 67.2953,
    y2: 70.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_10106_6282",
    x1: 57.7453,
    y1: 50.8634,
    x2: 67.291,
    y2: 70.6387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_10106_6282",
    x1: 57.8935,
    y1: 50.9508,
    x2: 67.2763,
    y2: 70.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_10106_6282",
    x1: 58.033,
    y1: 51.0542,
    x2: 67.2442,
    y2: 70.8736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_10106_6282",
    x1: 58.1961,
    y1: 51.1512,
    x2: 67.2403,
    y2: 70.9905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_10106_6282",
    x1: 58.3299,
    y1: 51.2552,
    x2: 67.2031,
    y2: 71.1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_10106_6282",
    x1: 58.474,
    y1: 51.3534,
    x2: 67.1731,
    y2: 71.2111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_10106_6282",
    x1: 58.6095,
    y1: 51.4571,
    x2: 67.1425,
    y2: 71.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B8A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_10106_6282",
    x1: 58.7436,
    y1: 51.5438,
    x2: 67.11,
    y2: 71.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_10106_6282",
    x1: 58.8886,
    y1: 51.6468,
    x2: 67.0816,
    y2: 71.5175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_10106_6282",
    x1: 59.005,
    y1: 51.7477,
    x2: 67.025,
    y2: 71.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_10106_6282",
    x1: 59.1379,
    y1: 51.8437,
    x2: 66.9893,
    y2: 71.7074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_10106_6282",
    x1: 59.2578,
    y1: 51.9511,
    x2: 66.9372,
    y2: 71.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_10106_6282",
    x1: 59.379,
    y1: 52.0489,
    x2: 66.8835,
    y2: 71.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_10106_6282",
    x1: 59.4845,
    y1: 52.1418,
    x2: 66.8182,
    y2: 71.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_10106_6282",
    x1: 59.6037,
    y1: 52.2553,
    x2: 66.7638,
    y2: 72.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_10106_6282",
    x1: 59.7012,
    y1: 52.3586,
    x2: 66.692,
    y2: 72.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_10106_6282",
    x1: 59.8041,
    y1: 52.465,
    x2: 66.6226,
    y2: 72.2149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_10106_6282",
    x1: 57.0426,
    y1: 50.3551,
    x2: 67.3559,
    y2: 70.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B01900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D14F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F28471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF9987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_10106_6282",
    x1: 58.8147,
    y1: 53.7683,
    x2: 65.5839,
    y2: 66.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_10106_6282",
    x1: 58.8243,
    y1: 53.7867,
    x2: 65.5839,
    y2: 66.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#480A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#724343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_10106_6282",
    x1: 58.9549,
    y1: 53.8749,
    x2: 65.6048,
    y2: 66.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_10106_6282",
    x1: 59.0739,
    y1: 53.9578,
    x2: 65.621,
    y2: 67.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_10106_6282",
    x1: 59.1974,
    y1: 54.0474,
    x2: 65.6395,
    y2: 67.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_10106_6282",
    x1: 59.3229,
    y1: 54.1313,
    x2: 65.6597,
    y2: 67.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_10106_6282",
    x1: 59.4381,
    y1: 54.2116,
    x2: 65.6653,
    y2: 67.3573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_10106_6282",
    x1: 59.5363,
    y1: 54.2886,
    x2: 65.6582,
    y2: 67.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_10106_6282",
    x1: 59.6671,
    y1: 54.3778,
    x2: 65.6794,
    y2: 67.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_10106_6282",
    x1: 59.7645,
    y1: 54.4642,
    x2: 65.6674,
    y2: 67.6682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_10106_6282",
    x1: 59.8723,
    y1: 54.5446,
    x2: 65.6635,
    y2: 67.7642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_10106_6282",
    x1: 59.976,
    y1: 54.6395,
    x2: 65.6537,
    y2: 67.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B8A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_10106_6282",
    x1: 60.0794,
    y1: 54.7168,
    x2: 65.6503,
    y2: 67.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_10106_6282",
    x1: 60.1893,
    y1: 54.8009,
    x2: 65.6473,
    y2: 68.0385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_10106_6282",
    x1: 60.2671,
    y1: 54.8729,
    x2: 65.6163,
    y2: 68.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_10106_6282",
    x1: 60.3599,
    y1: 54.9626,
    x2: 65.5966,
    y2: 68.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_10106_6282",
    x1: 60.4553,
    y1: 55.0463,
    x2: 65.5799,
    y2: 68.2946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_10106_6282",
    x1: 60.5427,
    y1: 55.1237,
    x2: 65.5554,
    y2: 68.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_10106_6282",
    x1: 60.6051,
    y1: 55.1995,
    x2: 65.5062,
    y2: 68.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_10106_6282",
    x1: 60.6977,
    y1: 55.2788,
    x2: 65.4875,
    y2: 68.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_10106_6282",
    x1: 60.7659,
    y1: 55.3706,
    x2: 65.4413,
    y2: 68.5978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_10106_6282",
    x1: 60.8365,
    y1: 55.4553,
    x2: 65.4014,
    y2: 68.6773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_10106_6282",
    x1: 58.7671,
    y1: 53.6766,
    x2: 65.6315,
    y2: 66.8985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8F1600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF735C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_10106_6282",
    x1: 60.544,
    y1: 57.099,
    x2: 63.8594,
    y2: 63.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_10106_6282",
    x1: 60.5534,
    y1: 57.1174,
    x2: 63.8593,
    y2: 63.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#480A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#724343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_10106_6282",
    x1: 60.6452,
    y1: 57.1905,
    x2: 63.895,
    y2: 63.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_10106_6282",
    x1: 60.7314,
    y1: 57.267,
    x2: 63.9309,
    y2: 63.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_10106_6282",
    x1: 60.8214,
    y1: 57.3501,
    x2: 63.9648,
    y2: 63.7421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_10106_6282",
    x1: 60.9045,
    y1: 57.4317,
    x2: 63.992,
    y2: 63.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_10106_6282",
    x1: 60.9959,
    y1: 57.5003,
    x2: 64.0276,
    y2: 63.9004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_10106_6282",
    x1: 61.0614,
    y1: 57.57,
    x2: 64.0374,
    y2: 63.9733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_10106_6282",
    x1: 61.1455,
    y1: 57.6463,
    x2: 64.0659,
    y2: 64.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_10106_6282",
    x1: 61.2107,
    y1: 57.7245,
    x2: 64.0756,
    y2: 64.1331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_10106_6282",
    x1: 61.2857,
    y1: 57.7968,
    x2: 64.09,
    y2: 64.1983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_10106_6282",
    x1: 61.3533,
    y1: 57.8735,
    x2: 64.1024,
    y2: 64.2763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B8A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_10106_6282",
    x1: 61.4119,
    y1: 57.936,
    x2: 64.1072,
    y2: 64.3393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_10106_6282",
    x1: 61.4863,
    y1: 58.0011,
    x2: 64.1266,
    y2: 64.4048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_10106_6282",
    x1: 61.5368,
    y1: 58.0729,
    x2: 64.1185,
    y2: 64.4671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_10106_6282",
    x1: 61.5946,
    y1: 58.143,
    x2: 64.1218,
    y2: 64.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_10106_6282",
    x1: 61.6457,
    y1: 58.2105,
    x2: 64.1184,
    y2: 64.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_10106_6282",
    x1: 61.699,
    y1: 58.2675,
    x2: 64.1139,
    y2: 64.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_10106_6282",
    x1: 61.7314,
    y1: 58.3324,
    x2: 64.0887,
    y2: 64.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_10106_6282",
    x1: 61.784,
    y1: 58.4038,
    x2: 64.0839,
    y2: 64.7619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_10106_6282",
    x1: 61.8093,
    y1: 58.4777,
    x2: 64.0523,
    y2: 64.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_10106_6282",
    x1: 61.8469,
    y1: 58.5407,
    x2: 64.0365,
    y2: 64.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_10106_6282",
    x1: 60.5106,
    y1: 57.0348,
    x2: 63.8881,
    y2: 63.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#801300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#941D07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CD381D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F1492A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF5030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_10106_6282",
    x1: 92.6586,
    y1: 89.8926,
    x2: 67.2237,
    y2: 19.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_10106_6282",
    x1: 59.2568,
    y1: 31.7869,
    x2: 59.9619,
    y2: 36.9495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_10106_6282",
    x1: 100.666,
    y1: 77.9824,
    x2: 99.9597,
    y2: 72.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_10106_6282",
    x1: 81.103,
    y1: 63.1636,
    x2: 82.1578,
    y2: 70.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_10106_6282",
    x1: 81.103,
    y1: 63.1636,
    x2: 82.1578,
    y2: 70.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_10106_6282",
    x1: 81.139,
    y1: 63.422,
    x2: 82.261,
    y2: 71.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_10106_6282",
    x1: 81.183,
    y1: 63.6697,
    x2: 82.372,
    y2: 71.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_10106_6282",
    x1: 81.2059,
    y1: 63.9078,
    x2: 82.4612,
    y2: 71.5593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_10106_6282",
    x1: 81.238,
    y1: 64.1421,
    x2: 82.5592,
    y2: 71.7615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_10106_6282",
    x1: 81.237,
    y1: 64.3779,
    x2: 82.6222,
    y2: 71.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_10106_6282",
    x1: 81.2554,
    y1: 64.6114,
    x2: 82.7055,
    y2: 72.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_10106_6282",
    x1: 81.2477,
    y1: 64.8155,
    x2: 82.7642,
    y2: 72.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_10106_6282",
    x1: 81.2439,
    y1: 65.0247,
    x2: 82.8224,
    y2: 72.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_10106_6282",
    x1: 81.228,
    y1: 65.2329,
    x2: 82.8676,
    y2: 72.6738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_10106_6282",
    x1: 81.2065,
    y1: 65.4404,
    x2: 82.9089,
    y2: 72.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_10106_6282",
    x1: 81.1654,
    y1: 65.6573,
    x2: 82.9265,
    y2: 73.0172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_10106_6282",
    x1: 81.1319,
    y1: 65.8506,
    x2: 82.9523,
    y2: 73.1641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_10106_6282",
    x1: 81.0906,
    y1: 66.0509,
    x2: 82.9695,
    y2: 73.3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_10106_6282",
    x1: 81.0428,
    y1: 66.2616,
    x2: 82.9756,
    y2: 73.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_10106_6282",
    x1: 80.9825,
    y1: 66.4436,
    x2: 82.9723,
    y2: 73.6056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_10106_6282",
    x1: 80.9398,
    y1: 66.6405,
    x2: 82.9832,
    y2: 73.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_10106_6282",
    x1: 80.8838,
    y1: 66.8241,
    x2: 82.9797,
    y2: 73.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_10106_6282",
    x1: 80.8149,
    y1: 67.0076,
    x2: 82.9625,
    y2: 73.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_10106_6282",
    x1: 80.74,
    y1: 67.2167,
    x2: 82.9372,
    y2: 74.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_10106_6282",
    x1: 80.6773,
    y1: 67.4039,
    x2: 82.9232,
    y2: 74.2725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_10106_6282",
    x1: 81.6766,
    y1: 67.3634,
    x2: 81.9158,
    y2: 69.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_10106_6282",
    x1: 81.6766,
    y1: 67.3634,
    x2: 81.9158,
    y2: 69.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_10106_6282",
    x1: 81.7423,
    y1: 67.4922,
    x2: 82.0001,
    y2: 69.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_10106_6282",
    x1: 81.8238,
    y1: 67.6086,
    x2: 82.0989,
    y2: 69.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_10106_6282",
    x1: 81.8809,
    y1: 67.7048,
    x2: 82.1755,
    y2: 69.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_10106_6282",
    x1: 81.9384,
    y1: 67.819,
    x2: 82.251,
    y2: 69.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_10106_6282",
    x1: 81.9765,
    y1: 67.9106,
    x2: 82.3088,
    y2: 69.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_10106_6282",
    x1: 82.0238,
    y1: 68.0115,
    x2: 82.3746,
    y2: 69.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_10106_6282",
    x1: 82.0425,
    y1: 68.0828,
    x2: 82.414,
    y2: 69.9273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_10106_6282",
    x1: 82.0713,
    y1: 68.1467,
    x2: 82.4616,
    y2: 69.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_10106_6282",
    x1: 82.0771,
    y1: 68.2217,
    x2: 82.4865,
    y2: 70.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_10106_6282",
    x1: 82.0749,
    y1: 68.2958,
    x2: 82.5034,
    y2: 70.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_10106_6282",
    x1: 82.0582,
    y1: 68.367,
    x2: 82.5057,
    y2: 70.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_10106_6282",
    x1: 82.0392,
    y1: 68.4266,
    x2: 82.5062,
    y2: 70.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_10106_6282",
    x1: 82.0202,
    y1: 68.4908,
    x2: 82.5067,
    y2: 70.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_10106_6282",
    x1: 81.9866,
    y1: 68.5453,
    x2: 82.4952,
    y2: 70.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_10106_6282",
    x1: 81.9565,
    y1: 68.5979,
    x2: 82.4823,
    y2: 70.4905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_10106_6282",
    x1: 81.9162,
    y1: 68.651,
    x2: 82.4649,
    y2: 70.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_10106_6282",
    x1: 81.8695,
    y1: 68.688,
    x2: 82.4384,
    y2: 70.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_10106_6282",
    x1: 81.8205,
    y1: 68.7318,
    x2: 82.4068,
    y2: 70.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_10106_6282",
    x1: 81.7499,
    y1: 68.7943,
    x2: 82.3563,
    y2: 70.7061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_10106_6282",
    x1: 81.6922,
    y1: 68.8449,
    x2: 82.3187,
    y2: 70.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_10106_6282",
    x1: 81.6696,
    y1: 67.3121,
    x2: 81.9228,
    y2: 69.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_10106_6282",
    x1: 81.089,
    y1: 63.0612,
    x2: 82.1718,
    y2: 70.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_10106_6282",
    x1: 77.7904,
    y1: 38.9075,
    x2: 81.4893,
    y2: 65.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_10106_6282",
    x1: 77.7259,
    y1: 38.4363,
    x2: 81.5213,
    y2: 66.2263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_10106_6282",
    x1: 77.631,
    y1: 38.6187,
    x2: 81.6691,
    y2: 66.3432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_10106_6282",
    x1: 77.5539,
    y1: 38.7996,
    x2: 81.8323,
    y2: 66.4461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_10106_6282",
    x1: 77.4501,
    y1: 38.9716,
    x2: 81.9709,
    y2: 66.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_10106_6282",
    x1: 77.354,
    y1: 39.1401,
    x2: 82.1194,
    y2: 66.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_10106_6282",
    x1: 77.2295,
    y1: 39.3198,
    x2: 82.23,
    y2: 66.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_10106_6282",
    x1: 77.1165,
    y1: 39.488,
    x2: 82.3557,
    y2: 66.7792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_10106_6282",
    x1: 76.9802,
    y1: 39.6475,
    x2: 82.4567,
    y2: 66.8394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_10106_6282",
    x1: 76.8569,
    y1: 39.8101,
    x2: 82.5671,
    y2: 66.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_10106_6282",
    x1: 76.7078,
    y1: 39.9641,
    x2: 82.6524,
    y2: 66.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_10106_6282",
    x1: 76.5664,
    y1: 40.1355,
    x2: 82.7417,
    y2: 66.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_10106_6282",
    x1: 76.3989,
    y1: 40.3179,
    x2: 82.7962,
    y2: 67.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_10106_6282",
    x1: 76.2436,
    y1: 40.4754,
    x2: 82.8683,
    y2: 67.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_10106_6282",
    x1: 76.082,
    y1: 40.6501,
    x2: 82.9298,
    y2: 67.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_10106_6282",
    x1: 75.9148,
    y1: 40.8243,
    x2: 82.9766,
    y2: 67.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_10106_6282",
    x1: 75.7449,
    y1: 40.9879,
    x2: 83.0262,
    y2: 67.1955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_10106_6282",
    x1: 75.5724,
    y1: 41.1722,
    x2: 83.0655,
    y2: 67.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_10106_6282",
    x1: 75.3951,
    y1: 41.3405,
    x2: 83.0978,
    y2: 67.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_10106_6282",
    x1: 75.2146,
    y1: 41.5057,
    x2: 83.1307,
    y2: 67.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_10106_6282",
    x1: 75.0249,
    y1: 41.7084,
    x2: 83.1387,
    y2: 67.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_10106_6282",
    x1: 74.8502,
    y1: 41.8991,
    x2: 83.1624,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_10106_6282",
    x1: 78.0323,
    y1: 40.6796,
    x2: 81.2472,
    y2: 64.2186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_10106_6282",
    x1: 77.9982,
    y1: 40.2773,
    x2: 81.3348,
    y2: 64.7075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_10106_6282",
    x1: 77.921,
    y1: 40.4675,
    x2: 81.4674,
    y2: 64.8159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_10106_6282",
    x1: 77.8622,
    y1: 40.6559,
    x2: 81.6157,
    y2: 64.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_10106_6282",
    x1: 77.7647,
    y1: 40.8267,
    x2: 81.7298,
    y2: 64.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_10106_6282",
    x1: 77.6874,
    y1: 41.0024,
    x2: 81.8628,
    y2: 65.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_10106_6282",
    x1: 77.5897,
    y1: 41.1773,
    x2: 81.9682,
    y2: 65.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_10106_6282",
    x1: 77.4853,
    y1: 41.3542,
    x2: 82.0696,
    y2: 65.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_10106_6282",
    x1: 77.3781,
    y1: 41.5184,
    x2: 82.1646,
    y2: 65.2847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_10106_6282",
    x1: 77.2617,
    y1: 41.6795,
    x2: 82.2488,
    y2: 65.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_10106_6282",
    x1: 77.1419,
    y1: 41.8375,
    x2: 82.3301,
    y2: 65.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_10106_6282",
    x1: 77.0174,
    y1: 42.0049,
    x2: 82.4028,
    y2: 65.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_10106_6282",
    x1: 76.8666,
    y1: 42.1833,
    x2: 82.4411,
    y2: 65.4796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_10106_6282",
    x1: 76.7307,
    y1: 42.3464,
    x2: 82.4989,
    y2: 65.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_10106_6282",
    x1: 76.586,
    y1: 42.5166,
    x2: 82.5435,
    y2: 65.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_10106_6282",
    x1: 76.438,
    y1: 42.6963,
    x2: 82.5764,
    y2: 65.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_10106_6282",
    x1: 76.2751,
    y1: 42.8579,
    x2: 82.5988,
    y2: 65.6189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_10106_6282",
    x1: 76.1293,
    y1: 43.0344,
    x2: 82.6336,
    y2: 65.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_10106_6282",
    x1: 75.9691,
    y1: 43.1975,
    x2: 82.6519,
    y2: 65.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_10106_6282",
    x1: 75.8085,
    y1: 43.3674,
    x2: 82.6675,
    y2: 65.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_10106_6282",
    x1: 75.6354,
    y1: 43.5647,
    x2: 82.6646,
    y2: 65.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_10106_6282",
    x1: 75.477,
    y1: 43.7499,
    x2: 82.6711,
    y2: 65.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_10106_6282",
    x1: 78.2744,
    y1: 42.4517,
    x2: 81.0051,
    y2: 62.4466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_10106_6282",
    x1: 87.2303,
    y1: 53.7811,
    x2: 88.2795,
    y2: 61.4635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_10106_6282",
    x1: 87.3022,
    y1: 53.8738,
    x2: 88.4168,
    y2: 61.5262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_10106_6282",
    x1: 87.3881,
    y1: 53.9428,
    x2: 88.5676,
    y2: 61.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_10106_6282",
    x1: 87.4382,
    y1: 54.0012,
    x2: 88.6834,
    y2: 61.5915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_10106_6282",
    x1: 87.5071,
    y1: 54.063,
    x2: 88.8177,
    y2: 61.6213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_10106_6282",
    x1: 87.5399,
    y1: 54.1156,
    x2: 88.914,
    y2: 61.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_10106_6282",
    x1: 87.5893,
    y1: 54.1737,
    x2: 89.0258,
    y2: 61.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_10106_6282",
    x1: 87.6121,
    y1: 54.2111,
    x2: 89.1123,
    y2: 61.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_10106_6282",
    x1: 87.6243,
    y1: 54.2442,
    x2: 89.1857,
    y2: 61.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_10106_6282",
    x1: 87.6315,
    y1: 54.2729,
    x2: 89.2556,
    y2: 61.6431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_10106_6282",
    x1: 87.6352,
    y1: 54.3198,
    x2: 89.3191,
    y2: 61.6447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_10106_6282",
    x1: 87.6041,
    y1: 54.3582,
    x2: 89.3459,
    y2: 61.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_10106_6282",
    x1: 87.5907,
    y1: 54.3883,
    x2: 89.3885,
    y2: 61.6115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_10106_6282",
    x1: 87.5569,
    y1: 54.4268,
    x2: 89.4124,
    y2: 61.6034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_10106_6282",
    x1: 87.5238,
    y1: 54.463,
    x2: 89.4325,
    y2: 61.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_10106_6282",
    x1: 87.4818,
    y1: 54.4981,
    x2: 89.444,
    y2: 61.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_10106_6282",
    x1: 87.4397,
    y1: 54.5298,
    x2: 89.4544,
    y2: 61.5344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_10106_6282",
    x1: 87.3814,
    y1: 54.5472,
    x2: 89.4479,
    y2: 61.4936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_10106_6282",
    x1: 87.324,
    y1: 54.5804,
    x2: 89.4413,
    y2: 61.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_10106_6282",
    x1: 87.2477,
    y1: 54.6322,
    x2: 89.4105,
    y2: 61.4516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_10106_6282",
    x1: 87.1843,
    y1: 54.6711,
    x2: 89.3949,
    y2: 61.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_10106_6282",
    x1: 72.695,
    y1: 55.7662,
    x2: 73.7442,
    y2: 63.4487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_10106_6282",
    x1: 72.741,
    y1: 55.9006,
    x2: 73.8467,
    y2: 63.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_10106_6282",
    x1: 72.8023,
    y1: 56.0222,
    x2: 73.9629,
    y2: 63.5213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_10106_6282",
    x1: 72.8346,
    y1: 56.1142,
    x2: 74.0531,
    y2: 63.5412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_10106_6282",
    x1: 72.8752,
    y1: 56.2118,
    x2: 74.1487,
    y2: 63.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_10106_6282",
    x1: 72.8786,
    y1: 56.2985,
    x2: 74.2044,
    y2: 63.5601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_10106_6282",
    x1: 72.9068,
    y1: 56.3817,
    x2: 74.2868,
    y2: 63.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_10106_6282",
    x1: 72.9095,
    y1: 56.4551,
    x2: 74.3403,
    y2: 63.5596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_10106_6282",
    x1: 72.9091,
    y1: 56.5123,
    x2: 74.3916,
    y2: 63.5429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_10106_6282",
    x1: 72.8928,
    y1: 56.5679,
    x2: 74.4257,
    y2: 63.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_10106_6282",
    x1: 72.87,
    y1: 56.6322,
    x2: 74.452,
    y2: 63.5138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_10106_6282",
    x1: 72.8233,
    y1: 56.6937,
    x2: 74.4521,
    y2: 63.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_10106_6282",
    x1: 72.7942,
    y1: 56.75,
    x2: 74.4673,
    y2: 63.4716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_10106_6282",
    x1: 72.7517,
    y1: 56.8026,
    x2: 74.4701,
    y2: 63.4487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_10106_6282",
    x1: 72.708,
    y1: 56.8507,
    x2: 74.4695,
    y2: 63.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_10106_6282",
    x1: 72.6523,
    y1: 56.8906,
    x2: 74.4567,
    y2: 63.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_10106_6282",
    x1: 72.5885,
    y1: 56.9405,
    x2: 74.4346,
    y2: 63.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_10106_6282",
    x1: 72.5272,
    y1: 56.9707,
    x2: 74.4167,
    y2: 63.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_10106_6282",
    x1: 72.4529,
    y1: 57.0101,
    x2: 74.3818,
    y2: 63.2852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_10106_6282",
    x1: 72.371,
    y1: 57.0728,
    x2: 74.3369,
    y2: 63.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_10106_6282",
    x1: 72.2982,
    y1: 57.1131,
    x2: 74.3032,
    y2: 63.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_10106_6282",
    x1: 78.2773,
    y1: 42.4722,
    x2: 79.8847,
    y2: 54.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_10106_6282",
    x1: 78.3262,
    y1: 42.6024,
    x2: 80.0264,
    y2: 54.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_10106_6282",
    x1: 78.3891,
    y1: 42.7085,
    x2: 80.1837,
    y2: 54.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_10106_6282",
    x1: 78.4263,
    y1: 42.8135,
    x2: 80.3126,
    y2: 54.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_10106_6282",
    x1: 78.4617,
    y1: 42.9248,
    x2: 80.4382,
    y2: 54.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_10106_6282",
    x1: 78.4835,
    y1: 43.0214,
    x2: 80.5483,
    y2: 54.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_10106_6282",
    x1: 78.5101,
    y1: 43.1261,
    x2: 80.6599,
    y2: 54.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_10106_6282",
    x1: 78.51,
    y1: 43.2098,
    x2: 80.7471,
    y2: 54.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_10106_6282",
    x1: 78.5195,
    y1: 43.2844,
    x2: 80.8403,
    y2: 54.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_10106_6282",
    x1: 78.5039,
    y1: 43.3582,
    x2: 80.9067,
    y2: 54.2621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_10106_6282",
    x1: 78.4951,
    y1: 43.4474,
    x2: 80.9782,
    y2: 54.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_10106_6282",
    x1: 78.4554,
    y1: 43.5359,
    x2: 81.0129,
    y2: 54.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_10106_6282",
    x1: 78.4319,
    y1: 43.617,
    x2: 81.0638,
    y2: 54.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_10106_6282",
    x1: 78.3959,
    y1: 43.6931,
    x2: 81.103,
    y2: 54.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_10106_6282",
    x1: 78.3548,
    y1: 43.7772,
    x2: 81.1282,
    y2: 54.1225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_10106_6282",
    x1: 78.3102,
    y1: 43.8483,
    x2: 81.1525,
    y2: 54.0784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_10106_6282",
    x1: 78.2584,
    y1: 43.9281,
    x2: 81.1677,
    y2: 54.0425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_10106_6282",
    x1: 78.2005,
    y1: 43.9899,
    x2: 81.1749,
    y2: 53.9883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_10106_6282",
    x1: 78.1335,
    y1: 44.0696,
    x2: 81.1681,
    y2: 53.9417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_10106_6282",
    x1: 78.0594,
    y1: 44.1625,
    x2: 81.1537,
    y2: 53.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_10106_6282",
    x1: 77.9983,
    y1: 44.2416,
    x2: 81.1503,
    y2: 53.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_10106_6282",
    x1: 87.2215,
    y1: 53.7196,
    x2: 88.2847,
    y2: 61.5045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_10106_6282",
    x1: 72.6862,
    y1: 55.7048,
    x2: 73.7494,
    y2: 63.4896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_10106_6282",
    x1: 78.2671,
    y1: 42.4005,
    x2: 79.8871,
    y2: 54.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_10106_6282",
    x1: 78.5163,
    y1: 44.2238,
    x2: 80.763,
    y2: 60.6745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_10106_6282",
    x1: 87.8098,
    y1: 55.507,
    x2: 88.3736,
    y2: 59.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_10106_6282",
    x1: 87.8971,
    y1: 55.5945,
    x2: 88.4946,
    y2: 59.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_10106_6282",
    x1: 87.9881,
    y1: 55.6597,
    x2: 88.619,
    y2: 59.7362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_10106_6282",
    x1: 88.0639,
    y1: 55.7109,
    x2: 88.7284,
    y2: 59.7611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_10106_6282",
    x1: 88.1399,
    y1: 55.7789,
    x2: 88.834,
    y2: 59.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_10106_6282",
    x1: 88.1898,
    y1: 55.836,
    x2: 88.914,
    y2: 59.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_10106_6282",
    x1: 88.2426,
    y1: 55.8799,
    x2: 88.9989,
    y2: 59.8192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_10106_6282",
    x1: 88.2729,
    y1: 55.9235,
    x2: 89.0587,
    y2: 59.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_10106_6282",
    x1: 88.3108,
    y1: 55.9483,
    x2: 89.1256,
    y2: 59.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_10106_6282",
    x1: 88.3255,
    y1: 55.9831,
    x2: 89.1687,
    y2: 59.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_10106_6282",
    x1: 88.3446,
    y1: 56.0236,
    x2: 89.2133,
    y2: 59.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_10106_6282",
    x1: 88.3309,
    y1: 56.0656,
    x2: 89.2259,
    y2: 59.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_10106_6282",
    x1: 88.3229,
    y1: 56.0916,
    x2: 89.2418,
    y2: 59.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_10106_6282",
    x1: 88.3074,
    y1: 56.1334,
    x2: 89.2494,
    y2: 59.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_10106_6282",
    x1: 88.2896,
    y1: 56.1629,
    x2: 89.2533,
    y2: 59.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_10106_6282",
    x1: 88.2626,
    y1: 56.1909,
    x2: 89.2451,
    y2: 59.7271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_10106_6282",
    x1: 88.2262,
    y1: 56.2183,
    x2: 89.2321,
    y2: 59.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_10106_6282",
    x1: 88.1861,
    y1: 56.2385,
    x2: 89.209,
    y2: 59.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_10106_6282",
    x1: 88.144,
    y1: 56.2642,
    x2: 89.1828,
    y2: 59.6439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_10106_6282",
    x1: 88.0726,
    y1: 56.3118,
    x2: 89.129,
    y2: 59.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_10106_6282",
    x1: 88.0243,
    y1: 56.3432,
    x2: 89.0975,
    y2: 59.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_10106_6282",
    x1: 72.619,
    y1: 57.5817,
    x2: 73.1828,
    y2: 61.7097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_10106_6282",
    x1: 72.6679,
    y1: 57.6977,
    x2: 73.2595,
    y2: 61.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_10106_6282",
    x1: 72.7216,
    y1: 57.8026,
    x2: 73.3398,
    y2: 61.7973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_10106_6282",
    x1: 72.7585,
    y1: 57.8867,
    x2: 73.4029,
    y2: 61.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_10106_6282",
    x1: 72.8012,
    y1: 57.9664,
    x2: 73.4724,
    y2: 61.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_10106_6282",
    x1: 72.8204,
    y1: 58.0536,
    x2: 73.5149,
    y2: 61.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_10106_6282",
    x1: 72.8421,
    y1: 58.131,
    x2: 73.5594,
    y2: 61.8673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_10106_6282",
    x1: 72.8464,
    y1: 58.1867,
    x2: 73.5874,
    y2: 61.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_10106_6282",
    x1: 72.8496,
    y1: 58.2364,
    x2: 73.6111,
    y2: 61.8478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_10106_6282",
    x1: 72.8366,
    y1: 58.2846,
    x2: 73.6198,
    y2: 61.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_10106_6282",
    x1: 72.8294,
    y1: 58.3494,
    x2: 73.6309,
    y2: 61.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_10106_6282",
    x1: 72.7855,
    y1: 58.4035,
    x2: 73.606,
    y2: 61.8321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_10106_6282",
    x1: 72.7571,
    y1: 58.4425,
    x2: 73.5961,
    y2: 61.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_10106_6282",
    x1: 72.7172,
    y1: 58.4879,
    x2: 73.5739,
    y2: 61.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_10106_6282",
    x1: 72.6788,
    y1: 58.5389,
    x2: 73.5488,
    y2: 61.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_10106_6282",
    x1: 72.6226,
    y1: 58.5619,
    x2: 73.511,
    y2: 61.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_10106_6282",
    x1: 72.5741,
    y1: 58.612,
    x2: 73.4743,
    y2: 61.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_10106_6282",
    x1: 72.515,
    y1: 58.6353,
    x2: 73.4289,
    y2: 61.7072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_10106_6282",
    x1: 72.4529,
    y1: 58.6648,
    x2: 73.3794,
    y2: 61.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_10106_6282",
    x1: 72.3728,
    y1: 58.7208,
    x2: 73.3105,
    y2: 61.6772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_10106_6282",
    x1: 72.3013,
    y1: 58.7543,
    x2: 73.2492,
    y2: 61.6531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_10106_6282",
    x1: 78.5162,
    y1: 44.2238,
    x2: 79.4255,
    y2: 50.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_10106_6282",
    x1: 78.5762,
    y1: 44.3211,
    x2: 79.5388,
    y2: 50.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_10106_6282",
    x1: 78.6513,
    y1: 44.4044,
    x2: 79.6647,
    y2: 50.9534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_10106_6282",
    x1: 78.6988,
    y1: 44.4765,
    x2: 79.7633,
    y2: 50.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_10106_6282",
    x1: 78.754,
    y1: 44.5528,
    x2: 79.8685,
    y2: 50.9804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_10106_6282",
    x1: 78.7766,
    y1: 44.6283,
    x2: 79.939,
    y2: 50.9948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_10106_6282",
    x1: 78.8119,
    y1: 44.6999,
    x2: 80.0203,
    y2: 50.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_10106_6282",
    x1: 78.8321,
    y1: 44.7584,
    x2: 80.0874,
    y2: 50.9914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_10106_6282",
    x1: 78.8393,
    y1: 44.8018,
    x2: 80.1405,
    y2: 50.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_10106_6282",
    x1: 78.843,
    y1: 44.8502,
    x2: 80.1868,
    y2: 50.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_10106_6282",
    x1: 78.843,
    y1: 44.9161,
    x2: 80.2281,
    y2: 50.9413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_10106_6282",
    x1: 78.8191,
    y1: 44.9688,
    x2: 80.2458,
    y2: 50.9312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_10106_6282",
    x1: 78.8012,
    y1: 45.0165,
    x2: 80.267,
    y2: 50.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_10106_6282",
    x1: 78.7729,
    y1: 45.0692,
    x2: 80.2765,
    y2: 50.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_10106_6282",
    x1: 78.7359,
    y1: 45.12,
    x2: 80.2751,
    y2: 50.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_10106_6282",
    x1: 78.695,
    y1: 45.1577,
    x2: 80.2725,
    y2: 50.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_10106_6282",
    x1: 78.6567,
    y1: 45.2012,
    x2: 80.2685,
    y2: 50.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_10106_6282",
    x1: 78.6042,
    y1: 45.2395,
    x2: 80.2491,
    y2: 50.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_10106_6282",
    x1: 78.5494,
    y1: 45.2828,
    x2: 80.2231,
    y2: 50.7278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_10106_6282",
    x1: 78.4799,
    y1: 45.3523,
    x2: 80.1833,
    y2: 50.7231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_10106_6282",
    x1: 78.4197,
    y1: 45.3981,
    x2: 80.1515,
    y2: 50.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_10106_6282",
    x1: 87.7739,
    y1: 55.4702,
    x2: 88.3488,
    y2: 59.6802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_10106_6282",
    x1: 72.624,
    y1: 57.5393,
    x2: 73.199,
    y2: 61.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_10106_6282",
    x1: 78.5108,
    y1: 44.1828,
    x2: 79.4369,
    y2: 50.9639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_10106_6282",
    x1: 109.382,
    y1: 92.6884,
    x2: 84.0545,
    y2: 17.5467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_10106_6282",
    x1: 85.6632,
    y1: 26.4365,
    x2: 84.5539,
    y2: 31.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E42900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_10106_6282",
    x1: 99.7984,
    y1: 42.3069,
    x2: 93.6612,
    y2: 68.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D91F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF684D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_10106_6282",
    x1: 99.7984,
    y1: 42.3069,
    x2: 93.6612,
    y2: 68.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#480A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#724343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_10106_6282",
    x1: 100.315,
    y1: 43.0798,
    x2: 94.783,
    y2: 69.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_10106_6282",
    x1: 99.7357,
    y1: 42.4196,
    x2: 94.8843,
    y2: 68.8969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_10106_6282",
    x1: 99.0875,
    y1: 41.7289,
    x2: 94.9339,
    y2: 68.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#734444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_10106_6282",
    x1: 99.3606,
    y1: 42.1716,
    x2: 95.8844,
    y2: 68.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_10106_6282",
    x1: 98.5404,
    y1: 41.3919,
    x2: 95.7879,
    y2: 68.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#724444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_10106_6282",
    x1: 98.6441,
    y1: 41.6326,
    x2: 96.5984,
    y2: 68.6314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_10106_6282",
    x1: 98.6565,
    y1: 41.7901,
    x2: 97.3327,
    y2: 68.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_10106_6282",
    x1: 97.5939,
    y1: 40.96,
    x2: 97.0093,
    y2: 67.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_10106_6282",
    x1: 97.4592,
    y1: 41.0167,
    x2: 97.6083,
    y2: 67.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#987676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B79F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_10106_6282",
    x1: 97.2423,
    y1: 40.9959,
    x2: 98.1252,
    y2: 67.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B8A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_10106_6282",
    x1: 96.9419,
    y1: 40.9415,
    x2: 98.5549,
    y2: 67.7993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_10106_6282",
    x1: 96.5563,
    y1: 40.8577,
    x2: 98.8921,
    y2: 67.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_10106_6282",
    x1: 96.1064,
    y1: 40.7462,
    x2: 99.1551,
    y2: 67.2693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B7A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_10106_6282",
    x1: 96.5813,
    y1: 41.1213,
    x2: 100.364,
    y2: 67.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_10106_6282",
    x1: 95.9676,
    y1: 40.9599,
    x2: 100.431,
    y2: 67.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D1C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5DCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_10106_6282",
    x1: 95.2773,
    y1: 40.8233,
    x2: 100.397,
    y2: 66.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_10106_6282",
    x1: 95.5154,
    y1: 41.0109,
    x2: 101.325,
    y2: 66.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_10106_6282",
    x1: 94.7038,
    y1: 40.9161,
    x2: 101.119,
    y2: 66.2561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E5DDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_10106_6282",
    x1: 94.7956,
    y1: 41.0275,
    x2: 101.857,
    y2: 66.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F3EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_10106_6282",
    x1: 94.8146,
    y1: 41.0889,
    x2: 102.499,
    y2: 65.9499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FCFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_10106_6282",
    x1: 98.8581,
    y1: 46.2808,
    x2: 94.3349,
    y2: 65.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C71D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_10106_6282",
    x1: 98.8583,
    y1: 46.2808,
    x2: 94.3351,
    y2: 65.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#673535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8F6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_10106_6282",
    x1: 99.4128,
    y1: 47.1264,
    x2: 95.3378,
    y2: 66.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#673535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8F6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_10106_6282",
    x1: 98.8908,
    y1: 46.5206,
    x2: 95.3233,
    y2: 65.9909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#673535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_10106_6282",
    x1: 98.2876,
    y1: 45.8594,
    x2: 95.235,
    y2: 65.3686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#673535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8F6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_10106_6282",
    x1: 98.623,
    y1: 46.3669,
    x2: 96.0687,
    y2: 66.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#673535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8E6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_10106_6282",
    x1: 97.8649,
    y1: 45.617,
    x2: 95.8448,
    y2: 65.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8F6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_10106_6282",
    x1: 98.027,
    y1: 45.9305,
    x2: 96.5275,
    y2: 65.7196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#906A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_10106_6282",
    x1: 98.1126,
    y1: 46.1511,
    x2: 97.1436,
    y2: 66.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#906A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_10106_6282",
    x1: 97.1122,
    y1: 45.3274,
    x2: 96.6846,
    y2: 65.0335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#906A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B19797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_10106_6282",
    x1: 97.0569,
    y1: 45.4356,
    x2: 97.1659,
    y2: 65.1361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B29898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_10106_6282",
    x1: 96.9123,
    y1: 45.4654,
    x2: 97.5566,
    y2: 65.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B29898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CDBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_10106_6282",
    x1: 96.686,
    y1: 45.451,
    x2: 97.8617,
    y2: 65.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B19898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#CDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_10106_6282",
    x1: 96.3963,
    y1: 45.4048,
    x2: 98.0976,
    y2: 64.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B19898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_10106_6282",
    x1: 96.0232,
    y1: 45.3213,
    x2: 98.24,
    y2: 64.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_10106_6282",
    x1: 96.5854,
    y1: 45.7702,
    x2: 99.3318,
    y2: 65.0504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_10106_6282",
    x1: 96.0587,
    y1: 45.6236,
    x2: 99.2953,
    y2: 64.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#CDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E3D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_10106_6282",
    x1: 95.4653,
    y1: 45.4986,
    x2: 99.1722,
    y2: 64.2597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E3DADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_10106_6282",
    x1: 95.7933,
    y1: 45.7465,
    x2: 99.9932,
    y2: 64.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E3DADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_10106_6282",
    x1: 95.0745,
    y1: 45.6403,
    x2: 99.7069,
    y2: 63.9382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_10106_6282",
    x1: 95.2615,
    y1: 45.7871,
    x2: 100.351,
    y2: 63.8975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F2EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_10106_6282",
    x1: 95.3896,
    y1: 45.8889,
    x2: 100.919,
    y2: 63.7766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_10106_6282",
    x1: 98.8724,
    y1: 46.2204,
    x2: 94.3111,
    y2: 65.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B01900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C73F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E56F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F88D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_10106_6282",
    x1: 97.9441,
    y1: 50.144,
    x2: 95.0374,
    y2: 62.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_10106_6282",
    x1: 97.944,
    y1: 50.144,
    x2: 95.0373,
    y2: 62.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#622E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8B6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_10106_6282",
    x1: 98.534,
    y1: 51.0618,
    x2: 95.9178,
    y2: 63.5271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#622E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8B6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_10106_6282",
    x1: 98.0714,
    y1: 50.4806,
    x2: 95.7822,
    y2: 62.9743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#622E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8B6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_10106_6282",
    x1: 97.531,
    y1: 49.843,
    x2: 95.5748,
    y2: 62.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#622E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#8B6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_10106_6282",
    x1: 97.9149,
    y1: 50.4127,
    x2: 96.2784,
    y2: 63.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8B6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_10106_6282",
    x1: 97.2263,
    y1: 49.6745,
    x2: 95.9336,
    y2: 62.2639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8B6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AE9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_10106_6282",
    x1: 97.4439,
    y1: 50.0398,
    x2: 96.4855,
    y2: 62.6893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8C6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_10106_6282",
    x1: 97.5987,
    y1: 50.3027,
    x2: 96.9795,
    y2: 62.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8C6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_10106_6282",
    x1: 96.6745,
    y1: 49.4774,
    x2: 96.4015,
    y2: 62.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8C6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_10106_6282",
    x1: 96.6929,
    y1: 49.616,
    x2: 96.7624,
    y2: 62.1906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_10106_6282",
    x1: 96.6232,
    y1: 49.6753,
    x2: 97.0341,
    y2: 62.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CCBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_10106_6282",
    x1: 96.4727,
    y1: 49.6795,
    x2: 97.2218,
    y2: 62.1524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_10106_6282",
    x1: 96.2593,
    y1: 49.6509,
    x2: 97.3416,
    y2: 62.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_10106_6282",
    x1: 95.9723,
    y1: 49.573,
    x2: 97.3821,
    y2: 61.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_10106_6282",
    x1: 96.6092,
    y1: 50.0617,
    x2: 98.3543,
    y2: 62.3129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_10106_6282",
    x1: 96.1762,
    y1: 49.9064,
    x2: 98.2315,
    y2: 61.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CBBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_10106_6282",
    x1: 95.6638,
    y1: 49.7629,
    x2: 98.0158,
    y2: 61.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_10106_6282",
    x1: 96.0839,
    y1: 50.0326,
    x2: 98.7473,
    y2: 61.8536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E2D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_10106_6282",
    x1: 95.4532,
    y1: 49.9026,
    x2: 98.3873,
    y2: 61.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_10106_6282",
    x1: 95.7181,
    y1: 50.0602,
    x2: 98.9386,
    y2: 61.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F2EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_10106_6282",
    x1: 95.937,
    y1: 50.1454,
    x2: 99.4359,
    y2: 61.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_10106_6282",
    x1: 97.9583,
    y1: 50.0837,
    x2: 95.0134,
    y2: 62.5286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8F1600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#991F09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C5452E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E4614A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8715B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_10106_6282",
    x1: 97.1656,
    y1: 53.4338,
    x2: 95.6729,
    y2: 59.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_10106_6282",
    x1: 97.1656,
    y1: 53.4338,
    x2: 95.6729,
    y2: 59.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#977474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_10106_6282",
    x1: 97.7922,
    y1: 54.4449,
    x2: 96.4587,
    y2: 60.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#490C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#977474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_10106_6282",
    x1: 97.3582,
    y1: 53.919,
    x2: 96.1998,
    y2: 60.2413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#521818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#977474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_10106_6282",
    x1: 96.8611,
    y1: 53.3376,
    x2: 95.8791,
    y2: 59.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#977474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_10106_6282",
    x1: 97.298,
    y1: 53.9902,
    x2: 96.483,
    y2: 60.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#967474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_10106_6282",
    x1: 96.6518,
    y1: 53.3051,
    x2: 96.0136,
    y2: 59.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#977575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_10106_6282",
    x1: 96.9321,
    y1: 53.7422,
    x2: 96.4624,
    y2: 59.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_10106_6282",
    x1: 97.1435,
    y1: 54.0757,
    x2: 96.842,
    y2: 60.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_10106_6282",
    x1: 96.2846,
    y1: 53.271,
    x2: 96.1526,
    y2: 59.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_10106_6282",
    x1: 96.3669,
    y1: 53.4687,
    x2: 96.4002,
    y2: 59.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#926D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#987575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_10106_6282",
    x1: 96.3641,
    y1: 53.5864,
    x2: 96.5598,
    y2: 59.5579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BDA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_10106_6282",
    x1: 96.2921,
    y1: 53.6276,
    x2: 96.6467,
    y2: 59.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_10106_6282",
    x1: 96.1494,
    y1: 53.6356,
    x2: 96.6585,
    y2: 59.4591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_10106_6282",
    x1: 95.9337,
    y1: 53.5834,
    x2: 96.5933,
    y2: 59.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BCA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_10106_6282",
    x1: 96.6529,
    y1: 54.1376,
    x2: 97.4633,
    y2: 59.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_10106_6282",
    x1: 96.2934,
    y1: 54.0061,
    x2: 97.2412,
    y2: 59.5821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D9CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_10106_6282",
    x1: 95.8706,
    y1: 53.8619,
    x2: 96.9495,
    y2: 59.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#DACCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_10106_6282",
    x1: 96.3609,
    y1: 54.1659,
    x2: 97.5745,
    y2: 59.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_10106_6282",
    x1: 95.807,
    y1: 54.0248,
    x2: 97.1373,
    y2: 59.2795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_10106_6282",
    x1: 96.1713,
    y1: 54.2068,
    x2: 97.6223,
    y2: 59.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EEE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_10106_6282",
    x1: 96.4598,
    y1: 54.323,
    x2: 98.0261,
    y2: 59.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_10106_6282",
    x1: 97.175,
    y1: 53.3936,
    x2: 95.6585,
    y2: 59.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#801300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#941D08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CD3A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F14D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_10106_6282",
    x1: 99.8176,
    y1: 42.2264,
    x2: 93.6303,
    y2: 68.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BA1C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10106_6282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 74,
    fill: "white",
    transform: "translate(0 0.898438)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default ForwardRef;